
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("bwmXM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ProjectNavigationContent", () => $fd33ac4be9eba12e$export$22df498f17743141);
$parcel$export(module.exports, "default", () => $fd33ac4be9eba12e$export$2e2bcd8739ae039);

var $6SGt4 = parcelRequire("6SGt4");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $lQFjJ = parcelRequire("lQFjJ");

var $c9Ur7 = parcelRequire("c9Ur7");

var $cm8b5 = parcelRequire("cm8b5");

var $4R6GH = parcelRequire("4R6GH");

var $7CMCs = parcelRequire("7CMCs");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $pa9q9 = parcelRequire("pa9q9");

var $eiWbj = parcelRequire("eiWbj");

var $lPApw = parcelRequire("lPApw");

var $hUYIv = parcelRequire("hUYIv");

var $gVVh2 = parcelRequire("gVVh2");

var $lVVC6 = parcelRequire("lVVC6");

var $lfTZh = parcelRequire("lfTZh");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $8qMCq = parcelRequire("8qMCq");

var $lIDet = parcelRequire("lIDet");

var $1MaBz = parcelRequire("1MaBz");

var $ao2h1 = parcelRequire("ao2h1");

var $1E3vT = parcelRequire("1E3vT");

var $itmJb = parcelRequire("itmJb");

var $aTlfe = parcelRequire("aTlfe");

var $ieDtd = parcelRequire("ieDtd");

var $83AT7 = parcelRequire("83AT7");

var $eoFNp = parcelRequire("eoFNp");

var $fOzv2 = parcelRequire("fOzv2");

var $8itvN = parcelRequire("8itvN");

var $cSPpW = parcelRequire("cSPpW");

var $2FBSL = parcelRequire("2FBSL");

var $j00Y4 = parcelRequire("j00Y4");

var $4miW5 = parcelRequire("4miW5");

var $cNBOV = parcelRequire("cNBOV");
const $fd33ac4be9eba12e$var$isJwmAutomationDiscoveryExperimentEnabled = ()=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jwm_automation_templates_discovery');
    return expConfig.get('cohort', 'not-enrolled') !== 'not-enrolled';
};
const $fd33ac4be9eba12e$var$HEADER_TEST_ID = 'business-horizontal-nav.ui.project-header';
const $fd33ac4be9eba12e$var$REDIRECT_FLAG = {
    type: 'info',
    title: (0, $2FBSL.default).defaultViewRedirectFlagTitle,
    description: (0, $2FBSL.default).defaultViewRedirectFlagDescription,
    messageId: 'business-horizontal-nav.ui.project-navigation.redirect-flag.info',
    messageType: 'transactional'
};
const $fd33ac4be9eba12e$var$REDIRECT_QUERY_PARAM = 'redirect';
const $fd33ac4be9eba12e$var$PACKAGE_NAME = 'jiraBusinessHorizontalNav';
const $fd33ac4be9eba12e$export$22df498f17743141 = ({ queryRef: queryRef, handleError: handleError })=>{
    const data = (0, $8Uumt.usePreloadedQuery)((0, $6SGt4.default), queryRef);
    const { data: featuresData } = (0, $lPApw.useFeatures)();
    const projectData = data.jira.projectDataByKey ? data.jira.projectDataByKey : data.jira.projectDataById;
    const [isThemePickerOpen, setIsThemePickerOpen] = (0, $5uXOq.useState)(false);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [theme] = (0, $4R6GH.fg)('jira_theming_relay_migration') ? [
        undefined
    ] : (0, $1MaBz.useThemeSetting)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [redirectQueryParam, setRedirectQueryParam] = (0, $ieDtd.useQueryParam)($fd33ac4be9eba12e$var$REDIRECT_QUERY_PARAM);
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const { updateProjectName: updateProjectName, validateProjectName: validateProjectName } = (0, $eiWbj.useRenameProject)();
    (0, $5uXOq.useEffect)(()=>{
        if (redirectQueryParam === 'viewMissing') {
            setRedirectQueryParam(undefined, 'replace');
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'defaultView redirectedTo', {});
            showFlag($fd33ac4be9eba12e$var$REDIRECT_FLAG);
        }
    }, [
        showFlag,
        setRedirectQueryParam,
        redirectQueryParam,
        createAnalyticsEvent
    ]);
    const editableAvatar = (0, $5uXOq.useMemo)(()=>projectData == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hUYIv.NavigationKitAvatar), {
            projectId: Number(projectData?.projectId),
            selectedAvatarUrl: projectData?.avatar?.large ?? '',
            canEdit: projectData?.canEditProjectConfig?.canPerform ?? false
        }), [
        projectData
    ]);
    const extraComponentsFar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lQFjJ.RightActionsWrapper), null, $fd33ac4be9eba12e$var$isJwmAutomationDiscoveryExperimentEnabled() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aTlfe.default), null) : null, featuresData?.hasSettings ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j00Y4.default), null) : null);
    (0, $5uXOq.useEffect)(()=>{
        !(0, $4R6GH.fg)('jira_theming_relay_migration') && (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'theme evaluated', {
            theme: theme?.value,
            projectId: projectData?.projectId
        });
    }, [
        createAnalyticsEvent,
        theme?.value,
        projectData?.projectId
    ]);
    const onUpdateProjectName = (0, $5uXOq.useCallback)((name)=>updateProjectName(Number(projectData?.projectId), name), [
        projectData?.projectId,
        updateProjectName
    ]);
    let headerProps = {};
    if (projectData?.projectId) {
        const inlineEditProps = {
            withInlineEdit: true,
            onConfirm: onUpdateProjectName,
            onValidate: validateProjectName,
            id: Number(projectData?.projectId)
        };
        headerProps = isAdmin ? inlineEditProps : {};
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, projectData && (0, $4R6GH.fg)('jira_custom_templates_ux') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cSPpW.CustomTemplateBusinessProjectBanner), {
        projectFragment: projectData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eoFNp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lVVC6.default), {
        title: projectData?.name,
        ...headerProps,
        extraComponentsClose: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, featuresData?.hasChangeTheme && !!projectData?.projectId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lIDet.ThemePicker), {
            isOpen: isThemePickerOpen,
            onOpenChange: setIsThemePickerOpen,
            projectId: Number(projectData.projectId)
        }), projectData?.projectKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8qMCq.default), {
            projectKey: projectData?.projectKey,
            projectName: projectData?.name
        })),
        icon: editableAvatar,
        isLoading: projectData == null,
        testId: $fd33ac4be9eba12e$var$HEADER_TEST_ID,
        extraComponentsFar: extraComponentsFar
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "BusinessHorizontalNavigationTabs",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8itvN.SkeletonComponent), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4miW5.default), {
        jiraQueryFragment: data.jira,
        handleError: handleError
    }))));
};
const $fd33ac4be9eba12e$var$ProjectNavigation = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { queryReference: queryReference } = (0, $ao2h1.useRelayResource)((0, $1E3vT.businessHorizontalNav3Resource));
    const queryReferenceRef = (0, $5uXOq.useRef)(null);
    const abortExperience = (0, $cm8b5.useExperienceAbort)((0, $83AT7.VIEW_HORIZONTAL_NAVIGATION_EXPERIENCE));
    const failExperience = (0, $cm8b5.useExperienceFail)((0, $83AT7.VIEW_HORIZONTAL_NAVIGATION_EXPERIENCE));
    if (queryReference) queryReferenceRef.current = queryReference;
    const handleError = (0, $5uXOq.useCallback)((error)=>{
        const statusCode = error && 'statusCode' in error ? Number(error.statusCode) : 0;
        const flagDetails = (0, $cNBOV.getFlagDetails)(statusCode);
        showFlag(flagDetails);
        if ((0, $cNBOV.HANDLED_STATUS_CODES).includes(statusCode)) {
            abortExperience('handled client side error');
            return;
        }
        failExperience('loading horizontal navigation failed', error);
        // only fire error analytics for non-handled query errors
        if (error instanceof (0, $c9Ur7.QueryError)) (0, $jcw0u.default)({
            meta: {
                id: 'businessHorizontalNavigationQuery',
                packageName: $fd33ac4be9eba12e$var$PACKAGE_NAME,
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        abortExperience,
        failExperience,
        showFlag
    ]);
    const analyticsData = (0, $5uXOq.useMemo)(()=>({
            navigationLayer: (0, $83AT7.CONTAINER),
            containerType: (0, $83AT7.PROJECT),
            withContainerNav: false
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceStart), {
        experience: (0, $83AT7.VIEW_HORIZONTAL_NAVIGATION_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "BusinessHorizontalNavigationErrorBoundary",
        packageName: $fd33ac4be9eba12e$var$PACKAGE_NAME,
        onError: (_, error)=>handleError(error),
        fallback: (0, $fOzv2.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gVVh2.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fOzv2.default), null),
        handleError: handleError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "BusinessHorizontalNavigation",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fOzv2.default), null)
    }, queryReferenceRef.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fd33ac4be9eba12e$export$22df498f17743141, {
        queryRef: queryReferenceRef.current,
        handleError: handleError
    })))));
};
var $fd33ac4be9eba12e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($fd33ac4be9eba12e$var$ProjectNavigation);

});
parcelRegister("6SGt4", function(module, exports) {

$parcel$export(module.exports, "default", () => $fed7f561d3a05da6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<820042db950ffe26b91d34ffe7050138>>
 * @relayHash bef16a6db03ecc4506e2c317ed3ec3dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c6a8fb0afe8804c6d8b040f3b4ccf6926f7a96b57ad873204c81c3a0ee4ada5
const $fed7f561d3a05da6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJiraCustomTemplatesUxEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectAri"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "useProjectKey"
    }, v7 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v8 = [
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v9 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v11 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "alias": "canEditProjectConfig",
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v14 = {
        "condition": "isJiraCustomTemplatesUxEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "customTemplateBusinessProjectBanner_businessHorizontalNav"
            }
        ]
    }, v15 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
        }
    ], v16 = [
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "projectIdOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v17 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = [
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "condition": "isJiraCustomTemplatesUxEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLiveTemplate"
                }
            ]
        },
        v18 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "projectNavigation_horizontalNavigationQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "tabs_businessHorizontalNav_TabsContent"
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "alias": "projectDataByKey",
                                        "args": v8 /*: any*/ ,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v10 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "jira.projectDataByKey.projectId"
                                            },
                                            v11 /*: any*/ ,
                                            v12 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            v14 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "alias": "projectDataById",
                                        "args": v15 /*: any*/ ,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProject",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v10 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "jira.projectDataById.projectId"
                                            },
                                            v11 /*: any*/ ,
                                            v12 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            v14 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "projectNavigation_horizontalNavigationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "navigationItems",
                            "args": v16 /*: any*/ ,
                            "concreteType": "JiraNavigationItemConnection",
                            "kind": "LinkedField",
                            "name": "jwmSavedViewsByProject",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNavigationItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isDefault"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "typeKey"
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraNavigationItem"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "label"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canRemove"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canSetAsDefault"
                                                }
                                            ]
                                        },
                                        v17 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "navigationItems",
                            "args": v16 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "projectIdOrKey"
                            ],
                            "handle": "connection",
                            "key": "tabs_jiraNavigation__navigationItems",
                            "kind": "LinkedHandle",
                            "name": "jwmSavedViewsByProject"
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "projectDataByKey",
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": v19 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "projectDataById",
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProject",
                                    "plural": false,
                                    "selections": v19 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4c6a8fb0afe8804c6d8b040f3b4ccf6926f7a96b57ad873204c81c3a0ee4ada5",
            "metadata": {},
            "name": "projectNavigation_horizontalNavigationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fed7f561d3a05da6$var$node.hash = "73d9509696eb943ac9eaa2deb0444981";
var $fed7f561d3a05da6$export$2e2bcd8739ae039 = $fed7f561d3a05da6$var$node;

});

parcelRegister("lQFjJ", function(module, exports) {

$parcel$export(module.exports, "ActionsWrapper", () => $31ed5059f3fb9550$export$c8223871eecc8f3a);
$parcel$export(module.exports, "ActionsWrapperStyled", () => $31ed5059f3fb9550$export$ac9cdc71f29d2899);
$parcel$export(module.exports, "LeftActionsWrapper", () => $31ed5059f3fb9550$export$42cb1c7ab389bf4d);
$parcel$export(module.exports, "RightActionsWrapper", () => $31ed5059f3fb9550$export$4aa2cd250ec24dcc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $bUSNl = parcelRequire("bUSNl");
const $31ed5059f3fb9550$export$c8223871eecc8f3a = ({ children: children, testId: testId })=>{
    const [{ content: content }] = (0, $bUSNl.useSidebar)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31ed5059f3fb9550$export$ac9cdc71f29d2899, {
        sidebarOpen: !!content,
        "data-testid": testId,
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)(),
        visualRefreshDrop6: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6')
    }, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $31ed5059f3fb9550$var$CenterAlignedWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $31ed5059f3fb9550$export$ac9cdc71f29d2899 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $31ed5059f3fb9550$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_t4p290": (0, $lD23V.default)((()=>{
                if (__cmplp.visualRefreshDrop6) return `0 ${"var(--ds-space-negative-300, -24px)"} ${__cmplp.hasBottomSpacing ?? true ? "var(--ds-space-200, 16px)" : 0} ${"var(--ds-space-negative-300, -24px)"}`;
                return `0 ${__cmplp.sidebarOpen ? 0 : "var(--ds-space-negative-300, -24px)"} ${__cmplp.hasBottomSpacing ?? true ? "var(--ds-space-200, 16px)" : 0} ${"var(--ds-space-negative-300, -24px)"}`;
            })())
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s8phfw _1tke1ylp _1n261g80 _bfhk1iew _18k9ad7r",
            __cmplp.visualRefresh ? "_1yt41big" : "_1yt46hdp",
            __cmplp.className
        ])
    });
});
const $31ed5059f3fb9550$export$42cb1c7ab389bf4d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $31ed5059f3fb9550$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $31ed5059f3fb9550$export$4aa2cd250ec24dcc = $31ed5059f3fb9550$var$CenterAlignedWrapper;

});
parcelRegister("bUSNl", function(module, exports) {

$parcel$export(module.exports, "getSidebarQueryParams", () => $39fc2da09b28cabf$export$ddc11e4d41e7cf62);
$parcel$export(module.exports, "useSidebar", () => $39fc2da09b28cabf$export$54c70f22f548bff8);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $hE5wF = parcelRequire("hE5wF");

var $3hGWp = parcelRequire("3hGWp");

var $dCm1o = parcelRequire("dCm1o");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $jnA4H = parcelRequire("jnA4H");
const $39fc2da09b28cabf$export$86880b4b2e1a2384 = 'jwm.sidebar';
const $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH_OLD = 360;
const $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH = 435;
const $39fc2da09b28cabf$export$ddc11e4d41e7cf62 = ()=>[
        (0, $hE5wF.SELECTED_ISSUE_PARAM),
        (0, $hE5wF.SELECTED_COMMENT_PARAM)
    ];
const $39fc2da09b28cabf$export$f4c7df452942956a = ()=>(0, $dCm1o.isVisualRefreshEnabled)() ? $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH : $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH_OLD;
const $39fc2da09b28cabf$var$setSidebarContent = (content)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            content: content
        });
    };
const $39fc2da09b28cabf$var$setSidebarWidth = (width)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const newWidth = Math.max(width, $39fc2da09b28cabf$export$f4c7df452942956a());
        if (newWidth === state.sidebarWidth) return;
        setState({
            ...state,
            sidebarWidth: newWidth
        });
        (0, $jnA4H.localStorage).set($39fc2da09b28cabf$export$86880b4b2e1a2384, newWidth);
    };
const $39fc2da09b28cabf$var$setSidebarOnClose = (onSidebarClose)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            onSidebarClose: onSidebarClose
        });
    };
const $39fc2da09b28cabf$var$closeSidebar = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        state.onSidebarClose();
        setState({
            ...state,
            content: null,
            onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        });
    };
const $39fc2da09b28cabf$var$actions = {
    setSidebarContent: $39fc2da09b28cabf$var$setSidebarContent,
    setSidebarWidth: $39fc2da09b28cabf$var$setSidebarWidth,
    setSidebarOnClose: $39fc2da09b28cabf$var$setSidebarOnClose,
    closeSidebar: $39fc2da09b28cabf$var$closeSidebar
};
const $39fc2da09b28cabf$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        content: null,
        sidebarWidth: (0, $jnA4H.localStorage).get($39fc2da09b28cabf$export$86880b4b2e1a2384) || $39fc2da09b28cabf$export$f4c7df452942956a(),
        onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    },
    actions: $39fc2da09b28cabf$var$actions,
    name: 'JWMSidebarStore'
});
const $39fc2da09b28cabf$var$useHook = (0, $3sQ5x.createHook)($39fc2da09b28cabf$var$Store);
const $39fc2da09b28cabf$export$54c70f22f548bff8 = ()=>{
    const [state, hookActions] = $39fc2da09b28cabf$var$useHook();
    const sidebarQueryParams = $39fc2da09b28cabf$export$ddc11e4d41e7cf62();
    const [, setQueryParams] = (0, $3hGWp.useQueryParams)(...sidebarQueryParams);
    const resetSidebarQueryParams = (0, $5uXOq.useCallback)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = sidebarQueryParams.reduce((acc, param)=>Object.assign(acc, {
                [param]: undefined
            }), {});
        setQueryParams(newQueryParams);
    }, [
        setQueryParams,
        sidebarQueryParams
    ]);
    return [
        state,
        {
            ...hookActions,
            resetSidebarQueryParams: resetSidebarQueryParams
        }
    ];
};

});
parcelRegister("hE5wF", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RANK_SORTING_DIRECTION", () => $bfd6cbe4770149b5$export$8386e51ba415e85d);
$parcel$export(module.exports, "DEFAULT_AVATAR_RES", () => $bfd6cbe4770149b5$export$159fe44438c210e9);
$parcel$export(module.exports, "FILTER_PARAM", () => $bfd6cbe4770149b5$export$d8301e0b33832d94);
$parcel$export(module.exports, "INLINE_CREATE_PARAM", () => $bfd6cbe4770149b5$export$599c163c1570a353);
$parcel$export(module.exports, "INVITE_OPEN_PARAM", () => $bfd6cbe4770149b5$export$3a74d1a195d2f007);
$parcel$export(module.exports, "SELECTED_ISSUE_PARAM", () => $bfd6cbe4770149b5$export$c070acdc9b0f1be5);
$parcel$export(module.exports, "SELECTED_COMMENT_PARAM", () => $bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8);
$parcel$export(module.exports, "GROUP_BY_ASSIGNEE", () => $bfd6cbe4770149b5$export$dba794af6c0f2afc);
$parcel$export(module.exports, "GROUP_BY_PRIORITY", () => $bfd6cbe4770149b5$export$56ecb5d2dfb80edc);
$parcel$export(module.exports, "GROUP_BY_CATEGORY", () => $bfd6cbe4770149b5$export$22ef551f315f2786);
$parcel$export(module.exports, "GROUP_BY_STATUS", () => $bfd6cbe4770149b5$export$6d69efb296b78a);
$parcel$export(module.exports, "START_DATE_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$e23e1d1ea45171c2);
$parcel$export(module.exports, "RANK_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$e35c6e217c75dc4b);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_TYPE", () => $bfd6cbe4770149b5$export$e5eab344feb92af9);
$parcel$export(module.exports, "COMMENT_SUMMARY_TYPE", () => $bfd6cbe4770149b5$export$a311e1b78816c048);
$parcel$export(module.exports, "CARD_COVERS_TYPE", () => $bfd6cbe4770149b5$export$f5583ff4ab4d63e5);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $bfd6cbe4770149b5$export$5716e8bcb003888d);
$parcel$export(module.exports, "STORY_POINTS_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$1f9fb9f15184100f);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_ALIAS_FIELD_ID", () => $bfd6cbe4770149b5$export$c72ea455b368cdd9);
$parcel$export(module.exports, "UNASSIGNED_USER_ID", () => $bfd6cbe4770149b5$export$12e572fd459c10dc);

const $bfd6cbe4770149b5$export$8386e51ba415e85d = (0, $2a9e000a443b1a95$export$1dee026a19752d6b);
const $bfd6cbe4770149b5$export$159fe44438c210e9 = '48x48';
const $bfd6cbe4770149b5$export$d8301e0b33832d94 = 'filter';
const $bfd6cbe4770149b5$export$599c163c1570a353 = 'inlineCreate';
const $bfd6cbe4770149b5$export$3a74d1a195d2f007 = 'inviteOpen';
const $bfd6cbe4770149b5$export$e1e3f9fa6f04d6d = 'quickFilters';
const $bfd6cbe4770149b5$export$c070acdc9b0f1be5 = 'selectedIssue';
const $bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8 = 'selectedComment';
const $bfd6cbe4770149b5$export$dba794af6c0f2afc = 'assignee';
const $bfd6cbe4770149b5$export$56ecb5d2dfb80edc = 'priority';
const $bfd6cbe4770149b5$export$22ef551f315f2786 = 'category';
const $bfd6cbe4770149b5$export$6d69efb296b78a = 'status';
const $bfd6cbe4770149b5$export$e23e1d1ea45171c2 = 'startdate';
const $bfd6cbe4770149b5$export$e35c6e217c75dc4b = 'rank';
const $bfd6cbe4770149b5$export$e5eab344feb92af9 = 'remoteIssueLinks';
const $bfd6cbe4770149b5$export$a311e1b78816c048 = 'commentsummary';
const $bfd6cbe4770149b5$export$f5583ff4ab4d63e5 = 'cardCovers';
const $bfd6cbe4770149b5$export$5716e8bcb003888d = 25;
const $bfd6cbe4770149b5$export$1f9fb9f15184100f = 'storypoints';
const $bfd6cbe4770149b5$export$c72ea455b368cdd9 = 'storypointestimate';
const $bfd6cbe4770149b5$export$786b42b4618e6ee4 = 'sprint';
const $bfd6cbe4770149b5$export$12e572fd459c10dc = 'unassigned';

});
const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';


parcelRegister("3hGWp", function(module, exports) {

$parcel$export(module.exports, "useQueryParams", () => $afd0e0a12e1f2496$export$b37ee0d76c6d2fbc);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $hGgHi = parcelRequire("hGgHi");

var $9xWGk = parcelRequire("9xWGk");

var $ebyGx = parcelRequire("ebyGx");

var $doZTA = parcelRequire("doZTA");
const $afd0e0a12e1f2496$export$b37ee0d76c6d2fbc = (...queryParamsToWatch)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push, replace: replace }] = (0, $doZTA.useRouter)();
    const queryParamsRef = (0, $5uXOq.useRef)({});
    const parsedQueryParams = (0, $5uXOq.useMemo)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = queryParamsToWatch.reduce((accumulator, currentValue)=>{
            accumulator[currentValue] = query[currentValue] || undefined;
            return accumulator;
        }, {});
        // update cache only when one of requested params actually changed
        // otherwise return cached value to avoid changing return object reference
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(queryParamsRef.current, newQueryParams)) queryParamsRef.current = newQueryParams;
        return queryParamsRef.current;
    }, [
        query,
        queryParamsToWatch
    ]);
    const setQueryParams = (0, $5uXOq.useCallback)((newQueryParams, options)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
            ...query,
            ...newQueryParams
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value));
        const { updateType: updateType, ...stringifyOptions } = options ?? {};
        // @ts-expect-error - TS2559 - Type '{ sort?: false | ((a: string, b: string) => number) | undefined; }' has no properties in common with type 'StringifyOptions'.
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(parsedSearch, stringifyOptions);
        const url = pathname + (strSearch !== '' ? `?${strSearch}` : '');
        updateType === 'replace' ? replace(url) : push(url);
    }, [
        pathname,
        push,
        replace,
        query
    ]);
    return [
        parsedQueryParams,
        setQueryParams
    ];
};

});

parcelRegister("jnA4H", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $301038d04a64b539$export$c2ed3351cac403d1);

var $bSSG7 = parcelRequire("bSSG7");
const $301038d04a64b539$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('jira_business_common');

});



parcelRegister("c9Ur7", function(module, exports) {

$parcel$export(module.exports, "QueryError", () => $835bdf2aa5daa049$export$83dcbdfe8cbc1e17);
const $835bdf2aa5daa049$export$f215947b3d76a6b7 = 'QueryError';
class $835bdf2aa5daa049$export$83dcbdfe8cbc1e17 extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.extensions = payload.extensions;
        this.message = payload.message ?? '';
        this.statusCode = payload.extensions?.[0]?.statusCode ?? -1;
    }
}

});

parcelRegister("cm8b5", function(module, exports) {

$parcel$export(module.exports, "useExperienceStart", () => $aca94fc714dddc77$export$675e0d25df38d426);
$parcel$export(module.exports, "useExperienceAbort", () => $aca94fc714dddc77$export$cc92b7ce453f4403);
$parcel$export(module.exports, "useExperienceSuccess", () => $aca94fc714dddc77$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "useExperienceFail", () => $aca94fc714dddc77$export$606da7704d8eaf06);
$parcel$export(module.exports, "useQueryBasedViewAutomaticTracking", () => $aca94fc714dddc77$export$8ca25d6ff1437be3);
$parcel$export(module.exports, "ExperienceStart", () => $aca94fc714dddc77$export$f20b867e738a222c);
$parcel$export(module.exports, "ExperienceFailed", () => $aca94fc714dddc77$export$ae65a9e09c4516b3);
$parcel$export(module.exports, "ExperienceErrorBoundary", () => $aca94fc714dddc77$export$139c4a4ad101c3c5);
$parcel$export(module.exports, "ExperienceSuccess", () => $aca94fc714dddc77$export$4962f3898bd5c829);
$parcel$export(module.exports, "ExperienceAbort", () => $aca94fc714dddc77$export$c9b6bcd70239a39c);

var $5uXOq = parcelRequire("5uXOq");

var $8Wswo = parcelRequire("8Wswo");

var $j8DrX = parcelRequire("j8DrX");

var $4R6GH = parcelRequire("4R6GH");

var $8UpTw = parcelRequire("8UpTw");

var $7CMCs = parcelRequire("7CMCs");

var $jcw0u = parcelRequire("jcw0u");

var $8dXDG = parcelRequire("8dXDG");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $jJZqs = parcelRequire("jJZqs");
const $aca94fc714dddc77$export$675e0d25df38d426 = ({ experience: experience, experienceId: experienceId, packageName: packageName })=>(0, $kaHBi.useExperienceStart)({
        experience: experience,
        experienceId: experienceId,
        analyticsSource: packageName
    });
const $aca94fc714dddc77$export$cc92b7ce453f4403 = ({ experience: experience }, attributes)=>(0, $8dXDG.useExperienceAbort)({
        experience: experience,
        attributes: attributes
    });
const $aca94fc714dddc77$var$shard = (0, $j8DrX.default)('ajs-shard');
const $aca94fc714dddc77$var$region = (0, $j8DrX.default)('ajs-region');
const $aca94fc714dddc77$export$e94f0da4fc0603c6 = ({ experience: experience })=>(0, $3bQtK.useExperienceSuccess)({
        experience: experience,
        ...(0, $4R6GH.fg)('jira_list_experience_tracker_with_shard') ? {
            attributes: {
                shard: $aca94fc714dddc77$var$shard,
                region: $aca94fc714dddc77$var$region
            }
        } : {}
    });
const $aca94fc714dddc77$export$606da7704d8eaf06 = ({ experience: experience, experienceId: experienceId, packageName: packageName, teamName: teamName })=>{
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: experience,
        ...(0, $4R6GH.fg)('jira_list_experience_tracker_with_shard') ? {
            attributes: {
                shard: $aca94fc714dddc77$var$shard,
                region: $aca94fc714dddc77$var$region
            }
        } : {}
    });
    const onFail = (0, $5uXOq.useCallback)((location, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error, extraAttributes)=>{
        const relevantError = error?.networkError ?? error;
        if (relevantError instanceof (0, $jJZqs.ValidationError) && relevantError.message === '' && relevantError.errors.length) relevantError.message = relevantError.errors[0].error;
        extraAttributes !== undefined ? onExperienceFail(location, relevantError, extraAttributes) : onExperienceFail(location, relevantError);
        (0, $jcw0u.default)({
            meta: {
                id: `experience-tracker-${experienceId ?? experience}`,
                packageName: packageName,
                teamName: teamName
            },
            attributes: {
                location: location
            },
            error: relevantError,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onExperienceFail,
        experienceId,
        experience,
        packageName,
        teamName
    ]);
    return onFail;
};
const $aca94fc714dddc77$export$8ca25d6ff1437be3 = (experience, { loading: loading, error: error, shouldStartExperience: shouldStartExperience })=>{
    const [hasStarted, setHasStarted] = (0, $5uXOq.useState)(loading);
    const [hasCompleted, setHasCompleted] = (0, $5uXOq.useState)(false);
    const [hasExperienceBeenTracked, setHasExperienceBeenTracked] = (0, $5uXOq.useState)(false);
    const startExperience = $aca94fc714dddc77$export$675e0d25df38d426(experience);
    const onFail = $aca94fc714dddc77$export$606da7704d8eaf06(experience);
    const onSuccess = $aca94fc714dddc77$export$e94f0da4fc0603c6(experience);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldStartExperience === true) startExperience();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldStartExperience
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasStarted === false && loading === true) setHasStarted(true);
        if (hasStarted === true && loading === false) {
            setHasCompleted(true);
            setHasExperienceBeenTracked(false);
        }
    }, [
        hasStarted,
        loading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasCompleted && !hasExperienceBeenTracked) {
            // make sure experience is tracked once despite re-rendering of the view
            setHasExperienceBeenTracked(true);
            if (typeof error !== 'undefined') {
                onFail(`${experience.experience} ${experience.experienceId || ''} useEffect error handling`, error, (0, $8Wswo.getGraphqlErrorAttributes)(error));
                return;
            }
            onSuccess({
                loaded: true
            });
        }
    }, [
        error,
        experience,
        hasCompleted,
        hasExperienceBeenTracked,
        onFail,
        onSuccess
    ]);
};
const $aca94fc714dddc77$export$f20b867e738a222c = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience })=>{
    const start = $aca94fc714dddc77$export$675e0d25df38d426(experience);
    (0, $5uXOq.useEffect)(()=>{
        start();
    }, [
        start
    ]);
    return null;
});
const $aca94fc714dddc77$export$ae65a9e09c4516b3 = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, error: error, attributes: attributes })=>{
    const onFail = $aca94fc714dddc77$export$606da7704d8eaf06(experience);
    (0, $5uXOq.useEffect)(()=>{
        onFail(experience.experience, error, attributes);
    }, [
        attributes,
        error,
        experience,
        onFail
    ]);
    return null;
});
const $aca94fc714dddc77$export$139c4a4ad101c3c5 = ({ experience: experience, shouldStartExperience: shouldStartExperience, fallback: fallback = (0, $8UpTw.ErrorPage), children: children })=>{
    const onFail = $aca94fc714dddc77$export$606da7704d8eaf06(experience);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: experience.packageName,
        teamName: experience.teamName,
        id: experience.experience,
        onError: onFail,
        fallback: fallback
    }, shouldStartExperience === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aca94fc714dddc77$export$f20b867e738a222c, {
        experience: experience
    }), children);
};
const $aca94fc714dddc77$export$4962f3898bd5c829 = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: experience.experience,
        attributes: {
            ...experience.experienceId == null ? undefined : {
                experienceId: experience.experienceId
            },
            ...attributes
        }
    }));
const $aca94fc714dddc77$export$c9b6bcd70239a39c = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, error: error })=>{
    const onAbort = $aca94fc714dddc77$export$cc92b7ce453f4403(experience);
    (0, $5uXOq.useEffect)(()=>{
        onAbort(experience.experience, {
            error: error.message
        });
    }, [
        error,
        experience,
        onAbort
    ]);
    return null;
});

});
parcelRegister("8Wswo", function(module, exports) {

$parcel$export(module.exports, "shouldHandleTheError", () => $6f94bc39289ec711$export$47770c8b6d645cdb);
$parcel$export(module.exports, "getGraphqlErrorAttributes", () => $6f94bc39289ec711$export$b19e649eafc62480);

var $e3a3O = parcelRequire("e3a3O");
const $6f94bc39289ec711$var$errorWhitelist = [
    'EXPERIENCE_UNAVAILABLE',
    'FIELD_UNAVAILABLE',
    'ISSUE_UNAVAILABLE'
];
const $6f94bc39289ec711$export$47770c8b6d645cdb = (error)=>{
    if (error?.networkError) return true;
    // when issue links are disabled at the instance level and we request it, it throws an error but we still get the whole response
    // There is a issue links perm check that happens after loading the list so the UI already deals with this properly and we can ignore it
    // similarly, even when issue links are enabled, but the field itself is hidden in every screen it will throw an error but we'll still get the whole response
    const filterIssueLinksDisabledErrors = (graphQLError)=>{
        const isWhitelisted = $6f94bc39289ec711$var$errorWhitelist.includes(graphQLError?.extensions?.errorType);
        return !isWhitelisted;
    };
    const errorsToShow = (error?.graphQLErrors || []).filter(filterIssueLinksDisabledErrors);
    return errorsToShow.length > 0;
};
const $6f94bc39289ec711$export$b19e649eafc62480 = (error)=>{
    const isApolloError = error instanceof (0, $e3a3O.ApolloError);
    if (!isApolloError) return {};
    const getErrorAttribute = (graphQLErrors, errorAttribute)=>{
        const errors = graphQLErrors.map((graphQLError)=>graphQLError?.extensions?.[errorAttribute]).filter(Boolean);
        return JSON.stringify(errors);
    };
    return {
        statusCodes: getErrorAttribute(error?.graphQLErrors || [], 'statusCode'),
        errorTypes: getErrorAttribute(error?.graphQLErrors || [], 'errorType')
    };
};

});
parcelRegister("e3a3O", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $02a3c2aebc919401$export$bd096ddbd246c79c);
$parcel$export(module.exports, "isApolloError", () => $02a3c2aebc919401$export$17f5e6bd290bb15d);
$parcel$export(module.exports, "ApolloError", () => $02a3c2aebc919401$export$26a337512320b8c6);
$parcel$export(module.exports, "ApolloClient", () => $02a3c2aebc919401$export$13f5a5f0f1dbab88);
$parcel$export(module.exports, "default", () => $02a3c2aebc919401$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");
var $bqMzA = parcelRequire("bqMzA");

var $clSzL = parcelRequire("clSzL");
var $aS6b9 = parcelRequire("aS6b9");

var $ebaCz = parcelRequire("ebaCz");

var $1DiV8 = parcelRequire("1DiV8");

var $12QNw = parcelRequire("12QNw");
var $02a3c2aebc919401$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($02a3c2aebc919401$export$bd096ddbd246c79c || ($02a3c2aebc919401$export$bd096ddbd246c79c = {}));
function $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $02a3c2aebc919401$var$Observable = function(_super) {
    (0, $3VFsf.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $ebaCz.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $aS6b9.default));
function $02a3c2aebc919401$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $02a3c2aebc919401$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $02a3c2aebc919401$var$generateErrorMessage = function(err) {
    var message = '';
    if ($02a3c2aebc919401$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $02a3c2aebc919401$export$26a337512320b8c6 = function(_super) {
    (0, $3VFsf.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $02a3c2aebc919401$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $02a3c2aebc919401$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($02a3c2aebc919401$export$160bafb6ac1e0641 || ($02a3c2aebc919401$export$160bafb6ac1e0641 = {}));
var $02a3c2aebc919401$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $02a3c2aebc919401$export$6c1b56eac59c9584 = function(_super) {
    (0, $3VFsf.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $jojW6.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($02a3c2aebc919401$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $02a3c2aebc919401$export$bd096ddbd246c79c.loading : $02a3c2aebc919401$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            stale: false
        }));
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $bqMzA.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $1DiV8.InvariantError)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $bqMzA.equal)(this.variables, variables)) this.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.variables), variables);
        if (!(0, $bqMzA.equal)(this.options.variables, this.variables)) this.options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $02a3c2aebc919401$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $1DiV8.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $02a3c2aebc919401$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $bqMzA.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $jojW6.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $jojW6.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $bqMzA.equal)(previousVariables, variables)) _this.refetch();
                        else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($02a3c2aebc919401$var$Observable);
function $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback(error) {}
function $02a3c2aebc919401$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $1DiV8.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $02a3c2aebc919401$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $02a3c2aebc919401$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $1DiV8.invariant)(!previousQuery || previousQuery.document === query.document || (0, $bqMzA.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.loading) {
            if (!(0, $bqMzA.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.refetch;
        else networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $02a3c2aebc919401$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $02a3c2aebc919401$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $jojW6.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $jojW6.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            return (0, $3VFsf.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $jojW6.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $jojW6.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $1DiV8.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            return (0, $3VFsf.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $3VFsf.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $12QNw.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $12QNw.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $jojW6.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $3VFsf.__generator)(this, function(_b) {
                mainDefinition = (0, $jojW6.getMainDefinition)(document);
                fragments = (0, $jojW6.getFragmentDefinitions)(document);
                fragmentMap = (0, $jojW6.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $02a3c2aebc919401$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $3VFsf.__generator)(this, function(_a) {
                            if (!(0, $jojW6.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $jojW6.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $jojW6.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $1DiV8.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $jojW6.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $jojW6.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $jojW6.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $02a3c2aebc919401$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $02a3c2aebc919401$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $02a3c2aebc919401$var$asyncMap(observable, mapFn) {
    return new $02a3c2aebc919401$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $02a3c2aebc919401$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $02a3c2aebc919401$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $02a3c2aebc919401$var$MutationStore();
        this.queryStore = new $02a3c2aebc919401$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $jojW6.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $02a3c2aebc919401$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $1DiV8.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $1DiV8.invariant)(mutation, 9);
                        (0, $1DiV8.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $02a3c2aebc919401$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $jojW6.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $02a3c2aebc919401$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($02a3c2aebc919401$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $jojW6.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $3VFsf.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $3VFsf.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $jojW6.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($02a3c2aebc919401$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $02a3c2aebc919401$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $02a3c2aebc919401$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $jojW6.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $jojW6.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $jojW6.getDefaultValues)((0, $jojW6.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $1DiV8.invariant)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $3VFsf.__assign)({}, options);
        return new $02a3c2aebc919401$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $1DiV8.invariant)(options.query, 12);
        (0, $1DiV8.invariant)(options.query.kind === 'Document', 13);
        (0, $1DiV8.invariant)(!options.returnPartialData, 14);
        (0, $1DiV8.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $1DiV8.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $jojW6.graphQLResultHasError)(result)) throw new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $02a3c2aebc919401$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $1DiV8.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) info.listeners.forEach(function(listener) {
                if (listener) listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $jojW6.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $02a3c2aebc919401$var$multiplex((0, $clSzL.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $02a3c2aebc919401$var$multiplex((0, $clSzL.execute)(link, operation));
        } else {
            observable = $02a3c2aebc919401$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $02a3c2aebc919401$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(result.errors)) return reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.ready && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $1DiV8.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $02a3c2aebc919401$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $02a3c2aebc919401$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $jojW6.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $jojW6.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $jojW6.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $jojW6.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $jojW6.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $jojW6.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $jojW6.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $02a3c2aebc919401$var$version = "2.6.10";
var $02a3c2aebc919401$var$hasSuggestedDevtools = false;
var $02a3c2aebc919401$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $clSzL.ApolloLink).empty();
        if (!link || !cache) throw new (0, $1DiV8.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $02a3c2aebc919401$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        this.version = $02a3c2aebc919401$var$version;
        this.localState = new $02a3c2aebc919401$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $02a3c2aebc919401$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.defaultOptions.query), options);
        (0, $1DiV8.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $clSzL.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $02a3c2aebc919401$export$2e2bcd8739ae039 = $02a3c2aebc919401$export$13f5a5f0f1dbab88;

});
parcelRegister("jojW6", function(module, exports) {

$parcel$export(module.exports, "storeKeyNameFromField", () => $e1dfb923a27ca793$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $e1dfb923a27ca793$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $e1dfb923a27ca793$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $e1dfb923a27ca793$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $e1dfb923a27ca793$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $e1dfb923a27ca793$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "isIdValue", () => $e1dfb923a27ca793$export$e33b89a9aa87695);
$parcel$export(module.exports, "toIdValue", () => $e1dfb923a27ca793$export$b124f125e34d720a);
$parcel$export(module.exports, "isJsonValue", () => $e1dfb923a27ca793$export$226c1c6d1a5b660a);
$parcel$export(module.exports, "getDirectiveInfoFromField", () => $e1dfb923a27ca793$export$2a7f471142984a91);
$parcel$export(module.exports, "shouldInclude", () => $e1dfb923a27ca793$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $e1dfb923a27ca793$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $e1dfb923a27ca793$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getFragmentQueryDocument", () => $e1dfb923a27ca793$export$abbf37c7cf644e41);
$parcel$export(module.exports, "assign", () => $e1dfb923a27ca793$export$e6e34fd1f2686227);
$parcel$export(module.exports, "checkDocument", () => $e1dfb923a27ca793$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $e1dfb923a27ca793$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $e1dfb923a27ca793$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $e1dfb923a27ca793$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $e1dfb923a27ca793$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getMainDefinition", () => $e1dfb923a27ca793$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $e1dfb923a27ca793$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $e1dfb923a27ca793$export$84c19026e616569e);
$parcel$export(module.exports, "removeDirectivesFromDocument", () => $e1dfb923a27ca793$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $e1dfb923a27ca793$export$43b332f87950a467);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $e1dfb923a27ca793$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $e1dfb923a27ca793$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $e1dfb923a27ca793$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $e1dfb923a27ca793$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $e1dfb923a27ca793$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "isProduction", () => $e1dfb923a27ca793$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $e1dfb923a27ca793$export$410cbc2864fa25b5);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $e1dfb923a27ca793$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $e1dfb923a27ca793$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $e1dfb923a27ca793$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $e1dfb923a27ca793$export$160070228be94b08);

var $12QNw = parcelRequire("12QNw");

var $1DiV8 = parcelRequire("1DiV8");

var $3VFsf = parcelRequire("3VFsf");

var $fkrBp = parcelRequire("fkrBp");

var $bqMzA = parcelRequire("bqMzA");

var $6cAn5 = parcelRequire("6cAn5");
function $e1dfb923a27ca793$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $e1dfb923a27ca793$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $e1dfb923a27ca793$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $e1dfb923a27ca793$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $e1dfb923a27ca793$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $e1dfb923a27ca793$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $e1dfb923a27ca793$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $e1dfb923a27ca793$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $e1dfb923a27ca793$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $e1dfb923a27ca793$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $e1dfb923a27ca793$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($e1dfb923a27ca793$var$isIntValue(value) || $e1dfb923a27ca793$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($e1dfb923a27ca793$var$isBooleanValue(value) || $e1dfb923a27ca793$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($e1dfb923a27ca793$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($e1dfb923a27ca793$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($e1dfb923a27ca793$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($e1dfb923a27ca793$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($e1dfb923a27ca793$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $1DiV8.InvariantError)(17);
}
function $e1dfb923a27ca793$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $e1dfb923a27ca793$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $e1dfb923a27ca793$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $e1dfb923a27ca793$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $e1dfb923a27ca793$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($fkrBp)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($e1dfb923a27ca793$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $e1dfb923a27ca793$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $e1dfb923a27ca793$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $e1dfb923a27ca793$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $e1dfb923a27ca793$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $3VFsf.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $e1dfb923a27ca793$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $e1dfb923a27ca793$var$defaultValueFromVariable(node) {
    throw new (0, $1DiV8.InvariantError)(18);
}
function $e1dfb923a27ca793$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $e1dfb923a27ca793$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $e1dfb923a27ca793$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $e1dfb923a27ca793$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $e1dfb923a27ca793$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $e1dfb923a27ca793$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $e1dfb923a27ca793$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $1DiV8.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $e1dfb923a27ca793$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $12QNw.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $e1dfb923a27ca793$export$2dafb573e282fe8d(names, doc) {
    return $e1dfb923a27ca793$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $e1dfb923a27ca793$export$8d1e9e5bbfa5d09a(document) {
    return document && $e1dfb923a27ca793$export$2dafb573e282fe8d([
        'client'
    ], document) && $e1dfb923a27ca793$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $e1dfb923a27ca793$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($e1dfb923a27ca793$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $1DiV8.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $1DiV8.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $1DiV8.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $e1dfb923a27ca793$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $1DiV8.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, document), {
        definitions: (0, $3VFsf.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $e1dfb923a27ca793$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $e1dfb923a27ca793$export$a92e7a440b22bdf0(doc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $1DiV8.invariant)(mutationDef, 1);
    return mutationDef;
}
function $e1dfb923a27ca793$export$a7d0d8111d2386df(doc) {
    (0, $1DiV8.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(3);
        return definition;
    });
    (0, $1DiV8.invariant)(operations.length <= 1, 4);
    return doc;
}
function $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $e1dfb923a27ca793$export$78a8e95d8d43ad7f(document) {
    var def = $e1dfb923a27ca793$export$7a5b1fa979d2c158(document);
    (0, $1DiV8.invariant)(def, 5);
    return def;
}
function $e1dfb923a27ca793$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $e1dfb923a27ca793$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $e1dfb923a27ca793$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc);
    (0, $1DiV8.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $e1dfb923a27ca793$export$772111caef41b3f5(doc) {
    (0, $1DiV8.invariant)(doc.kind === 'Document', 7);
    (0, $1DiV8.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $1DiV8.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $e1dfb923a27ca793$export$f431198736b7f96d(queryDoc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $1DiV8.InvariantError)(10);
}
function $e1dfb923a27ca793$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $e1dfb923a27ca793$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $e1dfb923a27ca793$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $e1dfb923a27ca793$export$e6e34fd1f2686227.apply(void 0, (0, $3VFsf.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $e1dfb923a27ca793$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $e1dfb923a27ca793$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $e1dfb923a27ca793$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $e1dfb923a27ca793$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $e1dfb923a27ca793$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $e1dfb923a27ca793$var$nullIfDocIsEmpty(doc) {
    return $e1dfb923a27ca793$var$isEmpty($e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) || $e1dfb923a27ca793$export$772111caef41b3f5(doc), $e1dfb923a27ca793$export$193789b4c8246dd4($e1dfb923a27ca793$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $e1dfb923a27ca793$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $e1dfb923a27ca793$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($e1dfb923a27ca793$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $e1dfb923a27ca793$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $e1dfb923a27ca793$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $e1dfb923a27ca793$export$43b332f87950a467(doc) {
    return (0, $12QNw.visit)($e1dfb923a27ca793$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($e1dfb923a27ca793$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                    selections: (0, $3VFsf.__spreadArrays)(selections, [
                        $e1dfb923a27ca793$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $e1dfb923a27ca793$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $e1dfb923a27ca793$export$74985f3324559867(doc) {
    return $e1dfb923a27ca793$export$e5ae0530da5fe96c([
        $e1dfb923a27ca793$var$connectionRemoveConfig
    ], $e1dfb923a27ca793$export$a7d0d8111d2386df(doc));
}
function $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$e1dfb923a27ca793$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives)) || nestedCheck && $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $e1dfb923a27ca793$export$deed3420cb5d2e1d(directives, doc) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $e1dfb923a27ca793$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $e1dfb923a27ca793$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $e1dfb923a27ca793$var$getArgumentMatcher(config);
    return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $e1dfb923a27ca793$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, $12QNw.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($e1dfb923a27ca793$export$fb56ad75dd311c12(selection) || $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $e1dfb923a27ca793$export$57c368c23873f32b(document) {
    var definition = $e1dfb923a27ca793$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $12QNw.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $e1dfb923a27ca793$export$8eae69e876ee321e(document) {
    $e1dfb923a27ca793$export$a7d0d8111d2386df(document);
    var modifiedDoc = $e1dfb923a27ca793$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $12QNw.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $e1dfb923a27ca793$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $e1dfb923a27ca793$var$toString = Object.prototype.toString;
function $e1dfb923a27ca793$export$629a2bd3f5a49ecc(value) {
    return $e1dfb923a27ca793$var$cloneDeepHelper(value, new Map());
}
function $e1dfb923a27ca793$var$cloneDeepHelper(val, seen) {
    switch($e1dfb923a27ca793$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $e1dfb923a27ca793$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $e1dfb923a27ca793$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() {
    if (typeof $6cAn5 !== 'undefined' && "production") return "production";
    return 'development';
}
function $e1dfb923a27ca793$export$f0cb0fda19c18b37(env) {
    return $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() === env;
}
function $e1dfb923a27ca793$export$f15d00aa73aafac4() {
    return $e1dfb923a27ca793$export$f0cb0fda19c18b37('production') === true;
}
function $e1dfb923a27ca793$export$df77466336fe5355() {
    return $e1dfb923a27ca793$export$f0cb0fda19c18b37('development') === true;
}
function $e1dfb923a27ca793$export$410cbc2864fa25b5() {
    return $e1dfb923a27ca793$export$f0cb0fda19c18b37('test') === true;
}
function $e1dfb923a27ca793$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $e1dfb923a27ca793$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $e1dfb923a27ca793$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $e1dfb923a27ca793$var$deepFreeze(o[prop]);
    });
    return o;
}
function $e1dfb923a27ca793$export$7f9c177735b71f18(obj) {
    if ($e1dfb923a27ca793$export$df77466336fe5355() || $e1dfb923a27ca793$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $e1dfb923a27ca793$var$deepFreeze(obj);
    }
    return obj;
}
var $e1dfb923a27ca793$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $e1dfb923a27ca793$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $e1dfb923a27ca793$export$160070228be94b08(sources);
}
function $e1dfb923a27ca793$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $e1dfb923a27ca793$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $e1dfb923a27ca793$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $e1dfb923a27ca793$var$mergeHelper(target, source, pastCopies) {
    if ($e1dfb923a27ca793$var$isObject(source) && $e1dfb923a27ca793$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($e1dfb923a27ca793$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $e1dfb923a27ca793$var$mergeHelper($e1dfb923a27ca793$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $e1dfb923a27ca793$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $3VFsf.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $e1dfb923a27ca793$var$haveWarned = Object.create({});
function $e1dfb923a27ca793$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$e1dfb923a27ca793$export$f15d00aa73aafac4() && !$e1dfb923a27ca793$var$haveWarned[msg]) {
        if (!$e1dfb923a27ca793$export$410cbc2864fa25b5()) $e1dfb923a27ca793$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $e1dfb923a27ca793$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("1DiV8", function(module, exports) {

$parcel$export(module.exports, "InvariantError", () => $13081c324be1f9ab$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $13081c324be1f9ab$export$f5708dca728d7177);

var $3VFsf = parcelRequire("3VFsf");

var $6cAn5 = parcelRequire("6cAn5");
var $13081c324be1f9ab$var$genericMessage = "Invariant Violation";
var $13081c324be1f9ab$var$_a = Object.setPrototypeOf, $13081c324be1f9ab$var$setPrototypeOf = $13081c324be1f9ab$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $13081c324be1f9ab$var$_a;
var $13081c324be1f9ab$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $13081c324be1f9ab$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $13081c324be1f9ab$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $13081c324be1f9ab$var$genericMessage;
        $13081c324be1f9ab$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $13081c324be1f9ab$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $13081c324be1f9ab$export$cea12affaee22fe8(message);
}
function $13081c324be1f9ab$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $13081c324be1f9ab$var$wrapConsoleMethod("warn");
    invariant.error = $13081c324be1f9ab$var$wrapConsoleMethod("error");
})($13081c324be1f9ab$export$f5708dca728d7177 || ($13081c324be1f9ab$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $13081c324be1f9ab$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $6cAn5 === "object") $13081c324be1f9ab$export$e54fe5b0f43758f7 = $6cAn5;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($13081c324be1f9ab$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $13081c324be1f9ab$var$invariant$1 = $13081c324be1f9ab$export$f5708dca728d7177;
var $13081c324be1f9ab$export$2e2bcd8739ae039 = $13081c324be1f9ab$var$invariant$1;

});

parcelRegister("fkrBp", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("bqMzA", function(module, exports) {

$parcel$export(module.exports, "equal", () => $8527cd05038b1b96$export$411ce8e5a71e3069);
var $8527cd05038b1b96$var$_a = Object.prototype, $8527cd05038b1b96$var$toString = $8527cd05038b1b96$var$_a.toString, $8527cd05038b1b96$var$hasOwnProperty = $8527cd05038b1b96$var$_a.hasOwnProperty;
var $8527cd05038b1b96$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $8527cd05038b1b96$export$411ce8e5a71e3069(a, b) {
    try {
        return $8527cd05038b1b96$var$check(a, b);
    } finally{
        $8527cd05038b1b96$var$previousComparisons.clear();
    }
}
function $8527cd05038b1b96$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $8527cd05038b1b96$var$toString.call(a);
    var bTag = $8527cd05038b1b96$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$8527cd05038b1b96$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$8527cd05038b1b96$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$8527cd05038b1b96$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $8527cd05038b1b96$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $8527cd05038b1b96$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $8527cd05038b1b96$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $8527cd05038b1b96$export$2e2bcd8739ae039 = $8527cd05038b1b96$export$411ce8e5a71e3069;

});


parcelRegister("clSzL", function(module, exports) {

$parcel$export(module.exports, "makePromise", () => makePromise);
$parcel$export(module.exports, "fromError", () => fromError);
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "from", () => from);
$parcel$export(module.exports, "split", () => split);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("aS6b9")).default);

var $aS6b9 = parcelRequire("aS6b9");

var $1DiV8 = parcelRequire("1DiV8");

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $1DiV8.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $3VFsf.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $aS6b9.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $aS6b9.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $jojW6.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $3VFsf.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $3VFsf.__assign)({}, context, next(context));
        else context = (0, $3VFsf.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $3VFsf.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $aS6b9.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $aS6b9.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $aS6b9.default).of() : rightLink.request(operation) || (0, $aS6b9.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $aS6b9.default).of() : rightLink.request(operation, forward) || (0, $aS6b9.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $aS6b9.default).of();
        }) || (0, $aS6b9.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $aS6b9.default).of();
        }) || (0, $aS6b9.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $1DiV8.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $aS6b9.default).of();
}

});
parcelRegister("aS6b9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ea3bd7f736c1eb4$export$2e2bcd8739ae039);

var $4osjv = parcelRequire("4osjv");
var $7ea3bd7f736c1eb4$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($4osjv)));
var $7ea3bd7f736c1eb4$export$2e2bcd8739ae039 = $7ea3bd7f736c1eb4$export$77cea355fa80b5f4;

});
parcelRegister("4osjv", function(module, exports) {

module.exports = (parcelRequire("k0hXK")).Observable;

});
parcelRegister("k0hXK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $e901bdc1c9a5edd7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e901bdc1c9a5edd7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e901bdc1c9a5edd7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $e901bdc1c9a5edd7$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $e901bdc1c9a5edd7$var$hasSymbol = function(name) {
    return $e901bdc1c9a5edd7$var$hasSymbols() && Boolean(Symbol[name]);
};
var $e901bdc1c9a5edd7$var$getSymbol = function(name) {
    return $e901bdc1c9a5edd7$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($e901bdc1c9a5edd7$var$hasSymbols() && !$e901bdc1c9a5edd7$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $e901bdc1c9a5edd7$var$SymbolIterator = $e901bdc1c9a5edd7$var$getSymbol('iterator');
var $e901bdc1c9a5edd7$var$SymbolObservable = $e901bdc1c9a5edd7$var$getSymbol('observable');
var $e901bdc1c9a5edd7$var$SymbolSpecies = $e901bdc1c9a5edd7$var$getSymbol('species'); // === Abstract Operations ===
function $e901bdc1c9a5edd7$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $e901bdc1c9a5edd7$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$e901bdc1c9a5edd7$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $e901bdc1c9a5edd7$var$Observable;
}
function $e901bdc1c9a5edd7$var$isObservable(x) {
    return x instanceof $e901bdc1c9a5edd7$var$Observable; // SPEC: Brand check
}
function $e901bdc1c9a5edd7$var$hostReportError(e) {
    if ($e901bdc1c9a5edd7$var$hostReportError.log) $e901bdc1c9a5edd7$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $e901bdc1c9a5edd7$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $e901bdc1c9a5edd7$var$hostReportError(e);
        }
    });
}
function $e901bdc1c9a5edd7$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $e901bdc1c9a5edd7$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $e901bdc1c9a5edd7$var$hostReportError(e);
    }
}
function $e901bdc1c9a5edd7$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $e901bdc1c9a5edd7$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $e901bdc1c9a5edd7$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $e901bdc1c9a5edd7$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $e901bdc1c9a5edd7$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $e901bdc1c9a5edd7$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $e901bdc1c9a5edd7$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $e901bdc1c9a5edd7$var$enqueue(function() {
            return $e901bdc1c9a5edd7$var$flushSubscription(subscription);
        });
        return;
    }
    $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value);
}
var $e901bdc1c9a5edd7$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $e901bdc1c9a5edd7$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $e901bdc1c9a5edd7$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $e901bdc1c9a5edd7$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $e901bdc1c9a5edd7$var$closeSubscription(this);
                    $e901bdc1c9a5edd7$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $e901bdc1c9a5edd7$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $e901bdc1c9a5edd7$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $e901bdc1c9a5edd7$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $e901bdc1c9a5edd7$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $e901bdc1c9a5edd7$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $e901bdc1c9a5edd7$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $e901bdc1c9a5edd7$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $e901bdc1c9a5edd7$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($e901bdc1c9a5edd7$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($e901bdc1c9a5edd7$var$hasSymbol('iterator')) {
                    method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $e901bdc1c9a5edd7$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $e901bdc1c9a5edd7$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $e901bdc1c9a5edd7$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $e901bdc1c9a5edd7$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $e901bdc1c9a5edd7$var$Observable;
if ($e901bdc1c9a5edd7$var$hasSymbols()) Object.defineProperty($e901bdc1c9a5edd7$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $e901bdc1c9a5edd7$var$SymbolObservable,
        hostReportError: $e901bdc1c9a5edd7$var$hostReportError
    },
    configurable: true
});

});






parcelRegister("8UpTw", function(module, exports) {

$parcel$export(module.exports, "ErrorPage", () => $5a72c35b5a5b98e9$export$c120a0e80fd44ca6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $beRD7 = parcelRequire("beRD7");
const $5a72c35b5a5b98e9$export$c120a0e80fd44ca6 = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5a72c35b5a5b98e9$var$ErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.JSErrorPageAsync), {
        error: error
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5a72c35b5a5b98e9$var$ErrorWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhkvuon _syaz1fxt",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8dXDG", function(module, exports) {

$parcel$export(module.exports, "useExperienceAbort", () => $2df1decadd95b490$export$cc92b7ce453f4403);

var $5uXOq = parcelRequire("5uXOq");

var $l9g16 = parcelRequire("l9g16");
const $2df1decadd95b490$export$cc92b7ce453f4403 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $l9g16.useExperienceContext)();
    const self = (0, $5uXOq.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $5uXOq.useCallback)((reason, extraAttributes = {})=>{
        const { current: current } = self;
        current.experienceTracker.abort({
            name: current.name,
            reason: reason,
            attributes: {
                ...current.attributes,
                ...extraAttributes
            }
        });
    }, [
        self
    ]);
};

});


parcelRegister("eiWbj", function(module, exports) {

$parcel$export(module.exports, "useRenameProject", () => $a0762bc644784a95$export$b7c373d314ddf2d4);

var $1S0sy = parcelRequire("1S0sy");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $j5YhT = parcelRequire("j5YhT");

var $cbTlr = parcelRequire("cbTlr");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $koeKL = parcelRequire("koeKL");

var $erN97 = parcelRequire("erN97");

var $1pO5h = parcelRequire("1pO5h");
const $a0762bc644784a95$export$b7c373d314ddf2d4 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $1S0sy.default));
    const updateProjectName = (0, $5uXOq.useCallback)((projectId, name)=>{
        if (!projectId) return;
        const nameUpdater = (store)=>{
            const ari = (0, $j5YhT.JiraProjectAri).create({
                siteId: cloudId,
                projectId: String(projectId)
            });
            const relayDataId = (0, $erN97.default)({
                id: ari
            }, 'JiraProject');
            if (!relayDataId) return;
            const project = store.get(relayDataId);
            if (project) project.setValue(name, 'name');
        };
        commitMutation({
            variables: {
                cloudId: cloudId,
                projectIdOrKey: String(projectId),
                name: name
            },
            optimisticUpdater: nameUpdater,
            updater: (store, response)=>{
                if (response?.jira?.updateProjectName?.success) nameUpdater(store);
            },
            onCompleted: (response)=>{
                const { success: success, errors: errors } = response?.jira?.updateProjectName ?? {};
                const error = errors?.find((e)=>e.message);
                if (success) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectName updated');
                else if (error) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectName update failed', {
                    error: error
                });
            }
        });
    }, [
        commitMutation,
        cloudId,
        createAnalyticsEvent
    ]);
    const validate = async (title, newValue)=>{
        try {
            const { errors: errors } = await (0, $cbTlr.get)('', newValue);
            if (errors.projectName) {
                // There's an error if the value is being updated to an existing project
                // name, but we can skip this if the value is the current project name
                if (newValue === title) return undefined;
                return errors.projectName;
            }
            return undefined;
        } catch  {
            return formatMessage((0, $1pO5h.default).updateProjectNameError);
        }
    };
    return {
        updateProjectName: updateProjectName,
        validateProjectName: validate
    };
};

});
parcelRegister("1S0sy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e908b36f47dbb646$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e550624a49ec1599712f23219d7f23c2>>
 * @relayHash 217a5bb199f8825080efb681bb8ec334
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5852ecb5e0195697ebd5fec84b359f25931f5c11bda87e1e8dbc09fa60dd3737
const $e908b36f47dbb646$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "name"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v3 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "name",
                    "variableName": "name"
                },
                {
                    "kind": "Variable",
                    "name": "projectIdOrKey",
                    "variableName": "projectIdOrKey"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v7 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "renameProjectOldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectUpdateNameMutationPayload",
                            "kind": "LinkedField",
                            "name": "updateProjectName",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "renameProjectOldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectUpdateNameMutationPayload",
                            "kind": "LinkedField",
                            "name": "updateProjectName",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5852ecb5e0195697ebd5fec84b359f25931f5c11bda87e1e8dbc09fa60dd3737",
            "metadata": {},
            "name": "renameProjectOldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$e908b36f47dbb646$var$node.hash = "91d7ce8e0e3b5d5e974924a07230b8dc";
var $e908b36f47dbb646$export$2e2bcd8739ae039 = $e908b36f47dbb646$var$node;

});

parcelRegister("cbTlr", function(module, exports) {

$parcel$export(module.exports, "constructEndpoint", () => $e9cd8f4f70921922$export$a5b7a8c3b1c6e775);
$parcel$export(module.exports, "get", () => $e9cd8f4f70921922$export$3988ae62b71be9a3);

var $eusud = parcelRequire("eusud");
const $e9cd8f4f70921922$export$a5b7a8c3b1c6e775 = (baseUrl, projectName)=>`/rest/simplified/latest/project/validate?projectName=${encodeURIComponent(projectName)}`;
const $e9cd8f4f70921922$export$3988ae62b71be9a3 = (baseUrl, projectKey, abortSignal)=>{
    const url = $e9cd8f4f70921922$export$a5b7a8c3b1c6e775(baseUrl, projectKey);
    return (0, $eusud.performGetRequest)(url, {
        signal: abortSignal
    });
};

});

parcelRegister("koeKL", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $559e3c14e9652b55$export$9da0f7c65f28ed16);

var $9OXo1 = parcelRequire("9OXo1");
const $559e3c14e9652b55$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});

parcelRegister("1pO5h", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d31b68fdfab3fba$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0d31b68fdfab3fba$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    updateProjectNameError: {
        "id": "horizontal-nav-common.services.rename-project.update-project-name-error",
        "defaultMessage": "We couldn't update your project name. Try again."
    }
});

});


parcelRegister("lPApw", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $fd44cc0bd2bece63$export$4a39035bacc4ed76);
$parcel$export(module.exports, "useProjectConnectItems", () => $fd44cc0bd2bece63$export$f23d0c24c77d7608);
$parcel$export(module.exports, "useProjectReportsConnectItems", () => $fd44cc0bd2bece63$export$a1c75c386c088992);
$parcel$export(module.exports, "useProjectSettingsConnectItems", () => $fd44cc0bd2bece63$export$41a50100db18b578);
$parcel$export(module.exports, "useProjectSettingsForgeItems", () => $fd44cc0bd2bece63$export$84761bbf25a4f51f);

var $18FbX = parcelRequire("18FbX");

var $7OqB4 = parcelRequire("7OqB4");

var $hWtQt = parcelRequire("hWtQt");

var $jfqNX = parcelRequire("jfqNX");

var $gZbSF = parcelRequire("gZbSF");

var $6hMYg = parcelRequire("6hMYg");

var $bkw8F = parcelRequire("bkw8F");
const $fd44cc0bd2bece63$export$4a39035bacc4ed76 = (0, $7OqB4.withThrowOnError)((0, $bkw8F.useFeatures));
const $fd44cc0bd2bece63$export$f23d0c24c77d7608 = (0, $7OqB4.withThrowOnError)((0, $gZbSF.useProjectConnectItems));
const $fd44cc0bd2bece63$export$a1c75c386c088992 = (0, $7OqB4.withThrowOnError)((0, $hWtQt.useProjectReportsConnectItems));
const $fd44cc0bd2bece63$export$41a50100db18b578 = (0, $7OqB4.withThrowOnError)((0, $jfqNX.useProjectSettingsConnectItems));
const $fd44cc0bd2bece63$export$84761bbf25a4f51f = (0, $6hMYg.useProjectSettingsForgeAppsForMenu);
const $fd44cc0bd2bece63$export$96e8a0c1f4717705 = (0, $7OqB4.withThrowOnError)((0, $18FbX.useJiraWorkManagementProjectPagesLink));

});
parcelRegister("18FbX", function(module, exports) {

$parcel$export(module.exports, "useJiraSoftwareProjectPagesLink", () => $066b0551287c1b35$export$50628ae0ad1a35f2);
$parcel$export(module.exports, "useJiraWorkManagementProjectPagesLink", () => $066b0551287c1b35$export$96e8a0c1f4717705);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $1J3t1 = parcelRequire("1J3t1");
const $066b0551287c1b35$var$pagesLinkBaseUrl = (baseUrl, projectKey)=>`${baseUrl}/rest/projects/1.0/pageslink/${projectKey}`;
const $066b0551287c1b35$var$enablePagesLinkUrl = (baseUrl, projectKey)=>`${$066b0551287c1b35$var$pagesLinkBaseUrl(baseUrl, projectKey)}/enable`;
const $066b0551287c1b35$var$disablePagesLinkUrl = (baseUrl, projectKey)=>`${$066b0551287c1b35$var$pagesLinkBaseUrl(baseUrl, projectKey)}/disable`;
const $066b0551287c1b35$var$setPagesLinkService = ({ baseUrl: baseUrl, projectKey: projectKey, enable: enable })=>enable ? (0, $eusud.performPutRequest)($066b0551287c1b35$var$enablePagesLinkUrl(baseUrl, projectKey)) : (0, $eusud.performPutRequest)($066b0551287c1b35$var$disablePagesLinkUrl(baseUrl, projectKey));
const $066b0551287c1b35$var$isProjectOrJiraAdmin = (permissionInfo)=>permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
const $066b0551287c1b35$export$50628ae0ad1a35f2 = ()=>{
    const { data: data, loading: loading, refresh: refresh, error: error } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const setPagesLink = (0, $5uXOq.useCallback)(async (...args)=>{
        await $066b0551287c1b35$var$setPagesLinkService(...args);
        await refresh();
    }, [
        refresh
    ]);
    return {
        data: {
            isEnabled: data?.hasPages === true,
            canEdit: data?.permissionInfo != null && $066b0551287c1b35$var$isProjectOrJiraAdmin(data.permissionInfo),
            pending: loading,
            setPagesLink: setPagesLink
        },
        loading: loading,
        error: error
    };
};
const $066b0551287c1b35$export$96e8a0c1f4717705 = ()=>{
    const { loading: loading, refresh: refresh, error: error } = (0, $1J3t1.useJiraWorkmanagementProjectNavigation)();
    const setPagesLink = (0, $5uXOq.useCallback)(async (...args)=>{
        await $066b0551287c1b35$var$setPagesLinkService(...args);
        await refresh();
    }, [
        refresh
    ]);
    return {
        data: {
            isEnabled: true,
            canEdit: false,
            pending: loading,
            setPagesLink: setPagesLink
        },
        loading: loading,
        error: error
    };
};

});

parcelRegister("7OqB4", function(module, exports) {

$parcel$export(module.exports, "withThrowOnError", () => $f0eadb98e9fdd0d1$export$a018832f2ec4dc91);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $gKZoD = parcelRequire("gKZoD");
const $f0eadb98e9fdd0d1$var$isDataEmpty = (data)=>data == null;
function $f0eadb98e9fdd0d1$export$a018832f2ec4dc91(theHook) {
    return (...args)=>{
        // tests like src/packages/navigation-apps/horizontal-nav/tabs/board-scoped-tab/src/test.tsx do not work without this line
        (0, $gKZoD.di)(theHook);
        const result = theHook(...args);
        // escalate .error if condition is met (by throwing a runtime exception from it; to be caught and logged by the nearest ErrorBoundary for example).
        if (!false && $f0eadb98e9fdd0d1$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
        return result;
    };
}

});

parcelRegister("hWtQt", function(module, exports) {

$parcel$export(module.exports, "useProjectReportsConnectItems", () => $a740427f233367ba$export$a1c75c386c088992);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
const $a740427f233367ba$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $a740427f233367ba$export$a1c75c386c088992 = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectReportsSidebarConnectNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data != null ? data.map((0, $5W6pd.transformLinkV4)).filter(Boolean) : [], [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $a740427f233367ba$var$findItemAndStackMemo(items, route.name, location, [
            'reports'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        error: error,
        loading: loading,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});
parcelRegister("7tsV0", function(module, exports) {

$parcel$export(module.exports, "findItemAndStack", () => $93fa8c16baad19b1$export$751e2e6237002565);

var $ajpes = parcelRequire("ajpes");

var $k0iPT = parcelRequire("k0iPT");
// JSPA-1062 remove qs items that might not always be there
const $93fa8c16baad19b1$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $93fa8c16baad19b1$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $93fa8c16baad19b1$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
    let found = null;
    if (!(0, $k0iPT.CONNECT_ROUTES_SET).has(routeName)) return found;
    const locationQuery = $93fa8c16baad19b1$var$splitRelevantQs(location.search);
    items.some((item)=>{
        const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
        const itemQuery = $93fa8c16baad19b1$var$splitRelevantQs(itemQs);
        const sameQuery = $93fa8c16baad19b1$var$isSameQuery(locationQuery, itemQuery);
        if (item.section !== true && itemPath === location.pathname && sameQuery) {
            found = {
                stack: parentStack,
                selected: item
            };
            return true;
        }
        if (item.items) {
            const stack = item.section === true ? parentStack : parentStack.concat(item.id);
            found = $93fa8c16baad19b1$export$751e2e6237002565(item.items, routeName, location, stack);
        }
        return Boolean(found);
    });
    return found;
};

});
parcelRegister("k0iPT", function(module, exports) {

$parcel$export(module.exports, "JWM_OVERVIEWS_ROUTE_SET", () => $c82776b15970ab04$export$a8aac2ba4dc1f57);
$parcel$export(module.exports, "CONNECT_ROUTES_SET", () => $c82776b15970ab04$export$c47bf667d3008c53);
$parcel$export(module.exports, "JSM_BOARD_ROUTES_SET", () => $c82776b15970ab04$export$50c2d6bcb0b94b74);
const $c82776b15970ab04$export$a8aac2ba4dc1f57 = new Set([
    'classic-business-overview-summary',
    'classic-business-overview-calendar',
    'classic-business-overview-timeline',
    'classic-business-overview-redirect'
]);
const $c82776b15970ab04$export$c47bf667d3008c53 = new Set([
    'connect-project',
    'connect-general',
    'connect-general-service-desk-project',
    'legacy-connect-project',
    'legacy-connect-general'
]);
const $c82776b15970ab04$export$50c2d6bcb0b94b74 = new Set([
    'servicedesk-boards',
    'servicedesk-queues-views-config',
    'servicedesk-practice-views-config'
]);

});


parcelRegister("5W6pd", function(module, exports) {

$parcel$export(module.exports, "transformLink", () => $1efacbf40a7b73c8$export$5a32dc366b1d641f);
$parcel$export(module.exports, "transformLinkV4", () => $1efacbf40a7b73c8$export$27267b6b6650eaa5);
const $1efacbf40a7b73c8$export$5a32dc366b1d641f = (link)=>{
    const items = link.links && link.links.length ? link.links.map($1efacbf40a7b73c8$export$5a32dc366b1d641f).filter(Boolean) : undefined;
    // section item
    if (link.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(link.name)
        };
        return {
            id: link.id,
            name: String(link.name),
            section: !!link.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: link.id,
        name: String(link.name),
        url: link.url,
        iconUrl: link.iconUrl || '',
        styleClass: link.styleClass || '',
        items: items
    };
};
const $1efacbf40a7b73c8$export$27267b6b6650eaa5 = (data)=>{
    const items = data.links && data.links.length ? data.links.map($1efacbf40a7b73c8$export$27267b6b6650eaa5).filter(Boolean) : undefined;
    // section item
    if (data.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(data.name)
        };
        return {
            id: data.id,
            name: String(data.name),
            section: !!data.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: data.id,
        name: String(data.name),
        url: data.url,
        iconUrl: data.iconUrl || '',
        styleClass: data.styleClass || '',
        items: items
    };
};

});


parcelRegister("jfqNX", function(module, exports) {

$parcel$export(module.exports, "useProjectSettingsConnectItems", () => $662340ab1e9d2787$export$41a50100db18b578);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
// use memoised functions per hook to avoid re-computation between same hooks
const $662340ab1e9d2787$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $662340ab1e9d2787$export$41a50100db18b578 = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectSettingsSidebarConnectNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, $5W6pd.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $662340ab1e9d2787$var$findItemAndStackMemo(items, route.name, location, [
            'settings'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("gZbSF", function(module, exports) {

$parcel$export(module.exports, "useProjectConnectItems", () => $fcf7bc53994ae8f3$export$f23d0c24c77d7608);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
const $fcf7bc53994ae8f3$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $fcf7bc53994ae8f3$export$f23d0c24c77d7608 = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectSidebarConnectNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, $5W6pd.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $fcf7bc53994ae8f3$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("6hMYg", function(module, exports) {

$parcel$export(module.exports, "useProjectSettingsForgeApps", () => $2106846b1818d2e6$export$bef2e514007d2f07);
$parcel$export(module.exports, "useProjectSettingsForgeAppsForMenu", () => $2106846b1818d2e6$export$b741e3e3cfb39b82);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $5cmSg = parcelRequire("5cmSg");

var $5bkvv = parcelRequire("5bkvv");

var $dAfqg = parcelRequire("dAfqg");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $2YP9W = parcelRequire("2YP9W");

var $kKdpt = parcelRequire("kKdpt");

var $7Tlti = parcelRequire("7Tlti");
const $2106846b1818d2e6$export$bef2e514007d2f07 = ()=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $5bkvv.forgeProjectSettingsModuleResource));
    const projectSettingsData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionVisible)) || null, [
        data
    ]);
    const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionHiddenByAppAccessRules)) || null, [
        data
    ]);
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const hasPermissions = (0, $5uXOq.useMemo)(()=>(projectContext?.isProjectAdmin || isAdmin || isSiteAdmin) === true, [
        isAdmin,
        isSiteAdmin,
        projectContext?.isProjectAdmin
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: projectSettingsData ? hasPermissions && projectSettingsData || [] : null,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error
        }), [
        projectSettingsData,
        accessNarrowedData,
        loading,
        error,
        hasPermissions
    ]);
};
const $2106846b1818d2e6$var$appsProjectTypeRouteMap = {
    tmp: {
        [(0, $2vSU6.CORE_PROJECT)]: 'core',
        [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software',
        [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'servicedesk',
        // it's genuinely missing Jira Product Discovery and CUSTOMER_SERVICE_PROJECT support
        [(0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)]: undefined,
        [(0, $2vSU6.CUSTOMER_SERVICE_PROJECT)]: undefined
    },
    cmp: {
        [(0, $2vSU6.CORE_PROJECT)]: 'core',
        [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software/c',
        [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'servicedesk',
        [(0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)]: undefined,
        [(0, $2vSU6.CUSTOMER_SERVICE_PROJECT)]: undefined
    }
};
const $2106846b1818d2e6$export$ed6342e0e28465a6 = (extension, projectType, projectKey, isSimplified)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/${$2106846b1818d2e6$var$appsProjectTypeRouteMap[isSimplified ? 'tmp' : 'cmp'][projectType]}/projects/${projectKey}/settings/apps/${appId}/${envId}`;
};
const $2106846b1818d2e6$export$b741e3e3cfb39b82 = (routeName, parentStack)=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { data: data, loading: loading, error: error } = $2106846b1818d2e6$export$bef2e514007d2f07();
    const stack = (0, $kKdpt.useForgeItemStack)(data, routeName, parentStack);
    const { projectType: projectType, projectKey: projectKey, simplified: isSimplified } = projectContext || {};
    return (0, $5uXOq.useMemo)(()=>({
            data: data ? data.map((extension)=>({
                    id: extension.id,
                    // @ts-expect-error - TS2345 - Argument of type 'ProjectType | undefined' is not assignable to parameter of type 'ProjectType'.
                    url: $2106846b1818d2e6$export$ed6342e0e28465a6(extension, projectType, projectKey, isSimplified),
                    name: extension.properties.title,
                    iconUrl: extension.properties.icon,
                    environmentType: extension.environmentType,
                    environmentKey: extension.environmentKey,
                    moduleName: (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE),
                    sections: (0, $7Tlti.toSections)(extension)
                })) : null,
            loading: loading,
            error: error,
            stack: stack
        }), [
        data,
        loading,
        error,
        stack,
        projectType,
        projectKey,
        isSimplified
    ]);
};

});
parcelRegister("5cmSg", function(module, exports) {

$parcel$export(module.exports, "isExtensionVisible", () => $30771269db74e480$export$41e48b53c2cc2013);
$parcel$export(module.exports, "isExtensionHidden", () => $30771269db74e480$export$3f5b3e61d567ef3);
$parcel$export(module.exports, "isExtensionHiddenByAppAccessRules", () => $30771269db74e480$export$5c38dfa9d1f96e61);
const $30771269db74e480$export$41e48b53c2cc2013 = (extension)=>!extension.hiddenBy;
const $30771269db74e480$export$3f5b3e61d567ef3 = (extension)=>!!extension.hiddenBy;
const $30771269db74e480$export$5c38dfa9d1f96e61 = (extension)=>extension.hiddenBy === 'AppAccessRules';
const $30771269db74e480$export$3cc53b8cca25d64 = (extension)=>extension.hiddenBy === 'DisplayConditions';

});

parcelRegister("dAfqg", function(module, exports) {

$parcel$export(module.exports, "useProjectContext", () => $0baaa0dcf730951a$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $0baaa0dcf730951a$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $0baaa0dcf730951a$export$a85f6b5857d2176);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dxCvy = parcelRequire("dxCvy");
const $0baaa0dcf730951a$export$8f31c2503e1efa93 = (customContext)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $324W5.useResourceWithCustomRouterContext)((0, $dxCvy.projectContextResourceWithCache), customContext);
    const updateCache = (0, $5uXOq.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $0baaa0dcf730951a$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $0baaa0dcf730951a$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return children(projectContext);
};

});

parcelRegister("cNd4s", function(module, exports) {

$parcel$export(module.exports, "useIsSiteAdmin", () => $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef);

var $9OXo1 = parcelRequire("9OXo1");
const $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isSiteAdmin || false;
};

});

parcelRegister("kKdpt", function(module, exports) {

$parcel$export(module.exports, "useForgeItemStack", () => $dac9c7c54c5ccbb1$export$462f82a278743d46);

var $5uXOq = parcelRequire("5uXOq");

var $c70gQ = parcelRequire("c70gQ");

var $doZTA = parcelRequire("doZTA");

var $7Tlti = parcelRequire("7Tlti");
const $dac9c7c54c5ccbb1$export$462f82a278743d46 = (modules, routeName, parentStack)=>{
    const [{ match: match, route: route }] = (0, $doZTA.useRouter)();
    const matchedExtension = (0, $c70gQ.useMatchedExtension)({
        modules: modules,
        match: match
    });
    return (0, $5uXOq.useMemo)(()=>{
        if (route.name !== routeName) return null;
        // match nested navigation view
        if (matchedExtension && (0, $7Tlti.toSections)(matchedExtension).length) {
            const stackId = `${matchedExtension.id}-subpages`;
            return parentStack ? [
                ...parentStack,
                stackId
            ] : [
                stackId
            ];
        }
        // match a simple navigation item (a single top-level page is defined in the manifest)
        if (matchedExtension && parentStack) return parentStack;
        // skip
        return null;
    }, [
        matchedExtension,
        parentStack,
        route.name,
        routeName
    ]);
};

});
parcelRegister("c70gQ", function(module, exports) {

$parcel$export(module.exports, "useMatchedExtension", () => $b661f1f04cec9385$export$13375c0abccaf6f6);
$parcel$export(module.exports, "useExtensionBasePath", () => $b661f1f04cec9385$export$25abed85383f0fbb);

var $5uXOq = parcelRequire("5uXOq");

var $e0AC8 = parcelRequire("e0AC8");
const $b661f1f04cec9385$export$13375c0abccaf6f6 = ({ modules: modules, match: match })=>(0, $5uXOq.useMemo)(()=>(modules || []).find((app)=>{
            const parsedExtensionId = (0, $e0AC8.parseExtensionId)(app.id);
            return parsedExtensionId.appId === match.params.appId && parsedExtensionId.envId === match.params.envId;
        }), [
        modules,
        match.params.appId,
        match.params.envId
    ]);
const $b661f1f04cec9385$export$25abed85383f0fbb = (baseUrl, route)=>route !== undefined ? baseUrl.replace(/\/?$/, '').slice(0, -route.length - 1) : baseUrl.replace(/\/?$/, '');

});

parcelRegister("7Tlti", function(module, exports) {

$parcel$export(module.exports, "toSections", () => $25b31557e9750c03$export$29678d1e04c0e8c4);

var $8QpSo = parcelRequire("8QpSo");
/**
 * Just in case someone passes a broken object we don't want to blow up the sidebar
 */ const $25b31557e9750c03$var$normalizeSection = (section)=>({
        header: section?.header,
        pages: Array.isArray(section?.pages) ? section.pages.map((page)=>({
                icon: page?.icon,
                route: page?.route,
                title: page?.title
            })) : []
    });
const $25b31557e9750c03$export$29678d1e04c0e8c4 = (0, $8QpSo.default)((extension)=>{
    const { properties: properties } = extension;
    // Only Custom UI supports subpages
    if (typeof properties.resource !== 'string') return [];
    // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.pages !== 'undefined' && properties.pages?.length) // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return [
        {
            pages: properties.pages
        }
    ].map($25b31557e9750c03$var$normalizeSection);
    // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.sections !== 'undefined' && properties.sections?.length) // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return properties.sections.map($25b31557e9750c03$var$normalizeSection);
    return [];
});

});



parcelRegister("bkw8F", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $7fc2f0545f0a83ac$export$4a39035bacc4ed76);
$parcel$export(module.exports, "useSettingFeatures", () => $7fc2f0545f0a83ac$export$56022a3b83c8ed6a);
$parcel$export(module.exports, "useReportFeatures", () => $7fc2f0545f0a83ac$export$4adaea9828b7ff13);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $jIwth = parcelRequire("jIwth");

var $cSUZZ = parcelRequire("cSUZZ");

var $daoB1 = parcelRequire("daoB1");

var $d4FZj = parcelRequire("d4FZj");
const $7fc2f0545f0a83ac$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useJiraWorkmanagementProjectNavigation)();
    const isPremiumUserSeat = (0, $cSUZZ.useIsPremiumUserSeat)();
    const transformedData = (0, $5uXOq.useMemo)(()=>data && (0, $d4FZj.getExtraData)(data, isPremiumUserSeat), [
        data,
        isPremiumUserSeat
    ]);
    return {
        data: transformedData,
        loading: loading,
        error: error
    };
};
const $7fc2f0545f0a83ac$export$56022a3b83c8ed6a = ()=>{
    const hasActiveSoftwareAccess = (0, $jIwth.useHasActiveSoftwareAccess)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useJiraWorkmanagementProjectNavigation)();
    const transformedData = (0, $5uXOq.useMemo)(()=>data && (0, $d4FZj.getExtraSettingsData)(data, hasActiveSoftwareAccess), [
        data,
        hasActiveSoftwareAccess
    ]);
    return {
        data: transformedData,
        loading: loading,
        error: error
    };
};
const $7fc2f0545f0a83ac$export$4adaea9828b7ff13 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useJiraWorkmanagementProjectNavigation)();
    const { hasSoftwareAccess: hasSoftwareAccess } = (0, $daoB1.useApplicationPermissions)();
    const transformedData = (0, $5uXOq.useMemo)(()=>data && (0, $d4FZj.getExtraReportData)(hasSoftwareAccess), [
        data,
        hasSoftwareAccess
    ]);
    return {
        data: transformedData,
        loading: loading,
        error: error
    };
};

});
parcelRegister("jIwth", function(module, exports) {

$parcel$export(module.exports, "useHasActiveSoftwareAccess", () => $c3adde43a433f1b5$export$895f9b38ce00671e);

var $k9JTq = parcelRequire("k9JTq");

var $daoB1 = parcelRequire("daoB1");
const $c3adde43a433f1b5$export$895f9b38ce00671e = ()=>{
    const { software: software } = (0, $k9JTq.useAppEditions)();
    const { hasSoftwareAccess: hasSoftwareAccess } = (0, $daoB1.useApplicationPermissions)();
    return software !== 'UNLICENSED' && hasSoftwareAccess === true;
};

});
parcelRegister("k9JTq", function(module, exports) {

$parcel$export(module.exports, "useAppEditions", () => $dde261c9da85268a$export$92ed15881fc090d7);

var $9OXo1 = parcelRequire("9OXo1");
const $dde261c9da85268a$export$92ed15881fc090d7 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.appEditions;
};

});

parcelRegister("daoB1", function(module, exports) {

$parcel$export(module.exports, "ApplicationPermissionsSubscriber", () => $77add4b5420e5058$export$d8c76f7e52d0a856);
$parcel$export(module.exports, "useApplicationPermissions", () => $77add4b5420e5058$export$4d9cadb4042acc1b);

var $dGvGJ = parcelRequire("dGvGJ");

var $51nlc = parcelRequire("51nlc");

var $2gywT = parcelRequire("2gywT");

var $9OXo1 = parcelRequire("9OXo1");
const $77add4b5420e5058$var$selector = (0, $dGvGJ.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
        data: {
            applicationPermissions: applicationPermissions
        }
    }));
const $77add4b5420e5058$export$d8c76f7e52d0a856 = (0, $51nlc.createSubscriber)((0, $2gywT.default), {
    displayName: 'ApplicationPermissionsSubscriber',
    selector: $77add4b5420e5058$var$selector
});
const $77add4b5420e5058$export$4d9cadb4042acc1b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.appPermissions;
};

});


parcelRegister("cSUZZ", function(module, exports) {

$parcel$export(module.exports, "licenseDetailsResource_DEPRECATED_DO_NOT_USE", () => $203c641f0a3380f5$export$92c4069b5349d086);
$parcel$export(module.exports, "useIsPremiumUserSeat", () => $203c641f0a3380f5$export$90749419e9042370);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $9dQKJ = parcelRequire("9dQKJ");
const $203c641f0a3380f5$export$92c4069b5349d086 = (0, $2M1hQ.createResource)({
    type: 'BUSINESS_LICENSE_DETAILS',
    getKey: ()=>'BUSINESS_LICENSE_DETAILS',
    getData: async (_routerContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        return (0, $9dQKJ.fetchLicenseDetails)((0, $2993c3eadd0dda3e$export$2b91517d6d5b4365), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity
});
const $203c641f0a3380f5$export$90749419e9042370 = ()=>{
    const { data: data } = (0, $2YP9W.useResource)($203c641f0a3380f5$export$92c4069b5349d086);
    return Boolean(data?.isPremiumUserSeat);
};

});
const $2993c3eadd0dda3e$export$2b91517d6d5b4365 = `
query JiraBusinessLicenseDetails($cloudId:ID!) {
  jira {
    jwmLicensing(cloudId: $cloudId) {
      currentUserSeatEdition
    }
  }
}
`;

parcelRegister("9dQKJ", function(module, exports) {

$parcel$export(module.exports, "fetchLicenseDetails", () => $164a09ef89830ae9$export$ec058a82eccb31e);

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $164a09ef89830ae9$var$EMPTY_RESPONSE = {
    isPremiumUserSeat: false
};
const $164a09ef89830ae9$export$ec058a82eccb31e = async (query, { cloudId: cloudId })=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        return {
            isPremiumUserSeat: response.data?.jira?.jwmLicensing?.currentUserSeatEdition === 'PREMIUM'
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessLicenseDetails', 'Something went wrong while fetching the license details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $jcw0u.default)({
            meta: {
                id: 'licenseDetailsResource',
                packageName: 'jiraRouterResourcesBusinessLicenseDetails',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $164a09ef89830ae9$var$EMPTY_RESPONSE;
};

});


parcelRegister("d4FZj", function(module, exports) {

$parcel$export(module.exports, "getExtraData", () => $acf9418ce967848e$export$6c55c6c980ed2046);
$parcel$export(module.exports, "getExtraSettingsData", () => $acf9418ce967848e$export$b77a5597b7177cfb);
$parcel$export(module.exports, "getExtraReportData", () => $acf9418ce967848e$export$be58a1e7b06d1d3);

var $6s1PB = parcelRequire("6s1PB");
const $acf9418ce967848e$export$6c55c6c980ed2046 = (data, isPremium)=>{
    const { permissionInfo: permissionInfo, hasComponents: hasComponents = false, project: project } = data;
    const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = permissionInfo;
    const isProjectOrJiraAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true || isAdmin;
    const isSimplifiedProject = project.simplified;
    const hasSettings = isAdmin || projectPermissionsQueried.ADMINISTER_PROJECTS || projectPermissionsQueried.EDIT_ISSUE_LAYOUT || projectPermissionsQueried.EDIT_WORKFLOW;
    return {
        hasVersions: true,
        hasSettings: hasSettings,
        hasBoard: true,
        hasReports: true,
        hasAddItem: isProjectOrJiraAdmin,
        hasComponents: hasComponents,
        hasIssues: true,
        hasSummary: true,
        hasPages: true,
        hasChangeTheme: isProjectOrJiraAdmin,
        hasApprovals: isSimplifiedProject && (isPremium || isProjectOrJiraAdmin)
    };
};
const $acf9418ce967848e$export$b77a5597b7177cfb = (data, hasActiveSoftwareAccess)=>{
    const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = data.permissionInfo;
    const isProjectAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    const isProjectOrJiraAdmin = isProjectAdmin || isAdmin;
    const isCMPProject = !data.project.simplified;
    const hasEditWorkflowPermissions = projectPermissionsQueried.EDIT_WORKFLOW === true;
    const hasIssueLayoutPermissions = projectPermissionsQueried.EDIT_ISSUE_LAYOUT === true;
    const hasDetails = isProjectOrJiraAdmin;
    const hasPeople = isProjectOrJiraAdmin;
    const hasIssueTypes = isAdmin;
    let hasAutomation = true;
    let hasSummary = true;
    let hasWorkflows = true;
    let hasScreens = true;
    /*
	 * SettingFeatures.hasSystemFieldsConfiguration and hasProjectEfaFields both
	 * show/hide a navigation menu item named "Fields".
	 *
	 * - `hasSystemFieldsConfiguration` is CMP specific; shows the
	 * "System Default Field Configuration" page which is visible by default
	 * - `hasProjectEfaFields` is TMP specific; only shows Project Fields page
	 * under certain circumstances.
	 */ let hasSystemFieldsConfiguration = true;
    let hasProjectEfaFields = false;
    let hasVersions = true;
    let hasComponents = true;
    let hasPermissions = true;
    let hasIssueSecurity = true;
    let hasNotifications = true;
    let hasIssueCollectors = true;
    let hasIssueLayout = true;
    const hasDevtools = isProjectAdmin && hasActiveSoftwareAccess;
    hasAutomation = isProjectOrJiraAdmin;
    hasSummary = isProjectOrJiraAdmin;
    hasWorkflows = hasEditWorkflowPermissions || isProjectOrJiraAdmin;
    hasScreens = isProjectOrJiraAdmin;
    hasSystemFieldsConfiguration = isCMPProject && isProjectOrJiraAdmin;
    hasVersions = isProjectOrJiraAdmin;
    hasComponents = isProjectOrJiraAdmin;
    hasPermissions = isProjectOrJiraAdmin;
    hasIssueSecurity = isProjectOrJiraAdmin;
    hasNotifications = isProjectOrJiraAdmin;
    hasIssueCollectors = isProjectOrJiraAdmin;
    hasIssueLayout = hasIssueLayoutPermissions || isProjectOrJiraAdmin;
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('efa_and_project_fields_page_for_tmp');
    if (expConfig.get('isEnabled', false)) hasProjectEfaFields = !isCMPProject && isProjectOrJiraAdmin && !!data.hasExplicitFieldAssociationsEnabled;
    return {
        hasAutomation: hasAutomation,
        hasProjectGroupOneSection: hasDetails || hasPeople || hasSummary,
        hasIssueConfigSection: hasIssueTypes,
        hasProjectGroupTwoSection: hasWorkflows || hasScreens || hasSystemFieldsConfiguration,
        hasProjectGroupThreeSection: hasVersions || hasComponents,
        hasProjectGroupFourSection: hasPermissions || hasIssueSecurity || hasNotifications,
        hasgetIssueCollectorSection: hasIssueCollectors,
        hasComponents: hasComponents,
        hasDetails: hasDetails,
        hasSystemFieldsConfiguration: hasSystemFieldsConfiguration,
        hasProjectEfaFields: hasProjectEfaFields,
        hasIssueCollectors: hasIssueCollectors,
        hasIssueSecurity: hasIssueSecurity,
        hasIssueTypes: hasIssueTypes,
        hasNotifications: hasNotifications,
        hasPeople: hasPeople,
        hasPermissions: hasPermissions,
        hasScreens: hasScreens,
        hasSummary: hasSummary,
        hasVersions: hasVersions,
        hasWorkflows: hasWorkflows,
        hasDevtools: hasDevtools,
        hasIssueLayout: hasIssueLayout
    };
};
const $acf9418ce967848e$export$be58a1e7b06d1d3 = (hasSoftwareAccess)=>({
        hasDeveloperWorkload: true,
        hasForcastSection: true,
        hasTimeTracking: true,
        hasVersionWorkloadReport: hasSoftwareAccess
    });

});



parcelRegister("hUYIv", function(module, exports) {

$parcel$export(module.exports, "NavigationKitAvatar", () => $64f885dfca1a150b$export$51803d203e8fe5b8);

var $5uXOq = parcelRequire("5uXOq");

var $ePNUn = parcelRequire("ePNUn");

var $4bUrz = parcelRequire("4bUrz");
const $64f885dfca1a150b$export$51803d203e8fe5b8 = ({ projectId: projectId, selectedAvatarUrl: selectedAvatarUrl, canEdit: canEdit })=>{
    const { systemAvatars: systemAvatars, latestCustomAvatar: latestCustomAvatar, updateProjectAvatar: updateProjectAvatar, uploadProjectAvatar: uploadProjectAvatar } = (0, $ePNUn.useUpdateProjectAvatar)(projectId, selectedAvatarUrl);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bUrz.NavigationKitAvatarPopup), {
        selectedAvatarUrl: selectedAvatarUrl,
        systemAvatars: systemAvatars,
        latestCustomAvatar: latestCustomAvatar,
        onSelectAvatar: updateProjectAvatar,
        onUploadAvatar: uploadProjectAvatar,
        canEdit: canEdit
    });
};

});
parcelRegister("ePNUn", function(module, exports) {

$parcel$export(module.exports, "useUpdateProjectAvatar", () => $9c40726a7d95ff55$export$e5aba91cdac71620);

var $lY09W = parcelRequire("lY09W");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $j5YhT = parcelRequire("j5YhT");

var $iKWKg = parcelRequire("iKWKg");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $koeKL = parcelRequire("koeKL");

var $erN97 = parcelRequire("erN97");
const $9c40726a7d95ff55$export$e5aba91cdac71620 = (projectId, selectedAvatarUrl)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { selectedAvatar: selectedAvatar, systemAvatars: systemAvatars, customAvatars: customAvatars, latestCustomAvatar: latestCustomAvatar, setLatestCustomAvatar: setLatestCustomAvatar, uploadCustomerIcon: uploadCustomerIcon } = (0, $iKWKg.useAvatars)(projectId, selectedAvatarUrl);
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $lY09W.default));
    const getAvatarUrlFromId = (0, $5uXOq.useCallback)((newAvatarId)=>{
        const url = selectedAvatarUrl.substring(0, selectedAvatarUrl.lastIndexOf('/'));
        return `${url}/${String(newAvatarId)}`;
    }, [
        selectedAvatarUrl
    ]);
    const updateProjectAvatar = (0, $5uXOq.useCallback)((avatarId, avatarUrl, onError)=>{
        if (!projectId || selectedAvatar && avatarUrl === selectedAvatar.dataURI) return;
        const avatarUpdater = (store)=>{
            const ari = (0, $j5YhT.JiraProjectAri).create({
                siteId: cloudId,
                projectId: String(projectId)
            });
            const projectRelayDataId = (0, $erN97.default)({
                id: ari
            }, 'JiraProject');
            if (!projectRelayDataId) return;
            const project = store.get(projectRelayDataId);
            const avatarRelayDataId = (0, $erN97.default)({
                id: ari
            }, 'JiraAvatar');
            if (project && avatarRelayDataId) {
                let avatar = store.get(avatarRelayDataId);
                if (!avatar) avatar = store.create(avatarRelayDataId, 'JiraAvatar');
                avatar.setValue(avatarRelayDataId, 'id');
                avatar.setValue(getAvatarUrlFromId(avatarId), 'large');
                project.setLinkedRecord(avatar, 'avatar');
            }
        };
        commitMutation({
            variables: {
                avatarId: String(avatarId),
                cloudId: cloudId,
                projectIdOrKey: String(projectId)
            },
            optimisticUpdater: avatarUpdater,
            updater: (store, response)=>{
                if (response?.jira?.updateProjectAvatar?.success) avatarUpdater(store);
            },
            onCompleted: (response)=>{
                const { success: success, errors: errors } = response?.jira?.updateProjectAvatar ?? {};
                const error = errors?.find((e)=>e.message);
                if (success) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectAvatarUpdate succeeded');
                else if (error) {
                    onError?.(true);
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectAvatarUpdate failed', {
                        error: error
                    });
                }
            },
            onError: (error)=>{
                onError?.(true);
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectAvatarUpdate failed', {
                    error: error
                });
            }
        });
    }, [
        projectId,
        selectedAvatar,
        commitMutation,
        cloudId,
        getAvatarUrlFromId,
        createAnalyticsEvent
    ]);
    const uploadProjectAvatar = (0, $5uXOq.useCallback)((file, crop, onError)=>{
        return uploadCustomerIcon(projectId, file, crop).then((data)=>{
            const url = getAvatarUrlFromId(data.id);
            updateProjectAvatar(data.id, url, onError);
            setLatestCustomAvatar({
                id: Number(data.id),
                dataURI: url,
                name: ''
            });
        });
    }, [
        uploadCustomerIcon,
        projectId,
        updateProjectAvatar,
        getAvatarUrlFromId,
        setLatestCustomAvatar
    ]);
    return {
        updateProjectAvatar: updateProjectAvatar,
        systemAvatars: systemAvatars,
        customAvatars: customAvatars,
        selectedAvatar: selectedAvatar,
        uploadProjectAvatar: uploadProjectAvatar,
        latestCustomAvatar: latestCustomAvatar
    };
};

});
parcelRegister("lY09W", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fb364d20a6a63ec$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<327a7b44f8a19cda5486d13abdd6d114>>
 * @relayHash 2ee5b8f157e13b76ba7c1a857a40d139
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b153db68626f6b209386872cd3403aa94f560092ec6c6a16dade13c6e1ec8a7d
const $0fb364d20a6a63ec$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "avatarId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIdOrKey"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "avatarId",
                    "variableName": "avatarId"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "projectIdOrKey",
                    "variableName": "projectIdOrKey"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "updateProjectAvatarMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectUpdateAvatarMutationPayload",
                            "kind": "LinkedField",
                            "name": "updateProjectAvatar",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "updateProjectAvatarMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectUpdateAvatarMutationPayload",
                            "kind": "LinkedField",
                            "name": "updateProjectAvatar",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b153db68626f6b209386872cd3403aa94f560092ec6c6a16dade13c6e1ec8a7d",
            "metadata": {},
            "name": "updateProjectAvatarMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0fb364d20a6a63ec$var$node.hash = "1eae1122bad53eeb145073aa6e04966f";
var $0fb364d20a6a63ec$export$2e2bcd8739ae039 = $0fb364d20a6a63ec$var$node;

});

parcelRegister("iKWKg", function(module, exports) {

$parcel$export(module.exports, "useAvatars", () => $7739f22edb0d0427$export$d4b55094163ce82);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $1J3t1 = parcelRequire("1J3t1");

var $4tcSU = parcelRequire("4tcSU");

var $8zOmE = parcelRequire("8zOmE");

var $ddOoS = parcelRequire("ddOoS");

var $gl0PU = parcelRequire("gl0PU");

var $koFzm = parcelRequire("koFzm");


var $36j29 = parcelRequire("36j29");
const $7739f22edb0d0427$export$30d427d8a06a542e = (avatar)=>{
    const avatarId = parseInt(avatar.id, 10);
    return {
        id: avatarId,
        avatarUrl: `/secure/viewavatar?size=xxxlarge@2x&avatarId=${avatarId}&avatarType=project`,
        fileName: avatar?.fileName
    };
};
const $7739f22edb0d0427$export$d3c60b218ff193fd = (projectId)=>(0, $koFzm.famaCatchAndLogFetchError)((0, $eusud.performGetRequest)(`/rest/api/2/universal_avatar/type/project/owner/${projectId}`), (0, $0175358ae1e6c114$export$b8b9d90f9e5bd72b), (0, $gl0PU.toErrorId)('getPredefinedAvatars'), (0, $gl0PU.toErrorMessage)('Failed to fetch avatars for project details')).catch(()=>({
            hasError: true,
            system: [],
            custom: []
        }));
const $7739f22edb0d0427$export$137fdb9263c4dbda = (projectId, avatarId)=>(0, $koFzm.famaCatchAndLogFetchError)((0, $eusud.performPutRequest)(`/rest/api/2/project/${String(projectId)}`, {
        body: JSON.stringify({
            avatarId: avatarId
        })
    }), 'navigation-app', (0, $gl0PU.toErrorId)('updateProjectIcon'), (0, $gl0PU.toErrorMessage)('Failed to update project Icon'));
const $7739f22edb0d0427$export$a9c70f27f3b2b5f3 = (projectId, file, crop)=>{
    const uploadUrl = `/rest/api/2/universal_avatar/type/project/owner/${projectId}` + // we are getting XSRF token from cookies directly because it is not being in the store and can be outdated
    `?atl_token=${(0, $4tcSU.default)() || ''}` + `&x=${Math.floor(crop.x)}` + `&y=${Math.floor(crop.y)}` + `&size=${Math.floor(crop.size)}`;
    return (0, $koFzm.famaCatchAndLogFetchError)((0, $eusud.performPostRequest)(uploadUrl, {
        body: file,
        headers: {}
    }), (0, $0175358ae1e6c114$export$b8b9d90f9e5bd72b), (0, $gl0PU.toErrorId)('uploadProjectAvatar'), (0, $gl0PU.toErrorMessage)('Failed to upload an avatar for project details'));
};
const $7739f22edb0d0427$export$d4b55094163ce82 = (projectId, selectedAvatarUrl)=>{
    const [predefinedSystemAvatars, setPredefinedSystemAvatars] = (0, $5uXOq.useState)([]);
    const [predefinedCustomAvatars, setPredefinedCustomAvatars] = (0, $5uXOq.useState)([]);
    const [latestCustomAvatar, setLatestCustomAvatar] = (0, $5uXOq.useState)(undefined);
    const [fetchingError, setFetchingError] = (0, $5uXOq.useState)(undefined);
    const isFetched = (0, $5uXOq.useRef)(false);
    const { refresh: refresh } = (0, $1J3t1.useProjectSidebarNavigation)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const intl = (0, $koVbs.default)();
    const { formatMessage: formatMessage } = intl;
    (0, $5uXOq.useEffect)(()=>{
        if (isFetched.current) return;
        $7739f22edb0d0427$export$d3c60b218ff193fd(projectId).then((response)=>{
            // need to load xxxlarge icons in AvatarModal
            setPredefinedSystemAvatars(response.system.map((avatar)=>{
                const transformedAvatar = $7739f22edb0d0427$export$30d427d8a06a542e(avatar);
                return {
                    dataURI: transformedAvatar.avatarUrl,
                    name: (0, $ddOoS.getAccessibleAvatarName)(transformedAvatar)(intl),
                    id: transformedAvatar.id
                };
            }));
            setPredefinedCustomAvatars(response.custom.map((avatar)=>{
                const transformedAvatar = $7739f22edb0d0427$export$30d427d8a06a542e(avatar);
                return {
                    dataURI: transformedAvatar.avatarUrl,
                    name: (0, $ddOoS.getAccessibleAvatarName)(transformedAvatar)(intl),
                    id: transformedAvatar.id
                };
            }));
            if (response.custom.length) {
                const lastCustomAvatar = response.custom[response.custom.length - 1];
                const transformedAvatar = $7739f22edb0d0427$export$30d427d8a06a542e(lastCustomAvatar);
                setLatestCustomAvatar({
                    dataURI: transformedAvatar.avatarUrl,
                    name: (0, $ddOoS.getAccessibleAvatarName)(transformedAvatar)(intl),
                    id: transformedAvatar.id
                });
            }
            if (response.hasError) setFetchingError(new Error('There is an error in fetching fetching avatar'));
        }).catch((e)=>{
            setFetchingError(e);
        });
        isFetched.current = true;
    }, [
        isFetched,
        projectId,
        intl
    ]);
    const allAvatars = (0, $5uXOq.useMemo)(()=>[
            ...predefinedSystemAvatars,
            ...predefinedCustomAvatars
        ], [
        predefinedSystemAvatars,
        predefinedCustomAvatars
    ]);
    const selectedAvatar = (0, $5uXOq.useMemo)(()=>{
        const selectedAvatarId = parseInt(selectedAvatarUrl.substring(selectedAvatarUrl.lastIndexOf('/') + 1), 10);
        return allAvatars?.find((avatar)=>avatar.id === selectedAvatarId);
    }, [
        allAvatars,
        selectedAvatarUrl
    ]);
    const onError = (0, $5uXOq.useCallback)(()=>{
        showFlag({
            key: 'update-project-icon-error',
            type: 'error',
            title: formatMessage((0, $36j29.default).updateError),
            messageId: 'navigation-apps-sidebar-inline-config-project-header.services.use-avatars.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        showFlag,
        formatMessage
    ]);
    const updateSelectedAvatar = (0, $5uXOq.useCallback)((avatarUrl, analyticsEvent)=>{
        if (selectedAvatar && avatarUrl === selectedAvatar.dataURI) return;
        const jiraAvatar = allAvatars?.find((avatar)=>avatar.dataURI === avatarUrl);
        if (jiraAvatar) $7739f22edb0d0427$export$137fdb9263c4dbda(projectId, jiraAvatar.id).then(()=>{
            analyticsEvent && (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'project updated', {
                projectType: (0, $2vSU6.SOFTWARE_PROJECT),
                updatedItems: '[projectIcon]'
            });
            refresh();
        })// eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error)=>{
            onError();
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'updateProjectIcon',
                    packageName: 'jiraNavigationAppsSidebarInlineConfigProjectHeader',
                    teamName: 'jlove-makkuro'
                }
            });
        });
    }, [
        selectedAvatar,
        allAvatars,
        projectId,
        refresh,
        onError
    ]);
    const uploadCustomerAvatar = (0, $5uXOq.useCallback)((file, crop, analyticsEvent)=>{
        if (file && crop) $7739f22edb0d0427$export$a9c70f27f3b2b5f3(projectId, file, crop).then((data)=>$7739f22edb0d0427$export$137fdb9263c4dbda(projectId, data.id)).then(()=>{
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'project updated', {
                projectType: (0, $2vSU6.SOFTWARE_PROJECT),
                updatedItems: '[projectIcon]'
            });
            refresh();
        }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error)=>{
            onError();
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'uploadCustomerIcon',
                    packageName: 'jiraNavigationAppsSidebarInlineConfigProjectHeader',
                    teamName: 'jlove-makkuro'
                }
            });
        });
    }, [
        projectId,
        onError,
        refresh
    ]);
    return {
        selectedAvatar: selectedAvatar,
        systemAvatars: predefinedSystemAvatars,
        customAvatars: predefinedCustomAvatars,
        fetchingError: fetchingError,
        updateSelectedAvatar: updateSelectedAvatar,
        uploadCustomerAvatar: uploadCustomerAvatar,
        uploadCustomerIcon: $7739f22edb0d0427$export$a9c70f27f3b2b5f3,
        allAvatars: allAvatars,
        isFetched: isFetched,
        latestCustomAvatar: latestCustomAvatar,
        setLatestCustomAvatar: setLatestCustomAvatar
    };
};

});
parcelRegister("ddOoS", function(module, exports) {

$parcel$export(module.exports, "getAccessibleAvatarName", () => $d91040f0177bcd66$export$b7a0be78db7aa598);

var $hZxwj = parcelRequire("hZxwj");
/**
 * This isn't the greatest of maps. It doesn't guarantee to actually describe all the avatars.
 * It's just the best effort to describe some of the default system avatars.
 * Trouble is that our backend doesn't return any names or alts or anything; all we have are filenames which mostly don't make much sense.
 *
 * See https://hello.atlassian.net/wiki/spaces/~hbegg/pages/1898366234/Updating+Jira+s+project+icons+to+make+them+more+accessible
 *
 * NOTE: this is just a temporary solution, this ticket: https://donut-world-dogfood.atlassian.net/browse/MCRTB-1522 will move this mapping to the back end instead
 *
 * @returns MessageDescriptor if there's an appropriate one; null if the filename is not recognized. If null then use some generic fallback.
 */ const $d91040f0177bcd66$var$filenameToMessageDescriptor = (filename)=>{
    switch(filename){
        case 'project_avatar_alien.svg':
            return (0, $hZxwj.messages).projectAvatarAlien;
        case 'project_avatar_parrot.svg':
            return (0, $hZxwj.messages).projectAvatarParrot;
        case 'project_avatar_cloud.svg':
            return (0, $hZxwj.messages).projectAvatarCloud;
        case 'project_avatar_disc.svg':
            return (0, $hZxwj.messages).projectAvatarDisc;
        case 'project_avatar_code.svg':
            return (0, $hZxwj.messages).projectAvatarCode;
        case 'project_avatar_coffee.svg':
            return (0, $hZxwj.messages).projectAvatarCoffee;
        case 'project_avatar_design.svg':
            return (0, $hZxwj.messages).projectAvatarDesign;
        case 'project_avatar_drill.svg':
            return (0, $hZxwj.messages).projectAvatarDrill;
        case 'project_avatar_food.svg':
            return (0, $hZxwj.messages).projectAvatarFood;
        case 'project_avatar_koala.svg':
            return (0, $hZxwj.messages).projectAvatarKoala;
        case 'project_avatar_mobile.svg':
            return (0, $hZxwj.messages).projectAvatarMobile;
        case 'project_avatar_money.svg':
            return (0, $hZxwj.messages).projectAvatarMoney;
        case 'project_avatar_website.svg':
            return (0, $hZxwj.messages).projectAvatarWebsite;
        case 'project_avatar_nature.svg':
            return (0, $hZxwj.messages).projectAvatarNature;
        case 'project_avatar_notes.svg':
            return (0, $hZxwj.messages).projectAvatarNotes;
        case 'project_avatar_plane.svg':
            return (0, $hZxwj.messages).projectAvatarPlane;
        case 'project_avatar_power.svg':
            return (0, $hZxwj.messages).projectAvatarPower;
        case 'project_avatar_flag.svg':
            return (0, $hZxwj.messages).projectAvatarFlag;
        case 'project_avatar_refresh.svg':
            return (0, $hZxwj.messages).projectAvatarRefresh;
        case 'project_avatar_rocket.svg':
            return (0, $hZxwj.messages).projectAvatarRocket;
        case 'project_avatar_science.svg':
            return (0, $hZxwj.messages).projectAvatarScience;
        case 'project_avatar_settings.svg':
            return (0, $hZxwj.messages).projectAvatarSettings;
        case 'project_avatar_spanner.svg':
            return (0, $hZxwj.messages).projectAvatarSpanner;
        case 'project_avatar_storm.svg':
            return (0, $hZxwj.messages).projectAvatarStorm;
        case 'project_avatar_support.svg':
            return (0, $hZxwj.messages).projectAvatarSupport;
        case 'project_avatar_yeti.svg':
            return (0, $hZxwj.messages).projectAvatarYeti;
        default:
            return null;
    }
};
const $d91040f0177bcd66$export$b7a0be78db7aa598 = (avatar)=>{
    if (avatar?.fileName) {
        const messageDescriptor = $d91040f0177bcd66$var$filenameToMessageDescriptor(avatar.fileName);
        if (messageDescriptor) return (intl)=>intl.formatMessage(messageDescriptor);
    }
    // Custom avatars have no alt because customers do not provide any when uploading images
    return ()=>'';
};

});
parcelRegister("hZxwj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $911dca1b9bee6042$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $911dca1b9bee6042$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    projectAvatarAlien: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-alien",
        "defaultMessage": "One-eyed alien in spaceship"
    },
    projectAvatarParrot: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-parrot",
        "defaultMessage": "Smiling bird with yellow beak"
    },
    projectAvatarCloud: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-cloud",
        "defaultMessage": "Happy cloud"
    },
    projectAvatarDisc: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-disc",
        "defaultMessage": "Vinyl record"
    },
    projectAvatarCode: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-code",
        "defaultMessage": "Computer browser"
    },
    projectAvatarCoffee: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-coffee",
        "defaultMessage": "Coffee cup"
    },
    projectAvatarDesign: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-design",
        "defaultMessage": "Painting of landscape resting on easel"
    },
    projectAvatarDrill: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-drill",
        "defaultMessage": "Yellow electric drill"
    },
    projectAvatarFood: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-food",
        "defaultMessage": "Hot dog with mustard"
    },
    projectAvatarKoala: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-koala",
        "defaultMessage": "Smiling koala eating leaf"
    },
    projectAvatarMobile: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-mobile",
        "defaultMessage": "Smartphone with smiley face"
    },
    projectAvatarMoney: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-money",
        "defaultMessage": "Wallet with money sticking out"
    },
    projectAvatarWebsite: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-website",
        "defaultMessage": "Computer browser with cursor in centre"
    },
    projectAvatarNature: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-nature",
        "defaultMessage": "Snow-capped mountains with sun behind"
    },
    projectAvatarNotes: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-notes",
        "defaultMessage": "Notebook with pencil"
    },
    projectAvatarPlane: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-plane",
        "defaultMessage": "Airplane flying skyward"
    },
    projectAvatarPower: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-power",
        "defaultMessage": "Purple and orange battery with plus symbol"
    },
    projectAvatarFlag: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-flag",
        "defaultMessage": "Red flag on pole"
    },
    projectAvatarRefresh: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-refresh",
        "defaultMessage": "Two circular arrows representing refresh icon"
    },
    projectAvatarRocket: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-rocket",
        "defaultMessage": "Rocket flying through space"
    },
    projectAvatarScience: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-science",
        "defaultMessage": "Science bottle full of bubbling red liquid"
    },
    projectAvatarSettings: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-settings",
        "defaultMessage": "Settings control panel with vertical sliders"
    },
    projectAvatarSpanner: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-spanner",
        "defaultMessage": "Silver wrench"
    },
    projectAvatarStorm: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-storm",
        "defaultMessage": "Storm cloud with rain and lightning"
    },
    projectAvatarSupport: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-support",
        "defaultMessage": "Red and white life buoy on blue background"
    },
    projectAvatarYeti: {
        "id": "project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-yeti",
        "defaultMessage": "Frowning abominable snowman"
    }
});

});


parcelRegister("gl0PU", function(module, exports) {

$parcel$export(module.exports, "toErrorId", () => $b5e194c6e2cc34cd$export$706bbe4209d93dfe);
$parcel$export(module.exports, "toErrorMessage", () => $b5e194c6e2cc34cd$export$95506c204c060a3);
// Package name to be used in famaCatchAndLogFetchError and logError utils
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $b5e194c6e2cc34cd$export$706bbe4209d93dfe = (id)=>id;
const $b5e194c6e2cc34cd$export$95506c204c060a3 = (message)=>message;

});

parcelRegister("koFzm", function(module, exports) {

$parcel$export(module.exports, "famaCatchAndLogFetchError", () => $eb8b95f475174133$export$c3948fffb56ff7bb);
$parcel$export(module.exports, "default", () => $eb8b95f475174133$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $jJZqs = parcelRequire("jJZqs");

var $1RLjE = parcelRequire("1RLjE");
const $eb8b95f475174133$var$HTTP_LOCATION = 'project-settings-apps.http.catch-and-log-fetch-error';
const $eb8b95f475174133$var$getStatusCodeGroup = (error)=>{
    if (error instanceof (0, $jJZqs.default)) {
        const { statusCode: statusCode } = error;
        if (statusCode >= 100 && statusCode <= 199) return '1xx';
        if (statusCode >= 300 && statusCode <= 399) return '3xx';
        if (statusCode >= 400 && statusCode <= 499) return '4xx';
        if (statusCode >= 500 && statusCode <= 599) return '5xx';
    }
    if (error instanceof (0, $jJZqs.ValidationError)) return '4xx';
    return 'unknown';
};
/**
 * All fetch calls made in project-settings should be wrapped by this method to ensure HTTP related errors can be
 * separated from JS errors in Splunk. The promise provided to this method MUST NOT perform any logic beside making
 * the fetch call (i.e. transforming responses). The caught error will be rethrown so any downstream methods can perform
 * their own error handling.
 *
 * @param promise Promise to wrap so any errors are caught and logged.
 * @param message Message to include in the log. This should provide context as to what action the user was taking.
 */ const $eb8b95f475174133$var$catchAndLogFetchError = (promise, message)=>promise.catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData($eb8b95f475174133$var$HTTP_LOCATION, message, error);
        throw error;
    });
const $eb8b95f475174133$export$c3948fffb56ff7bb = (promise, packageName, errorId, message)=>promise.catch((error)=>{
        const statusCodeGroup = $eb8b95f475174133$var$getStatusCodeGroup(error);
        (0, $1RLjE.logError)(packageName, errorId, message, error, {
            http: true,
            statusCodeGroup: statusCodeGroup
        });
        throw error;
    });
var $eb8b95f475174133$export$2e2bcd8739ae039 = $eb8b95f475174133$var$catchAndLogFetchError;

});
parcelRegister("1RLjE", function(module, exports) {

$parcel$export(module.exports, "logError", () => $b0fc9ceb76f86c8e$export$58da9968c3170cb1);

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");
const $b0fc9ceb76f86c8e$export$58da9968c3170cb1 = (packageName, errorId, message, error, attributes)=>{
    // Send error log to analytics pipeline (i.e. SFX) and Sentry
    (0, $jcw0u.default)({
        meta: {
            packageName: packageName,
            id: errorId,
            teamName: 'morphinecake'
        },
        attributes: {
            ...attributes,
            message: message
        },
        error: error
    });
    // Send error log to Splunk
    // We use this instead of `sendToPrivacyUnsafeSplunk` to preserve error message and custom properties
    const location = `${packageName}.${errorId}`;
    (0, $dJl1T.default).unsafeErrorWithCustomerData(location, message, error);
};

});


const $0175358ae1e6c114$export$b8b9d90f9e5bd72b = 'inlineConfigProjectHeader';
const $0175358ae1e6c114$export$7525482b5931e326 = 'input';
const $0175358ae1e6c114$export$9957974f8b4d8f74 = 'configurableProjectHeader';

parcelRegister("36j29", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea7d3ba4afd2d7be$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ea7d3ba4afd2d7be$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    updateError: {
        "id": "navigation-apps-sidebar-inline-config-project-header.services.use-avatars.update-error",
        "defaultMessage": "Something went wrong while updating the project icon. Try again."
    }
});

});



parcelRegister("4bUrz", function(module, exports) {

$parcel$export(module.exports, "NavigationKitAvatarPopup", () => $6a2143d6dd908868$export$500ef2645bac918e);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $koVbs = parcelRequire("koVbs");

var $9KMcd = parcelRequire("9KMcd");

var $jgJNO = parcelRequire("jgJNO");

var $g9v7Y = parcelRequire("g9v7Y");

var $9sET2 = parcelRequire("9sET2");
const $6a2143d6dd908868$export$500ef2645bac918e = ({ selectedAvatarUrl: selectedAvatarUrl, systemAvatars: systemAvatars, latestCustomAvatar: latestCustomAvatar, onSelectAvatar: onSelectAvatar, onUploadAvatar: onUploadAvatar, canEdit: canEdit })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onAvatarClick = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(true);
    }, [
        setIsOpen
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const selectedAvatarId = Number(selectedAvatarUrl.substring(selectedAvatarUrl.lastIndexOf('/') + 1));
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $g9v7Y.navigationKitAvatarPopupContentEntrypoint), {});
    const entrypointTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        messageId: "navigation-kit-avatar.ui.navigation-kit-avatar-popup.jira-popup.popup",
        messageType: "transactional",
        placement: "bottom-start",
        role: "dialog",
        label: formatMessage((0, $9sET2.default).title),
        isOpen: isOpen,
        onClose: onClose,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                id: "navigation-kit-avatar.popup-content",
                packageName: "jiraNavigationKitAvatarPopupContent",
                entryPointReferenceSubject: entryPointReferenceSubject,
                runtimeProps: {
                    selectedAvatarId: selectedAvatarId,
                    onClose: onClose,
                    systemAvatars: systemAvatars,
                    latestCustomAvatar: latestCustomAvatar,
                    onSelectAvatar: onSelectAvatar,
                    onUploadAvatar: onUploadAvatar
                }
            }),
        trigger: (triggerProps)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                ref: entrypointTrigger
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9KMcd.EditableAvatar), {
                avatarUrl: selectedAvatarUrl,
                canEdit: canEdit,
                onClick: onAvatarClick,
                triggerProps: triggerProps
            }));
        }
    });
};

});
parcelRegister("47gW9", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $1be876415a945060$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $1be876415a945060$export$5f13515bd3a35325);

var $5uXOq = parcelRequire("5uXOq");

var $iRKpN = parcelRequire("iRKpN");
const $1be876415a945060$export$25d2524a63315ed = (actions, isActive = true, eventMap)=>{
    const removePreviousListeners = (0, $5uXOq.useRef)(null);
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $5uXOq.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        const elementEventMap = eventMap || $1be876415a945060$export$5f13515bd3a35325(actions);
        if (element && isActive) {
            (0, $iRKpN.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: elementEventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $iRKpN.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: elementEventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        actions,
        eventMap,
        isActive
    ]);
};
const $1be876415a945060$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("iRKpN", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $62bae43418420b8a$export$15257a36a7e3f9d6);
function $62bae43418420b8a$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});


parcelRegister("7XluA", function(module, exports) {

$parcel$export(module.exports, "JiraEntryPointContainer", () => $f4c300dcb0cbacff$export$ee1e46af8fa2fb93);
$parcel$export(module.exports, "NestedEntryPointContainer", () => $f4c300dcb0cbacff$export$54db9e88249c9162);

var $5uXOq = parcelRequire("5uXOq");

var $8Bm0k = parcelRequire("8Bm0k");

var $c5vfY = parcelRequire("c5vfY");
const $f4c300dcb0cbacff$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
    const entryPointReference = (0, $8Bm0k.useEntryPointSubscription)(entryPointReferenceSubject);
    return entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5vfY.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        placeholderName: "jira-entry-point-container"
    }) : null;
};
const $f4c300dcb0cbacff$export$54db9e88249c9162 = (0, $c5vfY.InternalEntryPointContainer);

});
parcelRegister("8Bm0k", function(module, exports) {

$parcel$export(module.exports, "useEntryPointSubscription", () => $0458c70c3d6616bf$export$3cd1c81e13390c49);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");
const $0458c70c3d6616bf$export$3cd1c81e13390c49 = (subject)=>{
    const [entryPointReference, setEntryPointReference] = (0, $5uXOq.useState)(subject.getValue);
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = subject.subscribe(setEntryPointReference);
        setEntryPointReference(subject.getValue());
        return unsubscribe;
    }, [
        subject
    ]);
    // We should never provide an entrypoint that has been disposed.
    // This check guards against race conditions that could be triggered by the entrypoint load manager + concurrent rendering.
    if (entryPointReference?.isDisposed && (0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) return null;
    return entryPointReference;
};

});

parcelRegister("c5vfY", function(module, exports) {

$parcel$export(module.exports, "InternalEntryPointContainer", () => $df42b2d5b5551f77$export$5d4dc37edd8a3adb);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $l8ruj = parcelRequire("l8ruj");
const $df42b2d5b5551f77$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>/* eslint-disable-next-line jira/ufo/valid-labels */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: errorAttributes,
        fallback: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: placeholderName ?? packageName ?? 'internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    }))));

});
parcelRegister("l8ruj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6056b4460d0127e0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $aatTc = parcelRequire("aatTc");

var $lAOer = parcelRequire("lAOer");

var $5tDD0 = parcelRequire("5tDD0");

var $5i16O = parcelRequire("5i16O");

var $4R6GH = parcelRequire("4R6GH");

var $c1haS = parcelRequire("c1haS");
/** A portion of the page we apply measurement to */ function $6056b4460d0127e0$var$JiraUFOSegmentWrapper({ children: children }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const interactionContext = (0, $aatTc.useInteractionContext)();
    const relayProfilerContext = (0, $5uXOq.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $5uXOq.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    this.getInteractionContext().addPreload((0, $lAOer.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $lAOer.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4R6GH.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4R6GH.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5i16O.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children));
}
function $6056b4460d0127e0$export$2e2bcd8739ae039({ name: segmentName, children: children, mode: mode = 'single' }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5tDD0.default), {
        name: segmentName,
        mode: mode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6056b4460d0127e0$var$JiraUFOSegmentWrapper, null, children));
}

});



parcelRegister("4mO32", function(module, exports) {

$parcel$export(module.exports, "useEntryPoint", () => $f8987436643ccece$export$338256068bc140fb);

var $5uXOq = parcelRequire("5uXOq");

var $c8WsS = parcelRequire("c8WsS");

var $9CqsK = parcelRequire("9CqsK");

var $j1gA4 = parcelRequire("j1gA4");

var $bzXq1 = parcelRequire("bzXq1");
const $f8987436643ccece$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, $c8WsS.DEFAULT_OPTIONS))=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, $j1gA4.useEntryPointLoadManager)(entryPoint, entryPointParams);
    const { startMetric: startMetric, stopMetric: stopMetric } = (0, $bzXq1.useMetricLogger)(metric);
    const entryPointActions = (0, $9CqsK.useEntryPointActions)(loadActions, options, startMetric);
    return (0, $5uXOq.useMemo)(()=>({
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject,
            stopMetric: stopMetric
        }), [
        entryPointActions,
        entryPointReferenceSubject,
        stopMetric
    ]);
};

});
parcelRegister("c8WsS", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_OPTIONS", () => $34664e57314d5c26$export$93ca5d3f8675ae4c);
const $34664e57314d5c26$export$93ca5d3f8675ae4c = {
    preloadMaxAge: 2000,
    timeToIntent: 200
};

});

parcelRegister("9CqsK", function(module, exports) {

$parcel$export(module.exports, "useEntryPointActions", () => $7bc2afeacf23b901$export$90681c8c3a56f09a);

var $5uXOq = parcelRequire("5uXOq");

var $jQsty = parcelRequire("jQsty");

var $c8WsS = parcelRequire("c8WsS");
const $7bc2afeacf23b901$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
const $7bc2afeacf23b901$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, $c8WsS.DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, $c8WsS.DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
    const preloadIntentTimeout = (0, $5uXOq.useRef)();
    const preloadMaxAgeTimeout = (0, $5uXOq.useRef)();
    const preloadLastRequested = (0, $5uXOq.useRef)(0);
    const cancelPreload = (0, $5uXOq.useCallback)(()=>{
        if (!(0, $jQsty.default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) {
            clearTimeout(preloadIntentTimeout.current);
            clearTimeout(preloadMaxAgeTimeout.current);
        }
    }, []);
    const load = (0, $5uXOq.useCallback)(()=>{
        cancelPreload();
        startMetric(preloadLastRequested.current);
        if (preloadLastRequested.current > 0) commitPreload();
        else loadEntryPoint();
        preloadLastRequested.current = 0;
    }, [
        cancelPreload,
        commitPreload,
        loadEntryPoint,
        startMetric
    ]);
    const preload = (0, $5uXOq.useCallback)(()=>{
        if ((0, $jQsty.default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) return;
        cancelPreload();
        preloadIntentTimeout.current = setTimeout(()=>{
            preloadLastRequested.current = Date.now();
            loadEntryPoint({
                isPreload: true
            });
            preloadMaxAgeTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = 0;
            }, preloadMaxAge);
        }, timeToIntent);
    }, [
        cancelPreload,
        loadEntryPoint,
        preloadMaxAge,
        timeToIntent
    ]);
    (0, $5uXOq.useEffect)(()=>cancelPreload, [
        cancelPreload
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            cancelPreload: cancelPreload,
            load: load,
            preload: preload,
            unload: unloadEntryPoint
        }), [
        cancelPreload,
        load,
        preload,
        unloadEntryPoint
    ]);
};

});

parcelRegister("j1gA4", function(module, exports) {

$parcel$export(module.exports, "useEntryPointLoadManager", () => $d6e83c6db8fa388b$export$bfae318f9651db2f);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $fiv1r = parcelRequire("fiv1r");

var $iU8T2 = parcelRequire("iU8T2");
const $d6e83c6db8fa388b$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
    const environmentProvider = (0, $fiv1r.useJiraRelayEnvironmentProvider)();
    const canLoad = (0, $5uXOq.useRef)(true);
    const timer = (0, $5uXOq.useRef)();
    const removeInactiveLoadsIdleCallback = (0, $5uXOq.useRef)(null);
    const entryPointReferenceQueue = (0, $5uXOq.useRef)([]);
    const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, $iU8T2.useEntryPointReferenceSubject)(entryPoint);
    const setNextUpdate = (0, $5uXOq.useCallback)((nextEntryPointReference)=>{
        setEntryPointReference(nextEntryPointReference);
        if ((0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) {
            // Delay clean up to prioritise render cycle in case
            // prior queries get used again
            $d6e83c6db8fa388b$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
            removeInactiveLoadsIdleCallback.current = $d6e83c6db8fa388b$var$callWhenIdle(()=>{
                const { current: currentQueue } = entryPointReferenceQueue;
                entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $iU8T2.removeAll)(currentQueue) : (0, $iU8T2.removeInactiveLoads)(currentQueue);
            });
        } else // Delay clean up to prioritise render cycle in case
        // prior queries get used again
        timer.current = setTimeout(()=>{
            const { current: currentQueue } = entryPointReferenceQueue;
            entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $iU8T2.removeAll)(currentQueue) : (0, $iU8T2.removeInactiveLoads)(currentQueue);
        }, 0);
    }, [
        setEntryPointReference
    ]);
    const load = (0, $5uXOq.useCallback)(({ isPreload: isPreload } = {
        isPreload: false
    })=>{
        if (canLoad.current) {
            const reference = (0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
            entryPointReferenceQueue.current.unshift({
                value: reference,
                isPreload: isPreload
            });
            if (isPreload) entryPointReferenceQueue.current = (0, $iU8T2.removeRedundantPreloads)(entryPointReferenceQueue.current);
            else setNextUpdate(reference);
        }
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        setNextUpdate
    ]);
    const unload = (0, $5uXOq.useCallback)(()=>{
        setNextUpdate(null);
    }, [
        setNextUpdate
    ]);
    const commitPreload = (0, $5uXOq.useCallback)(()=>{
        const [firstItem] = entryPointReferenceQueue.current;
        if (firstItem?.isPreload) {
            firstItem.isPreload = false;
            setNextUpdate(firstItem.value);
        }
    }, [
        setNextUpdate
    ]);
    if ((0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        // In concurrent mode especially with strict mode, we would get stuck on canLoad.current = false
        // and it would never be turned back on to true without this
        canLoad.current = true;
        return ()=>{
            $d6e83c6db8fa388b$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $iU8T2.removeAll)(entryPointReferenceQueue.current);
        };
    }, []);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>()=>{
            clearTimeout(timer.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $iU8T2.removeAll)(entryPointReferenceQueue.current);
        }, []);
    return {
        entryPointReferenceSubject: (0, $5uXOq.useMemo)(()=>({
                getValue: getValue,
                subscribe: subscribe
            }), [
            getValue,
            subscribe
        ]),
        loadEntryPoint: load,
        unloadEntryPoint: unload,
        commitPreload: commitPreload
    };
};
function $d6e83c6db8fa388b$var$callWhenIdle(callback) {
    if ('requestIdleCallback' in window && typeof requestIdleCallback === 'function') return requestIdleCallback(callback);
    if ('requestAnimationFrame' in window && typeof requestAnimationFrame === 'function') return requestAnimationFrame(callback);
    return setTimeout(callback, 0);
}
function $d6e83c6db8fa388b$var$maybeCancelIdleCallback(idleCallbackId) {
    if (idleCallbackId === null) return;
    if ('cancelIdleCallback' in window && typeof cancelIdleCallback === 'function') {
        if (typeof idleCallbackId === 'number') return cancelIdleCallback(idleCallbackId);
        return;
    }
    if ('cancelAnimationFrame' in window && typeof cancelAnimationFrame === 'function') {
        if (typeof idleCallbackId === 'number') return cancelAnimationFrame(idleCallbackId);
        return;
    }
    return clearTimeout(idleCallbackId);
}

});
parcelRegister("iU8T2", function(module, exports) {

$parcel$export(module.exports, "removeRedundantPreloads", () => $011b3d8d407c2901$export$a5b3b808f05fede2);
$parcel$export(module.exports, "removeInactiveLoads", () => $011b3d8d407c2901$export$ae329fe3ea179cb4);
$parcel$export(module.exports, "removeAll", () => $011b3d8d407c2901$export$1cfc7aad5cb1833b);
$parcel$export(module.exports, "useEntryPointReferenceSubject", () => $011b3d8d407c2901$export$322c8997d351da6a);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $4R6GH = parcelRequire("4R6GH");
const $011b3d8d407c2901$export$a5b3b808f05fede2 = (queue)=>{
    const [, ...potentialRedundantItems] = queue;
    potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
        if (isPreload) value.dispose();
    });
    return queue.filter(({ value: value })=>!value.isDisposed);
};
const $011b3d8d407c2901$export$ae329fe3ea179cb4 = (queue)=>{
    if (queue.length === 0) return [];
    const [activeItem, ...redundantItems] = queue;
    redundantItems.forEach(({ value: value })=>{
        value.dispose();
    });
    return [
        activeItem
    ];
};
const $011b3d8d407c2901$export$1cfc7aad5cb1833b = (queue)=>{
    queue.forEach(({ value: value })=>{
        value.dispose();
    });
    return [];
};
const $011b3d8d407c2901$export$322c8997d351da6a = (entryPoint)=>{
    const value = (0, $5uXOq.useRef)(null);
    const subscribers = (0, $5uXOq.useRef)();
    const unsub = (0, $5uXOq.useRef)(null);
    const subscribe = (0, $5uXOq.useCallback)((subscriber)=>{
        if (!subscribers.current) subscribers.current = new Set();
        subscribers.current.add(subscriber);
        return ()=>{
            subscribers.current?.delete(subscriber);
        };
    }, []);
    const setEntryPointReference = (0, $5uXOq.useCallback)((entryPointReference)=>{
        value.current = entryPointReference;
        const notifySubscribers = ()=>{
            (0, $7nsd3.unstable_batchedUpdates)(()=>{
                if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                    subscriber(entryPointReference);
                });
            });
        };
        if ($011b3d8d407c2901$var$isReactAsyncJSResourceReference(entryPoint?.root) && (0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) unsub.current = entryPoint?.root?.onComplete?.(()=>{
            notifySubscribers();
        });
        else notifySubscribers();
    }, [
        entryPoint
    ]);
    const getValue = (0, $5uXOq.useCallback)(()=>value.current, []);
    (0, $5uXOq.useEffect)(()=>()=>{
            subscribers.current?.clear();
            if ((0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) unsub.current?.();
        }, []);
    return {
        getValue: getValue,
        setEntryPointReference: setEntryPointReference,
        subscribe: subscribe
    };
};
/**
 * JSResourceReference's in react-relay don't have an onComplete method,
 * but the version that we actually use from @atlassian/react-async does.
 */ function $011b3d8d407c2901$var$isReactAsyncJSResourceReference(value) {
    return Boolean(value && 'onComplete' in value && 'getModuleName' in value);
}

});


parcelRegister("bzXq1", function(module, exports) {

$parcel$export(module.exports, "useMetricLogger", () => $25198ca8fad8a13c$export$f291ec7cea728e1);

var $5uXOq = parcelRequire("5uXOq");
const $25198ca8fad8a13c$export$f291ec7cea728e1 = (metric)=>{
    const preloadStartTime = (0, $5uXOq.useRef)(0);
    const loadStartTime = (0, $5uXOq.useRef)(0);
    const startMetric = (0, $5uXOq.useCallback)((preloadTime = 0)=>{
        if (metric) {
            metric.start();
            preloadStartTime.current = preloadTime;
            loadStartTime.current = Date.now();
        }
    }, [
        metric
    ]);
    const stopMetric = (0, $5uXOq.useCallback)((additionalCustomData)=>{
        if (metric) {
            const preloadData = preloadStartTime.current > 0 ? {
                preloadToStartDuration: loadStartTime.current - preloadStartTime.current
            } : undefined;
            const metricData = preloadData || additionalCustomData ? {
                customData: {
                    ...preloadData,
                    ...additionalCustomData
                }
            } : undefined;
            metric.stop(metricData);
        }
    }, [
        metric
    ]);
    return {
        startMetric: startMetric,
        stopMetric: stopMetric
    };
};

});


parcelRegister("9KMcd", function(module, exports) {

$parcel$export(module.exports, "EditableAvatar", () => $7f651364a7a8bfa5$export$fd3a492e0b2eddae);

var $5uXOq = parcelRequire("5uXOq");

var $ew55A = parcelRequire("ew55A");

var $1Seuh = parcelRequire("1Seuh");

var $45xDm = parcelRequire("45xDm");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $5KCCi = parcelRequire("5KCCi");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $9IFFl = parcelRequire("9IFFl");

var $9nJ5Z = parcelRequire("9nJ5Z");
const $7f651364a7a8bfa5$var$EditIconWithTransparentBackground = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $7f651364a7a8bfa5$var$iconBackgroundStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($45xDm))), {
        label: "",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $7f651364a7a8bfa5$var$ProjectAvatar = ({ src: src, testId: testId })=>(0, $4R6GH.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9IFFl.ProjectIconSmallerSize), {
        "data-testid": testId && `${testId}--image`,
        "data-vc": "editable-avatar-project",
        src: src,
        alt: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew55A.default), {
        appearance: "square",
        borderColor: "transparent",
        size: "small",
        src: src,
        testId: testId,
        "data-vc": "editable-avatar-project"
    });
const $7f651364a7a8bfa5$export$fd3a492e0b2eddae = (props)=>{
    const { avatarUrl: avatarUrl, canEdit: canEdit, triggerProps: triggerProps = {}, onClick: onClick } = props;
    const [isHover, setIsHover] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        onMouseEnter: ()=>setIsHover(true),
        onMouseLeave: ()=>setIsHover(false)
    }, canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        content: formatMessage((0, $9nJ5Z.default).editIconLabel),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: $7f651364a7a8bfa5$var$editableAvatarContainerStyles
        }, isHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: (0, $4R6GH.fg)('blu-6305_tab_item_styling_in_horizontal_navigation') ? $7f651364a7a8bfa5$var$smallerIconButtonWrapperStyles : $7f651364a7a8bfa5$var$iconButtonWrapperStyles,
            ...tooltipProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
            appearance: "subtle",
            icon: $7f651364a7a8bfa5$var$EditIconWithTransparentBackground,
            label: formatMessage((0, $9nJ5Z.default).editIconLabel),
            spacing: "compact",
            ...triggerProps,
            onClick: onClick
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7f651364a7a8bfa5$var$ProjectAvatar, {
            src: avatarUrl ? `${avatarUrl}?size=xlarge` : avatarUrl,
            testId: "navigation-apps-sidebar-inline-config-project-header.ui.editable-avatar.project-icon-editable"
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7f651364a7a8bfa5$var$ProjectAvatar, {
        src: avatarUrl ? `${avatarUrl}?size=xlarge` : avatarUrl,
        testId: "navigation-apps-sidebar-inline-config-project-header.ui.editable-avatar.project-icon"
    })));
};
const $7f651364a7a8bfa5$var$iconBackgroundStyles = (0, $2s57o.xcss)({
    backgroundColor: 'color.background.neutral.pressed',
    borderRadius: '2px'
});
const $7f651364a7a8bfa5$var$editableAvatarContainerStyles = (0, $2s57o.xcss)({
    position: 'relative'
});
const $7f651364a7a8bfa5$var$iconButtonWrapperStyles = (0, $2s57o.xcss)({
    position: 'absolute',
    zIndex: 'card',
    left: "var(--ds-space-025, 2px)",
    top: "var(--ds-space-025, 2px)"
});
const $7f651364a7a8bfa5$var$smallerIconButtonWrapperStyles = (0, $2s57o.xcss)({
    position: 'absolute',
    zIndex: 'card',
    left: "var(--ds-space-negative-025, -2px)",
    top: "var(--ds-space-negative-025, -2px)"
});

});
parcelRegister("45xDm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8d8183d86255e266d89dc1fd99bbc4dd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2fa1b806f5b29ed7$var$_react = $2fa1b806f5b29ed7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2fa1b806f5b29ed7$var$_edit = $2fa1b806f5b29ed7$var$_interopRequireDefault((parcelRequire("084bx")));

var $2fa1b806f5b29ed7$var$_editFilled = $2fa1b806f5b29ed7$var$_interopRequireDefault((parcelRequire("glcam")));
function $2fa1b806f5b29ed7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2fa1b806f5b29ed7$var$EditIcon = (props)=>/*#__PURE__*/ $2fa1b806f5b29ed7$var$_react.default.createElement($2fa1b806f5b29ed7$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $2fa1b806f5b29ed7$var$_editFilled.default
    }, props));
$2fa1b806f5b29ed7$var$EditIcon.Name = 'EditIconMigration';
var $2fa1b806f5b29ed7$var$_default = module.exports.default = $2fa1b806f5b29ed7$var$EditIcon;

});
parcelRegister("084bx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce3559d453dff44735097f553c900f9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0006420a77150094$var$_react = $0006420a77150094$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0006420a77150094$var$_baseNew = $0006420a77150094$var$_interopRequireDefault((parcelRequire("enEmH")));
function $0006420a77150094$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0006420a77150094$var$EditIcon = (props)=>/*#__PURE__*/ $0006420a77150094$var$_react.default.createElement($0006420a77150094$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.707zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.217l-.54 1.89 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$0006420a77150094$var$EditIcon.displayName = 'EditIcon';
var $0006420a77150094$var$_default = module.exports.default = $0006420a77150094$var$EditIcon;

});

parcelRegister("glcam", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be580b73570dd198$var$_react = $be580b73570dd198$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $be580b73570dd198$var$_edit = $be580b73570dd198$var$_interopRequireDefault((parcelRequire("084bx")));
function $be580b73570dd198$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $be580b73570dd198$var$EditFilledIcon = (props)=>/*#__PURE__*/ $be580b73570dd198$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $be580b73570dd198$var$_edit.default
    }));
$be580b73570dd198$var$EditFilledIcon.displayName = 'EditFilledIcon';
var $be580b73570dd198$var$_default = module.exports.default = $be580b73570dd198$var$EditFilledIcon;

});


parcelRegister("9IFFl", function(module, exports) {

$parcel$export(module.exports, "ProjectIcon", () => $48848e57380c5fd1$export$219c8b8c393795b3);
$parcel$export(module.exports, "ProjectIconSmallerSize", () => $48848e57380c5fd1$export$f93a8bad82c8219);
$parcel$export(module.exports, "IconSkeleton", () => $48848e57380c5fd1$export$777a4901c1708535);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $48848e57380c5fd1$var$iconStylesCompiledStyles = null;
const $48848e57380c5fd1$var$iconStylesWithSmallerSize = null;
const $48848e57380c5fd1$export$219c8b8c393795b3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _vchhusvi _4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
});
const $48848e57380c5fd1$export$f93a8bad82c8219 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _vchhusvi _4t3igktf _1bsbgktf",
            __cmplp.className
        ])
    });
});
const $48848e57380c5fd1$export$777a4901c1708535 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _vchhusvi _4t3i1tcg _1bsb1tcg _bfhkn82g",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9nJ5Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $51c30433ca2f8a3a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $51c30433ca2f8a3a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editIconLabel: {
        "id": "navigation-apps-sidebar-inline-config-project-header.editable-avatar.edit-icon-label",
        "defaultMessage": "Edit project icon"
    }
});

});


parcelRegister("jgJNO", function(module, exports) {

$parcel$export(module.exports, "JiraPopup", () => $93ebfe5964b2617d$export$2da4be1e3f9adef3);

var $5uXOq = parcelRequire("5uXOq");

var $vCqQa = parcelRequire("vCqQa");

var $10xFf = parcelRequire("10xFf");

var $egZ8z = parcelRequire("egZ8z");
const $93ebfe5964b2617d$export$2da4be1e3f9adef3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egZ8z.ChoreographerPopup), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $vCqQa.Popup), rest);
};

});
parcelRegister("egZ8z", function(module, exports) {

$parcel$export(module.exports, "ChoreographerPopup", () => $985c2abc03675c6b$export$8ecc19d18d3df807);

var $vCqQa = parcelRequire("vCqQa");

var $fG5AJ = parcelRequire("fG5AJ");
const $985c2abc03675c6b$export$8ecc19d18d3df807 = (0, $fG5AJ.withChoreographedToggle)((0, $vCqQa.Popup), 'isOpen', 'content');

});


parcelRegister("g9v7Y", function(module, exports) {

$parcel$export(module.exports, "navigationKitAvatarPopupContentEntrypoint", () => $08450454006b14dc$export$6c49070d2ac14f7c);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $08450454006b14dc$export$6c49070d2ac14f7c = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("4kyxc")).then((module)=>module.NavigationKitAvatarPopupContentEntryPoint), {
        moduleId: "3303108b",
        moduleName: "NavigationKitAvatarPopupContent"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4kyxc", function(module, exports) {

let $3273d17e9cb2151d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3273d17e9cb2151d$var$load("h2MrD"),
    $3273d17e9cb2151d$var$load("bYT2S"),
    $3273d17e9cb2151d$var$load("cM9em"),
    $3273d17e9cb2151d$var$load("fr9NE"),
    $3273d17e9cb2151d$var$load("hPzOn"),
    $3273d17e9cb2151d$var$load("2Izrz")
]).then(()=>parcelRequire('3eWaM'));

});


parcelRegister("9sET2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef8d4d4e329ca408$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ef8d4d4e329ca408$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "navigation-kit-avatar.title",
        "defaultMessage": "Select an avatar"
    },
    close: {
        "id": "navigation-kit-avatar.close",
        "defaultMessage": "Close avatar selection"
    },
    error: {
        "id": "navigation-kit-avatar.error",
        "defaultMessage": "Error updating project avatar."
    },
    cancelUpload: {
        "id": "navigation-kit-avatar.cancel-upload",
        "defaultMessage": "Cancel"
    },
    submitUpload: {
        "id": "navigation-kit-avatar.submit-upload",
        "defaultMessage": "Submit"
    },
    uploadImageErrorMessage: {
        "id": "navigation-kit-avatar.upload-image-error-message",
        "defaultMessage": "We couldn't upload the image. Check your connection and try again."
    },
    updateAvatarErrorMessage: {
        "id": "navigation-kit-avatar.update-avatar-error-message",
        "defaultMessage": "We couldn't save the changes. Check your connection and try again."
    },
    imageUrlInvalidError: {
        "id": "navigation-kit-avatar.image-url-invalid-error",
        "defaultMessage": "Could not load image, the url is invalid."
    },
    imageFormatInvalidError: {
        "id": "navigation-kit-avatar.image-format-invalid-error",
        "defaultMessage": "Could not load image, the format is invalid."
    },
    imageSizeTooLargeError: {
        "id": "navigation-kit-avatar.image-size-too-large-error",
        "defaultMessage": "Image is too large, must be no larger than {MAX_SIZE_MB}Mb"
    },
    selectImageToUploadOrDragAndDrop: {
        "id": "navigation-kit-avatar.select-image-to-upload-or-drag-and-drop",
        "defaultMessage": "<link>Select an image to upload</link> or drag and drop it here"
    }
});

});



parcelRegister("gVVh2", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $53e3f96776906920$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");

var $fZneA = parcelRequire("fZneA");

var $balh3 = parcelRequire("balh3");
class $53e3f96776906920$export$e926676385687eaf extends (0, $5uXOq.Component) {
    static{
        this.getDerivedStateFromError = (error)=>{
            const aggError = (0, $balh3.getFirstAGGError)(error);
            return {
                error: aggError || error
            };
        };
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    componentDidCatch() {
        const { handleError: handleError } = this.props;
        const { error: error } = this.state;
        if (error) handleError?.(error);
    }
    render() {
        const { error: error } = this.state;
        const { children: children, fallback: fallback } = this.props;
        if (!error) return children;
        if ((0, $fZneA.isHttpClientErrorResponse)(error)) return fallback;
        // If this isn't a client side error, let the upper error boundary handle it
        throw error;
    }
}

});
parcelRegister("balh3", function(module, exports) {

$parcel$export(module.exports, "getFirstAGGError", () => $f708f387d321118f$export$b53263a573caff4a);
class $f708f387d321118f$export$97de343a82d27fe7 extends Error {
    constructor(error){
        super();
        this.graphQLError = error;
        this.statusCode = error.extensions?.statusCode ?? undefined;
        this.message = error.message;
        this.name = 'AGGError';
    }
}
const $f708f387d321118f$export$b53263a573caff4a = (error)=>{
    if (!('source' in error)) return null;
    const errorSource = error.source;
    const errors = errorSource && typeof errorSource === 'object' && 'errors' in errorSource && errorSource.errors;
    const firstError = Array.isArray(errors) ? errors[0] : null;
    return firstError ? new $f708f387d321118f$export$97de343a82d27fe7(firstError) : null;
};

});


parcelRegister("lVVC6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a8ba5cd0044c428$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /*
 * Component used at the top of the horizontal nav
 * featuring the project title, icon, and additional components around those key items
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9IFFl = parcelRequire("9IFFl");

var $eiSEx = parcelRequire("eiSEx");
const $2a8ba5cd0044c428$var$Header = ({ title: title, withInlineEdit: withInlineEdit, onConfirm: onConfirm, onValidate: onValidate, id: id, icon: icon, extraComponentsClose: extraComponentsClose, extraComponentsFar: extraComponentsFar, isLoading: isLoading = false, testId: testId })=>{
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a8ba5cd0044c428$var$HeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9IFFl.IconSkeleton), {
        "data-testid": "business-horizontal-nav.common.ui.header.icon-skeleton"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a8ba5cd0044c428$var$TitleSkeleton, {
        "data-testid": "business-horizontal-nav.common.ui.header.title-skeleton"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a8ba5cd0044c428$var$HeaderWrapper, {
        "data-testid": testId
    }, icon, withInlineEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eiSEx.InlineEditTitle), {
        key: id,
        title: title,
        onConfirm: onConfirm,
        onValidate: onValidate
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a8ba5cd0044c428$var$Title, null, title), extraComponentsClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a8ba5cd0044c428$var$ExtraComponentsCloseContainer, null, extraComponentsClose), extraComponentsFar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a8ba5cd0044c428$var$ExtraComponentsFarContainer, null, extraComponentsFar));
};
var $2a8ba5cd0044c428$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($2a8ba5cd0044c428$var$Header);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a8ba5cd0044c428$var$HeaderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c11p5 _wij21bp4 _1bah1y6m _yv0e17hv _4cvr1h6o _1ul9idpf _19bv1ejb _u5f31ejb",
            __cmplp.className
        ])
    });
});
const $2a8ba5cd0044c428$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c8nf1z _19pkidpf _syazfrbu _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $2a8ba5cd0044c428$var$TitleSkeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _vchhusvi _4t3i1tcg _1bsbuuw1 _bfhkn82g",
            __cmplp.className
        ])
    });
});
const $2a8ba5cd0044c428$var$ExtraComponentsCloseContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahv2br",
            __cmplp.className
        ])
    });
});
const $2a8ba5cd0044c428$var$ExtraComponentsFarContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1wpzh9n0 _1bahh9n0 _1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eiSEx", function(module, exports) {

$parcel$export(module.exports, "InlineEditTitle", () => $8dc320a99adb7dbc$export$30c7300f5fdd9da6);
/* InlineEditTitle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ec0Lk = parcelRequire("ec0Lk");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $jgJNO = parcelRequire("jgJNO");

var $aQ2e3 = parcelRequire("aQ2e3");
const $8dc320a99adb7dbc$var$renderReadView = (title, triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("h1", {
        ...triggerProps,
        className: (0, $bwpsq.default)([
            "_11c8nf1z _1e0c11p5 _k48pmoej"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8dc320a99adb7dbc$var$ReadView, {
        "data-testid": "navigation-kit-header.inline-edit-title.read-view"
    }, title));
const $8dc320a99adb7dbc$export$30c7300f5fdd9da6 = /*#__PURE__*/ (0, $5uXOq.memo)(({ title: title, onConfirm: onConfirm, onValidate: onValidate })=>{
    const [editValue, setEditValue] = (0, $5uXOq.useState)(title);
    const [error, setError] = (0, $5uXOq.useState)('');
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $aQ2e3.inlineEditTitleEditViewEntryPoint), {});
    const readViewTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $8dc320a99adb7dbc$var$inlineEditTitleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ec0Lk.default), {
        isRequired: true,
        defaultValue: editValue,
        onEdit: ()=>setError(''),
        editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                id: "navigation-kit-header.inline-edit-title-edit-view",
                packageName: "jiraNavigationKitHeaderInlineEditTitleEditView",
                entryPointReferenceSubject: entryPointReferenceSubject,
                runtimeProps: {
                    errorMessage: errorMessage,
                    fieldProps: fieldProps
                },
                fallback: $8dc320a99adb7dbc$var$renderReadView(title),
                errorFallback: ()=>$8dc320a99adb7dbc$var$renderReadView(title)
            }),
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                ref: readViewTrigger
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
                messageId: "navigation-kit-inline-edit-title.ui.jira-popup",
                messageType: "transactional",
                isOpen: error !== '',
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                        xcss: $8dc320a99adb7dbc$var$errorPopupStyles
                    }, error),
                placement: "right",
                trigger: (triggerProps)=>$8dc320a99adb7dbc$var$renderReadView(editValue, triggerProps)
            })),
        onConfirm: (newValue)=>{
            setEditValue(newValue);
            onConfirm(newValue);
        },
        validate: (newValue)=>onValidate(title ?? '', newValue)
    }));
});
const $8dc320a99adb7dbc$var$errorPopupStyles = (0, $2s57o.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    padding: 'space.200'
});
const $8dc320a99adb7dbc$var$headingStyles = null;
const $8dc320a99adb7dbc$var$inlineEditTitleStyles = (0, $2s57o.xcss)({
    // Negative margin is added here to make the inline edit field fit in the
    // header without needing to modify the header height
    marginTop: 'space.negative.200',
    marginBottom: 'space.negative.100',
    font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8dc320a99adb7dbc$var$ReadView = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _syazfrbu _19pk12x7 _otyr12x7 _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ec0Lk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c84accef102bc9e$export$2e2bcd8739ae039);
/* inline-edit.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $4EHpO = parcelRequire("4EHpO");

var $7folp = parcelRequire("7folp");

var $fHpHg = parcelRequire("fHpHg");

var $7rJgC = parcelRequire("7rJgC");

var $cBCgC = parcelRequire("cBCgC");

var $5uae8 = parcelRequire("5uae8");

var $1eXlh = parcelRequire("1eXlh");

var $4P8zB = parcelRequire("4P8zB");
const $3c84accef102bc9e$var$fieldStyles = null;
const $3c84accef102bc9e$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $3c84accef102bc9e$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $5uXOq.useState)(startWithEditViewOpen);
    const timerRef = (0, $5uXOq.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $1eXlh.default)(isEditing, isEditingState);
    const onCancel = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel?.();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit?.();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$3c84accef102bc9e$var$analyticsAttributes
    });
    const onCancelClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]); /**
                                 * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
                                 *  confirms the value, if the focus is not transferred to the action buttons.
                                 *
                                 *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
                                 *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
                                 *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
                                 *  `autoSubmitWhenBlur`.
                                 *
                                 *  There are two paths here the function can be triggered:
                                 *
                                 *  - focus on input first, and then use keyboard to `submit`
                                 *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
                                 */ 
    const onEditViewWrapperBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]); /**
                                                        * Gets called when focus is transferred to the editView, or action buttons.
                                                        *
                                                        * There are three paths here the function can be called:
                                                        *
                                                        * - when a user click the `editView`
                                                        * - when a user use keyboard to tab into `editView`
                                                        * - when a user use keyboard to tab into `submit` when they were on input field.
                                                        */ 
    const onEditViewWrapperFocus = (0, $5uXOq.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4P8zB.default), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7folp.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit),
        children: ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, $2OMIu.jsx)("form", {
                /**
                 * It is not normally acceptable to add key handlers to non-interactive elements
                 * as this is an accessibility anti-pattern. However, because this instance is
                 * to add support for keyboard functionality instead of creating an inaccessible
                 * custom element, we can add role="presentation" so that there is no negative
                 * impacts to assistive technologies.
                 */ role: "presentation",
                onKeyDown: (e)=>{
                    onKeyDown(e);
                    if (e.key === 'Esc' || e.key === 'Escape') {
                        if ((0, $fHpHg.fg)('platform-design-system-inline-edit-reset-on-escape')) reset();
                        onCancel();
                    }
                },
                onSubmit: onSubmit,
                ref: formRef,
                children: shouldBeEditing ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4EHpO.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: defaultValue,
                    validate: validate,
                    isRequired: isRequired,
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                            onBlur: (e)=>{
                                if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                            },
                            onFocus: onEditViewWrapperFocus,
                            className: (0, $bwpsq.default)([
                                "_p12f1osq _kqswh2mm"
                            ]),
                            children: [
                                editView({
                                    ...fieldProps,
                                    errorMessage: error
                                }, editViewRef),
                                !hideActionButtons ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uae8.default), {
                                    testId: testId,
                                    cancelButtonLabel: cancelButtonLabel,
                                    confirmButtonLabel: confirmButtonLabel,
                                    onMouseDown: ()=>{
                                        /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                                    },
                                    onCancelClick: (e)=>{
                                        reset();
                                        onCancelClick(e);
                                    }
                                }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
                                    hidden: true,
                                    type: "submit",
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
                                        children: "Submit"
                                    })
                                })
                            ]
                        })
                }, "edit-view" // used for reset to default value
                ) : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4EHpO.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: "",
                    isRequired: isRequired,
                    children: renderReadView
                }, "read-view" // used for reset to default value
                )
            })
    });
};
const $3c84accef102bc9e$var$InlineEdit = (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)($3c84accef102bc9e$var$InnerInlineEdit, {
        ...props
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $3c84accef102bc9e$export$2e2bcd8739ae039 = $3c84accef102bc9e$var$InlineEdit;

});
parcelRegister("4EHpO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4338501a4bebd545$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("3joPi");

var $jJsBW = parcelRequire("jJsBW");

var $bU9TL = parcelRequire("bU9TL");

var $7folp = parcelRequire("7folp");

var $cGltd = parcelRequire("cGltd");

var $cUUCJ = parcelRequire("cUUCJ");

var $6cAn5 = parcelRequire("6cAn5");
const $4338501a4bebd545$var$fieldWrapperStyles = null;
function $4338501a4bebd545$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $4338501a4bebd545$var$isFunction(x) {
    return typeof x === 'function';
}
function $4338501a4bebd545$var$usePreviousRef(current) {
    const ref = (0, $5uXOq.useRef)(current);
    // will be updated on the next render
    (0, $5uXOq.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $4338501a4bebd545$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $4338501a4bebd545$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, $7folp.FormContext));
    const isDisabled = (0, $5uXOq.useContext)((0, $7folp.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $4338501a4bebd545$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $4338501a4bebd545$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$4338501a4bebd545$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $5uXOq.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $4338501a4bebd545$var$usePreviousRef(state);
    (0, $5uXOq.useEffect)(()=>{
        typeof $6cAn5;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $4338501a4bebd545$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($4338501a4bebd545$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const uid = (0, $jJsBW.useId)();
    const fieldId = (0, $5uXOq.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $bwpsq.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cGltd.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cUUCJ.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bU9TL.FieldId).Provider, {
                value: fieldId,
                children: props.children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("bU9TL", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $fd4ca56d0899c490$export$3c4232819458a302);

var $5uXOq = parcelRequire("5uXOq");
const $fd4ca56d0899c490$export$3c4232819458a302 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});

parcelRegister("7folp", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $989b7d35312a49bd$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $989b7d35312a49bd$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $989b7d35312a49bd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lqWDn = parcelRequire("lqWDn");

var $8tHJX = parcelRequire("8tHJX");

var $gZL7V = parcelRequire("gZL7V");
const $989b7d35312a49bd$export$c24727297075ec6a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $989b7d35312a49bd$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
function $989b7d35312a49bd$export$2e2bcd8739ae039(props) {
    const formRef = (0, $5uXOq.useRef)(null);
    const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $5uXOq.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $lqWDn.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $5uXOq.useState)({
        dirty: false,
        submitting: false
    });
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $5uXOq.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: {
                    onSubmit: handleSubmit,
                    ref: formRef,
                    onKeyDown: handleKeyDown
                },
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change
            }) : children();
            return result === undefined ? null : result;
        }
        return children;
    })();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($989b7d35312a49bd$export$c24727297075ec6a.Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($989b7d35312a49bd$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
}

});
parcelRegister("lqWDn", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $f9a9822f8af64e2a$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $f9a9822f8af64e2a$export$97cd7fc25dd32915);
$parcel$export(module.exports, "ARRAY_ERROR", () => $f9a9822f8af64e2a$export$735bebc8ffabf28a);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $f9a9822f8af64e2a$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $f9a9822f8af64e2a$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $f9a9822f8af64e2a$export$f681a8129d2e9d28);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");
//      
var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
var $f9a9822f8af64e2a$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
    string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f9a9822f8af64e2a$var$keysCache = {};
var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
    }
    return $f9a9822f8af64e2a$var$keysCache[key];
};
//      
var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f9a9822f8af64e2a$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
    var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $ddEsc.default)(current, [
                key
            ].map($f9a9822f8af64e2a$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
};
var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
    var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f9a9822f8af64e2a$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                    shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values)); // clone to avoid writing
            if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                    var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $bS32t.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $bS32t.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("8tHJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c2f612c5adb35a$export$2e2bcd8739ae039);

var $lqWDn = parcelRequire("lqWDn");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $lqWDn.getIn)(errors, input.name);
    });
};
//      
var $62c2f612c5adb35a$var$noop = function noop() {};
var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;

});

parcelRegister("gZL7V", function(module, exports) {

var $ajB7H = parcelRequire("ajB7H");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $c5f6e64373be0bfc$var$set(object, path, value) {
    return object == null ? object : $ajB7H(object, path, value);
}
module.exports = $c5f6e64373be0bfc$var$set;

});


parcelRegister("cGltd", function(module, exports) {

$parcel$export(module.exports, "Label", () => $6da09f2418b6f13e$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $6da09f2418b6f13e$export$ed247974535929c7);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $6da09f2418b6f13e$var$fieldsetLabelStyles = null;
const $6da09f2418b6f13e$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
const $6da09f2418b6f13e$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("legend", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});

parcelRegister("cUUCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a7ed1e0c62cc06b$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $4a7ed1e0c62cc06b$var$requiredIndicatorStyles = null;
function $4a7ed1e0c62cc06b$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $bwpsq.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("5uae8", function(module, exports) {

$parcel$export(module.exports, "default", () => $568f5c85371814cc$export$2e2bcd8739ae039);
/* buttons.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1Seuh = parcelRequire("1Seuh");

var $goMg1 = parcelRequire("goMg1");

var $gANiX = parcelRequire("gANiX");

var $dR8fb = parcelRequire("dR8fb");
const $568f5c85371814cc$var$buttonsContainerStyles = null;
const $568f5c85371814cc$var$buttonWrapperBaseStyles = null;
const $568f5c85371814cc$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswstnw _1o9zidpf _152t1osq _rjxpidpf _1pfh12x7"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                tabIndex: -1,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
                    type: "submit",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dR8fb))), {
                            ...iconProps,
                            LEGACY_size: "small"
                        }),
                    onMouseDown: onMouseDown,
                    label: confirmButtonLabel,
                    testId: testId && `${testId}--confirm`
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                tabIndex: -1,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gANiX))), {
                            ...iconProps,
                            LEGACY_size: "small",
                            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($goMg1)))
                        }),
                    label: cancelButtonLabel,
                    onClick: onCancelClick,
                    onMouseDown: onMouseDown,
                    testId: testId && `${testId}--cancel`
                })
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$568f5c85371814cc$export$2e2bcd8739ae039 = $568f5c85371814cc$var$Buttons;

});
parcelRegister("dR8fb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9db35ecad695c835ed46bfa4bbde0dff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1669ea74f05704f$var$_react = $a1669ea74f05704f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a1669ea74f05704f$var$_checkMark = $a1669ea74f05704f$var$_interopRequireDefault((parcelRequire("aiSXl")));

var $a1669ea74f05704f$var$_check = $a1669ea74f05704f$var$_interopRequireDefault((parcelRequire("2n32C")));
function $a1669ea74f05704f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1669ea74f05704f$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $a1669ea74f05704f$var$_react.default.createElement($a1669ea74f05704f$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $a1669ea74f05704f$var$_check.default
    }, props));
$a1669ea74f05704f$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $a1669ea74f05704f$var$_default = module.exports.default = $a1669ea74f05704f$var$CheckMarkIcon;

});
parcelRegister("aiSXl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f681ccdbe722d68d6bd374c0928f0bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $780636fcbb2cccd4$var$_react = $780636fcbb2cccd4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $780636fcbb2cccd4$var$_baseNew = $780636fcbb2cccd4$var$_interopRequireDefault((parcelRequire("enEmH")));
function $780636fcbb2cccd4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $780636fcbb2cccd4$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $780636fcbb2cccd4$var$_react.default.createElement($780636fcbb2cccd4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m11.06 3-6.25 7a.75.75 0 0 1-1.15-.037l-2.75-3.5 1.18-.926 2.197 2.796L9.94 2z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$780636fcbb2cccd4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $780636fcbb2cccd4$var$_default = module.exports.default = $780636fcbb2cccd4$var$CheckMarkIcon;

});

parcelRegister("2n32C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1ba016b41382ba32$var$_react = $1ba016b41382ba32$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $1ba016b41382ba32$var$_checkMark = $1ba016b41382ba32$var$_interopRequireDefault((parcelRequire("dVU8x")));
function $1ba016b41382ba32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ba016b41382ba32$var$CheckIcon = (props)=>/*#__PURE__*/ $1ba016b41382ba32$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $1ba016b41382ba32$var$_checkMark.default
    }));
$1ba016b41382ba32$var$CheckIcon.displayName = 'CheckIcon';
var $1ba016b41382ba32$var$_default = module.exports.default = $1ba016b41382ba32$var$CheckIcon;

});
parcelRegister("dVU8x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a24c24cfbaad63c1$var$_react = $a24c24cfbaad63c1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a24c24cfbaad63c1$var$_baseNew = $a24c24cfbaad63c1$var$_interopRequireDefault((parcelRequire("enEmH")));
function $a24c24cfbaad63c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a24c24cfbaad63c1$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $a24c24cfbaad63c1$var$_react.default.createElement($a24c24cfbaad63c1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$a24c24cfbaad63c1$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $a24c24cfbaad63c1$var$_default = module.exports.default = $a24c24cfbaad63c1$var$CheckMarkIcon;

});




parcelRegister("1eXlh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac0118167eb799ed$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $ac0118167eb799ed$var$usePrevious = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $ac0118167eb799ed$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $5uXOq.useRef)(null);
    const editViewRef = (0, $5uXOq.useRef)();
    const preventFocusOnEditButtonRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $ac0118167eb799ed$var$usePrevious(shouldBeEditing);
    (0, $5uXOq.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $ac0118167eb799ed$export$2e2bcd8739ae039 = $ac0118167eb799ed$var$useButtonFocusHook;

});

parcelRegister("4P8zB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3969b97f38c61a8$export$2e2bcd8739ae039);
/* read-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $7rJgC = parcelRequire("7rJgC");
const $a3969b97f38c61a8$var$readViewContainerStyles = null;
const $a3969b97f38c61a8$var$editButtonStyles = {
    root: "_12ji1r31 _1qu2glyw _12y3idpf _189e1grb _1dqoglyw _1h6d3acm _1e0c1ule _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _r06hglyw _bfhk18uv _vwz4kb7n _1xp41p6i _14ly1bk5 _1j8znqa1 _mizu1r31 _ra3xglyw _128midpf"
};
const $a3969b97f38c61a8$var$readViewWrapperStyles = null;
const $a3969b97f38c61a8$var$readViewFitContainerWidthStyles = null;
const $a3969b97f38c61a8$var$DRAG_THRESHOLD = 5;
const $a3969b97f38c61a8$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $5uXOq.useRef)(0);
    const startY = (0, $5uXOq.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $a3969b97f38c61a8$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $a3969b97f38c61a8$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /**
     * If a link is clicked in the read view, default action should be taken
     */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: (0, $bwpsq.default)([
            "_vwz4kb7n"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
                xcss: $a3969b97f38c61a8$var$editButtonStyles.root,
                onClick: onEditRequested,
                ref: editButtonRef,
                testId: testId && `${testId}--edit-button`,
                "aria-label": editButtonLabel
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
                onClick: onReadViewClick,
                onMouseDown: (e)=>{
                    startX.current = e.clientX;
                    startY.current = e.clientY;
                },
                "data-read-view-fit-container-width": readViewFitContainerWidth,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _v564thzt _1h6d3acm _1dqonqa1 _189e1bk5 _1e0c1o8l _vchhusvi _1bsb1wug _p12f1osq _irr314ae",
                    readViewFitContainerWidth && "_1bsb1osq"
                ]),
                children: readView()
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a3969b97f38c61a8$export$2e2bcd8739ae039 = $a3969b97f38c61a8$var$ReadView;

});


parcelRegister("aQ2e3", function(module, exports) {

$parcel$export(module.exports, "inlineEditTitleEditViewEntryPoint", () => $dc77152c8971ba4d$export$6adaa323774f44e4);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $dc77152c8971ba4d$export$6adaa323774f44e4 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("etljZ")).then((module)=>module.InlineEditTitleEditViewEntryPoint), {
        moduleId: "48ab033b",
        moduleName: "InlineEditTitleEditView"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("etljZ", function(module, exports) {

let $a8945017cd1f26fa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a8945017cd1f26fa$var$load("eAFJA").then(()=>parcelRequire('4RzAB'));

});




parcelRegister("8qMCq", function(module, exports) {

$parcel$export(module.exports, "default", () => $87b5bc435d98c94f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lUz5s = parcelRequire("lUz5s");

var $hgsSB = parcelRequire("hgsSB");

var $2XiUm = parcelRequire("2XiUm");
const $87b5bc435d98c94f$var$ErrorBoundary = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        teamName: (0, $lUz5s.APP_TEAM_NAME),
        id: "projectCreateImportProgress",
        packageName: (0, $hgsSB.APP_IDENTIFIER),
        fallback: "unmount"
    }, children);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$87b5bc435d98c94f$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87b5bc435d98c94f$var$ErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2XiUm.default), props));

});
parcelRegister("lUz5s", function(module, exports) {

$parcel$export(module.exports, "X2C_SERVICE_URL_PREFIX", () => $c689fb2a7c606375$export$e8e1caec1dfda22c);
$parcel$export(module.exports, "APP_IDENTIFIER", () => $c689fb2a7c606375$export$2cea7f14750b8c19);
$parcel$export(module.exports, "APP_TEAM_NAME", () => $c689fb2a7c606375$export$a5a8ee89d936ca29);
$parcel$export(module.exports, "INITIAL_MIGRATION_STATUS", () => $c689fb2a7c606375$export$7198445d3ab0721e);
$parcel$export(module.exports, "FEEDBACK_GROUP_ID", () => $c689fb2a7c606375$export$14b33d63628336c2);
$parcel$export(module.exports, "IMPORT_TYPE_PARAM_KEY", () => $c689fb2a7c606375$export$85c452e39fc36d3d);
$parcel$export(module.exports, "WORKSPACE_ID_PARAM_KEY", () => $c689fb2a7c606375$export$ad63f63c74460d35);
$parcel$export(module.exports, "ENTITY_ID_PARAM_KEY", () => $c689fb2a7c606375$export$a14f08973e10eb93);

var $y3A0q = parcelRequire("y3A0q");
const $c689fb2a7c606375$export$e8e1caec1dfda22c = '/gateway/api/jira-x2c-service/api/v1';
const $c689fb2a7c606375$export$2cea7f14750b8c19 = 'jira-business.project-create-importer-common';
const $c689fb2a7c606375$export$a5a8ee89d936ca29 = 'x2c-wolverine';
const $c689fb2a7c606375$export$7198445d3ab0721e = {
    overallProgress: 0.05,
    overallStatus: (0, $y3A0q.Status).READY,
    createdIssues: 0,
    totalIssues: 0,
    detailedProgress: {
        dataTransformStatus: (0, $y3A0q.Status).READY,
        userImportStatus: (0, $y3A0q.Status).READY,
        projectCreateStatus: (0, $y3A0q.Status).READY
    }
};
const $c689fb2a7c606375$export$14b33d63628336c2 = 'jwm-feedback-importer';
const $c689fb2a7c606375$export$85c452e39fc36d3d = 'importType';
const $c689fb2a7c606375$export$ad63f63c74460d35 = 'workspaceId';
const $c689fb2a7c606375$export$a14f08973e10eb93 = 'entityId';

});
parcelRegister("y3A0q", function(module, exports) {

$parcel$export(module.exports, "Status", () => $c053cc3f623c4541$export$96e9906d6d93a972);
const $c053cc3f623c4541$export$96e9906d6d93a972 = {
    READY: 'READY',
    IN_PROGRESS: 'IN_PROGRESS',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED'
};

});


parcelRegister("hgsSB", function(module, exports) {

$parcel$export(module.exports, "IMPORT_IN_PROGRESS_FLAG_ID", () => $3f5b74842571fa2d$export$3ee01c364a42b386);
$parcel$export(module.exports, "IMPORT_SUCCESS_FLAG_ID", () => $3f5b74842571fa2d$export$b4a552f4abf9b350);
$parcel$export(module.exports, "IMPORT_PARTIAL_SUCCESS_FLAG_ID", () => $3f5b74842571fa2d$export$62eac7116dbcab91);
$parcel$export(module.exports, "IMPORT_ADVANCED_ERRORS_FLAG_ID", () => $3f5b74842571fa2d$export$18a16c13a76c4a32);
$parcel$export(module.exports, "BASE_POLLING_INTERVAL_MS", () => $3f5b74842571fa2d$export$aa34325aa01d2f38);
$parcel$export(module.exports, "APP_IDENTIFIER", () => $3f5b74842571fa2d$export$2cea7f14750b8c19);
$parcel$export(module.exports, "CONTACT_SUPPORT_URL", () => $3f5b74842571fa2d$export$2c16bd1d8b68b11f);
const $3f5b74842571fa2d$export$3ee01c364a42b386 = 'import-in-progress-flag';
const $3f5b74842571fa2d$export$b4a552f4abf9b350 = 'import-success-flag';
const $3f5b74842571fa2d$export$62eac7116dbcab91 = 'import-partial-success-flag';
const $3f5b74842571fa2d$export$18a16c13a76c4a32 = 'import-advanced-errors-error-flag';
const $3f5b74842571fa2d$export$aa34325aa01d2f38 = 5000;
const $3f5b74842571fa2d$export$2cea7f14750b8c19 = 'jira-business.project-create-import-progress';
const $3f5b74842571fa2d$export$2c16bd1d8b68b11f = 'https://support.atlassian.com/contact/#/?inquiry_category=technical_issues&is_cloud=true&product_key=jira-work-management&support_type=customer';

});

parcelRegister("2XiUm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f36303d1eb77403c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $dfBUy = parcelRequire("dfBUy");

var $1O9Yy = parcelRequire("1O9Yy");

var $gChKN = parcelRequire("gChKN");

var $9qb4V = parcelRequire("9qb4V");
const $f36303d1eb77403c$var$ImportProgressFlag = ({ migrationId: migrationId, onSuccess: onSuccess, onFail: onFail })=>{
    (0, $9qb4V.useTrackMigrationStatus)((0, $1O9Yy.EXPERIENCES).IMPORT_PART_2, migrationId, onSuccess, onFail);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $f36303d1eb77403c$var$ImportProgress = ({ projectKey: projectKey, projectName: projectName })=>{
    const { fetchMigrationId: fetchMigrationId, removeMigrationId: removeMigrationId } = (0, $dfBUy.useMigrationIdManager)();
    const [migrationId, setMigrationId] = (0, $5uXOq.useState)(undefined);
    const { onSuccess: onSuccess, onFail: onFail } = (0, $gChKN.useFlags)({
        projectKey: projectKey,
        projectName: projectName,
        migrationId: migrationId,
        removeMigrationId: removeMigrationId
    });
    (0, $5uXOq.useEffect)(()=>{
        setMigrationId(fetchMigrationId(projectKey));
    }, [
        fetchMigrationId,
        projectKey
    ]);
    if (!migrationId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: (0, $1O9Yy.X2C_SCREENS).ImportProgressBar,
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f36303d1eb77403c$var$ImportProgressFlag, {
        onSuccess: onSuccess,
        onFail: onFail,
        migrationId: migrationId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};
var $f36303d1eb77403c$export$2e2bcd8739ae039 = $f36303d1eb77403c$var$ImportProgress;

});
parcelRegister("5oFIy", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e);
$parcel$export(module.exports, "FireTrackAnalytics", () => $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $3ea3e1dfbcd8cda6$export$2ccf161b817b43b);

var $5uXOq = parcelRequire("5uXOq");

var $3TR0I = parcelRequire("3TR0I");


var $8zOmE = parcelRequire("8zOmE");
// eslint-disable-next-line jira/react/no-class-components
class $3ea3e1dfbcd8cda6$var$FireComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
        if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
        if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const action = actionProps || eventNameSplit[1];
        const actionSubject = actionSubjectProps || eventNameSplit[0];
        if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        const actionSubjectId = actionSubjectIdProps || componentName;
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $8zOmE.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $3ea3e1dfbcd8cda6$export$64eb47d7b94ba089 = (0, $3TR0I.default)()($3ea3e1dfbcd8cda6$var$FireComponent);
const $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e)
    });
const $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$947dac6c72b26f81)
    });
const $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$12346a674644c156)
    });
const $3ea3e1dfbcd8cda6$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("dfBUy", function(module, exports) {

$parcel$export(module.exports, "useMigrationIdManager", () => $89bd768709492155$export$b6df8a64ae5b060b);

var $5uXOq = parcelRequire("5uXOq");

var $7uUwQ = parcelRequire("7uUwQ");

var $9zHJW = parcelRequire("9zHJW");
const $89bd768709492155$export$b6df8a64ae5b060b = ()=>{
    const fetchMigrationId = (0, $5uXOq.useCallback)((projectKey)=>{
        const migrationIdStore = (0, $9zHJW.getMigrationIdStore)();
        return migrationIdStore[projectKey];
    }, []);
    const storeMigrationId = (0, $5uXOq.useCallback)((projectKey, migrationId)=>{
        const migrationIdStore = (0, $9zHJW.getMigrationIdStore)();
        (0, $9zHJW.setMigrationIdStore)({
            ...migrationIdStore,
            [projectKey]: migrationId
        });
    }, []);
    const removeMigrationId = (0, $5uXOq.useCallback)((projectKey)=>{
        const migrationIdStore = (0, $9zHJW.getMigrationIdStore)();
        if (!(projectKey in migrationIdStore)) return;
        const newMigrationIdStore = (0, $7uUwQ.unset)(migrationIdStore, projectKey);
        if (Object.keys(newMigrationIdStore).length === 0) {
            (0, $9zHJW.removeMigrationIdStore)();
            return;
        }
        (0, $9zHJW.setMigrationIdStore)(newMigrationIdStore);
    }, []);
    return {
        fetchMigrationId: fetchMigrationId,
        storeMigrationId: storeMigrationId,
        removeMigrationId: removeMigrationId
    };
};

});
parcelRegister("9zHJW", function(module, exports) {

$parcel$export(module.exports, "getMigrationIdStore", () => $7568774462293954$export$caa1665a7b4680f6);
$parcel$export(module.exports, "setMigrationIdStore", () => $7568774462293954$export$d5f201daa9ea05b7);
$parcel$export(module.exports, "removeMigrationIdStore", () => $7568774462293954$export$7a4ecb0a9136dcec);

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");
const $7568774462293954$var$MIGRATION_ID_STORE_KEY = 'X2C-Migration-Id-Store';
// TODO: JFP-2248 Please add the prefix for storage provider here
const $7568774462293954$var$localStorageProvider = (0, $bSSG7.createLocalStorageProvider)('');
const $7568774462293954$export$caa1665a7b4680f6 = ()=>(0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $7568774462293954$var$localStorageProvider.get($7568774462293954$var$MIGRATION_ID_STORE_KEY) || JSON.parse('{}') : JSON.parse(localStorage.getItem($7568774462293954$var$MIGRATION_ID_STORE_KEY) || '{}');
const $7568774462293954$export$d5f201daa9ea05b7 = (migrationIdStore)=>(0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $7568774462293954$var$localStorageProvider.set($7568774462293954$var$MIGRATION_ID_STORE_KEY, migrationIdStore) : localStorage.setItem($7568774462293954$var$MIGRATION_ID_STORE_KEY, JSON.stringify(migrationIdStore));
const $7568774462293954$export$7a4ecb0a9136dcec = ()=>(0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $7568774462293954$var$localStorageProvider.remove($7568774462293954$var$MIGRATION_ID_STORE_KEY) : localStorage.removeItem($7568774462293954$var$MIGRATION_ID_STORE_KEY);

});


parcelRegister("1O9Yy", function(module, exports) {

$parcel$export(module.exports, "EXPERIENCES", () => $9a9e8a67185abd0f$export$a2008ed3b02411a3);
$parcel$export(module.exports, "X2C_SCREENS", () => $9a9e8a67185abd0f$export$ff4b3425b39a0344);
const $9a9e8a67185abd0f$export$a2008ed3b02411a3 = {
    IMPORT_PART_2: 'projectCreateImporterImportPart2',
    IMPORT_PART_JSW: 'projectCreateImporterImportPart2JSW'
};
const $9a9e8a67185abd0f$export$ff4b3425b39a0344 = {
    ImportProgressBar: 'projectCreateImportProgressBar'
};

});

parcelRegister("gChKN", function(module, exports) {

$parcel$export(module.exports, "useFlags", () => $29ab02dd8dae572d$export$2879604e6aec4ab);

var $5uXOq = parcelRequire("5uXOq");

var $jPxJ7 = parcelRequire("jPxJ7");

var $pa9q9 = parcelRequire("pa9q9");

var $lpwtK = parcelRequire("lpwtK");

var $hgsSB = parcelRequire("hgsSB");

var $fz15h = parcelRequire("fz15h");

var $blRqr = parcelRequire("blRqr");
const $29ab02dd8dae572d$export$2879604e6aec4ab = ({ projectKey: projectKey, projectName: projectName, migrationId: migrationId, removeMigrationId: removeMigrationId })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag, hasFlag: hasFlag } = (0, $pa9q9.useFlagsService)();
    const openFeedbackModal = (0, $jPxJ7.useFeedbackCollector)();
    const { data: data } = (0, $lpwtK.useProject)();
    const name = data?.name || '';
    const handleDownloadLogsClick = (0, $fz15h.useDownloadLogs)(migrationId, projectName || name);
    const dismissInProgressFlag = (0, $5uXOq.useCallback)(()=>{
        dismissFlag((0, $hgsSB.IMPORT_IN_PROGRESS_FLAG_ID));
    }, [
        dismissFlag
    ]);
    const onSuccess = (0, $5uXOq.useCallback)((migrationStatus)=>{
        if (!hasFlag?.((0, $hgsSB.IMPORT_SUCCESS_FLAG_ID))) {
            dismissInProgressFlag();
            removeMigrationId(projectKey || projectName);
            showFlag((0, $blRqr.getSuccessFlag)(migrationStatus, projectName || name, openFeedbackModal));
        }
    }, // omit openFeedbackModal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        dismissInProgressFlag,
        hasFlag,
        migrationId,
        projectKey,
        removeMigrationId,
        showFlag
    ]);
    const onFail = (0, $5uXOq.useCallback)((migrationStatus)=>{
        if (migrationStatus.hasErrorLogs) {
            if (!hasFlag?.((0, $hgsSB.IMPORT_ADVANCED_ERRORS_FLAG_ID)) && migrationId) {
                dismissInProgressFlag();
                removeMigrationId(projectKey);
                showFlag((0, $blRqr.getAdvancedErrorFlag)({
                    migrationStatus: migrationStatus,
                    projectName: projectName || name,
                    onDownloadLogsClick: handleDownloadLogsClick
                }));
            }
            return;
        }
        if (!hasFlag?.((0, $hgsSB.IMPORT_PARTIAL_SUCCESS_FLAG_ID))) {
            dismissInProgressFlag();
            removeMigrationId(projectKey);
            showFlag((0, $blRqr.getPartialSuccessFlag)(migrationStatus, openFeedbackModal));
        }
    }, // omit openFeedbackModal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        handleDownloadLogsClick,
        dismissInProgressFlag,
        hasFlag,
        migrationId,
        projectKey,
        removeMigrationId,
        showFlag
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            dismissFlag((0, $hgsSB.IMPORT_IN_PROGRESS_FLAG_ID));
            dismissFlag((0, $hgsSB.IMPORT_SUCCESS_FLAG_ID));
            dismissFlag((0, $hgsSB.IMPORT_PARTIAL_SUCCESS_FLAG_ID));
        }, [
        dismissFlag
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!migrationId || hasFlag?.((0, $hgsSB.IMPORT_IN_PROGRESS_FLAG_ID))) return;
        showFlag((0, $blRqr.getInProgressFlag)());
    }, [
        hasFlag,
        migrationId,
        showFlag
    ]);
    return {
        onSuccess: onSuccess,
        onFail: onFail
    };
};

});
parcelRegister("jPxJ7", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $11c0bec8448c2614$export$4be696be8a3bff13);

var $5uXOq = parcelRequire("5uXOq");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $koVbs = parcelRequire("koVbs");

var $6jY6G = parcelRequire("6jY6G");

var $dAfqg = parcelRequire("dAfqg");

var $itmJb = parcelRequire("itmJb");

var $9OXo1 = parcelRequire("9OXo1");

var $5XRYo = parcelRequire("5XRYo");

var $5Dn32 = parcelRequire("5Dn32");
const $11c0bec8448c2614$export$698ff856156a88fe = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $5XRYo.default).canContactPrompt), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: "https://www.atlassian.com/legal/privacy-policy",
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $5XRYo.default).canContactPromptLink))));
});
const $11c0bec8448c2614$export$4f77effad9540593 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $5XRYo.default).enrollInResearchPrompt, {
        link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
            href: "https://www.atlassian.com/research-group",
            target: "_blank",
            rel: "noopener noreferrer"
        }, formatMessage((0, $5XRYo.default).enrollInResearchLink))
    })));
});
const $11c0bec8448c2614$export$4be696be8a3bff13 = ({ projectType: projectType = 'business' } = {})=>{
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const { licensedProducts: licensedProducts } = (0, $9OXo1.useTenantContext)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const getFeedbackContext = (0, $5uXOq.useCallback)((feedbackGroupId)=>{
        const baseFeedbackContext = [
            {
                id: (0, $7iULw.EntryKeys).INLINE_FEEDBACK_ID,
                value: feedbackGroupId
            },
            {
                id: (0, $7iULw.EntryKeys).ROUTE_NAME,
                value: route.name ?? 'unknown'
            },
            {
                id: (0, $7iULw.EntryKeys).ROUTE_GROUP,
                value: route.group ?? 'unknown'
            },
            {
                id: (0, $7iULw.EntryKeys).IS_ADMIN,
                value: isAdmin
            },
            {
                id: (0, $7iULw.EntryKeys).PROJECT_TYPE,
                value: project?.projectType || projectType
            },
            {
                id: (0, $7iULw.EntryKeys).SUPPORTED_PROJECT_TYPES,
                value: (0, $5Dn32.licensedProductsToString)(licensedProducts)
            }
        ];
        // Only send project specific information if project is available
        if (project) baseFeedbackContext.push({
            id: (0, $7iULw.EntryKeys).IS_SIMPLIFIED_PROJECT,
            value: project.simplified
        });
        return baseFeedbackContext;
    }, [
        isAdmin,
        licensedProducts,
        project,
        projectType,
        route.group,
        route.name
    ]);
    return (0, $5uXOq.useCallback)((feedbackGroupId, onClose, triggerRef)=>{
        const feedbackContext = getFeedbackContext(feedbackGroupId);
        openFeedbackCollector({
            entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_PLATFORM),
            feedbackGroupId: feedbackGroupId,
            canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($11c0bec8448c2614$export$698ff856156a88fe, null),
            enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($11c0bec8448c2614$export$4f77effad9540593, null),
            feedbackContext: feedbackContext,
            onClose: onClose,
            ...triggerRef != null ? {
                triggerRef: triggerRef
            } : {}
        });
    }, [
        getFeedbackContext,
        openFeedbackCollector
    ]);
};

});
parcelRegister("5XRYo", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c924dc8de5075ae$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6c924dc8de5075ae$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    canContactPrompt: {
        "id": "business-feedback-collector.can-contact-prompt",
        "defaultMessage": "Atlassian may contact me about this feedback."
    },
    canContactPromptLink: {
        "id": "business-feedback-collector.can-contact-prompt-link",
        "defaultMessage": "Privacy policy"
    },
    enrollInResearchPrompt: {
        "id": "business-feedback-collector.enroll-in-research-prompt",
        "defaultMessage": "I'd like to help improve Atlassian products by joining the {link}"
    },
    enrollInResearchLink: {
        "id": "business-feedback-collector.enroll-in-research-link",
        "defaultMessage": "Atlassian Research Group"
    }
});

});

parcelRegister("5Dn32", function(module, exports) {

$parcel$export(module.exports, "licensedProductsToString", () => $0dd3b476597799f0$export$f57a7f1d32485807);
const $0dd3b476597799f0$export$f57a7f1d32485807 = (licensedProducts)=>Object.keys(licensedProducts).map((productKey)=>licensedProducts[productKey] ? productKey : '').join(', ');

});


parcelRegister("fz15h", function(module, exports) {

$parcel$export(module.exports, "useDownloadLogs", () => $6d31cbbfee4870f9$export$178888e79b080a89);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $bGO0w = parcelRequire("bGO0w");

var $koeKL = parcelRequire("koeKL");
const $6d31cbbfee4870f9$export$bb3b75778e3e272 = (fileUrl, fileName)=>{
    // Need to create a link to trigger the download instead of redirecting
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.click();
};
const $6d31cbbfee4870f9$export$178888e79b080a89 = (migrationId, projectName)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const fileName = (0, $bGO0w.useErrorLogFileName)(projectName);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)(()=>{
        if (!migrationId) return;
        const url = (0, $bGO0w.createDownloadLogsUrl)({
            cloudId: cloudId,
            migrationId: migrationId,
            fileName: fileName
        });
        const uiEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'downloadX2CLogsLink'
        });
        (0, $8zOmE.fireUIAnalytics)(uiEvent);
        $6d31cbbfee4870f9$export$bb3b75778e3e272(url, fileName);
    }, [
        migrationId,
        cloudId,
        createAnalyticsEvent,
        fileName
    ]);
};

});
parcelRegister("bGO0w", function(module, exports) {

$parcel$export(module.exports, "isSynthetic", () => $c62bab4235c79636$export$947749d756ccb0a);
$parcel$export(module.exports, "createDownloadLogsUrl", () => $c62bab4235c79636$export$441dc85364beea74);
$parcel$export(module.exports, "useErrorLogFileName", () => $c62bab4235c79636$export$b3518e4126b755e4);

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $koVbs = parcelRequire("koVbs");

var $lUz5s = parcelRequire("lUz5s");

var $gUE7k = parcelRequire("gUE7k");
const $c62bab4235c79636$export$947749d756ccb0a = ()=>// Filter out synthetic tests using all known ways
    (0, $j8DrX.default)('ajs-is-synthetic') === 'true' || (0, $4R6GH.fg)('is_synthetic_tenant');
const $c62bab4235c79636$export$441dc85364beea74 = ({ cloudId: cloudId, migrationId: migrationId, fileName: fileName })=>`${0, $lUz5s.X2C_SERVICE_URL_PREFIX}/${cloudId}/import/${migrationId}/logs?${new URLSearchParams({
        fileName: fileName
    }).toString()}`;
const $c62bab4235c79636$export$b3518e4126b755e4 = (projectName)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return formatMessage((0, $gUE7k.default).errorLogFileName, {
        projectName: projectName.replace(/[&*()[\];'"?!() ]/g, '_')
    });
};

});
parcelRegister("gUE7k", function(module, exports) {

$parcel$export(module.exports, "default", () => $393e9c07e06134e1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $393e9c07e06134e1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorLogFileName: {
        "id": "project-create-importer-common.common.error-log-file-name",
        "defaultMessage": "{projectName}_import_error_log.zip"
    }
});

});



parcelRegister("blRqr", function(module, exports) {

$parcel$export(module.exports, "getSuccessFlag", () => $079ea54cd024905b$export$dbe4723f1df81b00);
$parcel$export(module.exports, "getAdvancedErrorFlag", () => $079ea54cd024905b$export$3bf6b82a650cc3f6);
$parcel$export(module.exports, "getPartialSuccessFlag", () => $079ea54cd024905b$export$368940990df88cd9);
$parcel$export(module.exports, "getInProgressFlag", () => $079ea54cd024905b$export$fc9c6c786fccb031);

var $6s1PB = parcelRequire("6s1PB");

var $lUz5s = parcelRequire("lUz5s");

var $hgsSB = parcelRequire("hgsSB");

var $2rCPm = parcelRequire("2rCPm");
const $079ea54cd024905b$export$dbe4723f1df81b00 = (migrationStatus, projectName, openFeedbackModal)=>({
        id: (0, $hgsSB.IMPORT_SUCCESS_FLAG_ID),
        type: 'success',
        isAutoDismiss: false,
        title: [
            (0, $2rCPm.default).importSuccessFlagTitle,
            {
                projectName: projectName
            }
        ],
        description: [
            (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2rCPm.default).importSuccessDescriptionIssueTermRefresh : (0, $2rCPm.default).importSuccessDescription,
            {
                count: migrationStatus.createdIssues
            }
        ],
        messageId: `project-create-import-progress.common.utils.use-flags.getSuccessFlag.${projectName}`,
        messageType: 'transactional',
        actions: [
            {
                content: (0, $2rCPm.default).refreshPage,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.reload()
            },
            {
                content: (0, $2rCPm.default).giveFeedback,
                onClick: ()=>openFeedbackModal((0, $lUz5s.FEEDBACK_GROUP_ID))
            }
        ]
    });
const $079ea54cd024905b$export$3bf6b82a650cc3f6 = ({ projectName: projectName, migrationStatus: migrationStatus, onDownloadLogsClick: onDownloadLogsClick })=>({
        id: (0, $hgsSB.IMPORT_ADVANCED_ERRORS_FLAG_ID),
        type: 'error',
        isAutoDismiss: false,
        title: (0, $2rCPm.default).importAdvancedErrorTitle,
        description: [
            (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2rCPm.default).importAdvancedErrorDescriptionIssueTermRefresh : (0, $2rCPm.default).importAdvancedErrorDescription,
            {
                failed: migrationStatus.totalIssues - migrationStatus.createdIssues,
                total: migrationStatus.totalIssues,
                projectName: projectName
            }
        ],
        messageId: `project-create-import-progress.common.utils.use-flags.getAdvancedErrorFlag.${projectName}`,
        messageType: 'transactional',
        actions: [
            {
                content: (0, $2rCPm.default).downloadLogs,
                onClick: onDownloadLogsClick
            },
            {
                content: (0, $2rCPm.default).contactSupport,
                href: (0, $hgsSB.CONTACT_SUPPORT_URL),
                target: '_blank'
            }
        ]
    });
const $079ea54cd024905b$export$368940990df88cd9 = (migrationStatus, openFeedbackModal)=>({
        id: (0, $hgsSB.IMPORT_PARTIAL_SUCCESS_FLAG_ID),
        type: 'info',
        isAutoDismiss: false,
        title: (0, $2rCPm.default).importPartialSuccessTitle,
        description: (0, $2rCPm.default).importPartialSuccessDescription,
        messageId: 'project-create-import-progress.common.utils.use-flags.flag.info.get-partial-success-flag',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $2rCPm.default).contactSupport,
                href: (0, $hgsSB.CONTACT_SUPPORT_URL),
                target: '_blank'
            },
            {
                content: (0, $2rCPm.default).giveFeedback,
                onClick: ()=>openFeedbackModal((0, $lUz5s.FEEDBACK_GROUP_ID))
            }
        ]
    });
const $079ea54cd024905b$export$fc9c6c786fccb031 = ()=>({
        id: (0, $hgsSB.IMPORT_IN_PROGRESS_FLAG_ID),
        type: 'info',
        isAutoDismiss: false,
        title: (0, $2rCPm.default).importingInProgressTitle,
        description: (0, $2rCPm.default).importingInProgressDescription,
        messageId: 'project-create-import-progress.common.utils.use-flags.flag.info.get-in-progress-flag',
        messageType: 'transactional'
    });

});
parcelRegister("2rCPm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9f9fa85f2d5ed95$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d9f9fa85f2d5ed95$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    importingInProgressTitle: {
        "id": "project-create-import-progress.common.utils.use-flags.importing-in-progress-title",
        "defaultMessage": "We\u2019re importing your data"
    },
    importingInProgressDescription: {
        "id": "project-create-import-progress.common.utils.use-flags.importing-in-progress-description",
        "defaultMessage": "You won't see any imported data yet, but feel free to work on other things while we get this done. Return to this page to check the progress of your import."
    },
    importSuccessDescription: {
        "id": "project-create-import-progress.common.utils.use-flags.import-success-description",
        "defaultMessage": "Refresh the page to see the {count, plural, one {# issue} other {# issues}} in your new project."
    },
    importSuccessFlagTitle: {
        "id": "project-create-import-progress.common.utils.use-flags.import-success-flag-title",
        "defaultMessage": "{projectName} is ready!"
    },
    importPartialSuccessTitle: {
        "id": "project-create-import-progress.common.utils.use-flags.import-partial-success-title",
        "defaultMessage": "We couldn\u2019t import all your data"
    },
    importAdvancedErrorTitle: {
        "id": "project-create-import-progress.common.utils.use-flags.import-advanced-error-title",
        "defaultMessage": "We can't seem to import all your data"
    },
    importAdvancedErrorDescription: {
        "id": "project-create-import-progress.common.utils.use-flags.import-advanced-error-description",
        "defaultMessage": "See the error log to understand why {failed} of your {total} {total, plural, one {issue} other {issues}} failed."
    },
    importPartialSuccessDescription: {
        "id": "project-create-import-progress.common.utils.use-flags.import-partial-success-description",
        "defaultMessage": "Try again in a few minutes. If you continue experiencing problems with your import, contact support."
    },
    contactSupport: {
        "id": "project-create-import-progress.common.utils.use-flags.contact-support",
        "defaultMessage": "Contact Support"
    },
    downloadLogs: {
        "id": "project-create-import-progress.common.utils.use-flags.download-logs",
        "defaultMessage": "Download logs"
    },
    giveFeedback: {
        "id": "project-create-import-progress.common.utils.use-flags.give-feedback",
        "defaultMessage": "Give feedback"
    },
    refreshPage: {
        "id": "project-create-import-progress.common.utils.use-flags.refresh-page",
        "defaultMessage": "Refresh page"
    },
    importSuccessDescriptionIssueTermRefresh: {
        "id": "project-create-import-progress.common.utils.use-flags.import-success-description-issue-term-refresh",
        "defaultMessage": "Refresh the page to see the {count, plural, one {# work item} other {# work items}} in your new project."
    },
    importAdvancedErrorDescriptionIssueTermRefresh: {
        "id": "project-create-import-progress.common.utils.use-flags.import-advanced-error-description-issue-term-refresh",
        "defaultMessage": "See the error log to understand why {failed} of your {total} {total, plural, one {work item} other {work items}} failed."
    }
});

});



parcelRegister("9qb4V", function(module, exports) {

$parcel$export(module.exports, "useTrackMigrationStatus", () => $b3e371579e4bd3ba$export$840ba962ebf22de);

var $5uXOq = parcelRequire("5uXOq");

var $y3A0q = parcelRequire("y3A0q");

var $av6CA = parcelRequire("av6CA");

var $97g70 = parcelRequire("97g70");

var $hgsSB = parcelRequire("hgsSB");
const $b3e371579e4bd3ba$export$840ba962ebf22de = (experience, migrationId, onSuccess, onFail)=>{
    const { migrationStatus: migrationStatus } = (0, $97g70.usePollMigrationStatus)(migrationId, (0, $hgsSB.BASE_POLLING_INTERVAL_MS));
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $av6CA.useExperienceTracker)(experience);
    (0, $5uXOq.useEffect)(()=>{
        onExperienceStart();
    }, [
        onExperienceStart
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (migrationStatus.overallStatus === (0, $y3A0q.Status).SUCCESS) {
            onExperienceSuccess();
            onSuccess && onSuccess(migrationStatus);
            return;
        }
        if (migrationStatus.overallStatus === (0, $y3A0q.Status).FAILED) {
            onExperienceFail((0, $hgsSB.APP_IDENTIFIER), {
                name: 'Import Failed',
                message: 'Issue Import Failed'
            }, {
                migrationId: migrationId
            });
            onFail && onFail(migrationStatus);
        }
    }, [
        migrationId,
        migrationStatus,
        onExperienceFail,
        onExperienceSuccess,
        onFail,
        onSuccess
    ]);
    return {
        migrationStatus: migrationStatus
    };
};

});
parcelRegister("av6CA", function(module, exports) {

$parcel$export(module.exports, "useExperienceTracker", () => $21b8d38806d1cf23$export$cdefb2a8b53f879f);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $fZneA = parcelRequire("fZneA");

var $lGpwc = parcelRequire("lGpwc");
const $21b8d38806d1cf23$var$analyticsSource = 'ProjectCreateImporter';
const $21b8d38806d1cf23$export$cdefb2a8b53f879f = (experience)=>{
    const onExperienceStart = (0, $kaHBi.useExperienceStart)({
        experienceId: (0, $7Jxgt.v4)(),
        experience: experience,
        analyticsSource: $21b8d38806d1cf23$var$analyticsSource
    });
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: experience,
        attributes: {}
    });
    const onFail = (0, $93jKl.useExperienceFail)({
        experience: experience,
        attributes: {}
    });
    const onExperienceFail = (0, $5uXOq.useCallback)((location, error, extraAttributes)=>{
        if ((0, $fZneA.isClientFetchError)(error) || (0, $fZneA.isHttpClientErrorResponse)(error)) {
            onExperienceSuccess();
            return;
        }
        onFail(location, error, {
            errorName: (0, $lGpwc.extractErrorName)(error),
            errorMessage: (0, $lGpwc.extractErrorMessage)(error),
            statusCode: (0, $lGpwc.extractStatusCode)(error),
            traceId: (0, $lGpwc.extractTraceId)(error),
            buildKey: (0, $lGpwc.getBuildKey)(),
            ...extraAttributes || {}
        });
    }, [
        onExperienceSuccess,
        onFail
    ]);
    return [
        onExperienceStart,
        onExperienceSuccess,
        onExperienceFail
    ];
};

});
parcelRegister("lGpwc", function(module, exports) {

$parcel$export(module.exports, "getBuildKey", () => $0b1b329ab61a1369$export$14551268fbd9a06f);
$parcel$export(module.exports, "extractStatusCode", () => $0b1b329ab61a1369$export$1fdf7c1c0741a7e7);
$parcel$export(module.exports, "extractTraceId", () => $0b1b329ab61a1369$export$431eacb6aecbacdf);
$parcel$export(module.exports, "extractErrorName", () => $0b1b329ab61a1369$export$ebcf8325c79b7706);
$parcel$export(module.exports, "extractErrorMessage", () => $0b1b329ab61a1369$export$8cc545829c7461b0);

var $9XE6b = parcelRequire("9XE6b");
const $0b1b329ab61a1369$export$ba068cc3610b559d = 'NOT_PRESENT';
const $0b1b329ab61a1369$export$14551268fbd9a06f = ()=>window.BUILD_KEY;
const $0b1b329ab61a1369$export$1fdf7c1c0741a7e7 = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'statusCode'
    ], $0b1b329ab61a1369$export$ba068cc3610b559d);
const $0b1b329ab61a1369$export$431eacb6aecbacdf = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'traceId'
    ], $0b1b329ab61a1369$export$ba068cc3610b559d);
const $0b1b329ab61a1369$export$ebcf8325c79b7706 = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'name'
    ], $0b1b329ab61a1369$export$ba068cc3610b559d);
const $0b1b329ab61a1369$export$8cc545829c7461b0 = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'message'
    ], $0b1b329ab61a1369$export$ba068cc3610b559d);

});


parcelRegister("97g70", function(module, exports) {

$parcel$export(module.exports, "usePollMigrationStatus", () => $4c6504a7ae7fd778$export$523c1933cb8cd7a6);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $koeKL = parcelRequire("koeKL");

var $lUz5s = parcelRequire("lUz5s");

var $9E3iL = parcelRequire("9E3iL");

var $y3A0q = parcelRequire("y3A0q");

var $bGO0w = parcelRequire("bGO0w");

var $av6CA = parcelRequire("av6CA");

var $5wfyT = parcelRequire("5wfyT");
const $4c6504a7ae7fd778$export$84e2f2da851426a9 = 1800000;
const $4c6504a7ae7fd778$export$a1301e284b39cd56 = 1.3;
const $4c6504a7ae7fd778$var$getX2CMigrationStatusUrl = (cloudId, migrationId)=>`${0, $lUz5s.X2C_SERVICE_URL_PREFIX}/${cloudId}/import/${migrationId}/status`;
const $4c6504a7ae7fd778$export$7edd275ea1b9d090 = (cloudId, migrationId)=>(0, $7f4tk.default)($4c6504a7ae7fd778$var$getX2CMigrationStatusUrl(cloudId, migrationId), {
        method: 'GET',
        headers: {
            'x-issynthetic-traffic': String((0, $bGO0w.isSynthetic)())
        }
    });
const $4c6504a7ae7fd778$export$523c1933cb8cd7a6 = (migrationId, basePollingIntervalMs)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [migrationStatus, setMigrationStatus] = (0, $5uXOq.useState)((0, $lUz5s.INITIAL_MIGRATION_STATUS));
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $av6CA.useExperienceTracker)((0, $9E3iL.EXPERIENCES).POLLING);
    const getPollingRetryStatus = (0, $5uXOq.useCallback)(async ()=>{
        if (!migrationId) return false;
        try {
            onExperienceStart();
            (0, $9E3iL.pollingInteractionMetric).start();
            const containerTransferStatus = await $4c6504a7ae7fd778$export$7edd275ea1b9d090(cloudId, migrationId);
            const status = (0, $5wfyT.calculateMigrationStatus)(containerTransferStatus);
            setMigrationStatus(status);
            (0, $9E3iL.pollingInteractionMetric).stop();
            onExperienceSuccess();
            return status.overallStatus !== (0, $y3A0q.Status).SUCCESS && status.overallStatus !== (0, $y3A0q.Status).FAILED;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9E3iL.pollingInteractionMetric).stop();
            onExperienceFail((0, $lUz5s.APP_IDENTIFIER), error, {
                migrationId: migrationId
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetch-migration-status-error',
                    packageName: (0, $lUz5s.APP_IDENTIFIER),
                    teamName: (0, $lUz5s.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            if ((0, $5wfyT.isRetryable)(error)) return true;
            setMigrationStatus({
                ...migrationStatus,
                overallStatus: (0, $y3A0q.Status).FAILED
            });
            return false;
        }
    }, [
        cloudId,
        migrationId,
        migrationStatus,
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (migrationId) (0, $5wfyT.withExponentialBackoff)(getPollingRetryStatus, basePollingIntervalMs, $4c6504a7ae7fd778$export$84e2f2da851426a9, $4c6504a7ae7fd778$export$a1301e284b39cd56);
    // Only setup new polling if migrationId or interval changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        migrationId,
        basePollingIntervalMs
    ]);
    return {
        migrationStatus: migrationStatus
    };
};

});
parcelRegister("9E3iL", function(module, exports) {

$parcel$export(module.exports, "EXPERIENCES", () => $19021017c40d5b8e$export$a2008ed3b02411a3);
$parcel$export(module.exports, "pollingInteractionMetric", () => $19021017c40d5b8e$export$40607ce86ffe9e76);

var $2nKjG = parcelRequire("2nKjG");

var $lUz5s = parcelRequire("lUz5s");
const $19021017c40d5b8e$export$a2008ed3b02411a3 = {
    POLLING: 'projectCreateImporterPolling'
};
const $19021017c40d5b8e$var$POLLING_ITERACTION_METRIC_KEY = `${(0, $lUz5s.APP_IDENTIFIER)}.polling`;
const $19021017c40d5b8e$export$40607ce86ffe9e76 = (0, $2nKjG.metrics).interaction({
    key: $19021017c40d5b8e$var$POLLING_ITERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});

});

parcelRegister("5wfyT", function(module, exports) {

$parcel$export(module.exports, "calculateMigrationStatus", () => $3eb6aec6bd421b16$export$214c69f9b592e736);
$parcel$export(module.exports, "isRetryable", () => $3eb6aec6bd421b16$export$f146c102d7613638);
$parcel$export(module.exports, "withExponentialBackoff", () => $3eb6aec6bd421b16$export$20eaa22f2295996f);

var $9XE6b = parcelRequire("9XE6b");

var $lUz5s = parcelRequire("lUz5s");

var $y3A0q = parcelRequire("y3A0q");

var $hmhzd = parcelRequire("hmhzd");
const $3eb6aec6bd421b16$var$JIRA_IMPORT_OPERATION_KEY = 'jiraImport';
const $3eb6aec6bd421b16$var$JIRA_IMPORT_V4_OPERATION_KEY = 'jiraX2CProjectImport';
const $3eb6aec6bd421b16$var$JIRA_DATA_TRANSFORM_OPERATION_KEY = 'jiraDataTransform';
const $3eb6aec6bd421b16$var$ALL_USER_IMPORT_OPERATION_KEY = 'allUserImport';
const $3eb6aec6bd421b16$var$PROJECT_ENTITY_KEY = 'jira/classic:project';
const $3eb6aec6bd421b16$var$ISSUE_ENTITY_KEY = 'jira:issue';
const $3eb6aec6bd421b16$var$QUEUES_ENTITY_KEY = 'jira/servicedesk:queue';
const $3eb6aec6bd421b16$var$PROGRESS_WEIGHTING = {
    jiraImport: 0.5,
    allUserImport: 0.3,
    jiraProjectFinalise: 0.1,
    jiraDataTransfer: 0.1
};
const $3eb6aec6bd421b16$var$isFailedStatus = (status)=>status === (0, $hmhzd.TransferStatus).FAILED || status === (0, $hmhzd.TransferStatus).INCOMPLETE || status === (0, $hmhzd.TransferStatus).CANCELLED || status === (0, $hmhzd.TransferStatus).SKIPPED;
const $3eb6aec6bd421b16$var$getCreatedJiraImportCountForEntity = (transfer, entityKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(transfer, [
        'progressProperties',
        'completedEntityCounts',
        entityKey,
        'completed',
        'created'
    ], 0);
const $3eb6aec6bd421b16$var$getFailedJiraImportCountForEntity = (transfer, entityKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(transfer, [
        'progressProperties',
        'completedEntityCounts',
        entityKey,
        'completed',
        'failed'
    ], 0);
const $3eb6aec6bd421b16$var$getTotalJiraImportCountForEntity = (transfer, entityKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(transfer, [
        'progressProperties',
        'completedEntityCounts',
        entityKey,
        'totalEntities'
    ], 0);
const $3eb6aec6bd421b16$export$37d331774442a79a = (containerTransferStatus)=>{
    const jiraImportTransfer = containerTransferStatus.transfers?.find((transfer)=>transfer.operationKey === $3eb6aec6bd421b16$var$JIRA_IMPORT_OPERATION_KEY || transfer.operationKey === $3eb6aec6bd421b16$var$JIRA_IMPORT_V4_OPERATION_KEY);
    if (!jiraImportTransfer) return {
        createdIssues: 0,
        totalIssues: 0
    };
    return {
        createdIssues: $3eb6aec6bd421b16$var$getCreatedJiraImportCountForEntity(jiraImportTransfer, $3eb6aec6bd421b16$var$ISSUE_ENTITY_KEY),
        totalIssues: $3eb6aec6bd421b16$var$getTotalJiraImportCountForEntity(jiraImportTransfer, $3eb6aec6bd421b16$var$ISSUE_ENTITY_KEY)
    };
};
const $3eb6aec6bd421b16$var$transformTranferStatusToStatus = (transferStatus)=>{
    if ($3eb6aec6bd421b16$var$isFailedStatus(transferStatus)) return (0, $y3A0q.Status).FAILED;
    if (transferStatus === (0, $hmhzd.TransferStatus).SUCCESS) return (0, $y3A0q.Status).SUCCESS;
    if (transferStatus === (0, $hmhzd.TransferStatus).IN_PROGRESS) return (0, $y3A0q.Status).IN_PROGRESS;
    return (0, $y3A0q.Status).READY;
};
const $3eb6aec6bd421b16$var$getStatusForOperation = (containerTransferStatus, operationKey)=>{
    const transfer = containerTransferStatus.transfers?.find((t)=>t.operationKey === operationKey);
    return transfer?.businessStatus ? $3eb6aec6bd421b16$var$transformTranferStatusToStatus(transfer.businessStatus) : (0, $y3A0q.Status).READY;
};
const $3eb6aec6bd421b16$var$getProjectCreateStatus = (containerTransferStatus)=>{
    const jiraImportTransfer = containerTransferStatus.transfers?.find((transfer)=>transfer.operationKey === $3eb6aec6bd421b16$var$JIRA_IMPORT_OPERATION_KEY || transfer.operationKey === $3eb6aec6bd421b16$var$JIRA_IMPORT_V4_OPERATION_KEY);
    if (!jiraImportTransfer) return (0, $y3A0q.Status).READY;
    const createdProjectEntities = $3eb6aec6bd421b16$var$getCreatedJiraImportCountForEntity(jiraImportTransfer, $3eb6aec6bd421b16$var$PROJECT_ENTITY_KEY);
    const totalProjectEntities = $3eb6aec6bd421b16$var$getTotalJiraImportCountForEntity(jiraImportTransfer, $3eb6aec6bd421b16$var$PROJECT_ENTITY_KEY);
    const failedProjectEntities = $3eb6aec6bd421b16$var$getFailedJiraImportCountForEntity(jiraImportTransfer, $3eb6aec6bd421b16$var$PROJECT_ENTITY_KEY);
    if (failedProjectEntities !== 0) return (0, $y3A0q.Status).FAILED;
    if (createdProjectEntities === 0) return (0, $y3A0q.Status).READY;
    if (createdProjectEntities === totalProjectEntities) return (0, $y3A0q.Status).SUCCESS;
    return (0, $y3A0q.Status).IN_PROGRESS;
};
const $3eb6aec6bd421b16$var$getQueuesCreateStatus = (containerTransferStatus)=>{
    const jiraImportTransfer = containerTransferStatus.transfers?.find((transfer)=>transfer.operationKey === $3eb6aec6bd421b16$var$JIRA_IMPORT_OPERATION_KEY || transfer.operationKey === $3eb6aec6bd421b16$var$JIRA_IMPORT_V4_OPERATION_KEY);
    if (!jiraImportTransfer) return (0, $y3A0q.Status).READY;
    const createdQueuesEntities = $3eb6aec6bd421b16$var$getCreatedJiraImportCountForEntity(jiraImportTransfer, $3eb6aec6bd421b16$var$QUEUES_ENTITY_KEY);
    const totalQueuesEntities = $3eb6aec6bd421b16$var$getTotalJiraImportCountForEntity(jiraImportTransfer, $3eb6aec6bd421b16$var$QUEUES_ENTITY_KEY);
    const failedQueuesEntities = $3eb6aec6bd421b16$var$getFailedJiraImportCountForEntity(jiraImportTransfer, $3eb6aec6bd421b16$var$QUEUES_ENTITY_KEY);
    if (totalQueuesEntities === 0) return undefined;
    if (failedQueuesEntities !== 0) return (0, $y3A0q.Status).FAILED;
    if (createdQueuesEntities === 0) return (0, $y3A0q.Status).READY;
    if (createdQueuesEntities === totalQueuesEntities) return (0, $y3A0q.Status).SUCCESS;
    return (0, $y3A0q.Status).IN_PROGRESS;
};
const $3eb6aec6bd421b16$export$ad5f54dfa4c25e4b = (containerTransferStatus)=>({
        dataTransformStatus: $3eb6aec6bd421b16$var$getStatusForOperation(containerTransferStatus, $3eb6aec6bd421b16$var$JIRA_DATA_TRANSFORM_OPERATION_KEY),
        userImportStatus: $3eb6aec6bd421b16$var$getStatusForOperation(containerTransferStatus, $3eb6aec6bd421b16$var$ALL_USER_IMPORT_OPERATION_KEY),
        projectCreateStatus: $3eb6aec6bd421b16$var$getProjectCreateStatus(containerTransferStatus),
        queueCreationStatus: $3eb6aec6bd421b16$var$getQueuesCreateStatus(containerTransferStatus)
    });
const $3eb6aec6bd421b16$var$getProgressForTransfer = (transfer)=>{
    if (transfer.businessStatus === (0, $hmhzd.TransferStatus).SUCCESS) return 1;
    if (transfer.businessStatus === (0, $hmhzd.TransferStatus).READY) return 0;
    if (transfer.progressProperties === undefined || transfer.progressProperties === null) return 0;
    const { createdEntities: createdEntities, totalEntities: totalEntities } = transfer.progressProperties;
    if (createdEntities === undefined || totalEntities === undefined) return 0;
    return createdEntities / totalEntities;
};
const $3eb6aec6bd421b16$var$calculateProgress = (containerTransferStatus)=>{
    let progress = 0;
    containerTransferStatus.transfers?.forEach((transfer)=>{
        const weighting = $3eb6aec6bd421b16$var$PROGRESS_WEIGHTING[transfer.operationKey] || 0;
        progress += $3eb6aec6bd421b16$var$getProgressForTransfer(transfer) * weighting;
    });
    return progress;
};
const $3eb6aec6bd421b16$export$214c69f9b592e736 = (containerTransferStatus)=>{
    if (containerTransferStatus.businessStatus === (0, $hmhzd.TransferStatus).READY) return 0, $lUz5s.INITIAL_MIGRATION_STATUS;
    const issueStats = $3eb6aec6bd421b16$export$37d331774442a79a(containerTransferStatus);
    const detailedProgress = $3eb6aec6bd421b16$export$ad5f54dfa4c25e4b(containerTransferStatus);
    if (containerTransferStatus.businessStatus === (0, $hmhzd.TransferStatus).SUCCESS) return {
        overallProgress: 1,
        overallStatus: (0, $y3A0q.Status).SUCCESS,
        detailedProgress: detailedProgress,
        ...issueStats
    };
    const progress = $3eb6aec6bd421b16$var$calculateProgress(containerTransferStatus);
    if ($3eb6aec6bd421b16$var$isFailedStatus(containerTransferStatus.businessStatus)) {
        const migrationFailedStatus = {
            overallProgress: progress,
            overallStatus: (0, $y3A0q.Status).FAILED,
            detailedProgress: detailedProgress,
            ...issueStats
        };
        return {
            ...migrationFailedStatus,
            hasErrorLogs: containerTransferStatus.hasErrorLogs
        };
    }
    return {
        overallProgress: progress,
        overallStatus: (0, $y3A0q.Status).IN_PROGRESS,
        detailedProgress: detailedProgress,
        ...issueStats
    };
};
const $3eb6aec6bd421b16$export$f146c102d7613638 = (error)=>error?.statusCode === 429 || error?.statusCode === 503 || error?.name === 'NetworkError';
const $3eb6aec6bd421b16$var$waitTimeMs = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $3eb6aec6bd421b16$export$c3c863e65cddb513 = (baseIntervalMs, maxPollingIntervalMs, exponentialBase, retryCount)=>{
    const time = baseIntervalMs * exponentialBase ** retryCount;
    return time > maxPollingIntervalMs ? maxPollingIntervalMs : time;
};
const $3eb6aec6bd421b16$export$20eaa22f2295996f = (callback, baseIntervalMs, maxPollingInterval, exponentialBase, retryCount = 0)=>callback().then((shouldRetry)=>shouldRetry && $3eb6aec6bd421b16$var$waitTimeMs($3eb6aec6bd421b16$export$c3c863e65cddb513(baseIntervalMs, maxPollingInterval, exponentialBase, retryCount)).then(()=>$3eb6aec6bd421b16$export$20eaa22f2295996f(callback, baseIntervalMs, maxPollingInterval, exponentialBase, retryCount + 1)));

});
parcelRegister("hmhzd", function(module, exports) {

$parcel$export(module.exports, "TransferStatus", () => $7f1b77f714ac571e$export$91301ebb6ad45fab);
const $7f1b77f714ac571e$export$7d7a98f44861e6f7 = {
    JIRA_PROJECT: 'JiraProject',
    SITE: 'Site'
};
const $7f1b77f714ac571e$export$91301ebb6ad45fab = {
    READY: 'READY',
    IN_PROGRESS: 'IN_PROGRESS',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
    SKIPPED: 'SKIPPED',
    INCOMPLETE: 'INCOMPLETE',
    CANCELLED: 'CANCELLED'
};

});






parcelRegister("lIDet", function(module, exports) {

$parcel$export(module.exports, "ThemePicker", () => $38cbfafa72d9bc58$export$75505f096a733fb9);
/* ThemePicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $IaDcR = parcelRequire("IaDcR");

var $5KCCi = parcelRequire("5KCCi");

var $jgJNO = parcelRequire("jgJNO");

var $j5YhT = parcelRequire("j5YhT");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $kaHBi = parcelRequire("kaHBi");

var $pa9q9 = parcelRequire("pa9q9");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $g8I5C = parcelRequire("g8I5C");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $ky2ui = parcelRequire("ky2ui");

var $koeKL = parcelRequire("koeKL");

var $jpH5a = parcelRequire("jpH5a");

var $ca7Zi = parcelRequire("ca7Zi");

var $lwRIP = parcelRequire("lwRIP");

var $22OQR = parcelRequire("22OQR");

var $7qHTI = parcelRequire("7qHTI");

var $ggJP8 = parcelRequire("ggJP8");
const $38cbfafa72d9bc58$var$SOURCE_NAME = 'projectThemePicker';
const $38cbfafa72d9bc58$var$messages = (0, $7VHMR.defineMessages)({
    backgroundTitle: {
        "id": "business-theme-components.theme-picker.background-title",
        "defaultMessage": "Project background"
    },
    buttonTitle: {
        "id": "business-theme-components.theme-picker.button-title",
        "defaultMessage": "Set project background"
    },
    errorFlagTitle: {
        "id": "business-theme-components.theme-picker.error-flag-title",
        "defaultMessage": "Something's gone wrong"
    },
    errorFlagDescription: {
        "id": "business-theme-components.theme-picker.error-flag-description",
        "defaultMessage": "Our team has been notified. If the problem persists, please contact Atlassian Support."
    }
});
const $38cbfafa72d9bc58$export$bb0d35c1fc48487f = {
    id: 'open-theme-picker-error',
    type: 'error',
    title: $38cbfafa72d9bc58$var$messages.errorFlagTitle,
    description: $38cbfafa72d9bc58$var$messages.errorFlagDescription,
    isAutoDismiss: true,
    messageId: 'project-theme-components.ui.theme-picker-nav3.popup-entrypoint-error-flag.error.error.open-theme-picker-error',
    messageType: 'transactional'
}; /**
    * Nav3 version of the ThemePicker component. Should not be used when nav4 is enabled.
    * Do not introduce nav4 checks in this component.
    * The nav4 version of this component is located at ../theme-picker/ThemePicker.tsx
    *
    * Remove this component when the jira_nav4 feature gate is cleaned up.
    */ 
const $38cbfafa72d9bc58$export$75505f096a733fb9 = /*#__PURE__*/ (0, $5uXOq.memo)(({ isOpen: isOpen, onOpenChange: onOpenChange, projectId: projectId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const projectAri = (0, $j5YhT.JiraProjectAri).create({
        siteId: cloudId,
        projectId: String(projectId)
    }).toString();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $7qHTI.backgroundPickerPopupContentEntryPoint), (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectAri: projectAri
        }), [
        cloudId,
        projectAri
    ]));
    const startExperience = (0, $kaHBi.useExperienceStart)((0, $jpH5a.VIEW_THEME_PICKER_EXPERIENCE));
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [flagShown, setFlagShown] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [openState, setOpenState] = (0, $5uXOq.useState)(false);
    const isThemePickerOpen = isOpen || openState;
    const setIsThemePickerOpen = onOpenChange || setOpenState;
    const toggleThemePicker = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (_, analyticsEvent)=>{
        // If we are about to open the theme picker, start the experience
        if (!isThemePickerOpen) startExperience();
        setIsThemePickerOpen((oldValue)=>!oldValue);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent ?? createAnalyticsEvent({}), 'button clicked', 'themePickerButton');
        setFlagShown(false);
    }, [
        isThemePickerOpen,
        startExperience,
        setIsThemePickerOpen,
        createAnalyticsEvent
    ]);
    const renderNudgeWrapper = (0, $5uXOq.useCallback)((children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ky2ui.BackgroundColourNudgeAsync), null, children), []);
    const buttonTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onOpenChange: setIsThemePickerOpen
        }), [
        setIsThemePickerOpen
    ]);
    const trigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
            content: formatMessage($38cbfafa72d9bc58$var$messages.buttonTitle),
            hideTooltipOnClick: true,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($38cbfafa72d9bc58$var$RoundButton, {
            ...triggerProps,
            testId: "project-theme-components.ui.theme-picker.button",
            isSelected: isThemePickerOpen,
            ref: (element)=>{
                buttonTrigger(element);
                if (typeof triggerProps.ref === 'function') triggerProps.ref(element);
            },
            onClick: toggleThemePicker,
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($IaDcR))), {
                label: formatMessage($38cbfafa72d9bc58$var$messages.buttonTitle),
                LEGACY_size: "medium",
                spacing: "spacious"
            })
        })), [
        buttonTrigger,
        formatMessage,
        isThemePickerOpen,
        toggleThemePicker
    ]);
    const errorFallback = (0, $5uXOq.useCallback)(({ error: error })=>{
        if (!flagShown) {
            showFlag($38cbfafa72d9bc58$export$bb0d35c1fc48487f);
            setFlagShown(true);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ca7Zi.ExperienceFailed), {
            experience: (0, $jpH5a.VIEW_THEME_PICKER_EXPERIENCE),
            error: error
        });
    }, [
        flagShown,
        showFlag
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "background-picker-popup-content",
            packageName: "@atlassian/jira-project-theme-components",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ggJP8.ThemePickerSkeleton), null),
            errorFallback: errorFallback,
            runtimeProps: runtimeProps
        }), [
        errorFallback,
        entryPointReferenceSubject,
        runtimeProps
    ]);
    const onCloseHandler = (0, $5uXOq.useCallback)(()=>setIsThemePickerOpen(false), [
        setIsThemePickerOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g8I5C.QuickstartNudge), {
        renderWrapper: renderNudgeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: $38cbfafa72d9bc58$var$SOURCE_NAME,
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isThemePickerOpen,
        onClose: onCloseHandler,
        shouldRenderToParent: false,
        content: content,
        trigger: trigger,
        placement: "bottom-start",
        id: (0, $lwRIP.THEME_PICKER_ELEMENT_ID),
        messageId: "project-theme-components.ui.theme-picker-nav3.popup.theme-picker-nav3",
        messageType: "transactional"
    })));
});
/* Seems like the only way to get a rounded button. Because atlaskit button already has a border radius !important is required */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $38cbfafa72d9bc58$var$RoundButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $22OQR.ThemedButton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoaq80",
            __cmplp.className
        ])
    });
});

});
parcelRegister("IaDcR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7b72e4cfb1948d4b5694556923ff149>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $084c5b57c86b975d$var$_react = $084c5b57c86b975d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $084c5b57c86b975d$var$_paintBucket = $084c5b57c86b975d$var$_interopRequireDefault((parcelRequire("hB9a3")));

var $084c5b57c86b975d$var$_backgroundColor = $084c5b57c86b975d$var$_interopRequireDefault((parcelRequire("17EmJ")));
function $084c5b57c86b975d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PaintBucketIcon.
 * This component is PaintBucketIcon, with `UNSAFE_fallbackIcon` set to "EditorBackgroundColorIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Customize fill color.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $084c5b57c86b975d$var$PaintBucketIcon = (props)=>/*#__PURE__*/ $084c5b57c86b975d$var$_react.default.createElement($084c5b57c86b975d$var$_paintBucket.default, Object.assign({
        LEGACY_fallbackIcon: $084c5b57c86b975d$var$_backgroundColor.default
    }, props));
$084c5b57c86b975d$var$PaintBucketIcon.Name = 'PaintBucketIconMigration';
var $084c5b57c86b975d$var$_default = module.exports.default = $084c5b57c86b975d$var$PaintBucketIcon;

});
parcelRegister("hB9a3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83080ad07e1bfea64637edcdcb5973cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ccfcff99e8186679$var$_react = $ccfcff99e8186679$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ccfcff99e8186679$var$_baseNew = $ccfcff99e8186679$var$_interopRequireDefault((parcelRequire("enEmH")));
function $ccfcff99e8186679$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PaintBucket".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Customize fill color.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ccfcff99e8186679$var$PaintBucketIcon = (props)=>/*#__PURE__*/ $ccfcff99e8186679$var$_react.default.createElement($ccfcff99e8186679$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.655.095 13.78 8.22a.75.75 0 0 1 0 1.06l-5.616 5.617a2 2 0 0 1-2.828 0L.604 10.164a2 2 0 0 1 0-2.828L5.689 2.25 4.595 1.155zM6.75 3.31 2.06 8h9.38zm4.69 6.19H2.06l4.336 4.335a.5.5 0 0 0 .708 0z" clip-rule="evenodd"/><path fill="currentcolor" d="M14.5 12a.75.75 0 0 0-.654.383v.002l-.003.003-.007.013-.026.046a16 16 0 0 0-.36.695 8 8 0 0 0-.283.642c-.068.176-.167.457-.167.716a1.5 1.5 0 0 0 3 0c0-.259-.1-.54-.167-.716a8 8 0 0 0-.284-.642 16 16 0 0 0-.36-.695l-.025-.046-.007-.013-.002-.004-.001-.001A.75.75 0 0 0 14.5 12"/>`
    }, props));
$ccfcff99e8186679$var$PaintBucketIcon.displayName = 'PaintBucketIcon';
var $ccfcff99e8186679$var$_default = module.exports.default = $ccfcff99e8186679$var$PaintBucketIcon;

});

parcelRegister("17EmJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d15c1aa5923f306$var$_react = $0d15c1aa5923f306$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $0d15c1aa5923f306$var$_paintBucket = $0d15c1aa5923f306$var$_interopRequireDefault((parcelRequire("hB9a3")));
function $0d15c1aa5923f306$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0d15c1aa5923f306$var$EditorBackgroundColorIcon = (props)=>/*#__PURE__*/ $0d15c1aa5923f306$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m7.818 12.56 4.243 4.243 4.242-4.242-4.242-4.243zm-1.414 1.415a1.995 1.995 0 0 1 0-2.828l4.243-4.243a1.995 1.995 0 0 1 2.828 0l4.243 4.243c.78.78.786 2.041 0 2.828l-4.243 4.243a1.996 1.996 0 0 1-2.828 0zM6.5 13h11l-5.44 5.218zm2.732-8.925a1 1 0 0 1 1.414 0l3.536 3.536-1.414 1.414L9.232 5.49a1 1 0 0 1 0-1.415M18 16s1.5 2 1.5 3.5c0 1-1 1.5-1.5 1.5s-1.5-.4-1.5-1.5C16.5 18 18 16 18 16"/></svg>`
    }, props, {
        newIcon: $0d15c1aa5923f306$var$_paintBucket.default
    }));
$0d15c1aa5923f306$var$EditorBackgroundColorIcon.displayName = 'EditorBackgroundColorIcon';
var $0d15c1aa5923f306$var$_default = module.exports.default = $0d15c1aa5923f306$var$EditorBackgroundColorIcon;

});


parcelRegister("g8I5C", function(module, exports) {

$parcel$export(module.exports, "QuickstartNudge", () => $0174d522ba9dfb06$export$bd61ee610c74db6c);

var $5uXOq = parcelRequire("5uXOq");

var $6OJ73 = parcelRequire("6OJ73");

var $axUP7 = parcelRequire("axUP7");
const $0174d522ba9dfb06$export$bd61ee610c74db6c = (0, $axUP7.withNestingOptimisation)(({ renderWrapper: renderWrapper, children: children })=>{
    const isFullyExpanded = (0, $6OJ73.useIsFullyExpanded)();
    return isFullyExpanded ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
});

});
parcelRegister("6OJ73", function(module, exports) {

$parcel$export(module.exports, "useIsFullyExpanded", () => $c20291d4f7970c77$export$7212b6b01271f5d1);

var $5uXOq = parcelRequire("5uXOq");

var $gPQRI = parcelRequire("gPQRI");
const $c20291d4f7970c77$var$TIMEOUT = 500;
const $c20291d4f7970c77$export$7212b6b01271f5d1 = ()=>{
    const [ready, setReady] = (0, $5uXOq.useState)(false);
    const { isCollapsed: isCollapsed } = (0, $gPQRI.useLeftSidebarState)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setReady(!isCollapsed);
        }, $c20291d4f7970c77$var$TIMEOUT);
        return ()=>clearTimeout(timeoutId);
    }, [
        isCollapsed
    ]);
    return ready && !isCollapsed;
};

});
parcelRegister("gPQRI", function(module, exports) {

$parcel$export(module.exports, "useLeftSidebarState", () => $b19712b3cdd78134$export$610d81e163a897b3);
$parcel$export(module.exports, "useLeftSidebarController", () => $b19712b3cdd78134$export$900f29014a48fb23);

var $5uXOq = parcelRequire("5uXOq");

var $iqLcb = parcelRequire("iqLcb");

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $b19712b3cdd78134$var$useSweetStateLeftSidebarState = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>({
            ...state.content.leftSidebar,
            shouldRender: !state.isChromeless
        })
});
const $b19712b3cdd78134$export$610d81e163a897b3 = ()=>{
    const [leftSidebar] = $b19712b3cdd78134$var$useSweetStateLeftSidebarState();
    return leftSidebar;
};
const $b19712b3cdd78134$export$900f29014a48fb23 = ()=>{
    const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, $iqLcb.usePageLayoutResize)();
    return (0, $5uXOq.useMemo)(()=>({
            collapseLeftSidebar: collapseLeftSidebar,
            expandLeftSidebar: expandLeftSidebar
        }), [
        collapseLeftSidebar,
        expandLeftSidebar
    ]);
};

});
parcelRegister("iqLcb", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $3d7d84f3bc65155e$export$6d1402fb58384e4f);
$parcel$export(module.exports, "Banner", () => $3d7d84f3bc65155e$export$3b4e64e77073e307);
$parcel$export(module.exports, "TopNavigation", () => $3d7d84f3bc65155e$export$8a421bddecb2bf5b);
$parcel$export(module.exports, "LeftPanel", () => $3d7d84f3bc65155e$export$110709f040143804);
$parcel$export(module.exports, "LeftSidebarWithoutResize", () => $3d7d84f3bc65155e$export$43ae342508cf8cc9);
$parcel$export(module.exports, "LeftSidebar", () => $3d7d84f3bc65155e$export$3cabf771c4f2de);
$parcel$export(module.exports, "Main", () => $3d7d84f3bc65155e$export$861edd1ccea2f746);
$parcel$export(module.exports, "Content", () => $3d7d84f3bc65155e$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "RightSidebar", () => $3d7d84f3bc65155e$export$84d58c19c21f637f);
$parcel$export(module.exports, "RightPanel", () => $3d7d84f3bc65155e$export$364a989a35814102);
$parcel$export(module.exports, "useCustomSkipLink", () => $3d7d84f3bc65155e$export$ee6b12c2613bdf8e);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $3d7d84f3bc65155e$export$94561f6055639ef7);
$parcel$export(module.exports, "usePageLayoutResize", () => $3d7d84f3bc65155e$export$10c7104037a7af62);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", () => $3d7d84f3bc65155e$export$991ef8098f87814a);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$7eaf986ecb4d5cac);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$e95b388ca8c92019);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$2ab8b83eed76656c);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$ac017575d43f5da);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", () => $3d7d84f3bc65155e$export$d697087c06fd5e25);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $gWVyJ = parcelRequire("gWVyJ");
var $l2AH9 = parcelRequire("l2AH9");
var $iCvLW = parcelRequire("iCvLW");
var $56fJj = parcelRequire("56fJj");
var $by9S8 = parcelRequire("by9S8");
var $7Stls = parcelRequire("7Stls");
var $33D3Q = parcelRequire("33D3Q");
var $jreT6 = parcelRequire("jreT6");
var $3IHID = parcelRequire("3IHID");
var $7EYXE = parcelRequire("7EYXE");
var $3fzVB = parcelRequire("3fzVB");
var $02o6B = parcelRequire("02o6B");

var $3HwlS = parcelRequire("3HwlS");

var $geqKu = parcelRequire("geqKu");
var $7YDkZ = parcelRequire("7YDkZ");
var $gXjR2 = parcelRequire("gXjR2");
var $ehQHm = parcelRequire("ehQHm");
var $dkD6V = parcelRequire("dkD6V");
var $jN4ko = parcelRequire("jN4ko");
var $fZJPK = parcelRequire("fZJPK");
function $3d7d84f3bc65155e$export$6d1402fb58384e4f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dkD6V.Root), {
        UNSAFE_dangerouslyHoistSlotSizes: true,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $33D3Q.default), props);
}
function $3d7d84f3bc65155e$export$3b4e64e77073e307(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7YDkZ.Banner), {
        UNSAFE_height: props.height,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gWVyJ.default), props);
}
function $3d7d84f3bc65155e$export$8a421bddecb2bf5b(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fZJPK.TopBar), {
        UNSAFE_height: props.height,
        testId: props.testId,
        UNSAFE_theme: props.theme
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7EYXE.default), props);
}
function $3d7d84f3bc65155e$export$110709f040143804(props) {
    // LeftPanel is not supported in new page layout
    return (0, $3HwlS.getWillShowNav4)() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iCvLW.default), props);
}
function $3d7d84f3bc65155e$export$43ae342508cf8cc9(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jN4ko.SideNav), {
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $by9S8.default), props);
}
function $3d7d84f3bc65155e$export$3cabf771c4f2de(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jN4ko.SideNav), {
        defaultCollapsed: props.collapsedState === 'collapsed',
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $56fJj.default), props);
}
function $3d7d84f3bc65155e$export$861edd1ccea2f746(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gXjR2.Main), {
        isFixed: props.isFixed,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Stls.default), props);
}
function $3d7d84f3bc65155e$export$7c6e2c02157bb7d2(props) {
    return (0, $3HwlS.getWillShowNav4)() ? // There isn't a concept of a `Content` wrapper component in the new page layout
    props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l2AH9.default), props);
}
function $3d7d84f3bc65155e$export$84d58c19c21f637f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $geqKu.Aside), {
        isFixed: props.isFixed,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3IHID.default), props);
}
function $3d7d84f3bc65155e$export$364a989a35814102(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehQHm.Panel), {
        xcss: $3d7d84f3bc65155e$var$rightPanelStyles.root,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jreT6.default), props);
}
const $3d7d84f3bc65155e$export$ee6b12c2613bdf8e = (id, title, index)=>(0, $3HwlS.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3fzVB.useCustomSkipLink)(id, title, index);
const $3d7d84f3bc65155e$export$94561f6055639ef7 = ()=>(0, $3HwlS.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $02o6B.useLeftSidebarFlyoutLock)();
// A mock value is needed to match the signature of the hook
const $3d7d84f3bc65155e$var$mockPageLayoutResize = {
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    collapseLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    leftSidebarState: {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    },
    setLeftSidebarState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    toggleLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $3d7d84f3bc65155e$export$10c7104037a7af62 = ()=>(0, $3HwlS.getWillShowNav4)() ? $3d7d84f3bc65155e$var$mockPageLayoutResize : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $02o6B.usePageLayoutResize)();
const $3d7d84f3bc65155e$var$rightPanelStyles = {
    root: "_bfhk1bhr"
};
const $3d7d84f3bc65155e$export$991ef8098f87814a = (0, $62b79b702763d93f$export$ed7cc0d417ee89e);
const $3d7d84f3bc65155e$export$7eaf986ecb4d5cac = (0, $62b79b702763d93f$export$f963aecf2d4465bd);
const $3d7d84f3bc65155e$export$e95b388ca8c92019 = (0, $62b79b702763d93f$export$f897e1ed9f8ed251);
const $3d7d84f3bc65155e$export$2ab8b83eed76656c = (0, $62b79b702763d93f$export$750459958906793);
const $3d7d84f3bc65155e$export$ac017575d43f5da = (0, $62b79b702763d93f$export$b44ab66843c05a69);
const $3d7d84f3bc65155e$export$d697087c06fd5e25 = (0, $62b79b702763d93f$export$aeff86a16f13529);

});
// dimension vars
const $62b79b702763d93f$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $62b79b702763d93f$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $62b79b702763d93f$export$c103b605cd368aed = 'rightSidebarWidth';
const $62b79b702763d93f$export$fa34f417972d6341 = 'rightPanelWidth';
const $62b79b702763d93f$export$3a6a779d9181047c = 'topNavigationHeight';
const $62b79b702763d93f$export$bcd94a6a792e7f96 = 'bannerHeight';
const $62b79b702763d93f$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $62b79b702763d93f$export$344062f7cfc9528e = 'left-panel';
const $62b79b702763d93f$export$c7139cc2d6110b5f = 'right-panel';
const $62b79b702763d93f$export$238d30785c4bca84 = 'banner';
const $62b79b702763d93f$export$bec6dca2e63de4ae = 'top-navigation';
const $62b79b702763d93f$export$d1213e82613ff4df = 'content';
const $62b79b702763d93f$export$be83e7118304b28e = 56;
const $62b79b702763d93f$export$4a98ee0bd1ae362 = 56;
const $62b79b702763d93f$export$539e68c09584883a = 240;
const $62b79b702763d93f$export$b92df8810d2fcd01 = 280;
const $62b79b702763d93f$export$c3e41153b9288bcf = 368;
const $62b79b702763d93f$export$c4d6152f86ea28f6 = 368;
const $62b79b702763d93f$export$46acf8758e9e2636 = 20;
const $62b79b702763d93f$export$70740f5ad8360a78 = 16;
const $62b79b702763d93f$export$991d5285ad765a3d = 240;
const $62b79b702763d93f$export$6949d4f32b161684 = 200;
const $62b79b702763d93f$export$d6e7e8af042815bb = 350;
const $62b79b702763d93f$export$3749e1104328fde4 = 300;
const $62b79b702763d93f$export$1074d925b0b82be5 = 200;
const $62b79b702763d93f$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $62b79b702763d93f$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $62b79b702763d93f$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $62b79b702763d93f$export$70c702a8c5895f03 = 'data-grab-area-line';
const $62b79b702763d93f$export$48a43f91e4becf4e = 'data-grab-area';
const $62b79b702763d93f$export$dac2fb31a9f6844d = 'data-resize-button';
const $62b79b702763d93f$export$9ecd22db14e6c70e = 'data-resize-control';
const $62b79b702763d93f$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $62b79b702763d93f$export$206a08f7f8beb554 = 'Skip to:';
const $62b79b702763d93f$export$659ee746b31b360d = 'data-layout-container';
const $62b79b702763d93f$export$f963aecf2d4465bd = `var(--${$62b79b702763d93f$export$cbfb0f5b2869b17b}, 0px)`;
const $62b79b702763d93f$export$750459958906793 = `var(--${$62b79b702763d93f$export$fa34f417972d6341}, 0px)`;
const $62b79b702763d93f$export$f897e1ed9f8ed251 = `var(--${$62b79b702763d93f$export$a30f2e00489a8957}, 0px)`;
const $62b79b702763d93f$export$b44ab66843c05a69 = `var(--${$62b79b702763d93f$export$c103b605cd368aed}, 0px)`;
const $62b79b702763d93f$export$aeff86a16f13529 = `var(--${$62b79b702763d93f$export$3a6a779d9181047c}, 0px)`;
const $62b79b702763d93f$export$ed7cc0d417ee89e = `var(--${$62b79b702763d93f$export$bcd94a6a792e7f96}, 0px)`;
const $62b79b702763d93f$export$d2fa14f05b61e66 = `var(--${$62b79b702763d93f$export$b6744d31294864fd}, ${$62b79b702763d93f$export$991d5285ad765a3d}px)`;


parcelRegister("5e5zm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $0c99a19d69d506cf$export$539e68c09584883a);
$parcel$export(module.exports, "layoutStore", () => $0c99a19d69d506cf$export$b8cdfd44cddaf07);
$parcel$export(module.exports, "useLayoutStoreActions", () => $0c99a19d69d506cf$export$6136bc3b9858cff4);
$parcel$export(module.exports, "useDetailPanelWidth", () => $0c99a19d69d506cf$export$95fd7b6da3b9bbb0);
$parcel$export(module.exports, "useDetailPanelActions", () => $0c99a19d69d506cf$export$99e05a60cac05e86);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $8CM3x = parcelRequire("8CM3x");
const $0c99a19d69d506cf$export$539e68c09584883a = 240;
const $0c99a19d69d506cf$export$b92df8810d2fcd01 = 0;
const $0c99a19d69d506cf$var$initialState = {
    isChromeless: false,
    isFullscreen: false,
    banner: {
        height: 0,
        activeBanner: null
    },
    topNavigation: {
        isVisible: true
    },
    leftPanel: {
        isVisible: true,
        width: 0
    },
    rightPanel: {
        isVisible: true,
        width: 0
    },
    bottomRightCorner: {
        container: undefined,
        portals: []
    },
    content: {
        leftSidebar: {
            width: $0c99a19d69d506cf$export$539e68c09584883a,
            isCollapsed: true,
            isVisible: true,
            isFlyoutOpen: false
        },
        rightSidebar: {
            stackState: []
        }
    }
};
const $0c99a19d69d506cf$export$b8cdfd44cddaf07 = (0, $iXqE5.createStore)({
    initialState: $0c99a19d69d506cf$var$initialState,
    actions: $8CM3x.actions,
    name: 'JiraLayoutStore'
});
const $0c99a19d69d506cf$export$6136bc3b9858cff4 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$export$b8cdfd44cddaf07, {
    selector: null
});
const $0c99a19d69d506cf$var$detailPanelWidthStore = (0, $iXqE5.createStore)({
    name: 'detailPanelWidth',
    initialState: {
        width: 0
    },
    actions: {
        setWidth: (value)=>({ setState: setState })=>{
                setState({
                    width: value
                });
            }
    }
});
const $0c99a19d69d506cf$export$95fd7b6da3b9bbb0 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
const $0c99a19d69d506cf$export$99e05a60cac05e86 = (0, $3sQ5x.createActionsHook)($0c99a19d69d506cf$var$detailPanelWidthStore);

});
parcelRegister("8CM3x", function(module, exports) {

$parcel$export(module.exports, "actions", () => $939ad82f8ddcb8d9$export$e324594224ef24da);

var $4oU0I = parcelRequire("4oU0I");

var $flhve = parcelRequire("flhve");

var $f5TQt = parcelRequire("f5TQt");

var $hPsAX = parcelRequire("hPsAX");

var $gqQUV = parcelRequire("gqQUV");

var $byk51 = parcelRequire("byk51");
const $939ad82f8ddcb8d9$export$e324594224ef24da = {
    setIsChromeless: // global
    $f5TQt.setIsChromeless,
    setIsFullscreen: $hPsAX.setIsFullscreen,
    showBanner: // banner
    $4oU0I.showBanner,
    dismissCurrentBanner: $4oU0I.dismissCurrentBanner,
    setLeftSidebarState: // left-sidebar
    $gqQUV.setLeftSidebarState,
    setRightSidebarState: // right-sidebar
    $byk51.setRightSidebarState,
    openRightSidebar: $byk51.openRightSidebar,
    closeRightSidebar: $byk51.closeRightSidebar,
    closeAllRightSidebar: $byk51.closeAllRightSidebar,
    closeCurrentRightSidebar: $byk51.closeCurrentRightSidebar,
    minimiseRightSidebar: $byk51.minimiseRightSidebar,
    registerBottomRightCornerContainer: // bottom-right-corner
    $flhve.registerBottomRightCornerContainer,
    insertBottomRightCornerPortal: $flhve.insertBottomRightCornerPortal,
    removeBottomRightCornerPortal: $flhve.removeBottomRightCornerPortal
};

});
parcelRegister("4oU0I", function(module, exports) {

$parcel$export(module.exports, "showBanner", () => $820929f36789bf81$export$f5c0eb035ef26e87);
$parcel$export(module.exports, "dismissCurrentBanner", () => $820929f36789bf81$export$a45bccc0cc9ac424);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $820929f36789bf81$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
        setState({
            banner: newState
        });
    };
const $820929f36789bf81$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
        dispatch($820929f36789bf81$export$f5c0eb035ef26e87({
            height: 0,
            activeBanner: null
        }));
    };

});

parcelRegister("flhve", function(module, exports) {

$parcel$export(module.exports, "registerBottomRightCornerContainer", () => $560ff4740e75fa9e$export$2992ecf780497763);
$parcel$export(module.exports, "insertBottomRightCornerPortal", () => $560ff4740e75fa9e$export$3ed25a6bee272520);
$parcel$export(module.exports, "removeBottomRightCornerPortal", () => $560ff4740e75fa9e$export$928bf7e228ce06d2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $560ff4740e75fa9e$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                container: ref ?? undefined
            }
        });
    };
const $560ff4740e75fa9e$export$3ed25a6bee272520 = (item)=>// @ts-expect-error - TS2322 - Type '({ setState, getState }: StoreActionApi<LayoutState>) => number' is not assignable to type 'Action<LayoutState, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        const sorted = [
            item,
            ...portals
        ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
        const index = sorted.findIndex((portal)=>portal.id === item.id);
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: sorted
            }
        });
        return index;
    };
const $560ff4740e75fa9e$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: portals.filter((portal)=>portal.id !== id)
            }
        });
    };

});

parcelRegister("f5TQt", function(module, exports) {

$parcel$export(module.exports, "setIsChromeless", () => $0389a2d5715d1f25$export$1998c4816ad37edb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $0389a2d5715d1f25$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
        setState({
            isChromeless: isChromeless
        });
    };

});

parcelRegister("hPsAX", function(module, exports) {

$parcel$export(module.exports, "setIsFullscreen", () => $e3c9e6899dc6b3f0$export$9c73b2f282069160);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e3c9e6899dc6b3f0$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
        setState({
            isFullscreen: isFullscreen
        });
    };

});

parcelRegister("gqQUV", function(module, exports) {

$parcel$export(module.exports, "setLeftSidebarState", () => $54ca906cbb882b25$export$3e0fd2d894ef83c8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $54ca906cbb882b25$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                leftSidebar: {
                    ...content.leftSidebar,
                    ...newState
                }
            }
        });
    };

});

parcelRegister("byk51", function(module, exports) {

$parcel$export(module.exports, "selectCurrentRightSidebar", () => $4dabd377b098e1a2$export$57758d0cfaeec2c);
$parcel$export(module.exports, "setRightSidebarState", () => $4dabd377b098e1a2$export$f5584170a8c1db02);
$parcel$export(module.exports, "closeAllRightSidebar", () => $4dabd377b098e1a2$export$d91a6e55d52aa3e9);
$parcel$export(module.exports, "closeCurrentRightSidebar", () => $4dabd377b098e1a2$export$a9a5075d3d1b2165);
$parcel$export(module.exports, "closeRightSidebar", () => $4dabd377b098e1a2$export$d7149233c76efb32);
$parcel$export(module.exports, "minimiseRightSidebar", () => $4dabd377b098e1a2$export$4eedf7fa26a2749a);
$parcel$export(module.exports, "openRightSidebar", () => $4dabd377b098e1a2$export$c8dafe074328c4ca);

var $ajpes = parcelRequire("ajpes");
const $4dabd377b098e1a2$var$arrayMove = (array, oldIndex, newIndex)=>{
    const arrayCopy = [
        ...array
    ];
    const f = arrayCopy.splice(oldIndex, 1)[0];
    arrayCopy.splice(newIndex, 0, f);
    return arrayCopy;
};
const $4dabd377b098e1a2$var$dedupe = (stackState = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visited = {};
    return stackState.filter((item)=>{
        if (visited[item.panelId]) return false;
        visited[item.panelId] = true;
        return true;
    });
};
const $4dabd377b098e1a2$export$57758d0cfaeec2c = (state)=>{
    if (state.stackState.length === 1) return state.stackState[0];
    return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
};
const $4dabd377b098e1a2$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: $4dabd377b098e1a2$var$dedupe(newState.stackState)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: []
                }
            }
        });
    };
const $4dabd377b098e1a2$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        if (!currentStack.length) return;
        const currentRightSidebar = $4dabd377b098e1a2$export$57758d0cfaeec2c(content.rightSidebar);
        if (!currentRightSidebar) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.filter((item)=>item.panelId !== panelId)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.map((item)=>{
                        if (item.panelId !== panelId) return item;
                        return {
                            ...item,
                            isMinimised: true
                        };
                    })
                }
            }
        });
    };
const $4dabd377b098e1a2$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
            ...content.rightSidebar.stackState.map((item)=>{
                if (item.panelId === panelId) return {
                    ...item,
                    isMinimised: isMinimised,
                    width: width
                };
                return item;
            })
        ] : [];
        const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
        // if there's any matched panel id, we only move it to the top of the stack.
        if (matchedPanelIndex >= 0) {
            const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
            tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
            tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
            const newRightSidebarStackStateValue = $4dabd377b098e1a2$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
            newRightSidebarStackStateValue[nextIdx].width = width;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
            return;
        }
        const newRightSidebarStackStateValue = toTop ? [
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            },
            ...tempRightSidebarStackStateValue
        ] : [
            ...tempRightSidebarStackStateValue,
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            }
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: newRightSidebarStackStateValue
                }
            }
        });
    };

});





parcelRegister("axUP7", function(module, exports) {

$parcel$export(module.exports, "withNestingOptimisation", () => $c861ce2b697701b9$export$ee1cb2a8280d8710);

var $5uXOq = parcelRequire("5uXOq");

var $fsi33 = parcelRequire("fsi33");

var $9sGI6 = parcelRequire("9sGI6");
const $c861ce2b697701b9$export$ee1cb2a8280d8710 = (Component)=>{
    const WithNestingOptimisation = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
        const children = // @ts-expect-error - Property 'children' does not exist on type 'Props'.ts(2339)
        typeof props === 'object' && props != null ? props.children : null;
        return (0, $fsi33.useShouldNestedElementRender)().shouldRender && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            ref: ref
        }) : children;
    });
    WithNestingOptimisation.displayName = `withNestingOptimisation(${(0, $9sGI6.getDisplayName)(Component)})`;
    return WithNestingOptimisation;
};

});
parcelRegister("9sGI6", function(module, exports) {

$parcel$export(module.exports, "getDisplayName", () => $0d4ebae82d1d47ab$export$be63e0664592e141);
$parcel$export(module.exports, "default", () => $0d4ebae82d1d47ab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $0d4ebae82d1d47ab$export$be63e0664592e141 = (WrappedComponent)=>{
    if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
    if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
    return 'Component';
};
/**
 * @deprecated Just pass the props explicitly or create a new component that provides them. Do not use HOCs.
 */ const $0d4ebae82d1d47ab$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
    const WithInjectedProps = (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...injectedProps,
            ...props
        });
    WithInjectedProps.displayName = `withInjectedProps(${$0d4ebae82d1d47ab$export$be63e0664592e141(WrappedComponent)})`;
    return WithInjectedProps;
};
var $0d4ebae82d1d47ab$export$2e2bcd8739ae039 = $0d4ebae82d1d47ab$var$withInjectedProps;

});



parcelRegister("ky2ui", function(module, exports) {

$parcel$export(module.exports, "BackgroundColourNudgeAsync", () => $cb3deafbb4dbbb82$export$a3dbb521061a599a);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cb3deafbb4dbbb82$var$BackgroundColourNudgeLazy = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("5fQMX")).then((exportedModule)=>exportedModule.BackgroundColourNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges-jwm-background-color/src/index.tsx"
});
const $cb3deafbb4dbbb82$export$a3dbb521061a599a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $d231c4839441ff18$export$eb0b199de90a7ec2),
        fallback: children,
        attributes: {
            nudgeId: (0, $d231c4839441ff18$export$eb0b199de90a7ec2)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "background-colour-onboarding-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb3deafbb4dbbb82$var$BackgroundColourNudgeLazy, null, children)));
$cb3deafbb4dbbb82$export$a3dbb521061a599a.displayName = 'BackgroundColourNudgeAsync';

});
parcelRegister("bBbEG", function(module, exports) {

$parcel$export(module.exports, "OnboardingNudgeErrorBoundary", () => $383be1d115a6551b$export$3915a8814b99f0b);

var $5uXOq = parcelRequire("5uXOq");

var $lkem5 = parcelRequire("lkem5");

var $8Bc5A = parcelRequire("8Bc5A");
const $383be1d115a6551b$export$3915a8814b99f0b = (props)=>{
    const { id: id, attributes: attributes, fallback: fallback, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkem5.ErrorBoundaryWithChunkErrorLogging), {
        id: id,
        packageName: (0, $8Bc5A.PACKAGE_NAME),
        render: ()=>fallback,
        attributes: attributes
    }, children);
};

});
parcelRegister("lkem5", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryWithChunkErrorLogging", () => $3df8b034ebbd68e5$export$9171acf2e93b7d4d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $30rnQ = parcelRequire("30rnQ");
const $3df8b034ebbd68e5$export$9171acf2e93b7d4d = (props)=>{
    const { attributes: attributes, children: children, ...rest } = props;
    const addErrorBoundaryAnalyticsAttributes = (0, $30rnQ.useAddErrorBoundaryAnalyticsAttributes)(attributes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        ...rest,
        attributes: addErrorBoundaryAnalyticsAttributes
    }, children);
};

});
parcelRegister("30rnQ", function(module, exports) {

$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $53c68ff9a9edd0fe$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", () => $53c68ff9a9edd0fe$export$807be5f3f1ea996);

var $5uXOq = parcelRequire("5uXOq");

var $3vs13 = parcelRequire("3vs13");
const $53c68ff9a9edd0fe$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $3vs13.isLoaderError)(error)
    });
const $53c68ff9a9edd0fe$export$807be5f3f1ea996 = (attributes = {})=>(0, $5uXOq.useCallback)((error)=>({
            ...attributes,
            ...$53c68ff9a9edd0fe$export$94ee0b5fca1e74d2(error)
        }), [
        attributes
    ]);

});


parcelRegister("8Bc5A", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $5f07ce956337ba8b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $5f07ce956337ba8b$export$2b3151a089bc8780);
$parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", () => $5f07ce956337ba8b$export$6826d33e9a2c0119);
$parcel$export(module.exports, "ROOT_TASK", () => $5f07ce956337ba8b$export$b580da85daad7757);
$parcel$export(module.exports, "REVERSE_TRIAL_ROOT_TASK", () => $5f07ce956337ba8b$export$5eef19b26a4bbe70);
$parcel$export(module.exports, "QUICKSTART_TYPE", () => $5f07ce956337ba8b$export$c57d251ae83aff51);
$parcel$export(module.exports, "getBackendVisibilityKey", () => $5f07ce956337ba8b$export$d9df7fd23ab00c49);
$parcel$export(module.exports, "KEY_OPEN", () => $5f07ce956337ba8b$export$93a67c1026e8cb7c);
$parcel$export(module.exports, "KEY_DISMISSED", () => $5f07ce956337ba8b$export$a7dcb0b5013e932b);
$parcel$export(module.exports, "KEY_TASK_GROUP", () => $5f07ce956337ba8b$export$f962b14e410d598f);
$parcel$export(module.exports, "KEY_OPEN_TASK", () => $5f07ce956337ba8b$export$21e8355b28449456);
$parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", () => $5f07ce956337ba8b$export$536a90031123e004);
$parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", () => $5f07ce956337ba8b$export$3ccd291a1a3a4f6d);
$parcel$export(module.exports, "KEY_IS_DEVOPS_PROJECT", () => $5f07ce956337ba8b$export$e5b557e3bbb7ec52);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $5f07ce956337ba8b$export$9957974f8b4d8f74);
$parcel$export(module.exports, "SOURCE", () => $5f07ce956337ba8b$export$83c8d7110915321e);
$parcel$export(module.exports, "KEY_JSW_ONBOARDING", () => $5f07ce956337ba8b$export$8b9bd2a9275b0187);
$parcel$export(module.exports, "convertToHaveSeenItTask", () => $5f07ce956337ba8b$export$ec43e7bf5973b10f);
$parcel$export(module.exports, "ADD_COLUMNS_TASK", () => $5f07ce956337ba8b$export$cbeb719208f32c8a);
$parcel$export(module.exports, "CREATE_PROJECT_TASK", () => $5f07ce956337ba8b$export$88c918f2cfaff86);
$parcel$export(module.exports, "CREATE_ISSUE_TASK", () => $5f07ce956337ba8b$export$abbbea7c37c93cb5);
$parcel$export(module.exports, "CREATE_ISSUE_TASK_SIMPLIFIED", () => $5f07ce956337ba8b$export$2a0253cb20f48a8);
$parcel$export(module.exports, "INVITE_TEAMMATES_TASK", () => $5f07ce956337ba8b$export$f97428bb4b1991ec);
$parcel$export(module.exports, "INVITE_TEAMMATES_VIDEO_TASK", () => $5f07ce956337ba8b$export$45eaf4204fcc7);
$parcel$export(module.exports, "CAPTURE_INTEGRATIONS_TASK", () => $5f07ce956337ba8b$export$af57685e201438e8);
$parcel$export(module.exports, "FIND_HELP_TASK", () => $5f07ce956337ba8b$export$d6c67e9aab4e2b26);
$parcel$export(module.exports, "SET_UP_BOARD_TASK", () => $5f07ce956337ba8b$export$3de8c242d2b82f26);
$parcel$export(module.exports, "GET_MOBILE_APP_TASK", () => $5f07ce956337ba8b$export$a01fa44f793dbfac);
$parcel$export(module.exports, "MAP_OUT_YOUR_PROJECT_GOALS_TASK", () => $5f07ce956337ba8b$export$6a4507e462fd41da);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK", () => $5f07ce956337ba8b$export$e64c1dced6ac4458);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", () => $5f07ce956337ba8b$export$63b0e55f9c6454ac);
$parcel$export(module.exports, "MONITOR_MANAGE_RISK_TASK", () => $5f07ce956337ba8b$export$c1effb1c8979fe22);
$parcel$export(module.exports, "PREMIUM_REVERSE_TRIAL_TASK", () => $5f07ce956337ba8b$export$d97d31d934dbb194);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK", () => $5f07ce956337ba8b$export$cafb5bd13b02056b);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN", () => $5f07ce956337ba8b$export$e55c18b809946e72);
$parcel$export(module.exports, "STANDARD_EDITION_OVERVIEW_TASK", () => $5f07ce956337ba8b$export$de5640b9ae8140a7);
$parcel$export(module.exports, "ADVANCED_ROADMAPS_TASK", () => $5f07ce956337ba8b$export$540b5c3c4b6ce459);
$parcel$export(module.exports, "CHANGE_CONTROL_TASK", () => $5f07ce956337ba8b$export$6f71dff531ff592);
$parcel$export(module.exports, "AUTOMATIONS_TASK", () => $5f07ce956337ba8b$export$83255ab79e45f34f);
$parcel$export(module.exports, "SITE_ADMINISTRATIONS_TASK", () => $5f07ce956337ba8b$export$b57d172af9ad7647);
$parcel$export(module.exports, "USER_MANAGEMENT_TASK", () => $5f07ce956337ba8b$export$ff4c933c1fe90b68);
$parcel$export(module.exports, "SCRUM_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$3e2776d61f3662dc);
$parcel$export(module.exports, "CUSTOMIZE_SITE_NAME_TASK", () => $5f07ce956337ba8b$export$9048315f2c03fd9d);
$parcel$export(module.exports, "GET_TO_KNOW_YOUR_TEMPLATE_TASK", () => $5f07ce956337ba8b$export$a333714599f14a6);
$parcel$export(module.exports, "CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK", () => $5f07ce956337ba8b$export$4145c2cec2da6f9b);
$parcel$export(module.exports, "TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$4957a1ad203cf6dd);
$parcel$export(module.exports, "CALENDAR_VIEW_TASK", () => $5f07ce956337ba8b$export$190b5dd0a1322552);
$parcel$export(module.exports, "JWM_PROJECT_SUMMARY_TASK", () => $5f07ce956337ba8b$export$501166b25f254aab);
$parcel$export(module.exports, "JWM_CREATE_SAMPLE_PROJECT_TASK", () => $5f07ce956337ba8b$export$94ad6507a703f4eb);
$parcel$export(module.exports, "JWM_BACKGROUND_COLOR_TASK", () => $5f07ce956337ba8b$export$be1c522400a1bd7c);
$parcel$export(module.exports, "JWM_CALENDAR_TASK", () => $5f07ce956337ba8b$export$2aa6e7b6e24a04f5);
$parcel$export(module.exports, "JWM_TIMELINE_TASK", () => $5f07ce956337ba8b$export$f3b53199b07af2a1);
$parcel$export(module.exports, "JWM_BUILD_FORM_TASK", () => $5f07ce956337ba8b$export$d37415ffddcf2142);
$parcel$export(module.exports, "JWM_FEEDBACK_TASK", () => $5f07ce956337ba8b$export$2ae00586da7cb606);
$parcel$export(module.exports, "JWM_FEEDBACK_SAMPLE_PROJECT_TASK", () => $5f07ce956337ba8b$export$b86266e6594a97bb);
$parcel$export(module.exports, "JWM_CREATE_YOUR_OWN_PROJECT_TASK", () => $5f07ce956337ba8b$export$20bc3dc137ac1c38);
$parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", () => $5f07ce956337ba8b$export$77071b77e2801b18);
$parcel$export(module.exports, "JWM_SHARE_PROJECT_TASK", () => $5f07ce956337ba8b$export$9c89f946f05d884a);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", () => $5f07ce956337ba8b$export$b52a7c936684cfc5);
$parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", () => $5f07ce956337ba8b$export$b5555f24061f9fb);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", () => $5f07ce956337ba8b$export$ff25449f34b8abf);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", () => $5f07ce956337ba8b$export$3380e677209260fe);
$parcel$export(module.exports, "GET_STARTED_LIST_TASK", () => $5f07ce956337ba8b$export$7a2fcaad1564e6b7);
$parcel$export(module.exports, "OPS_JTBD_1_LIST", () => $5f07ce956337ba8b$export$da23b72d32bfad9e);
$parcel$export(module.exports, "OPS_JTBD_2_BOARD", () => $5f07ce956337ba8b$export$4b064659282e0238);
$parcel$export(module.exports, "OPS_JTBD_2_FORMS", () => $5f07ce956337ba8b$export$3ab51851f6d823e);
$parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", () => $5f07ce956337ba8b$export$e4a1a37a9a1350ad);
$parcel$export(module.exports, "OPS_JTBD_3_LIST", () => $5f07ce956337ba8b$export$b7f7da5e795f0327);
$parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", () => $5f07ce956337ba8b$export$80a401c1aa47a377);
$parcel$export(module.exports, "OPS_JTBD_3_PAGES", () => $5f07ce956337ba8b$export$934ac7a251b26dc7);
$parcel$export(module.exports, "OPS_JTBD_4_LIST", () => $5f07ce956337ba8b$export$4634f6395df3ebbe);
$parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", () => $5f07ce956337ba8b$export$768fb41107a1e8d7);
$parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", () => $5f07ce956337ba8b$export$d797a81bace17184);
$parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", () => $5f07ce956337ba8b$export$746102c94db9df1f);
$parcel$export(module.exports, "OPS_JTBD_5_LIST", () => $5f07ce956337ba8b$export$5f1efd797d65e349);
$parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", () => $5f07ce956337ba8b$export$cccc812ccafbf11f);
$parcel$export(module.exports, "OPS_JTBD_5_PAGES", () => $5f07ce956337ba8b$export$64822db87abd8a47);
$parcel$export(module.exports, "OPS_JTBD_6_PAGES", () => $5f07ce956337ba8b$export$64f764d8be495c82);
$parcel$export(module.exports, "OPS_JTBD_7_LIST", () => $5f07ce956337ba8b$export$24eae23dc1c68bbd);
$parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", () => $5f07ce956337ba8b$export$50fa92eba6f82feb);
$parcel$export(module.exports, "OPS_JTBD_0_LIST", () => $5f07ce956337ba8b$export$4155d22fe3f14cd6);
$parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", () => $5f07ce956337ba8b$export$76813cbead887191);
$parcel$export(module.exports, "OPS_JTBD_0_PAGES", () => $5f07ce956337ba8b$export$90aab2ff89daf770);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", () => $5f07ce956337ba8b$export$a2bc0cbad2e6e605);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", () => $5f07ce956337ba8b$export$f90872a1280728bb);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", () => $5f07ce956337ba8b$export$bce644e96518cbd2);
$parcel$export(module.exports, "MKT_JTBD_1_LIST", () => $5f07ce956337ba8b$export$241aaebffac0a3e5);
$parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", () => $5f07ce956337ba8b$export$f9dfc43b5b31c4b7);
$parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", () => $5f07ce956337ba8b$export$79759e9e62fb9312);
$parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", () => $5f07ce956337ba8b$export$992d1e0dce255d19);
$parcel$export(module.exports, "MKT_JTBD_2_PAGES", () => $5f07ce956337ba8b$export$d28c1b0e5b3e768);
$parcel$export(module.exports, "MKT_JTBD_3_PAGES", () => $5f07ce956337ba8b$export$ca714ee197bed4ec);
$parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", () => $5f07ce956337ba8b$export$faae55ceea4b6073);
$parcel$export(module.exports, "MKT_JTBD_4_LIST", () => $5f07ce956337ba8b$export$200bc24cd120667e);
$parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", () => $5f07ce956337ba8b$export$a0d784a48b4e886c);
$parcel$export(module.exports, "MKT_JTBD_4_PAGES", () => $5f07ce956337ba8b$export$baf5bd09b4b33b8a);
$parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", () => $5f07ce956337ba8b$export$4702007eedbca8ab);
$parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", () => $5f07ce956337ba8b$export$aa9d2d635ea63898);
$parcel$export(module.exports, "MKT_JTBD_6_FORMS", () => $5f07ce956337ba8b$export$2ea449225c1f6cac);
$parcel$export(module.exports, "MKT_JTBD_0_LIST", () => $5f07ce956337ba8b$export$deb8b557e735e26a);
$parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", () => $5f07ce956337ba8b$export$d45754df44e4c309);
$parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", () => $5f07ce956337ba8b$export$78b2913b550edbb);
$parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", () => $5f07ce956337ba8b$export$71243272608c58ab);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", () => $5f07ce956337ba8b$export$39a08f215c33bc39);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", () => $5f07ce956337ba8b$export$d2377f6a6fa3b49c);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", () => $5f07ce956337ba8b$export$befa8f6533309779);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", () => $5f07ce956337ba8b$export$736b40db8701ba6c);
$parcel$export(module.exports, "TAILORED_ONBOARDING_SUMMARY", () => $5f07ce956337ba8b$export$11eff6ae2f70b67b);
$parcel$export(module.exports, "TAILORED_ONBOARDING_LIST", () => $5f07ce956337ba8b$export$fb2d23e5315a67a9);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CALENDAR", () => $5f07ce956337ba8b$export$32e794bb49d60b6);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BOARD", () => $5f07ce956337ba8b$export$fed256238b27db06);
$parcel$export(module.exports, "TAILORED_ONBOARDING_TIMELINE", () => $5f07ce956337ba8b$export$132eecb4d35a590d);
$parcel$export(module.exports, "TAILORED_ONBOARDING_PAGES", () => $5f07ce956337ba8b$export$2579c51cadd45eca);
$parcel$export(module.exports, "TAILORED_ONBOARDING_FORM", () => $5f07ce956337ba8b$export$4b1a0cefa966ea0);
$parcel$export(module.exports, "TAILORED_ONBOARDING_INVITE", () => $5f07ce956337ba8b$export$f6558daacc312a65);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BACKLOG", () => $5f07ce956337ba8b$export$925efa2e24e86b88);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CODE", () => $5f07ce956337ba8b$export$40454d3e062dcd44);
$parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", () => $5f07ce956337ba8b$export$99b0e09ff6f00490);
$parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", () => $5f07ce956337ba8b$export$2a82344eb273eeff);
$parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", () => $5f07ce956337ba8b$export$1de5766b7e640d6b);
$parcel$export(module.exports, "DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK", () => $5f07ce956337ba8b$export$8ab0859f5b30b013);
$parcel$export(module.exports, "DEVOPS_GET_TO_KNOW_JIRA_TASK", () => $5f07ce956337ba8b$export$d1f6d18c6698104c);
$parcel$export(module.exports, "DEVOPS_NAVIGATE_YOUR_TOOLS_TASK", () => $5f07ce956337ba8b$export$e6ee159eee7adc1c);
$parcel$export(module.exports, "DEVOPS_CAPTURE_INTEGRATIONS_TASK", () => $5f07ce956337ba8b$export$dd267ca1e3cd3bad);
$parcel$export(module.exports, "DEVOPS_CREATE_AUTOMATION_RULES_TASK", () => $5f07ce956337ba8b$export$f14c8bffc35200d3);
$parcel$export(module.exports, "DEVOPS_INVITE_TEAMMATES_TASK", () => $5f07ce956337ba8b$export$36cc22c9997d92a);
$parcel$export(module.exports, "DEVOPS_FIND_HELP_TASK", () => $5f07ce956337ba8b$export$d651cc94a46ff383);
$parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", () => $5f07ce956337ba8b$export$11c0696d49e68c93);
$parcel$export(module.exports, "ACCOUNT_ID", () => $5f07ce956337ba8b$export$c8ab6996f562d0db);
$parcel$export(module.exports, "KANBAN_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$2b5f951ad8e70cfe);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => $5f07ce956337ba8b$export$5703447487aaccdf);
$parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", () => $5f07ce956337ba8b$export$e0197e09cccd4e50);
$parcel$export(module.exports, "PROJECT_SETTING_PAGES", () => $5f07ce956337ba8b$export$f779bbfe667acddc);
$parcel$export(module.exports, "JSM_BUSINESS_TASKS", () => $5f07ce956337ba8b$export$38fbac7a5bf4aa33);
$parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", () => $5f07ce956337ba8b$export$7578902c7f420a3);

var $g5X3G = parcelRequire("g5X3G");
const $5f07ce956337ba8b$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeDevopsTaskName = (taskId)=>`devops-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
const $5f07ce956337ba8b$export$2b3151a089bc8780 = 'jlove-makkuro';
const $5f07ce956337ba8b$export$6826d33e9a2c0119 = 320;
const $5f07ce956337ba8b$export$b580da85daad7757 = 'root';
const $5f07ce956337ba8b$export$5eef19b26a4bbe70 = 'reverseTrialRoot';
const $5f07ce956337ba8b$export$c57d251ae83aff51 = {
    JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
    OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
};
const $5f07ce956337ba8b$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
const $5f07ce956337ba8b$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
const $5f07ce956337ba8b$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
const $5f07ce956337ba8b$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
const $5f07ce956337ba8b$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
const $5f07ce956337ba8b$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
const $5f07ce956337ba8b$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
const $5f07ce956337ba8b$export$e5b557e3bbb7ec52 = 'isDevopsProject';
const $5f07ce956337ba8b$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
const $5f07ce956337ba8b$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
const $5f07ce956337ba8b$export$8b9bd2a9275b0187 = 'jsw.onboarding';
const $5f07ce956337ba8b$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
const $5f07ce956337ba8b$export$cbeb719208f32c8a = $5f07ce956337ba8b$var$completeJswTaskName('add-columns-task');
const $5f07ce956337ba8b$export$88c918f2cfaff86 = $5f07ce956337ba8b$var$completeJswTaskName('create-project-task');
const $5f07ce956337ba8b$export$abbbea7c37c93cb5 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task');
const $5f07ce956337ba8b$export$2a0253cb20f48a8 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task-simplified');
const $5f07ce956337ba8b$export$f97428bb4b1991ec = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-task');
const $5f07ce956337ba8b$export$45eaf4204fcc7 = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-video-task');
const $5f07ce956337ba8b$export$af57685e201438e8 = $5f07ce956337ba8b$var$completeJswTaskName('capture-integrations-task');
const $5f07ce956337ba8b$export$d6c67e9aab4e2b26 = $5f07ce956337ba8b$var$completeJswTaskName('find-help-task');
const $5f07ce956337ba8b$export$3de8c242d2b82f26 = $5f07ce956337ba8b$var$completeJswTaskName('set-up-board-task');
const $5f07ce956337ba8b$export$a01fa44f793dbfac = $5f07ce956337ba8b$var$completeJswTaskName('get-mobile-app-task');
const $5f07ce956337ba8b$export$6a4507e462fd41da = $5f07ce956337ba8b$var$completeJswTaskName('map-out-your-project-goals');
const $5f07ce956337ba8b$export$e64c1dced6ac4458 = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work');
const $5f07ce956337ba8b$export$63b0e55f9c6454ac = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
const $5f07ce956337ba8b$export$c1effb1c8979fe22 = $5f07ce956337ba8b$var$completeJswTaskName('monitor-manage-risk');
const $5f07ce956337ba8b$export$d97d31d934dbb194 = $5f07ce956337ba8b$var$completeJswTaskName('premium-reverse-trial-task');
const $5f07ce956337ba8b$export$cafb5bd13b02056b = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task');
const $5f07ce956337ba8b$export$e55c18b809946e72 = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task-non-admin');
const $5f07ce956337ba8b$export$de5640b9ae8140a7 = $5f07ce956337ba8b$var$completeJswTaskName('standard-edition-overview-task');
const $5f07ce956337ba8b$export$540b5c3c4b6ce459 = $5f07ce956337ba8b$var$completeJswTaskName('advanced-roadmaps-task');
const $5f07ce956337ba8b$export$6f71dff531ff592 = $5f07ce956337ba8b$var$completeJswTaskName('change-control-task');
const $5f07ce956337ba8b$export$83255ab79e45f34f = $5f07ce956337ba8b$var$completeJswTaskName('automations-task');
const $5f07ce956337ba8b$export$b57d172af9ad7647 = $5f07ce956337ba8b$var$completeJswTaskName('site-administrations-task');
const $5f07ce956337ba8b$export$ff4c933c1fe90b68 = $5f07ce956337ba8b$var$completeJswTaskName('user-management-task');
const $5f07ce956337ba8b$export$3e2776d61f3662dc = $5f07ce956337ba8b$var$completeJswTaskName('scrum-onboarding-task');
const $5f07ce956337ba8b$export$9048315f2c03fd9d = $5f07ce956337ba8b$var$completeJswTaskName('customize-site-name-task');
const $5f07ce956337ba8b$export$a333714599f14a6 = $5f07ce956337ba8b$var$completeJswTaskName('get-to-know-your-template-task');
const $5f07ce956337ba8b$export$4145c2cec2da6f9b = $5f07ce956337ba8b$var$completeJswTaskName('create-business-project-from-jsw-quickstart-task');
const $5f07ce956337ba8b$export$4957a1ad203cf6dd = $5f07ce956337ba8b$var$completeJswTaskName('try-atlassian-university-task');
const $5f07ce956337ba8b$export$190b5dd0a1322552 = $5f07ce956337ba8b$var$completeJswTaskName('calendar-view-task');
const $5f07ce956337ba8b$export$501166b25f254aab = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-project-summary-task');
const $5f07ce956337ba8b$export$94ad6507a703f4eb = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-sample-project-task');
const $5f07ce956337ba8b$export$be1c522400a1bd7c = $5f07ce956337ba8b$var$completeJwmTaskName('background-color-task');
const $5f07ce956337ba8b$export$2aa6e7b6e24a04f5 = $5f07ce956337ba8b$var$completeJwmTaskName('calendar-task');
const $5f07ce956337ba8b$export$f3b53199b07af2a1 = $5f07ce956337ba8b$var$completeJwmTaskName('timeline-task');
const $5f07ce956337ba8b$export$d37415ffddcf2142 = $5f07ce956337ba8b$var$completeJwmTaskName('build-form-task');
const $5f07ce956337ba8b$export$2ae00586da7cb606 = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-task');
const $5f07ce956337ba8b$export$b86266e6594a97bb = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-sample-project-task');
const $5f07ce956337ba8b$export$20bc3dc137ac1c38 = $5f07ce956337ba8b$var$completeJwmTaskName('create-your-own-project-task');
const $5f07ce956337ba8b$export$77071b77e2801b18 = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-project-task');
const $5f07ce956337ba8b$export$9c89f946f05d884a = $5f07ce956337ba8b$var$completeJwmTaskName('share-project-task');
const $5f07ce956337ba8b$export$b52a7c936684cfc5 = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-import');
const $5f07ce956337ba8b$export$b5555f24061f9fb = $5f07ce956337ba8b$var$completeJwmTaskName('summary-and-reports-task');
const $5f07ce956337ba8b$export$ff25449f34b8abf = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
const $5f07ce956337ba8b$export$3380e677209260fe = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-key-differences');
const $5f07ce956337ba8b$export$7a2fcaad1564e6b7 = $5f07ce956337ba8b$var$completeJwmTaskName('get-started-list-task');
const $5f07ce956337ba8b$export$da23b72d32bfad9e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_1_LIST');
const $5f07ce956337ba8b$export$4b064659282e0238 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
const $5f07ce956337ba8b$export$3ab51851f6d823e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
const $5f07ce956337ba8b$export$e4a1a37a9a1350ad = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
const $5f07ce956337ba8b$export$b7f7da5e795f0327 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_LIST');
const $5f07ce956337ba8b$export$80a401c1aa47a377 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
const $5f07ce956337ba8b$export$934ac7a251b26dc7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
const $5f07ce956337ba8b$export$4634f6395df3ebbe = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_LIST');
const $5f07ce956337ba8b$export$768fb41107a1e8d7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
const $5f07ce956337ba8b$export$d797a81bace17184 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
const $5f07ce956337ba8b$export$746102c94db9df1f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
const $5f07ce956337ba8b$export$5f1efd797d65e349 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_LIST');
const $5f07ce956337ba8b$export$cccc812ccafbf11f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
const $5f07ce956337ba8b$export$64822db87abd8a47 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
const $5f07ce956337ba8b$export$64f764d8be495c82 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
const $5f07ce956337ba8b$export$24eae23dc1c68bbd = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_LIST');
const $5f07ce956337ba8b$export$50fa92eba6f82feb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
const $5f07ce956337ba8b$export$4155d22fe3f14cd6 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_LIST');
const $5f07ce956337ba8b$export$76813cbead887191 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
const $5f07ce956337ba8b$export$90aab2ff89daf770 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
const $5f07ce956337ba8b$export$a2bc0cbad2e6e605 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
const $5f07ce956337ba8b$export$f90872a1280728bb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
const $5f07ce956337ba8b$export$bce644e96518cbd2 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
const $5f07ce956337ba8b$export$241aaebffac0a3e5 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_LIST');
const $5f07ce956337ba8b$export$f9dfc43b5b31c4b7 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
const $5f07ce956337ba8b$export$79759e9e62fb9312 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
const $5f07ce956337ba8b$export$992d1e0dce255d19 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
const $5f07ce956337ba8b$export$d28c1b0e5b3e768 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
const $5f07ce956337ba8b$export$ca714ee197bed4ec = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
const $5f07ce956337ba8b$export$faae55ceea4b6073 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
const $5f07ce956337ba8b$export$200bc24cd120667e = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_LIST');
const $5f07ce956337ba8b$export$a0d784a48b4e886c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
const $5f07ce956337ba8b$export$baf5bd09b4b33b8a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
const $5f07ce956337ba8b$export$4702007eedbca8ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
const $5f07ce956337ba8b$export$aa9d2d635ea63898 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
const $5f07ce956337ba8b$export$2ea449225c1f6cac = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
const $5f07ce956337ba8b$export$deb8b557e735e26a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_LIST');
const $5f07ce956337ba8b$export$d45754df44e4c309 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
const $5f07ce956337ba8b$export$78b2913b550edbb = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
const $5f07ce956337ba8b$export$71243272608c58ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
const $5f07ce956337ba8b$export$39a08f215c33bc39 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
const $5f07ce956337ba8b$export$d2377f6a6fa3b49c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
const $5f07ce956337ba8b$export$befa8f6533309779 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
const $5f07ce956337ba8b$export$736b40db8701ba6c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
const $5f07ce956337ba8b$export$11eff6ae2f70b67b = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_SUMMARY');
const $5f07ce956337ba8b$export$fb2d23e5315a67a9 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_LIST');
const $5f07ce956337ba8b$export$32e794bb49d60b6 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_CALENDAR');
const $5f07ce956337ba8b$export$fed256238b27db06 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_BOARD');
const $5f07ce956337ba8b$export$132eecb4d35a590d = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_TIMELINE');
const $5f07ce956337ba8b$export$2579c51cadd45eca = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_PAGES');
const $5f07ce956337ba8b$export$4b1a0cefa966ea0 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_FORM');
const $5f07ce956337ba8b$export$f6558daacc312a65 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_INVITE');
const $5f07ce956337ba8b$export$925efa2e24e86b88 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_BACKLOG');
const $5f07ce956337ba8b$export$40454d3e062dcd44 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_CODE');
const $5f07ce956337ba8b$export$99b0e09ff6f00490 = $5f07ce956337ba8b$var$completeJsmTaskName('customize-your-request-types-task');
const $5f07ce956337ba8b$export$2a82344eb273eeff = $5f07ce956337ba8b$var$completeJsmTaskName('review-your-channels-task');
const $5f07ce956337ba8b$export$1de5766b7e640d6b = $5f07ce956337ba8b$var$completeJsmTaskName('invite-your-team-task');
const $5f07ce956337ba8b$export$8ab0859f5b30b013 = $5f07ce956337ba8b$var$completeDevopsTaskName('welcome-to-your-project-task');
const $5f07ce956337ba8b$export$d1f6d18c6698104c = $5f07ce956337ba8b$var$completeDevopsTaskName('get-to-know-jira-task');
const $5f07ce956337ba8b$export$e6ee159eee7adc1c = $5f07ce956337ba8b$var$completeDevopsTaskName('navigate-your-tools-task');
const $5f07ce956337ba8b$export$dd267ca1e3cd3bad = $5f07ce956337ba8b$var$completeDevopsTaskName('capture-integrations-task');
const $5f07ce956337ba8b$export$f14c8bffc35200d3 = $5f07ce956337ba8b$var$completeDevopsTaskName('create-automation-rules-task');
const $5f07ce956337ba8b$export$36cc22c9997d92a = $5f07ce956337ba8b$var$completeDevopsTaskName('invite-teammates-task');
const $5f07ce956337ba8b$export$d651cc94a46ff383 = $5f07ce956337ba8b$var$completeDevopsTaskName('find-help-task');
const $5f07ce956337ba8b$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
const $5f07ce956337ba8b$export$c8ab6996f562d0db = (0, $g5X3G.toAccountId)('accountId');
const $5f07ce956337ba8b$export$2b5f951ad8e70cfe = $5f07ce956337ba8b$var$completeJswTaskName('kanban-onboarding-task');
const $5f07ce956337ba8b$export$5703447487aaccdf = {
    NOT_LOADED: 'NOT_LOADED',
    OPEN: 'OPEN',
    MINIMIZED: 'MINIMIZED',
    DISMISSED: 'DISMISSED'
};
const $5f07ce956337ba8b$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $5f07ce956337ba8b$export$f779bbfe667acddc = [
    'legacy-project-settings-people',
    'project-settings-software-access'
];
const $5f07ce956337ba8b$export$38fbac7a5bf4aa33 = [
    $5f07ce956337ba8b$export$2a82344eb273eeff,
    $5f07ce956337ba8b$export$99b0e09ff6f00490,
    $5f07ce956337ba8b$export$1de5766b7e640d6b
];
const $5f07ce956337ba8b$export$7578902c7f420a3 = [
    $5f07ce956337ba8b$export$88c918f2cfaff86,
    $5f07ce956337ba8b$export$6a4507e462fd41da,
    $5f07ce956337ba8b$export$e64c1dced6ac4458,
    $5f07ce956337ba8b$export$63b0e55f9c6454ac,
    $5f07ce956337ba8b$export$c1effb1c8979fe22,
    $5f07ce956337ba8b$export$cbeb719208f32c8a,
    $5f07ce956337ba8b$export$abbbea7c37c93cb5,
    $5f07ce956337ba8b$export$2a0253cb20f48a8,
    $5f07ce956337ba8b$export$f97428bb4b1991ec,
    $5f07ce956337ba8b$export$d6c67e9aab4e2b26,
    $5f07ce956337ba8b$export$3de8c242d2b82f26,
    $5f07ce956337ba8b$export$a01fa44f793dbfac,
    $5f07ce956337ba8b$export$45eaf4204fcc7,
    $5f07ce956337ba8b$export$af57685e201438e8,
    $5f07ce956337ba8b$export$d97d31d934dbb194,
    $5f07ce956337ba8b$export$cafb5bd13b02056b,
    $5f07ce956337ba8b$export$e55c18b809946e72,
    $5f07ce956337ba8b$export$de5640b9ae8140a7,
    $5f07ce956337ba8b$export$540b5c3c4b6ce459,
    $5f07ce956337ba8b$export$6f71dff531ff592,
    $5f07ce956337ba8b$export$83255ab79e45f34f,
    $5f07ce956337ba8b$export$b57d172af9ad7647,
    $5f07ce956337ba8b$export$ff4c933c1fe90b68,
    $5f07ce956337ba8b$export$77071b77e2801b18,
    $5f07ce956337ba8b$export$94ad6507a703f4eb,
    $5f07ce956337ba8b$export$501166b25f254aab,
    $5f07ce956337ba8b$export$be1c522400a1bd7c,
    $5f07ce956337ba8b$export$2aa6e7b6e24a04f5,
    $5f07ce956337ba8b$export$f3b53199b07af2a1,
    $5f07ce956337ba8b$export$d37415ffddcf2142,
    $5f07ce956337ba8b$export$2ae00586da7cb606,
    $5f07ce956337ba8b$export$9c89f946f05d884a,
    $5f07ce956337ba8b$export$20bc3dc137ac1c38,
    $5f07ce956337ba8b$export$b52a7c936684cfc5,
    $5f07ce956337ba8b$export$b5555f24061f9fb,
    $5f07ce956337ba8b$export$ff25449f34b8abf,
    $5f07ce956337ba8b$export$3380e677209260fe,
    $5f07ce956337ba8b$export$b86266e6594a97bb,
    $5f07ce956337ba8b$export$8ab0859f5b30b013,
    $5f07ce956337ba8b$export$d1f6d18c6698104c,
    $5f07ce956337ba8b$export$e6ee159eee7adc1c,
    $5f07ce956337ba8b$export$dd267ca1e3cd3bad,
    $5f07ce956337ba8b$export$f14c8bffc35200d3,
    $5f07ce956337ba8b$export$36cc22c9997d92a,
    $5f07ce956337ba8b$export$d651cc94a46ff383,
    $5f07ce956337ba8b$export$3e2776d61f3662dc,
    $5f07ce956337ba8b$export$2b5f951ad8e70cfe,
    $5f07ce956337ba8b$export$9048315f2c03fd9d,
    $5f07ce956337ba8b$export$a333714599f14a6,
    $5f07ce956337ba8b$export$4145c2cec2da6f9b,
    $5f07ce956337ba8b$export$4957a1ad203cf6dd,
    $5f07ce956337ba8b$export$7a2fcaad1564e6b7,
    $5f07ce956337ba8b$export$190b5dd0a1322552,
    $5f07ce956337ba8b$export$da23b72d32bfad9e,
    $5f07ce956337ba8b$export$4b064659282e0238,
    $5f07ce956337ba8b$export$3ab51851f6d823e,
    $5f07ce956337ba8b$export$e4a1a37a9a1350ad,
    $5f07ce956337ba8b$export$b7f7da5e795f0327,
    $5f07ce956337ba8b$export$80a401c1aa47a377,
    $5f07ce956337ba8b$export$934ac7a251b26dc7,
    $5f07ce956337ba8b$export$4634f6395df3ebbe,
    $5f07ce956337ba8b$export$768fb41107a1e8d7,
    $5f07ce956337ba8b$export$d797a81bace17184,
    $5f07ce956337ba8b$export$746102c94db9df1f,
    $5f07ce956337ba8b$export$5f1efd797d65e349,
    $5f07ce956337ba8b$export$cccc812ccafbf11f,
    $5f07ce956337ba8b$export$64822db87abd8a47,
    $5f07ce956337ba8b$export$64f764d8be495c82,
    $5f07ce956337ba8b$export$24eae23dc1c68bbd,
    $5f07ce956337ba8b$export$50fa92eba6f82feb,
    $5f07ce956337ba8b$export$4155d22fe3f14cd6,
    $5f07ce956337ba8b$export$76813cbead887191,
    $5f07ce956337ba8b$export$90aab2ff89daf770,
    $5f07ce956337ba8b$export$a2bc0cbad2e6e605,
    $5f07ce956337ba8b$export$f90872a1280728bb,
    $5f07ce956337ba8b$export$bce644e96518cbd2,
    $5f07ce956337ba8b$export$241aaebffac0a3e5,
    $5f07ce956337ba8b$export$f9dfc43b5b31c4b7,
    $5f07ce956337ba8b$export$79759e9e62fb9312,
    $5f07ce956337ba8b$export$992d1e0dce255d19,
    $5f07ce956337ba8b$export$d28c1b0e5b3e768,
    $5f07ce956337ba8b$export$ca714ee197bed4ec,
    $5f07ce956337ba8b$export$faae55ceea4b6073,
    $5f07ce956337ba8b$export$200bc24cd120667e,
    $5f07ce956337ba8b$export$a0d784a48b4e886c,
    $5f07ce956337ba8b$export$baf5bd09b4b33b8a,
    $5f07ce956337ba8b$export$4702007eedbca8ab,
    $5f07ce956337ba8b$export$aa9d2d635ea63898,
    $5f07ce956337ba8b$export$2ea449225c1f6cac,
    $5f07ce956337ba8b$export$deb8b557e735e26a,
    $5f07ce956337ba8b$export$d45754df44e4c309,
    $5f07ce956337ba8b$export$78b2913b550edbb,
    $5f07ce956337ba8b$export$71243272608c58ab,
    $5f07ce956337ba8b$export$39a08f215c33bc39,
    $5f07ce956337ba8b$export$d2377f6a6fa3b49c,
    $5f07ce956337ba8b$export$befa8f6533309779,
    $5f07ce956337ba8b$export$736b40db8701ba6c,
    // Tailored onboarding M3
    $5f07ce956337ba8b$export$11eff6ae2f70b67b,
    $5f07ce956337ba8b$export$fb2d23e5315a67a9,
    $5f07ce956337ba8b$export$32e794bb49d60b6,
    $5f07ce956337ba8b$export$fed256238b27db06,
    $5f07ce956337ba8b$export$132eecb4d35a590d,
    $5f07ce956337ba8b$export$2579c51cadd45eca,
    $5f07ce956337ba8b$export$4b1a0cefa966ea0,
    $5f07ce956337ba8b$export$f6558daacc312a65,
    $5f07ce956337ba8b$export$925efa2e24e86b88,
    $5f07ce956337ba8b$export$40454d3e062dcd44
];

});


// JWM Background Colour tour
const $d231c4839441ff18$export$eb0b199de90a7ec2 = 'backgroundColorNudge';

parcelRegister("5fQMX", function(module, exports) {

let $3d374d29dd0201c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3d374d29dd0201c0$var$load("cM9em"),
    $3d374d29dd0201c0$var$load("fr9NE"),
    $3d374d29dd0201c0$var$load("ebypf")
]).then(()=>parcelRequire('8uIuW'));

});


parcelRegister("jpH5a", function(module, exports) {

$parcel$export(module.exports, "VIEW_THEME_PICKER_EXPERIENCE", () => $34fd6f1472f32723$export$9a8c95b97c1ee885);
const $34fd6f1472f32723$export$47a1a20f3722c8ce = {
    experience: 'viewThemePicker',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $34fd6f1472f32723$export$9a8c95b97c1ee885 = {
    experience: 'viewThemePicker',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};

});

parcelRegister("ca7Zi", function(module, exports) {

$parcel$export(module.exports, "useExperienceFail", () => $99088cc1a7014505$export$606da7704d8eaf06);
$parcel$export(module.exports, "ExperienceFailed", () => $99088cc1a7014505$export$ae65a9e09c4516b3);
$parcel$export(module.exports, "ExperienceSuccess", () => $99088cc1a7014505$export$4962f3898bd5c829);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $93jKl = parcelRequire("93jKl");

var $3bQtK = parcelRequire("3bQtK");

var $jJZqs = parcelRequire("jJZqs");
const $99088cc1a7014505$export$606da7704d8eaf06 = ({ experience: experience, experienceId: experienceId, analyticsSource: analyticsSource, teamName: teamName })=>{
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: experience
    });
    const onFail = (0, $5uXOq.useCallback)((location, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error, extraAttributes)=>{
        const relevantError = error?.networkError ?? error;
        if (relevantError instanceof (0, $jJZqs.ValidationError) && relevantError.message === '' && relevantError.errors.length) relevantError.message = relevantError.errors[0].error;
        extraAttributes !== undefined ? onExperienceFail(location, relevantError, extraAttributes) : onExperienceFail(location, relevantError);
        (0, $jcw0u.default)({
            meta: {
                id: `experience-tracker-${experienceId ?? experience}`,
                packageName: analyticsSource,
                teamName: teamName
            },
            attributes: {
                location: location
            },
            error: relevantError,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onExperienceFail,
        experienceId,
        experience,
        analyticsSource,
        teamName
    ]);
    return onFail;
};
const $99088cc1a7014505$export$ae65a9e09c4516b3 = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, error: error, attributes: attributes })=>{
    const onFail = $99088cc1a7014505$export$606da7704d8eaf06(experience);
    (0, $5uXOq.useEffect)(()=>{
        onFail(experience.experience, error, attributes);
    }, [
        attributes,
        error,
        experience,
        onFail
    ]);
    return null;
});
const $99088cc1a7014505$export$4962f3898bd5c829 = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: experience.experience,
        attributes: {
            ...experience.experienceId == null ? undefined : {
                experienceId: experience.experienceId
            },
            ...attributes
        }
    }));

});

parcelRegister("lwRIP", function(module, exports) {

$parcel$export(module.exports, "CREATE_CUSTOM_BACKGROUND_EXPERIENCE", () => $9162f72ca6991e19$export$46e0706742711dad);
$parcel$export(module.exports, "UPDATE_ALT_TEXT_EXPERIENCE", () => $9162f72ca6991e19$export$678653f2c10961c5);
$parcel$export(module.exports, "DELETE_CUSTOM_BACKGROUND_EXPERIENCE", () => $9162f72ca6991e19$export$f84f0c56982ddf9a);
$parcel$export(module.exports, "THEME_PICKER_ELEMENT_ID", () => $9162f72ca6991e19$export$8dde8522a4856b87);
const $9162f72ca6991e19$export$91a4460f34f2ee75 = {
    experience: 'createCustomBackground',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$46e0706742711dad = {
    experience: 'createCustomBackground',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$3b5b01b3ae53bee3 = {
    experience: 'updateCustomBackground',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$678653f2c10961c5 = {
    experience: 'updateCustomBackground',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$da5da525dec4b73a = {
    experience: 'deleteCustomBackground',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$f84f0c56982ddf9a = {
    experience: 'deleteCustomBackground',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$8dde8522a4856b87 = 'background-picker-popup-wrapper';

});

parcelRegister("22OQR", function(module, exports) {

$parcel$export(module.exports, "ThemedButton", () => $87e6157378e1cf19$export$f67fb575035cc7d0);
/* ThemedButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $i95f5 = parcelRequire("i95f5");
const $87e6157378e1cf19$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87e6157378e1cf19$var$CustomButton, {
        ...props,
        as: as,
        ref: ref
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87e6157378e1cf19$var$CustomButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $i95f5.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1qt3kjry _1g9h1tex _1umfuwj9 _6l8r3x59 _9se5176f _12rallho _zk5uzt2a _18vg2zyf _192e1jcw _fnp717ga _1xjgvy9e _1u0u14e8 _17z218zq _7n83frbu _n2ul1jo4 _1cf1r7td _1d7c1ag4 _nwukvy9e _fsjd4zrn _z1i3eyly",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7qHTI", function(module, exports) {

$parcel$export(module.exports, "backgroundPickerPopupContentEntryPoint", () => $702afda145d8b12a$export$e02fb03d7ff1aabe);

var $jAE3D = parcelRequire("jAE3D");

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

var $4R6GH = parcelRequire("4R6GH");
const $702afda145d8b12a$var$fetchPolicy = 'network-only';

const $702afda145d8b12a$export$e02fb03d7ff1aabe = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("kzrIR")).then((module)=>module.BackgroundPickerPopupContent), {
        moduleId: "c1622917",
        moduleName: "PopupContentNav3"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectAri: projectAri })=>{
        const popupContentQuery = {
            parameters: (0, $jAE3D.default),
            variables: {
                cloudId: cloudId,
                entityId: projectAri,
                durationInSeconds: 900,
                imageCount: 50,
                isThemingRelayMigrationEnabled: (0, $4R6GH.fg)('jira_theming_relay_migration')
            },
            options: {
                fetchPolicy: $702afda145d8b12a$var$fetchPolicy
            }
        };
        return {
            queries: {
                popupContentQuery: popupContentQuery
            }
        };
    }
});

});
parcelRegister("jAE3D", function(module, exports) {

$parcel$export(module.exports, "default", () => $6962925dbb570ba1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<769be35d8f633045ce8d82b4effcc486>>
 * @relayHash 35c031f0e551ffdb1606790bd7317186
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2832ec15692c6414d21b36725e02826a8bac361ed767cd6564b8dccad7572b87
const $6962925dbb570ba1$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2832ec15692c6414d21b36725e02826a8bac361ed767cd6564b8dccad7572b87",
        "metadata": {},
        "name": "PopupContentNav3Query",
        "operationKind": "query",
        "text": null
    }
};
var $6962925dbb570ba1$export$2e2bcd8739ae039 = $6962925dbb570ba1$var$node;

});

parcelRegister("kzrIR", function(module, exports) {

let $ef9c94a8b216bb6b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ef9c94a8b216bb6b$var$load("h2MrD"),
    $ef9c94a8b216bb6b$var$load("bYT2S"),
    $ef9c94a8b216bb6b$var$load("hPzOn"),
    $ef9c94a8b216bb6b$var$load("2cY3h")
]).then(()=>parcelRequire('lAVsK'));

});


parcelRegister("ggJP8", function(module, exports) {

$parcel$export(module.exports, "ThemePickerSkeleton", () => $75e220768d4a4ad5$export$c3dc17aa42c33254);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $clxo5 = parcelRequire("clxo5");
const $75e220768d4a4ad5$export$c3dc17aa42c33254 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $75e220768d4a4ad5$var$skeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
        size: "medium"
    }));
const $75e220768d4a4ad5$var$skeletonStyles = (0, $2s57o.xcss)({
    width: '346px',
    height: '240px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});


parcelRegister("1MaBz", function(module, exports) {

$parcel$export(module.exports, "ThemeContainerOld", () => $5ffb1b62a0c37aa6$export$c6e50a832af54243);
$parcel$export(module.exports, "ThemeContainer", () => $5ffb1b62a0c37aa6$export$11eb671888ed6e7d);
$parcel$export(module.exports, "useThemeHook", () => $5ffb1b62a0c37aa6$export$b95ba2c6b597cfbb);
$parcel$export(module.exports, "useThemeSetting", () => $5ffb1b62a0c37aa6$export$87d26f94ea053d38);
$parcel$export(module.exports, "useSelectedThemeSetting", () => $5ffb1b62a0c37aa6$export$4ba6f9d407e18961);
// Delete file when cleaning up jira_theming_relay_migration

var $ajpes = parcelRequire("ajpes");

var $fHEdP = parcelRequire("fHEdP");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");
const $5ffb1b62a0c37aa6$var$setTheme = (newTheme)=>({ getState: getState, setState: setState })=>{
        const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
        if ((0, $fHEdP.themeManager).isValidTheme(newTheme) && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(themeSetting?.value, newTheme?.value)) setState({
            entityId: entityId,
            selectedThemeSetting: selectedThemeSetting,
            themeSetting: newTheme
        });
    };
const $5ffb1b62a0c37aa6$var$setSelectedThemeSetting = (newTheme)=>({ getState: getState, setState: setState })=>{
        const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
        if (newTheme === null || (0, $fHEdP.themeManager).isValidTheme(newTheme) && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(selectedThemeSetting?.type === 'image' ? selectedThemeSetting?.id : selectedThemeSetting?.value, newTheme?.type === 'image' ? newTheme?.id : newTheme?.value)) setState({
            entityId: entityId,
            themeSetting: themeSetting,
            selectedThemeSetting: newTheme
        });
    };
const $5ffb1b62a0c37aa6$var$actions = {
    setTheme: $5ffb1b62a0c37aa6$var$setTheme,
    setSelectedThemeSetting: $5ffb1b62a0c37aa6$var$setSelectedThemeSetting
};
const $5ffb1b62a0c37aa6$var$initialState = {
    themeSetting: null,
    selectedThemeSetting: null,
    entityId: ''
};
const $5ffb1b62a0c37aa6$var$Store = (0, $iXqE5.createStore)({
    initialState: $5ffb1b62a0c37aa6$var$initialState,
    actions: $5ffb1b62a0c37aa6$var$actions,
    name: 'ProjectTheme'
});
const $5ffb1b62a0c37aa6$export$c6e50a832af54243 = (0, $gg7kZ.createContainer)($5ffb1b62a0c37aa6$var$Store, {
    onInit: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme),
    onUpdate: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme)
});
const $5ffb1b62a0c37aa6$export$11eb671888ed6e7d = (0, $gg7kZ.createContainer)($5ffb1b62a0c37aa6$var$Store, {
    onInit: ()=>({ setState: setState }, { entityTheme: entityTheme })=>{
            setState(entityTheme ?? $5ffb1b62a0c37aa6$var$initialState);
        },
    onUpdate: ()=>({ setState: setState }, { entityTheme: entityTheme })=>{
            setState(entityTheme ?? $5ffb1b62a0c37aa6$var$initialState);
        }
});
const $5ffb1b62a0c37aa6$export$b95ba2c6b597cfbb = (0, $3sQ5x.createHook)($5ffb1b62a0c37aa6$var$Store);
const $5ffb1b62a0c37aa6$var$getThemeSetting = (0, $6dDSs.createSelector)((state)=>state.themeSetting, (themeSetting)=>themeSetting);
const $5ffb1b62a0c37aa6$export$87d26f94ea053d38 = (0, $3sQ5x.createHook)($5ffb1b62a0c37aa6$var$Store, {
    selector: $5ffb1b62a0c37aa6$var$getThemeSetting
});
const $5ffb1b62a0c37aa6$var$getSelectedThemeSetting = (0, $6dDSs.createSelector)((state)=>state.selectedThemeSetting, (selectedThemeSetting)=>selectedThemeSetting);
const $5ffb1b62a0c37aa6$export$4ba6f9d407e18961 = (0, $3sQ5x.createHook)($5ffb1b62a0c37aa6$var$Store, {
    selector: $5ffb1b62a0c37aa6$var$getSelectedThemeSetting
});

});
parcelRegister("fHEdP", function(module, exports) {

$parcel$export(module.exports, "themeManager", () => $a34e148e1f33a06a$export$aba92a7f3273f617);
$parcel$export(module.exports, "generateMediaImageUrl", () => $a34e148e1f33a06a$export$fe2402bbc6ac3125);
$parcel$export(module.exports, "getBackgroundConfigs", () => $a34e148e1f33a06a$export$224c78c119a97f91);

var $6cG4N = parcelRequire("6cG4N");
const $a34e148e1f33a06a$var$ALL_COLOR_BACKGROUND_CONFIGS = [
    ...(0, $6cG4N.FIXED_COLOR_BACKGROUND_CONFIGS),
    ...(0, $6cG4N.ADAPTIVE_COLOR_BACKGROUND_CONFIGS),
    (0, $6cG4N.NO_BACKGROUND_CONFIG)
];
const $a34e148e1f33a06a$var$ALL_GRADIENT_BACKGROUND_CONFIGS = [
    ...(0, $6cG4N.GRADIENT_BACKGROUND_CONFIGS),
    ...(0, $6cG4N.ADAPTIVE_GRADIENT_BACKGROUND_CONFIGS)
];
/**
 * This is a temporary class that will be used to transition between the old
 * and new theme systems. Once the old theme system is removed, this class
 * will be removed as well.
 */ class $a34e148e1f33a06a$var$ThemeManager {
    init() {
        $a34e148e1f33a06a$var$ALL_GRADIENT_BACKGROUND_CONFIGS.forEach((theme)=>{
            this.gradients.set(theme.name, theme);
            this.gradientNames.add(theme.name);
        });
        $a34e148e1f33a06a$var$ALL_COLOR_BACKGROUND_CONFIGS.forEach((theme)=>{
            this.colors.set(theme.name, theme);
            this.colorNames.add(theme.name);
        });
        (0, $6cG4N.BACKGROUND_CONFIGS_OLD).forEach((theme)=>{
            this.oldColorNames.add(theme.name);
        });
    }
    isColorTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.colorNames.has(themeName);
    }
    isOldColorTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.oldColorNames.has(themeName);
    }
    isGradientTheme(themeName) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return this.gradientNames.has(themeName);
    }
    isImageTheme(themeSetting) {
        return themeSetting.type === 'image';
    }
    getGradient(themeName) {
        return this.gradients.get(themeName);
    }
    getColor(themeName) {
        return this.colors.get(themeName);
    }
    /**
	 * Gets the theme meta for the given theme setting and version.
	 * This is used because we want to handle cases where users get flag
	 * variations during rollout that change what background is allowed.
	 * For example, if you have a new background color, but the flag is off,
	 * we want to revert back to the default background color instead.
	 * @param themeSetting the name setting with its type and value.
	 * @param enableImages determines if image backgrounds are enabled.
	 * @returns the meta information for the theme.
	 */ get({ themeSetting: themeSetting, enableImages: enableImages }) {
        if (!themeSetting) return 0, $6cG4N.DEFAULT_BACKGROUND_CONFIG;
        if (enableImages && themeSetting.type === 'image') return 0, $6cG4N.IMAGE_BACKGROUND_CONFIG;
        if (this.isGradientTheme(themeSetting.value)) return this.getGradient(themeSetting.value) ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG);
        if (this.isColorTheme(themeSetting.value)) return this.getColor(themeSetting.value) ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG);
        // we have an old color on the image version
        return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $6cG4N.OLD_TO_NEW_BACKGROUND_CONFIG_MAP)[themeSetting.value] ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG));
    }
    constructor(){
        this.gradients = new Map();
        this.gradientNames = new Set();
        this.colors = new Map();
        this.colorNames = new Set();
        this.oldColorNames = new Set();
        this.isValidTheme = (themeSetting)=>this.isColorTheme(themeSetting.value) || this.isOldColorTheme(themeSetting.value) || this.isGradientTheme(themeSetting.value) || this.isImageTheme(themeSetting);
    }
}
const $a34e148e1f33a06a$export$aba92a7f3273f617 = new $a34e148e1f33a06a$var$ThemeManager();
$a34e148e1f33a06a$export$aba92a7f3273f617.init();
function $a34e148e1f33a06a$export$fe2402bbc6ac3125({ mediaApiFileId: mediaApiFileId, mediaClientId: mediaClientId, mediaExternalEndpointUrl: mediaExternalEndpointUrl, mediaEndpoint: mediaEndpoint, ...queryParams }) {
    const url = new URL(`${mediaExternalEndpointUrl}/file/${mediaApiFileId}/${mediaEndpoint}`);
    url.searchParams.append('client', mediaClientId);
    Object.entries(queryParams).forEach(([param, value])=>url.searchParams.append(param, String(value)));
    return url.toString();
}
function $a34e148e1f33a06a$export$224c78c119a97f91(withAdaptiveColorTheme) {
    return withAdaptiveColorTheme ? {
        backgroundColorConfigs: (0, $6cG4N.ADAPTIVE_COLOR_BACKGROUND_CONFIGS),
        gradientBackgroundConfigs: (0, $6cG4N.ADAPTIVE_GRADIENT_BACKGROUND_CONFIGS)
    } : {
        backgroundColorConfigs: (0, $6cG4N.FIXED_COLOR_BACKGROUND_CONFIGS),
        gradientBackgroundConfigs: (0, $6cG4N.GRADIENT_BACKGROUND_CONFIGS)
    };
}

});


parcelRegister("1E3vT", function(module, exports) {

$parcel$export(module.exports, "businessHorizontalNav3Resource", () => $4f364072ed560b43$export$b3359003584ee2b0);

var $j5YhT = parcelRequire("j5YhT");

var $dJl1T = parcelRequire("dJl1T");

var $4R6GH = parcelRequire("4R6GH");

var $6YG83 = parcelRequire("6YG83");

var $ktofH = parcelRequire("ktofH");

var $ao2h1 = parcelRequire("ao2h1");

var $6SGt4 = parcelRequire("6SGt4");

var $1nb22 = parcelRequire("1nb22");
const $4f364072ed560b43$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_HORIZONTAL_NAVIGATION';
const $4f364072ed560b43$var$getProjectAri = (projectId, cloudId)=>{
    try {
        return projectId ? (0, $j5YhT.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString() : '';
    } catch (err) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jiraRouterResourcesNavigationItems', 'Failed to get project ari');
        return '';
    }
};
const $4f364072ed560b43$export$b3359003584ee2b0 = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: $4f364072ed560b43$var$RESOURCE_TYPE_KEY,
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        const { cloudId: cloudId } = tenantContext;
        const projectIdOrKey = projectKey || projectId;
        const scopeId = $4f364072ed560b43$var$getProjectAri(projectId, cloudId);
        return {
            parameters: (0, $6SGt4.default),
            variables: {
                cloudId: cloudId,
                projectIdOrKey: projectIdOrKey,
                first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE),
                isConsolidatedQuery: false,
                containerNavigationInput: scopeId ? {
                    scopeId: scopeId
                } : {
                    projectKeyQuery: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                useContainerNavigation: false,
                useNewProjectHeader: false,
                projectKey: projectKey,
                projectAri: scopeId,
                useProjectKey: Boolean(projectKey),
                isJiraCustomTemplatesUxEnabled: (0, $4R6GH.fg)('jira_custom_templates_ux')
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
}));

});

parcelRegister("aTlfe", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7adac75eab47da4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");


var $lTRjN = parcelRequire("lTRjN");

const $e7adac75eab47da4$var$runtimeProps = {};
const $e7adac75eab47da4$var$entryPointParams = {};
const $e7adac75eab47da4$export$74de64a88a8bb973 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $lTRjN.jwmAutomationDiscoveryExperimentEntrypoint), $e7adac75eab47da4$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jwmAutomationDiscoveryExperimentEntrypoint",
        packageName: (0, $01e1e32c939dcb86$export$b8b9d90f9e5bd72b),
        teamName: "jira-warepil",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $e7adac75eab47da4$var$runtimeProps,
        errorFallback: "unmount"
    });
};
var $e7adac75eab47da4$export$2e2bcd8739ae039 = $e7adac75eab47da4$export$74de64a88a8bb973;

});
const $01e1e32c939dcb86$export$b8b9d90f9e5bd72b = 'programMoonJwmAutomationDiscoveryExperiment';

parcelRegister("lTRjN", function(module, exports) {

$parcel$export(module.exports, "jwmAutomationDiscoveryExperimentEntrypoint", () => $a95d6d9491c1d780$export$7634f97a1a2b62f2);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $a95d6d9491c1d780$export$7634f97a1a2b62f2 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("80b3Z")), {
        moduleId: "f41474f2"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("80b3Z", function(module, exports) {

let $5d36e7ca48b93126$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5d36e7ca48b93126$var$load("jiFUc").then(()=>parcelRequire('bYSdZ'));

});



parcelRegister("83AT7", function(module, exports) {

$parcel$export(module.exports, "VIEW_NAV_EXPERIENCE", () => $7af307ee0d484bc5$export$e7883a9cbc6811c5);
$parcel$export(module.exports, "VIEW_HORIZONTAL_NAVIGATION_EXPERIENCE", () => $7af307ee0d484bc5$export$7cda409ac84f8a51);
$parcel$export(module.exports, "CONTAINER", () => $7af307ee0d484bc5$export$33d8c916a600c5e9);
$parcel$export(module.exports, "PROJECT", () => $7af307ee0d484bc5$export$fe791c4fa892e400);
$parcel$export(module.exports, "TAB", () => $7af307ee0d484bc5$export$f1c9dd0f5207dd5e);
const $7af307ee0d484bc5$var$PACKAGE_NAME = 'jiraBusinessHorizontalNav';
const $7af307ee0d484bc5$export$e7883a9cbc6811c5 = {
    experience: 'view-horizontal-nav',
    packageName: $7af307ee0d484bc5$var$PACKAGE_NAME,
    teamName: 'wanjel'
};
const $7af307ee0d484bc5$export$7cda409ac84f8a51 = {
    experience: 'viewHorizontalNavigation',
    packageName: $7af307ee0d484bc5$var$PACKAGE_NAME,
    teamName: 'wanjel'
};
const $7af307ee0d484bc5$export$33d8c916a600c5e9 = 'container';
const $7af307ee0d484bc5$export$fe791c4fa892e400 = 'project';
const $7af307ee0d484bc5$export$f1c9dd0f5207dd5e = 'tab';

});

parcelRegister("eoFNp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b092a8267ffe6d0e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2GZKW = parcelRequire("2GZKW");
var $2s57o = parcelRequire("2s57o");

var $cm8b5 = parcelRequire("cm8b5");

var $6cG4N = parcelRequire("6cG4N");

var $83AT7 = parcelRequire("83AT7");

var $1g6cy = parcelRequire("1g6cy");
const $b092a8267ffe6d0e$var$Z_INDEX = 11;
const $b092a8267ffe6d0e$var$TEST_ID = 'business-horizontal-nav.ui.horizontal-nav';
const $b092a8267ffe6d0e$var$NavWrapper = ({ children: children })=>/*#__PURE__*/ $5uXOq.createElement((0, $cm8b5.ExperienceErrorBoundary), {
        experience: (0, $83AT7.VIEW_NAV_EXPERIENCE),
        shouldStartExperience: true
    }, /*#__PURE__*/ $5uXOq.createElement((0, $1g6cy.PerformanceMark), {
        id: (0, $1g6cy.RENDER_START_MARK)
    }), /*#__PURE__*/ $5uXOq.createElement($b092a8267ffe6d0e$var$StyledHeader, {
        id: "ak-project-view-navigation",
        "data-testid": $b092a8267ffe6d0e$var$TEST_ID
    }, /*#__PURE__*/ $5uXOq.createElement((0, $2GZKW.default), {
        gap: "space.050",
        alignItems: "end",
        xcss: $b092a8267ffe6d0e$var$contentOldStyles
    }, children)), /*#__PURE__*/ $5uXOq.createElement((0, $cm8b5.ExperienceSuccess), {
        experience: (0, $83AT7.VIEW_NAV_EXPERIENCE)
    }), /*#__PURE__*/ $5uXOq.createElement((0, $1g6cy.PerformanceMark), {
        id: (0, $1g6cy.RENDER_END_MARK)
    }), /*#__PURE__*/ $5uXOq.createElement((0, $1g6cy.PerformanceReport), null));
var $b092a8267ffe6d0e$export$2e2bcd8739ae039 = $b092a8267ffe6d0e$var$NavWrapper;
const $b092a8267ffe6d0e$var$contentOldStyles = (0, $2s57o.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $6cG4N.HORIZONTAL_NAV_HEIGHT)}px`,
    paddingTop: 'space.300'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $b092a8267ffe6d0e$var$StyledHeader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "header", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q71iew _v56418c9 _1e0c11p5 _kqsw1n9t _1pbyibnn _1bsb18ua _vchhusvi _4t3i14em _18k9ad7r",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1g6cy", function(module, exports) {

$parcel$export(module.exports, "RENDER_START_MARK", () => $3e0dfe133a8179e0$export$8f8203e04f80aed);
$parcel$export(module.exports, "RENDER_END_MARK", () => $3e0dfe133a8179e0$export$dc795f9b21e2778a);
$parcel$export(module.exports, "PerformanceMark", () => $3e0dfe133a8179e0$export$b8228db3a01d9a76);
$parcel$export(module.exports, "PerformanceReport", () => $3e0dfe133a8179e0$export$c97ab321326d29f7);

var $5uXOq = parcelRequire("5uXOq");

var $2nKjG = parcelRequire("2nKjG");
const $3e0dfe133a8179e0$var$JWM_HORIZONTAL_NAV_SEGMENT_NAME = 'jwm.horizontal-nav';
const $3e0dfe133a8179e0$export$8f8203e04f80aed = `${$3e0dfe133a8179e0$var$JWM_HORIZONTAL_NAV_SEGMENT_NAME}.render.start`;
const $3e0dfe133a8179e0$export$dc795f9b21e2778a = `${$3e0dfe133a8179e0$var$JWM_HORIZONTAL_NAV_SEGMENT_NAME}.render.end`;
const $3e0dfe133a8179e0$var$segment = (0, $2nKjG.metrics).pageSegmentLoad({
    key: $3e0dfe133a8179e0$var$JWM_HORIZONTAL_NAV_SEGMENT_NAME,
    timings: [
        {
            key: 'tti',
            endMark: $3e0dfe133a8179e0$export$dc795f9b21e2778a
        }
    ]
});
const $3e0dfe133a8179e0$export$b8228db3a01d9a76 = ({ id: id })=>{
    const startedRef = (0, $5uXOq.useRef)(false);
    if (!false && !startedRef.current) {
        $3e0dfe133a8179e0$var$segment.startFromPageLoad();
        startedRef.current = true;
    }
    (0, $5uXOq.useEffect)(()=>$3e0dfe133a8179e0$var$segment.mark(id), [
        id
    ]);
    return null;
};
const $3e0dfe133a8179e0$export$c97ab321326d29f7 = ()=>{
    (0, $5uXOq.useEffect)(()=>{
        $3e0dfe133a8179e0$var$segment.stop();
    }, []);
    return null;
};

});


parcelRegister("fOzv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $07a713a024503403$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");

var $8itvN = parcelRequire("8itvN");
const $07a713a024503403$var$HeaderSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        space: "space.100",
        alignBlock: "end",
        xcss: $07a713a024503403$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $07a713a024503403$var$primaryContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: [
            $07a713a024503403$var$baseSkeletonStyles,
            $07a713a024503403$var$squareStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: [
            $07a713a024503403$var$baseSkeletonStyles,
            $07a713a024503403$var$projectTitleStyles
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        space: "space.150",
        xcss: $07a713a024503403$var$actionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: [
            $07a713a024503403$var$baseSkeletonStyles,
            $07a713a024503403$var$squareStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: [
            $07a713a024503403$var$baseSkeletonStyles,
            $07a713a024503403$var$squareStyles
        ]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8itvN.SkeletonComponent), null));
var $07a713a024503403$export$2e2bcd8739ae039 = $07a713a024503403$var$HeaderSkeleton;
const $07a713a024503403$var$wrapperStyles = (0, $2s57o.xcss)({
    paddingTop: 'space.300',
    minBlockSize: '96px'
});
const $07a713a024503403$var$baseSkeletonStyles = (0, $2s57o.xcss)({
    backgroundColor: 'color.skeleton',
    borderRadius: 'border.radius'
});
const $07a713a024503403$var$primaryContainerStyles = (0, $2s57o.xcss)({
    display: 'flex',
    gap: 'space.100',
    marginInlineStart: 'space.300'
});
const $07a713a024503403$var$squareStyles = (0, $2s57o.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: "var(--ds-space-300, 24px)"
});
const $07a713a024503403$var$projectTitleStyles = (0, $2s57o.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: '180px'
});
const $07a713a024503403$var$actionStyles = (0, $2s57o.xcss)({
    marginInlineEnd: 'space.300'
});

});
parcelRegister("8itvN", function(module, exports) {

$parcel$export(module.exports, "SkeletonComponent", () => $418350e0250d7818$export$daa0a8a0031b3bb3);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $2s57o = parcelRequire("2s57o");

var $ktofH = parcelRequire("ktofH");
const $418350e0250d7818$export$daa0a8a0031b3bb3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        xcss: $418350e0250d7818$var$skeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $418350e0250d7818$var$skeletonItemStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $418350e0250d7818$var$skeletonItemStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $418350e0250d7818$var$skeletonItemStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $418350e0250d7818$var$skeletonItemStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $418350e0250d7818$var$skeletonItemStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $418350e0250d7818$var$skeletonItemStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $418350e0250d7818$var$skeletonItemStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $418350e0250d7818$var$skeletonItemStyles
    }));
const $418350e0250d7818$var$skeletonWrapperStyles = (0, $2s57o.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    height: `${(0, $ktofH.TAB_HEIGHT)}px`,
    gap: 'space.200',
    paddingInlineStart: 'space.300',
    paddingInlineEnd: 'space.300',
    paddingBlockStart: 'space.100',
    paddingBlockEnd: 'space.150',
    position: 'relative',
    '::after': {
        content: '""',
        position: 'absolute',
        bottom: '0',
        backgroundColor: 'color.skeleton',
        height: '2px',
        left: '0',
        right: '0'
    }
});
const $418350e0250d7818$var$skeletonItemStyles = (0, $2s57o.xcss)({
    minWidth: "var(--ds-space-1000, 80px)",
    backgroundColor: 'color.skeleton',
    borderRadius: "var(--ds-border-radius, 4px)"
});

});


parcelRegister("cSPpW", function(module, exports) {

$parcel$export(module.exports, "CustomTemplateBusinessProjectBanner", () => $089cfaad75aa9f41$export$e36b81ae643228e);

var $2ddzl = parcelRequire("2ddzl");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $9eEJv = parcelRequire("9eEJv");

var $6eFvr = parcelRequire("6eFvr");

var $koVbs = parcelRequire("koVbs");

var $2KXsc = parcelRequire("2KXsc");
const $089cfaad75aa9f41$var$isBannerSupported = ()=>{
    if (false) return true;
    if (typeof window !== 'undefined') return window.__SPA__;
    return false;
};
const $089cfaad75aa9f41$export$e36b81ae643228e = ({ projectFragment: projectFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $2ddzl.default), projectFragment);
    return data.isLiveTemplate === true && $089cfaad75aa9f41$var$isBannerSupported() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9eEJv.default), {
        appearance: "announcement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), null, formatMessage((0, $2KXsc.default).customTemplateProjectBannerMessage)));
};

});
parcelRegister("2ddzl", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a419f005921ab84$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e80cadeec0148b12d0e7441129b597e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0a419f005921ab84$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "customTemplateBusinessProjectBanner_businessHorizontalNav",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isLiveTemplate"
        }
    ],
    "type": "JiraProject"
};
$0a419f005921ab84$var$node.hash = "b53840460a785858a03465e2d4e8a922";
var $0a419f005921ab84$export$2e2bcd8739ae039 = $0a419f005921ab84$var$node;

});

parcelRegister("2KXsc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0458403e668d443$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d0458403e668d443$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    customTemplateProjectBannerMessage: {
        "id": "jira-horizontal-nav.custom-template-project-banner-message",
        "defaultMessage": "This project is saved as a custom template. Project settings changes will apply to the template."
    }
});

});


parcelRegister("2FBSL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae5ab0e8e2edda8e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ae5ab0e8e2edda8e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    defaultViewRedirectFlagTitle: {
        "id": "business-horizontal-nav.project-navigation.default-view-redirect-flag-title",
        "defaultMessage": "We've taken you to the default view"
    },
    defaultViewRedirectFlagDescription: {
        "id": "business-horizontal-nav.project-navigation.default-view-redirect-flag-description",
        "defaultMessage": "The view you're trying to access has been removed."
    },
    defaultErrorMessage: {
        "id": "business-horizontal-nav.project-navigation.default-error-message",
        "defaultMessage": "Try refreshing or navigating to another page."
    },
    defaultErrorTitle: {
        "id": "business-horizontal-nav.project-navigation.default-error-title",
        "defaultMessage": "Something's gone wrong"
    },
    unauthenticatedUserErrorTitle: {
        "id": "business-horizontal-nav.project-navigation.unauthenticated-user-error-title",
        "defaultMessage": "You'll need to log in"
    },
    unauthenticatedUserErrorMessage: {
        "id": "business-horizontal-nav.project-navigation.unauthenticated-user-error-message",
        "defaultMessage": "You need to be logged in to manage the navigation. Please log in and try again."
    },
    unauthorizedUserErrorTitle: {
        "id": "business-horizontal-nav.project-navigation.unauthorized-user-error-title",
        "defaultMessage": "You don't have permission"
    },
    unauthorizedUserErrorMessage: {
        "id": "business-horizontal-nav.project-navigation.unauthorized-user-error-message",
        "defaultMessage": "You don't have permission to view this project."
    },
    projectNotFoundErrorTitle: {
        "id": "business-horizontal-nav.project-navigation.project-not-found-error-title",
        "defaultMessage": "Project not found"
    },
    projectNotFoundErrorMessage: {
        "id": "business-horizontal-nav.project-navigation.project-not-found-error-message",
        "defaultMessage": "The project might have been deleted or you don't have permission."
    }
});

});

parcelRegister("j00Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b89f4a965d54547$export$2e2bcd8739ae039);
/* A button invoking the project settings.
 * This button is meant to be part of group of navigation buttons.
 * When the settings are open, this button should highlight itself as "current" (aria-current + visual cue).
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $hecDf = parcelRequire("hecDf");

var $dvFQw = parcelRequire("dvFQw");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");
const $1b89f4a965d54547$var$JIRA_BUSINESS_BASE_PROJECT_URL = '/jira/core/projects';
const $1b89f4a965d54547$var$ProjectSettingsButton = ()=>{
    const { project: project } = (0, $hecDf.useNavigationProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const onClick = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'horizontalNav', {
            itemId: 'settings'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dvFQw.default), {
        project: project,
        projectUrlBase: $1b89f4a965d54547$var$JIRA_BUSINESS_BASE_PROJECT_URL,
        onClick: onClick
    });
};
var $1b89f4a965d54547$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($1b89f4a965d54547$var$ProjectSettingsButton);

});
parcelRegister("hecDf", function(module, exports) {

$parcel$export(module.exports, "useNavigationProject", () => $46378552d09cbbed$export$befd5d7ebc77f264);


var $iNzEe = parcelRequire("iNzEe");

var $l2N2a = parcelRequire("l2N2a");

var $doZTA = parcelRequire("doZTA");
const $46378552d09cbbed$export$befd5d7ebc77f264 = ()=>{
    const { data: currentProject, loading: currentProjectLoading } = (0, $l2N2a.useProject_DEPRECATED_DO_NOT_USE)();
    const { data: navigationData, loading: navigationDataLoading } = (0, $iNzEe.useNavigationResource)();
    const [{ match: { params: { projectKey: projectKey } } }] = (0, $doZTA.useRouter)();
    if (currentProject != null) return {
        project: currentProject,
        loading: currentProjectLoading
    };
    if (projectKey != null && navigationData != null && navigationData !== (0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71)) {
        const project = navigationData.favorites.find((proj)=>proj.key === projectKey) ?? navigationData.recents.find((proj)=>proj.key === projectKey) ?? null;
        return {
            project: project,
            loading: navigationDataLoading
        };
    }
    return {
        project: null,
        loading: currentProjectLoading || navigationDataLoading
    };
};

});
const $4ee2cfa1c76e72ed$export$3349219a88ac77cd = 10;
const $4ee2cfa1c76e72ed$export$e8958a6508ec5b71 = 'NOT_APPLICABLE';

parcelRegister("iNzEe", function(module, exports) {

$parcel$export(module.exports, "navigationResource", () => $6b942b0827824c4b$export$62940941ee574cdc);
$parcel$export(module.exports, "useNavigationResource", () => $6b942b0827824c4b$export$c17011c09e042a31);

var $gccSB = parcelRequire("gccSB");

var $j5YhT = parcelRequire("j5YhT");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


var $geiy6 = parcelRequire("geiy6");

const $6b942b0827824c4b$export$62940941ee574cdc = (0, $2M1hQ.createResource)({
    type: 'BUSINESS_NAVIGATION',
    getKey: ()=>'BUSINESS_NAVIGATION',
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(match, query);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(projectKey)) return (0, $geiy6.fetchNavigation)((0, $77516b48757f52de$export$a40c5d12b8a53ba2), {
            cloudId: cloudId,
            projectKey: projectKey
        });
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(projectId)) return (0, $geiy6.fetchNavigation)((0, $77516b48757f52de$export$7c9197b656229b53), {
            cloudId: cloudId,
            projectId: (0, $j5YhT.JiraProjectAri).create({
                siteId: cloudId,
                projectId: projectId
            }).toString()
        });
        return (0, $geiy6.fetchNavigation)((0, $77516b48757f52de$export$c378ca4a0e2c9fec), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity
});
const $6b942b0827824c4b$export$c17011c09e042a31 = ()=>(0, $2YP9W.useResource)($6b942b0827824c4b$export$62940941ee574cdc);

});
const $77516b48757f52de$var$ProjectFragment = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectStyle
  projectType
  isFavourite
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
  defaultView: jwmDefaultSavedView {
    ... on JiraNavigationItem {
      typeKey
    }
  }
}
`;
const $77516b48757f52de$var$ProjectConnectionFragment = `
fragment ProjectConnectionFragment on JiraProjectConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...ProjectFragment
    }
  }
}
`;
const $77516b48757f52de$var$OverviewFragment = `
fragment OverviewFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
}
`;
const $77516b48757f52de$var$OverviewConnectionFragment = `
fragment OverviewConnectionFragment on JiraWorkManagementGiraOverviewConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...OverviewFragment
    }
  }
}
`;
const $77516b48757f52de$var$NavigationDataFragment = `
fragment NavigationFragment on JiraWorkManagementNavigation {
  jwmLicensing {
    currentUserSeatEdition
  }
  recentProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  favoriteProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  overviews: jwmOverviews(cloudId: $cloudId, first: $first) @optIn(to: "JiraWorkManagementGiraOverviews") {
    __typename
    ... on JiraWorkManagementGiraOverviewConnection {
      ...OverviewConnectionFragment
    }
  }
}
`;
const $77516b48757f52de$export$7c9197b656229b53 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectId(projectId: $projectId) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
const $77516b48757f52de$export$a40c5d12b8a53ba2 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectKey: String!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectKey(cloudId: $cloudId, projectKey: $projectKey) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;
const $77516b48757f52de$export$c378ca4a0e2c9fec = `
query JiraBusinessOverviewNavigation($cloudId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigation(cloudId: $cloudId) {
      ...NavigationFragment
    }
  }
}
${$77516b48757f52de$var$ProjectFragment}
${$77516b48757f52de$var$ProjectConnectionFragment}
${$77516b48757f52de$var$NavigationDataFragment}
${$77516b48757f52de$var$OverviewFragment}
${$77516b48757f52de$var$OverviewConnectionFragment}
`;

parcelRegister("geiy6", function(module, exports) {

$parcel$export(module.exports, "fetchNavigation", () => $446f8b979bebb841$export$1fc5fff73d9a570c);

var $jlq4V = parcelRequire("jlq4V");

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");


var $ifwpM = parcelRequire("ifwpM");
const $446f8b979bebb841$var$EMPTY_RESPONSE = {
    recents: [],
    favorites: [],
    hasMoreFavorite: false,
    overviews: [],
    overviewsError: null,
    isPremiumUserSeat: false,
    shouldHideOverviews: false
};
const $446f8b979bebb841$export$1fc5fff73d9a570c = async (query, params)=>{
    try {
        const response = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: (0, $4ee2cfa1c76e72ed$export$3349219a88ac77cd),
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        // checking only for undefined, as null is a valid value (not applicable)
        if (response.data?.jira?.navigation === undefined) throw new (0, $jlq4V.GraphQLErrors)(response.errors);
        let areOverviewsGone = false;
        if (Array.isArray(response.errors)) // Overviews have been migrated to plans and should no longer be shown to the user
        areOverviewsGone = response.errors.some((error)=>error.extensions?.statusCode === 410);
        return (0, $ifwpM.transformData)(response.data.jira.navigation, areOverviewsGone);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessNavigation', 'Something went wrong while fetching the navigation items');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $jcw0u.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesBusinessNavigation',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $446f8b979bebb841$var$EMPTY_RESPONSE;
};

});
parcelRegister("ifwpM", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $9031e5290b70d3d6$export$3ceb62baab058c6b);

var $6cG4N = parcelRequire("6cG4N");


var $027FQ = parcelRequire("027FQ");
const $9031e5290b70d3d6$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
const $9031e5290b70d3d6$var$PREMIUM = 'PREMIUM';
const $9031e5290b70d3d6$var$mapProjectNode = (node)=>({
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.projectStyle === $9031e5290b70d3d6$var$SIMPLIFIED_PROJECT_STYLE,
        isFavorite: node.isFavourite,
        permissions: {
            viewIssues: node.viewIssues.canPerform
        },
        defaultView: node.defaultView?.typeKey?.toLowerCase()
    });
const $9031e5290b70d3d6$var$mapOverviewNode = (node)=>({
        id: node.id,
        name: node.name,
        theme: node?.theme ?? (0, $6cG4N.DEFAULT_BACKGROUND_CONFIG).name
    });
const $9031e5290b70d3d6$export$3ceb62baab058c6b = (navigation, areOverviewsGone)=>{
    if (navigation == null) // not a JWM context
    return 0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71;
    let overviews = [];
    let overviewsError = null;
    const isPremiumUserSeat = navigation.jwmLicensing?.currentUserSeatEdition === $9031e5290b70d3d6$var$PREMIUM;
    if (isPremiumUserSeat) {
        if (navigation.overviews?.__typename === (0, $027FQ.OVERVIEWS_SUCCESS_RESPONSE_TYPE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        overviews = navigation.overviews.edges.map((edge)=>$9031e5290b70d3d6$var$mapOverviewNode(edge.node));
        else overviewsError = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        navigation.overviews ?? new Error('Unknown overviews error');
    }
    let recents = navigation.recentProjects?.edges?.map((edge)=>$9031e5290b70d3d6$var$mapProjectNode(edge.node)) ?? [];
    const favorites = navigation.favoriteProjects?.edges?.map((edge)=>$9031e5290b70d3d6$var$mapProjectNode(edge.node)) ?? [];
    // Remove favorited projects from the recent projects list
    recents = recents.filter((recentProject)=>!favorites.some((favProject)=>favProject.id === recentProject.id));
    return {
        recents: recents,
        favorites: favorites,
        hasMoreFavorite: navigation.favoriteProjects?.pageInfo?.hasNextPage ?? false,
        overviews: overviews,
        overviewsError: overviewsError,
        isPremiumUserSeat: isPremiumUserSeat,
        shouldHideOverviews: areOverviewsGone
    };
};

});
parcelRegister("027FQ", function(module, exports) {

$parcel$export(module.exports, "OVERVIEWS_SUCCESS_RESPONSE_TYPE", () => $fd4c320fd9ec6c35$export$ddf2fc82885279d);
const $fd4c320fd9ec6c35$export$ddf2fc82885279d = 'JiraWorkManagementGiraOverviewConnection';
const $fd4c320fd9ec6c35$export$39284f7325536558 = {
    ServiceDesk: 'SERVICE_DESK',
    Business: 'BUSINESS',
    Software: 'SOFTWARE'
};
const $fd4c320fd9ec6c35$export$1f66f9f05afa05a8 = {
    TeamManagedProject: 'TEAM_MANAGED_PROJECT',
    CompanyManagedProject: 'COMPANY_MANAGED_PROJECT'
};

});





parcelRegister("dvFQw", function(module, exports) {

$parcel$export(module.exports, "default", () => $35dfbfae0ceb8fbf$export$2e2bcd8739ae039);
/* A button invoking the project settings.
 * This button is meant to be part of group of navigation buttons.
 * When the settings are open, this button should highlight itself as "current" (aria-current + visual cue).
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $dnGcR = parcelRequire("dnGcR");

var $koVbs = parcelRequire("koVbs");

var $6jY6G = parcelRequire("6jY6G");

var $22OQR = parcelRequire("22OQR");

var $hjSul = parcelRequire("hjSul");

var $es6DP = parcelRequire("es6DP");
const $35dfbfae0ceb8fbf$var$_PROJECT_SETTINGS_ROUTES_GROUPS = [
    'project-settings-classic',
    'project-settings-core',
    'project-settings-servicedesk',
    'project-settings-software'
];
const $35dfbfae0ceb8fbf$export$b0bafa414bdc2b17 = new Set($35dfbfae0ceb8fbf$var$_PROJECT_SETTINGS_ROUTES_GROUPS);
const $35dfbfae0ceb8fbf$var$_PROJECT_SETTINGS_ROUTES_NAMES = [
    'project-settings-core-proforma-project-forms',
    'project-settings-core-proforma-project-forms',
    'project-settings-classic-data-classifications',
    'classic-software-details',
    'classic-software-features',
    'project-settings-classic-issue-layout',
    'project-settings-classic-issue-layout',
    'classic-software-link-opsgenie',
    'project-settings-software-proforma-edit-forms',
    'project-settings-software-proforma-project-forms',
    'project-settings-software-toolchain-company-managed',
    'classic-software-notifications-issue-logs',
    'legacy-project-settings-collectors',
    'legacy-project-settings-collectors-add',
    'legacy-project-settings-collectors-help',
    'legacy-project-settings-collectors-view',
    'legacy-project-settings-config',
    'project-settings-classic-data-classifications',
    'legacy-project-settings-delete',
    'legacy-project-settings-dev',
    'legacy-project-settings-edit',
    'legacy-project-settings-fields',
    'legacy-project-settings-fields-associate',
    'legacy-project-settings-issue-layout',
    'legacy-project-settings-issue-security',
    'legacy-project-settings-issue-security-associate',
    'legacy-project-settings-issue-types',
    'legacy-project-settings-issue-types-associate',
    'legacy-project-settings-notifications',
    'legacy-project-settings-notifications-associate',
    'legacy-project-settings-opsgenie',
    'legacy-project-settings-people',
    'legacy-project-settings-permissions',
    'legacy-project-settings-permissions-associate',
    'legacy-project-settings-screens',
    'legacy-project-settings-screens-associate',
    'legacy-project-settings-summary',
    'legacy-project-settings-workflows',
    'legacy-project-settings-workflows-associate',
    'project-settings-automation',
    'project-settings-components',
    'project-settings-core-access',
    'project-settings-core-access-redirect',
    'project-settings-core-approvals',
    'project-settings-core-apps',
    'project-settings-core-apps-fields',
    'project-settings-core-automation',
    'project-settings-core-data-classifications',
    'project-settings-core-redirect',
    'project-settings-core-details',
    'project-settings-core-fields',
    'project-settings-core-forge-apps',
    'project-settings-core-issuetypes',
    'project-settings-core-issuetypes-workflow',
    'project-settings-core-notifications-notification-email',
    'project-settings-core-notifications',
    'project-settings-core-notifications-issue-logs',
    'project-settings-core-proforma-jira-form-builder',
    'project-settings-core-proforma-project-forms',
    'project-settings-software-notifications-issue-logs',
    'project-settings-software-forge-apps',
    'project-settings-software-apps-forge',
    'project-settings-servicedesk-apps-fields',
    'project-settings-servicedesk-chat',
    'project-settings-servicedesk-customer-notifications',
    'project-settings-servicedesk-customer-permissions',
    'project-settings-servicedesk-email',
    'project-settings-servicedesk-details',
    'project-settings-servicedesk-forge-apps',
    'project-settings-servicedesk-notifications',
    'project-settings-servicedesk-notifications-notification-email',
    'project-settings-servicedesk-portal-settings',
    'project-settings-servicedesk-ticket-types-config',
    'project-settings-servicedesk-ticket-type-fields',
    'project-settings-servicedesk-itsm-ticket-types-config',
    'project-settings-servicedesk-itsm-ticket-type-fields',
    'project-settings-servicedesk-notification-email',
    'project-settings-servicedesk-internal-notifications-nextGen',
    'project-settings-servicedesk-unassigned-ticket-types-config',
    'project-settings-servicedesk-unassigned-ticket-type-fields',
    'project-settings-servicedesk-widget',
    'project-settings-software-access',
    'project-settings-software-apps-fields',
    'project-settings-software-automation',
    'project-settings-software-boards-card',
    'project-settings-software-boards-csm',
    'project-settings-software-boards-custom-filters',
    'project-settings-software-boards-redirect',
    'project-settings-software-boards-roadmap',
    'project-settings-software-boards-timeline',
    'project-settings-software-data-classifications',
    'project-settings-software-details',
    'project-settings-software-next-gen-features',
    'project-settings-software-fields',
    'project-settings-software-issuetypes',
    'project-settings-software-notifications-notification-email',
    'project-settings-software-notifications',
    'project-settings-software-link-opsgenie',
    'project-settings-software-toolchain-team-managed',
    'project-settings-versions',
    // Route names without "PROJECT-SETTINGS" in their original ROUTE_NAMES constant
    // from src/packages/platform/utils/constants/src/spa-routes.tsx
    'project-settings-playbooks-edit',
    'project-settings-playbooks-list',
    'project-settings-servicedesk-access',
    'project-settings-servicedesk-access-redirect',
    'project-settings-servicedesk-apps',
    'project-settings-servicedesk-automation-copy-rule',
    'project-settings-servicedesk-automation-create',
    'project-settings-servicedesk-automation-edit-rule',
    'project-settings-servicedesk-automation-redirect-copy',
    'project-settings-servicedesk-automation-redirect-create',
    'project-settings-servicedesk-automation-redirect-edit',
    'project-settings-servicedesk-automation-redirect-summary',
    'project-settings-servicedesk-automation-redirect-viewlog',
    'project-settings-servicedesk-automation-summary',
    'project-settings-servicedesk-automation-view-log',
    'project-settings-servicedesk-change-management',
    'project-settings-servicedesk-channels',
    'project-settings-servicedesk-channels-chat',
    'project-settings-servicedesk-channels-email-next-gen',
    'project-settings-servicedesk-channels-permissions-next-gen',
    'project-settings-servicedesk-channels-portal',
    'project-settings-servicedesk-channels-widget',
    'project-settings-servicedesk-classic-apps',
    'project-settings-servicedesk-data-classifications',
    'project-settings-servicedesk-external-links',
    'project-settings-servicedesk-feedback',
    'project-settings-servicedesk-fields',
    'project-settings-servicedesk-incident-management',
    'project-settings-servicedesk-issuetypes',
    'project-settings-servicedesk-issuetypes-workflow',
    'project-settings-servicedesk-itsm-features',
    'project-settings-servicedesk-journey-configuration',
    'project-settings-servicedesk-journey-configuration-edit',
    'project-settings-servicedesk-journeys',
    'project-settings-servicedesk-kb',
    'project-settings-servicedesk-language',
    'project-settings-servicedesk-language-key',
    'project-settings-servicedesk-notifications-customer-notifications',
    'project-settings-servicedesk-notifications-internal-notifications',
    'project-settings-servicedesk-proforma-jira-form-builder',
    'project-settings-servicedesk-proforma-project-forms',
    'project-settings-servicedesk-redirect',
    'project-settings-servicedesk-virtualagent-ai-answers',
    'project-settings-servicedesk-virtualagent-browse-intents',
    'project-settings-servicedesk-virtualagent-browseconversations',
    'project-settings-servicedesk-virtualagent-performance',
    'project-settings-servicedesk-virtualagent-settings',
    'project-settings-servicedesk-virtualagent-standard-flows',
    'project-settings-servicedesk-virtualagent-view-intent',
    'project-settings-servicedesk-virtualagent-view-standard-flow',
    'project-settings-servicedesk-virtualagentonboarding',
    'project-settings-servicedesk-workflow-scheme-config',
    'project-settings-software-access-redirect',
    'project-settings-software-apps',
    'project-settings-software-issuetypes-workflow',
    'project-settings-software-proforma-jira-form-builder',
    'project-settings-software-redirect',
    'project-settings-customer-service-features'
];
const $35dfbfae0ceb8fbf$export$5ef2cb07eda31187 = new Set($35dfbfae0ceb8fbf$var$_PROJECT_SETTINGS_ROUTES_NAMES);
function $35dfbfae0ceb8fbf$export$2b03163fc654d37a(route) {
    return route.group && $35dfbfae0ceb8fbf$export$b0bafa414bdc2b17.has(route.group) || $35dfbfae0ceb8fbf$export$5ef2cb07eda31187.has(route.name);
}
function $35dfbfae0ceb8fbf$export$bc25d32895083684(project, projectUrlBase) {
    const projectKey = project?.key || '';
    // allow a little flexibility in how the "project URL base" is provided:
    // - we allow having the key already in the base (last segment) or not
    // - we allow having a trailing slash or not
    // Rationale:
    // - Jira Business projects "base URL" comes from a const string without the project key
    // We don't want to bother the caller with these details
    const projectUrlSplit = projectUrlBase.split('/').filter(Boolean);
    if (projectUrlSplit.slice(-1)[0] !== projectKey) projectUrlSplit.push(projectKey);
    return `/${projectUrlSplit.join('/')}/settings`;
}
const $35dfbfae0ceb8fbf$var$ProjectSettingsButton = ({ project: project, projectUrlBase: projectUrlBase, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const isLoading = project == null || !project?.key;
    const isCurrent = $35dfbfae0ceb8fbf$export$2b03163fc654d37a(route);
    const projectSettingsUrl = $35dfbfae0ceb8fbf$export$bc25d32895083684(project, projectUrlBase);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dnGcR))), {
            spacing: "spacious",
            label: ""
        }),
        href: projectSettingsUrl,
        isLoading: isLoading,
        isSelected: isCurrent,
        "aria-current": isCurrent,
        appearance: "subtle",
        component: (0, $hjSul.Link),
        onClick: onClick
    }, formatMessage((0, $es6DP.default).settings));
};
var $35dfbfae0ceb8fbf$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($35dfbfae0ceb8fbf$var$ProjectSettingsButton);

});
parcelRegister("es6DP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f139858c3ce32916$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f139858c3ce32916$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    settings: {
        "id": "navigation-kit-project-settings-button.settings",
        "defaultMessage": "Project settings"
    }
});

});



parcelRegister("4miW5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2e2b51a47320905$export$2e2bcd8739ae039);

var $7iCaP = parcelRequire("7iCaP");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $esGcf = parcelRequire("esGcf");

var $c9Ur7 = parcelRequire("c9Ur7");

var $cm8b5 = parcelRequire("cm8b5");

var $21JTp = parcelRequire("21JTp");

var $7UhxN = parcelRequire("7UhxN");

var $k1ALc = parcelRequire("k1ALc");


var $aaezu = parcelRequire("aaezu");

var $h2ENq = parcelRequire("h2ENq");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $l2N2a = parcelRequire("l2N2a");

var $2YP9W = parcelRequire("2YP9W");

var $83AT7 = parcelRequire("83AT7");

var $8itvN = parcelRequire("8itvN");

var $l3f0R = parcelRequire("l3f0R");

var $71WSM = parcelRequire("71WSM");
const $f2e2b51a47320905$export$bd905d70e8fd2ebb = ({ jiraQueryFragment: jiraQueryFragment, handleError: handleError })=>{
    const { data: projectDetails } = (0, $2YP9W.useResource)((0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource));
    const { data: shortcutsData, loading: loading } = (0, $7UhxN.useShortcutsData)();
    /**
   * edges field is included to allow the @connection directive to be used in the query,
   * even though it is not used in the component.
   * For more context, check this Github issue discussing the problem: https://github.com/facebook/relay/issues/1983
   */ const data = (0, $8Uumt.useFragment)((0, $7iCaP.default), jiraQueryFragment);
    const hideAppsTab = (0, $71WSM.useHideAppsTab)();
    const dataSource = data.navigationItems;
    (0, $5uXOq.useEffect)(()=>{
        if (dataSource?.errors && dataSource?.errors?.length > 0) {
            const error = dataSource.errors[0];
            handleError(new (0, $c9Ur7.QueryError)(error));
        }
    }, [
        data,
        handleError,
        dataSource?.errors,
        dataSource?.edges
    ]);
    const canEdit = projectDetails?.currentProject?.permissions.administerProject === true;
    // The apps tab filters itself on the frontend, but is returned in the list of tabs
    // As such, we need to remove it from the store so its hidden from drag and drop logic
    (0, $5uXOq.useEffect)(()=>{
        hideAppsTab();
    }, [
        hideAppsTab,
        dataSource
    ]);
    const attributes = (0, $5uXOq.useMemo)(()=>({
            projectType: (projectDetails?.currentProject?.type ?? '').toLowerCase(),
            navigationContainer: (0, $83AT7.TAB)
        }), [
        projectDetails?.currentProject?.type
    ]);
    return dataSource && !dataSource.errors && dataSource.edges ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "businessHorizontalNav",
        containerType: (0, $5da7873a71c45b64$export$fe791c4fa892e400),
        containerId: String(projectDetails?.currentProject?.id ?? ''),
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1ALc.ShortcutsContainer), {
        data: shortcutsData,
        loading: loading,
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aaezu.TabsConfigurationProvider), {
        tabsConfiguration: (0, $l3f0R.tabsConfiguration)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h2ENq.default), {
        tabsFragment: dataSource,
        addTab: canEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $esGcf.AddTab), null),
        typeKeyToRoutesMapping: (0, $21JTp.ITEM_TYPE_KEY_TO_ROUTES)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8b5.ExperienceSuccess), {
        experience: (0, $83AT7.VIEW_HORIZONTAL_NAVIGATION_EXPERIENCE),
        attributes: {
            withContainerNav: false
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8itvN.SkeletonComponent), null);
};
var $f2e2b51a47320905$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($f2e2b51a47320905$export$bd905d70e8fd2ebb);

});
parcelRegister("7iCaP", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ab55271f098a56$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<32ba0e84cb4199e3ca5e34cfacda4f19>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $19ab55271f098a56$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "projectIdOrKey"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "navigationItems"
                    ]
                }
            ]
        },
        "name": "tabs_businessHorizontalNav_TabsContent",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "navigationItems",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectIdOrKey",
                            "variableName": "projectIdOrKey"
                        }
                    ],
                    "concreteType": "JiraNavigationItemConnection",
                    "kind": "LinkedField",
                    "name": "__tabs_jiraNavigation__navigationItems_connection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "ui_navigationKitTabListOld_TabList"
                        },
                        {
                            "concreteType": "JiraNavigationItemEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v0 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "QueryError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCode"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "navigationItems"
            }
        ],
        "type": "JiraQuery"
    };
}();
$19ab55271f098a56$var$node.hash = "c292b845078d48f1c79863de64495f87";
var $19ab55271f098a56$export$2e2bcd8739ae039 = $19ab55271f098a56$var$node;

});

parcelRegister("esGcf", function(module, exports) {

$parcel$export(module.exports, "AddTab", () => $02b01c04f7dd1b93$export$cf6efde2557493a2);

var $5uXOq = parcelRequire("5uXOq");

var $hd8po = parcelRequire("hd8po");

var $aRCO1 = parcelRequire("aRCO1");
const $02b01c04f7dd1b93$export$cf6efde2557493a2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hd8po.default), {
        menuContent: (0, $aRCO1.AsyncMenuContent)
    });

});
parcelRegister("hd8po", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cc84dd01c959930$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $j7m8K = parcelRequire("j7m8K");

var $g16BY = parcelRequire("g16BY");

var $2Eqc8 = parcelRequire("2Eqc8");
var $2s57o = parcelRequire("2s57o");

var $5KCCi = parcelRequire("5KCCi");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $22OQR = parcelRequire("22OQR");

var $imTKV = parcelRequire("imTKV");
const $7cc84dd01c959930$var$AddTab = ({ menuContent: MenuContent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [isDropdownMenuOpen, setIsDropdownMenuOpen] = (0, $5uXOq.useState)(false);
    const onOpenChange = (0, $5uXOq.useCallback)(()=>{
        const event = isDropdownMenuOpen ? 'closeAddViewMenu' : 'addViewMenu';
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', event);
        setIsDropdownMenuOpen((isDropdownMenuCurrent)=>!isDropdownMenuCurrent);
    }, [
        createAnalyticsEvent,
        isDropdownMenuOpen
    ]);
    const closeDropdown = (0, $5uXOq.useCallback)(()=>{
        setIsDropdownMenuOpen(false);
    }, []);
    const trigger = ({ triggerRef: triggerRef, isSelected: isMenuOpen, onClick: onClick, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
            alignBlock: "end",
            xcss: $7cc84dd01c959930$var$inlineActionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
            content: formatMessage((0, $imTKV.default).triggerLabel),
            hideTooltipOnMouseDown: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
            spacing: "none",
            appearance: "subtle",
            name: formatMessage((0, $imTKV.default).triggerLabel),
            ref: triggerRef,
            onClick: (event)=>{
                onClick && onClick(event);
            },
            isSelected: isDropdownMenuOpen,
            ...triggerProps,
            testId: "navigation-kit-add-tab-old.ui.trigger"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g16BY))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $imTKV.default).triggerLabel)
        }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j7m8K.default), {
        trigger: trigger,
        placement: "bottom-start",
        testId: "navigation-kit-add-tab-old.ui.dropdown-menu",
        isOpen: isDropdownMenuOpen,
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuContent, {
        closeDropdown: closeDropdown
    }));
};
var $7cc84dd01c959930$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($7cc84dd01c959930$var$AddTab);
const $7cc84dd01c959930$var$inlineActionStyles = (0, $2s57o.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '0',
    position: 'relative',
    alignSelf: 'start',
    paddingBlockStart: 'space.075'
});

});
parcelRegister("imTKV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c59637e15f7c644$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3c59637e15f7c644$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    triggerLabel: {
        "id": "navigation-kit-add-tab-old.trigger-label",
        "defaultMessage": "Add to project view navigation"
    }
});

});


parcelRegister("aRCO1", function(module, exports) {

$parcel$export(module.exports, "AsyncMenuContent", () => $937e7421da4df1ea$export$765a60d1bf9d6cf6);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");


var $1meEx = parcelRequire("1meEx");

var $hvEkm = parcelRequire("hvEkm");
const $937e7421da4df1ea$export$765a60d1bf9d6cf6 = ({ closeDropdown: closeDropdown })=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $1meEx.addTabContentEntryPoint), {
        closeDropdown: closeDropdown
    });
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $937e7421da4df1ea$var$addTabContentWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "navigation-kit-add-tab-content",
        packageName: "jiraNavigationKitAddTab",
        runtimeProps: {
            closeDropdown: closeDropdown
        },
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hvEkm.LoadingSkeleton), null)
    }));
};
const $937e7421da4df1ea$var$addTabContentWrapperStyles = (0, $2s57o.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    inlineSize: `${(0, $e044b60f322542e8$export$5e641a5f03919b38)}px`
});

});
const $e044b60f322542e8$export$5e641a5f03919b38 = 600;

parcelRegister("1meEx", function(module, exports) {

$parcel$export(module.exports, "addTabContentEntryPoint", () => $22a428f0a0677c09$export$196d3b4618d24c77);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $22a428f0a0677c09$export$196d3b4618d24c77 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("i704q")), {
        moduleId: "b20a185d"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("i704q", function(module, exports) {

let $d2f8ef68cf70b9ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d2f8ef68cf70b9ec$var$load("hPzOn"),
    $d2f8ef68cf70b9ec$var$load("aD2au")
]).then(()=>parcelRequire('fywJh'));

});


parcelRegister("hvEkm", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $519b62659b5c2efc$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aOrxC = parcelRequire("aOrxC");
var $eCE62 = parcelRequire("eCE62");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

const $519b62659b5c2efc$export$44c18d210d5de37b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $519b62659b5c2efc$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $519b62659b5c2efc$var$skeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $519b62659b5c2efc$var$listSkeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), {
        minWidth: 280
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $519b62659b5c2efc$var$titleSkeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($519b62659b5c2efc$var$Skeleton, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCE62.default), {
        hasIcon: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $519b62659b5c2efc$var$detailsSkeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($519b62659b5c2efc$var$SkeletonPreview, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($519b62659b5c2efc$var$Skeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($519b62659b5c2efc$var$Skeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($519b62659b5c2efc$var$SkeletonButton, null))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $519b62659b5c2efc$var$Skeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1b66 _bfhkn82g _1bsbmgvx _4t3ipxbi",
            __cmplp.className
        ])
    });
});
const $519b62659b5c2efc$var$SkeletonPreview = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $519b62659b5c2efc$var$Skeleton, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbp3fh _4t3in0hr",
            __cmplp.className
        ])
    });
});
const $519b62659b5c2efc$var$SkeletonButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $519b62659b5c2efc$var$Skeleton, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbo7ol _4t3ixy5q",
            __cmplp.className
        ])
    });
});
const $519b62659b5c2efc$var$skeletonWrapperStyles = (0, $2s57o.xcss)({
    height: '100%',
    display: 'flex',
    flexDirection: 'row'
});
const $519b62659b5c2efc$var$titleSkeletonWrapperStyles = (0, $2s57o.xcss)({
    height: '42px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingInlineStart: 'space.250'
});
const $519b62659b5c2efc$var$listSkeletonWrapperStyles = (0, $2s57o.xcss)({
    paddingBlockStart: 'space.100',
    width: '280px',
    height: '100%'
});
const $519b62659b5c2efc$var$detailsSkeletonWrapperStyles = (0, $2s57o.xcss)({
    width: '320px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'flex-start',
    gap: 'space.200',
    padding: 'space.500'
});
const $519b62659b5c2efc$var$wrapperStyles = (0, $2s57o.xcss)({
    boxSizing: 'border-box',
    color: 'color.text',
    blockSize: '385px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    inlineSize: `${(0, $e044b60f322542e8$export$5e641a5f03919b38)}px`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});

});



parcelRegister("21JTp", function(module, exports) {

$parcel$export(module.exports, "SUMMARY_ROUTES", () => $c0cde28c413e1e6f$export$7b615bf2166eaf97);
$parcel$export(module.exports, "BOARD_ROUTES", () => $c0cde28c413e1e6f$export$7e8f5e09edcb2f4f);
$parcel$export(module.exports, "LIST_ROUTES", () => $c0cde28c413e1e6f$export$19715d228ac04ea9);
$parcel$export(module.exports, "TIMELINE_ROUTES", () => $c0cde28c413e1e6f$export$386b12e4be961c6a);
$parcel$export(module.exports, "CALENDAR_ROUTES", () => $c0cde28c413e1e6f$export$c654f666c6fe282c);
$parcel$export(module.exports, "FORMS_ROUTES", () => $c0cde28c413e1e6f$export$53f9b1126a9932bf);
$parcel$export(module.exports, "APPROVALS_ROUTES", () => $c0cde28c413e1e6f$export$836ceb295ab8870a);
$parcel$export(module.exports, "ATTACHMENTS_ROUTES", () => $c0cde28c413e1e6f$export$18ffaace1ea97b62);
$parcel$export(module.exports, "PAGES_ROUTES", () => $c0cde28c413e1e6f$export$198758fb20cf9c24);
$parcel$export(module.exports, "ISSUES_ROUTES", () => $c0cde28c413e1e6f$export$4fb2a1e6cdeb484c);
$parcel$export(module.exports, "REPORTS_ROUTES", () => $c0cde28c413e1e6f$export$2d66198c09937cfa);
$parcel$export(module.exports, "COMPONENTS_ROUTES", () => $c0cde28c413e1e6f$export$4ded1ee7f7ef2b1);
$parcel$export(module.exports, "SHORTCUTS_ROUTES", () => $c0cde28c413e1e6f$export$ef5d944a978bfdf7);
$parcel$export(module.exports, "ARCHIVE_ROUTES", () => $c0cde28c413e1e6f$export$48a322a0c5940d5e);
$parcel$export(module.exports, "ITEM_TYPE_KEY_TO_ROUTES", () => $c0cde28c413e1e6f$export$fd18bc64b2db735c);
const $c0cde28c413e1e6f$export$7b615bf2166eaf97 = new Set([
    'classic-business-summary'
]);
const $c0cde28c413e1e6f$export$7e8f5e09edcb2f4f = new Set([
    'classic-business-board'
]);
const $c0cde28c413e1e6f$export$19715d228ac04ea9 = new Set([
    'classic-business-list'
]);
const $c0cde28c413e1e6f$export$386b12e4be961c6a = new Set([
    'classic-business-timeline'
]);
const $c0cde28c413e1e6f$export$c654f666c6fe282c = new Set([
    'classic-business-calendar'
]);
const $c0cde28c413e1e6f$export$53f9b1126a9932bf = new Set([
    'classic-business-form',
    'classic-business-form-builder'
]);
const $c0cde28c413e1e6f$export$836ceb295ab8870a = new Set([
    'classic-business-approvals'
]);
const $c0cde28c413e1e6f$export$18ffaace1ea97b62 = new Set([
    'classic-business-attachments'
]);
const $c0cde28c413e1e6f$export$198758fb20cf9c24 = new Set([
    'project-pages'
]);
const $c0cde28c413e1e6f$export$4fb2a1e6cdeb484c = new Set([
    'issue-navigator'
]);
const $c0cde28c413e1e6f$export$2d66198c09937cfa = new Set([
    'classic-business-reports-overview',
    'legacy-all-reports',
    'legacy-reports-configure',
    'legacy-reports-average-age-report',
    'legacy-reports-created-vs-resolved-report',
    'legacy-reports-pie-report',
    'legacy-reports-recently-created-report',
    'legacy-reports-resolution-time-report',
    'legacy-reports-single-level-group-by-report',
    'legacy-reports-time-since-report',
    'legacy-reports-time-tracking-report',
    'legacy-reports-developer-workload-report',
    'legacy-reports-version-workload-report',
    'legacy-reports-workload-pie-report'
]);
const $c0cde28c413e1e6f$export$4ded1ee7f7ef2b1 = new Set([
    'project-components'
]);
const $c0cde28c413e1e6f$export$ef5d944a978bfdf7 = new Set([
    'classic-business-shortcut'
]);
const $c0cde28c413e1e6f$export$48a322a0c5940d5e = new Set([
    'archive-issues'
]);
const $c0cde28c413e1e6f$export$fd18bc64b2db735c = new Map([
    [
        'SUMMARY',
        $c0cde28c413e1e6f$export$7b615bf2166eaf97
    ],
    [
        'BOARD',
        $c0cde28c413e1e6f$export$7e8f5e09edcb2f4f
    ],
    [
        'LIST',
        $c0cde28c413e1e6f$export$19715d228ac04ea9
    ],
    [
        'CALENDAR',
        $c0cde28c413e1e6f$export$c654f666c6fe282c
    ],
    [
        'TIMELINE',
        $c0cde28c413e1e6f$export$386b12e4be961c6a
    ],
    [
        'APPROVALS',
        $c0cde28c413e1e6f$export$836ceb295ab8870a
    ],
    [
        'FORMS',
        $c0cde28c413e1e6f$export$53f9b1126a9932bf
    ],
    [
        'PAGES',
        $c0cde28c413e1e6f$export$198758fb20cf9c24
    ],
    [
        'ATTACHMENTS',
        $c0cde28c413e1e6f$export$18ffaace1ea97b62
    ],
    [
        'ISSUES',
        $c0cde28c413e1e6f$export$4fb2a1e6cdeb484c
    ],
    [
        'COMPONENTS',
        $c0cde28c413e1e6f$export$4ded1ee7f7ef2b1
    ],
    [
        'REPORTS',
        $c0cde28c413e1e6f$export$2d66198c09937cfa
    ],
    [
        'ARCHIVED_ISSUES',
        $c0cde28c413e1e6f$export$48a322a0c5940d5e
    ]
]);

});

parcelRegister("7UhxN", function(module, exports) {

$parcel$export(module.exports, "useShortcutsData", () => $799685b63be28a3b$export$47d387d66bf16cb);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $iEUaw = parcelRequire("iEUaw");

var $324W5 = parcelRequire("324W5");

var $5hv0u = parcelRequire("5hv0u");

var $89Akw = parcelRequire("89Akw");
const $799685b63be28a3b$var$transformShortcutsMemo = (0, $8QpSo.default)((a, b)=>(0, $89Akw.transformShortcuts)(a, b));
const $799685b63be28a3b$var$emptyData = [];
const $799685b63be28a3b$export$47d387d66bf16cb = (customContext)=>{
    const canEdit = (0, $5hv0u.useCanEditShortcuts)(customContext);
    const { data: data, loading: loading, error: error } = (0, $324W5.useResourceWithCustomRouterContext)((0, $iEUaw.staticSidebarShortcutsResource), customContext);
    const items = (0, $5uXOq.useMemo)(()=>data && $799685b63be28a3b$var$transformShortcutsMemo(data, canEdit), [
        data,
        canEdit
    ]); // canEdit should be the same for all shortcuts per person, per project
    return {
        data: items || $799685b63be28a3b$var$emptyData,
        loading: loading,
        error: error
    };
};

});
parcelRegister("5hv0u", function(module, exports) {

$parcel$export(module.exports, "useCanEditShortcuts", () => $e888d8394c5baf80$export$cf4f3a9f01fdc8a7);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $dhuBw = parcelRequire("dhuBw");
const $e888d8394c5baf80$export$cf4f3a9f01fdc8a7 = (customContext)=>{
    const { data: data } = (0, $1J3t1.useProjectSidebarNavigation)(customContext);
    return (0, $5uXOq.useMemo)(()=>data && (0, $dhuBw.getCanEditShortcuts)(data), [
        data
    ]) || false;
};

});
parcelRegister("dhuBw", function(module, exports) {

$parcel$export(module.exports, "getCanEditShortcuts", () => $050e711b4fac24d4$export$c64b03ccce2c3de);
const $050e711b4fac24d4$var$isProjectOrJiraAdmin = (permissionInfo)=>permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS || false;
const $050e711b4fac24d4$export$c64b03ccce2c3de = (data)=>{
    const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
    switch(projectType){
        case 'jira_work_management':
            return jiraWorkManagementNavData?.permissionInfo ? $050e711b4fac24d4$var$isProjectOrJiraAdmin(jiraWorkManagementNavData.permissionInfo) : false;
        case 'jira_software':
            return jiraSoftwareNavData?.permissionInfo ? $050e711b4fac24d4$var$isProjectOrJiraAdmin(jiraSoftwareNavData.permissionInfo) : false;
        case 'jira_service_management':
            return jiraServiceManagementNavData?.permissionInfo ? $050e711b4fac24d4$var$isProjectOrJiraAdmin(jiraServiceManagementNavData.permissionInfo) : false;
        case 'jira_product_discovery':
            return jiraProductDiscoveryNavData?.permissionInfo ? $050e711b4fac24d4$var$isProjectOrJiraAdmin(jiraProductDiscoveryNavData.permissionInfo) : false;
        case null:
            return false;
        default:
            return false;
    }
};

});


parcelRegister("89Akw", function(module, exports) {

$parcel$export(module.exports, "transformShortcuts", () => $c195049077f99f76$export$1fc4378e3ea910d0);
const $c195049077f99f76$var$getShortcutIcon = (type)=>{
    if (type == null || type === 'unknown' || type === 'unsupported') return 'shortcut';
    if (type === 'github') return 'repos';
    return type;
};
const $c195049077f99f76$export$1fc4378e3ea910d0 = (arrayOfShortcuts, canEditOld)=>{
    if (arrayOfShortcuts && Array.isArray(arrayOfShortcuts)) {
        const links = [];
        const repos = [];
        arrayOfShortcuts.forEach((shortcut)=>{
            const shortcutIcon = $c195049077f99f76$var$getShortcutIcon(shortcut.dvcsType);
            const s = {
                id: shortcut.type == null ? `com.atlassian.jira.jira-projects-plugin:project.shortcut.default.link.${shortcut.id}` : `com.atlassian.jira.jira-projects-plugin:${shortcut.type}.${shortcut.id}`,
                name: shortcut.name,
                icon: shortcutIcon,
                url: shortcut.url,
                selected: false,
                section: false,
                separator: false,
                showDot: false,
                hasLandingPage: false,
                canEdit: canEditOld,
                showSync: false,
                canDismiss: false,
                sortable: false,
                target: '_blank'
            };
            shortcut.type === 'source.code.link' ? repos.push(s) : links.push(s);
        });
        return repos.concat(links);
    }
    return [];
};

});


parcelRegister("k1ALc", function(module, exports) {

$parcel$export(module.exports, "ShortcutsContainer", () => $6885b5bf730cd03e$export$df449cf702d8e0fd);
$parcel$export(module.exports, "useShortcutItems", () => $6885b5bf730cd03e$export$2c1990af0fa688a3);

var $5uXOq = parcelRequire("5uXOq");

var $6P0Kj = parcelRequire("6P0Kj");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4bqWq = parcelRequire("4bqWq");
const $6885b5bf730cd03e$var$renderShortcutIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6P0Kj))), {
        spacing: "spacious",
        label: "shortcut"
    });
const $6885b5bf730cd03e$export$fb9705de59d96855 = (item)=>({ setState: setState, getState: getState })=>{
        const { shortcutType: shortcutType } = item;
        const state = getState();
        const index = state.data.map((i)=>i.shortcutType).lastIndexOf(shortcutType);
        const newItem = {
            before: $6885b5bf730cd03e$var$renderShortcutIcon,
            ...item,
            target: '_blank',
            canEdit: true,
            itemType: 'shortcut'
        };
        // Append new item to same shortcuts group
        if (index === -1) // @ts-expect-error - TS2322 - Type 'ShortcutItem | { target: string; canEdit: boolean; itemType: string; before: ComponentType<Record<any, any>> | (() => Element); href?: string | undefined; ... 7 more ...; text?: string | undefined; }' is not assignable to type 'ShortcutItem'. | TS2322 - Type '{ target: string; canEdit: boolean; itemType: string; before: React.ComponentType<Record<any, any>> | (() => JSX.Element); href?: string | undefined; icon?: string | undefined; ... 6 more ...; text?: string | undefined; }' is not assignable to type 'ShortcutItem'.
        setState({
            data: [
                ...state.data,
                newItem
            ]
        });
        else setState({
            // @ts-expect-error - TS2322 - Type '(ShortcutItem | { target: string; canEdit: boolean; itemType: string; before: ComponentType<Record<any, any>> | (() => Element); href?: string | undefined; ... 7 more ...; text?: string | undefined; })[]' is not assignable to type 'ShortcutItem[]'.
            data: [
                ...state.data.slice(0, index + 1),
                newItem,
                ...state.data.slice(index + 1)
            ]
        });
    };
const $6885b5bf730cd03e$export$8d8542dbbc23fe1a = (id)=>({ setState: setState, getState: getState })=>{
        const { data: data } = getState();
        const newItems = data.filter((existingItem)=>existingItem.id !== id);
        setState({
            data: newItems
        });
    };
const $6885b5bf730cd03e$export$60832f4899fbf6a1 = (item)=>({ setState: setState, getState: getState })=>{
        const { data: data } = getState();
        const newItems = data.map((existingItem)=>existingItem.id !== item.id ? existingItem : item);
        setState({
            data: newItems
        });
    };
const $6885b5bf730cd03e$export$8c896bccb18e1db1 = (items)=>({ setState: setState, getState: getState })=>{
        if (!items.length) return;
        const { data: data } = getState();
        const newItems = data.map((existingItem)=>items.find((item)=>item.id === existingItem.id) || existingItem);
        setState({
            data: newItems
        });
    };
const $6885b5bf730cd03e$export$ed2a7beca2c9674 = (data, loading)=>({ setState: setState, getState: getState })=>{
        const items = (data || []).map((0, $4bqWq.getItemFromLink));
        const state = getState();
        return setState({
            ...state,
            loading: loading,
            data: items,
            oldData: items,
            isLoaded: true
        });
    };
const $6885b5bf730cd03e$export$e324594224ef24da = {
    addItem: $6885b5bf730cd03e$export$fb9705de59d96855,
    deleteItem: $6885b5bf730cd03e$export$8d8542dbbc23fe1a,
    editItem: $6885b5bf730cd03e$export$60832f4899fbf6a1,
    editItems: $6885b5bf730cd03e$export$8c896bccb18e1db1,
    updateContainer: $6885b5bf730cd03e$export$ed2a7beca2c9674
};
const $6885b5bf730cd03e$export$d4c72bab9d6cc13a = {
    data: [],
    oldData: null,
    loading: false,
    isLoaded: false
};
/**
 * Instance
 */ const $6885b5bf730cd03e$var$Store = (0, $iXqE5.createStore)({
    name: 'shortcuts',
    initialState: $6885b5bf730cd03e$export$d4c72bab9d6cc13a,
    actions: $6885b5bf730cd03e$export$e324594224ef24da
});
var $6885b5bf730cd03e$export$2e2bcd8739ae039 = $6885b5bf730cd03e$var$Store;
const $6885b5bf730cd03e$export$df449cf702d8e0fd = (0, $gg7kZ.createContainer)($6885b5bf730cd03e$var$Store, {
    onInit: ()=>({ dispatch: dispatch }, { data: data, loading: loading })=>{
            dispatch($6885b5bf730cd03e$export$e324594224ef24da.updateContainer(data, loading));
        },
    onUpdate: ()=>({ dispatch: dispatch }, { data: data, loading: loading })=>{
            dispatch($6885b5bf730cd03e$export$e324594224ef24da.updateContainer(data, loading));
        }
});
const $6885b5bf730cd03e$export$2c1990af0fa688a3 = (0, $3sQ5x.createHook)($6885b5bf730cd03e$var$Store);

});
parcelRegister("4bqWq", function(module, exports) {

$parcel$export(module.exports, "getItemFromLink", () => $5f237ed4c010c05c$export$60d4c4ef6da272ad);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $ixUGT = parcelRequire("ixUGT");

var $hYfgW = parcelRequire("hYfgW");

var $32ra4 = parcelRequire("32ra4");

var $a8Wzb = parcelRequire("a8Wzb");

var $h6M2t = parcelRequire("h6M2t");
const $5f237ed4c010c05c$var$getLinkParts = (linkId)=>linkId.split(':')[1].split('.');
// @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
const $5f237ed4c010c05c$var$SizedBitBucketIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h6M2t.BitbucketIcon), {
        ...props,
        size: "small"
    });
const $5f237ed4c010c05c$export$16b26cd5e98d9100 = (iconName)=>{
    switch(iconName){
        case 'bitbucket':
            return $5f237ed4c010c05c$var$SizedBitBucketIcon;
        case 'github':
        case 'repos':
            // @ts-expect-error - TS2322 - Type 'typeof default' is not assignable to type 'ComponentType<GlyphProps | Props | (Pick<GlyphProps, "testId" | "primaryColor" | "secondaryColor"> & Partial<Pick<GlyphProps, "label" | "size">> & Partial<...>) | (Pick<...> & ... 1 more ... & Partial<...>)>'.
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
            return 0, (/*@__PURE__*/$parcel$interopDefault($32ra4));
        default:
            // @ts-expect-error - TS2322 - Type 'typeof default' is not assignable to type 'ComponentType<GlyphProps | Props | (Pick<GlyphProps, "testId" | "primaryColor" | "secondaryColor"> & Partial<Pick<GlyphProps, "label" | "size">> & Partial<...>) | (Pick<...> & ... 1 more ... & Partial<...>)>'.
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
            return 0, (/*@__PURE__*/$parcel$interopDefault($a8Wzb));
    }
};
const $5f237ed4c010c05c$export$3cec694c50bc695d = (linkId)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($5f237ed4c010c05c$var$getLinkParts(linkId));
const $5f237ed4c010c05c$export$d37d2882f5261346 = (linkId)=>linkId;
const $5f237ed4c010c05c$export$92a97f8239a551c5 = (linkId)=>(0, (/*@__PURE__*/$parcel$interopDefault($ixUGT)))($5f237ed4c010c05c$var$getLinkParts(linkId)).join('.');
const $5f237ed4c010c05c$export$60d4c4ef6da272ad = (link)=>{
    const { id: linkId, icon: icon } = link;
    const id = $5f237ed4c010c05c$export$3cec694c50bc695d(linkId);
    const shortcutType = $5f237ed4c010c05c$export$92a97f8239a551c5(linkId);
    const target = link.target ?? '_blank';
    const Icon = $5f237ed4c010c05c$export$16b26cd5e98d9100(icon);
    return {
        id: id,
        icon: icon,
        legacyId: linkId,
        target: target,
        shortcutType: shortcutType,
        text: link.name,
        before: Icon,
        href: link.url,
        canEdit: link.canEdit,
        showSync: link.showSync,
        itemType: 'shortcut'
    };
};

});
parcelRegister("ixUGT", function(module, exports) {

var $dM3Z8 = parcelRequire("dM3Z8");
/**
 * Gets all but the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.initial([1, 2, 3]);
 * // => [1, 2]
 */ function $d80748aee2c24c33$var$initial(array) {
    var length = array == null ? 0 : array.length;
    return length ? $dM3Z8(array, 0, -1) : [];
}
module.exports = $d80748aee2c24c33$var$initial;

});

parcelRegister("32ra4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2366a0b0419b8fbf$var$_react = $2366a0b0419b8fbf$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $2366a0b0419b8fbf$var$_angleBrackets = $2366a0b0419b8fbf$var$_interopRequireDefault((parcelRequire("elXz8")));
function $2366a0b0419b8fbf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2366a0b0419b8fbf$var$BitbucketReposIcon = (props)=>/*#__PURE__*/ $2366a0b0419b8fbf$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 5v14h14V5zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/><path d="M9.23 8.31 6.3 11.26a1.06 1.06 0 0 0 0 1.48l2.93 2.96a1.03 1.03 0 0 0 1.47 0 1.05 1.05 0 0 0 0-1.48L8.5 12l2.2-2.22a1.05 1.05 0 0 0 0-1.48 1.02 1.02 0 0 0-.73-.3c-.27 0-.53.1-.73.31m4.06 0a1.05 1.05 0 0 0 0 1.48L15.5 12l-2.2 2.22a1.05 1.05 0 0 0 0 1.48c.4.41 1.06.41 1.46 0l2.93-2.95a1.05 1.05 0 0 0 0-1.48l-2.93-2.96a1.03 1.03 0 0 0-1.46 0"/></g></svg>`
    }, props, {
        newIcon: $2366a0b0419b8fbf$var$_angleBrackets.default
    }));
$2366a0b0419b8fbf$var$BitbucketReposIcon.displayName = 'BitbucketReposIcon';
var $2366a0b0419b8fbf$var$_default = module.exports.default = $2366a0b0419b8fbf$var$BitbucketReposIcon;

});
parcelRegister("elXz8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a7313b5c9f1080d6$var$_react = $a7313b5c9f1080d6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a7313b5c9f1080d6$var$_baseNew = $a7313b5c9f1080d6$var$_interopRequireDefault((parcelRequire("enEmH")));
function $a7313b5c9f1080d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a7313b5c9f1080d6$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $a7313b5c9f1080d6$var$_react.default.createElement($a7313b5c9f1080d6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$a7313b5c9f1080d6$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $a7313b5c9f1080d6$var$_default = module.exports.default = $a7313b5c9f1080d6$var$AngleBracketsIcon;

});


parcelRegister("h6M2t", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", () => $8d4219c64b075729$export$5fc1066e677788d4);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $8d4219c64b075729$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>
    </svg>`;
};
const $8d4219c64b075729$export$5fc1066e677788d4 = ({ appearance: appearance, label: label = 'Bitbucket', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $8d4219c64b075729$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});



const $5da7873a71c45b64$export$fe791c4fa892e400 = 'project';
const $5da7873a71c45b64$export$b83d0ee9325a2d0a = 'projectTitle';

parcelRegister("aaezu", function(module, exports) {

$parcel$export(module.exports, "TabsConfigurationProvider", () => $4e6626c0b092574d$export$1bce62184976ada3);

var $5uXOq = parcelRequire("5uXOq");
const $4e6626c0b092574d$var$TabsConfigurationContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $4e6626c0b092574d$export$1bce62184976ada3 = ({ tabsConfiguration: tabsConfiguration, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e6626c0b092574d$var$TabsConfigurationContext.Provider, {
        value: tabsConfiguration
    }, children);
const $4e6626c0b092574d$export$e5ac2ee76dd2d5a5 = (typeKey)=>{
    const tabsConfiguration = (0, $5uXOq.useContext)($4e6626c0b092574d$var$TabsConfigurationContext);
    if (!tabsConfiguration) throw new Error('useTabsConfiguration must be used within a TabConfigurationProvider');
    if (!typeKey || !(typeKey in tabsConfiguration)) return null;
    return tabsConfiguration[typeKey];
};
const $4e6626c0b092574d$export$997db1b8d6ce9f71 = ()=>{
    const tabsConfiguration = (0, $5uXOq.useContext)($4e6626c0b092574d$var$TabsConfigurationContext);
    if (!tabsConfiguration) throw new Error('useTabsConfiguration must be used within a TabConfigurationProvider');
    return tabsConfiguration;
};

});

parcelRegister("h2ENq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a7ad79a8ac8846d$export$2e2bcd8739ae039);

var $9OwcC = parcelRequire("9OwcC");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $kUSGs = parcelRequire("kUSGs");

var $koVbs = parcelRequire("koVbs");

var $97ke5 = parcelRequire("97ke5");

var $6jY6G = parcelRequire("6jY6G");

var $bGvtA = parcelRequire("bGvtA");

var $dZ5ym = parcelRequire("dZ5ym");

var $iJvdU = parcelRequire("iJvdU");
const $9a7ad79a8ac8846d$var$TabList = ({ tabsFragment: tabsFragment, addTab: addTab, typeKeyToRoutesMapping: typeKeyToRoutesMapping })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { group: currentRouteGroup, name: currentRouteName } = (0, $6jY6G.useCurrentRoute)();
    const tabListRef = (0, $5uXOq.useRef)(null);
    const selectedTabRef = (0, $5uXOq.useRef)(null);
    const tabsData = (0, $8Uumt.useFragment)((0, $9OwcC.default), tabsFragment);
    let tabs = Array.from(tabsData?.edges || []).filter(Boolean);
    const tabList = (0, $bGvtA.useDroppableTabListOld)(tabs);
    tabs = tabList.tabs;
    const defaultViewTypeKey = tabs?.find((edge)=>edge?.node?.isDefault)?.node?.typeKey;
    const selectedViewTypeKey = (0, $5uXOq.useMemo)(()=>tabs.find(({ node: { typeKey: typeKey } })=>{
            if (typeKey && typeKeyToRoutesMapping?.has(typeKey)) {
                const routes = typeKeyToRoutesMapping.get(typeKey);
                return routes?.has(currentRouteName) || routes?.has(currentRouteGroup ?? '') || false;
            }
            return false;
        })?.node?.typeKey, [
        currentRouteGroup,
        currentRouteName,
        tabs,
        typeKeyToRoutesMapping
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!tabListRef.current) return;
        (0, $kUSGs.autoScrollForElements)({
            element: tabListRef.current
        });
    }, []);
    // this effect is used to ensure the selected tab is scrolled into view
    // when a new value is detected (e.g. after a mutation or a navigation event)
    (0, $5uXOq.useEffect)(()=>{
        if (selectedViewTypeKey) requestAnimationFrame(()=>{
            selectedTabRef.current && selectedTabRef.current.scrollIntoView();
        });
    }, [
        selectedViewTypeKey
    ]);
    const tabElements = tabs?.map((edge, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZ5ym.default), {
            key: edge.node.id,
            id: edge.node.id,
            position: index,
            tabFragment: edge.node,
            beforeItemId: index === 0 ? null : tabs[index - 1]?.node?.id,
            afterItemId: index === tabs.length - 1 ? null : tabs[index + 1]?.node?.id,
            defaultViewTypeKey: defaultViewTypeKey ?? undefined,
            ref: selectedViewTypeKey === edge.node.typeKey ? selectedTabRef : undefined
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $97ke5.default), {
        ref: tabListRef,
        label: formatMessage((0, $iJvdU.default).tabGroup),
        addTab: addTab
    }, tabElements);
};
var $9a7ad79a8ac8846d$export$2e2bcd8739ae039 = $9a7ad79a8ac8846d$var$TabList;

});
parcelRegister("9OwcC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4e136951c2687f5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<008d7eff8fd3fb11036a07b078c81c06>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a4e136951c2687f5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_navigationKitTabListOld_TabList",
    "selections": [
        {
            "concreteType": "JiraNavigationItemEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                "action": "THROW",
                                "path": "edges.node.id"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "isDefault"
                                },
                                "action": "THROW",
                                "path": "edges.node.isDefault"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "typeKey"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "jiraTab_navigationKitTabListOld"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "edges.node"
                }
            ]
        }
    ],
    "type": "JiraNavigationItemConnection"
};
$a4e136951c2687f5$var$node.hash = "13af948a91b2cf429d4bfff91d3847f2";
var $a4e136951c2687f5$export$2e2bcd8739ae039 = $a4e136951c2687f5$var$node;

});

parcelRegister("kUSGs", function(module, exports) {

$parcel$export(module.exports, "autoScrollForElements", () => $6bf6c721298921df$export$4b66ee8317094cdb);

var $4nayr = parcelRequire("4nayr");

var $8m7FJ = parcelRequire("8m7FJ");
const $6bf6c721298921df$var$api = (0, $8m7FJ.makeApi)({
    monitor: (0, $4nayr.monitorForElements)
});
const $6bf6c721298921df$export$4b66ee8317094cdb = $6bf6c721298921df$var$api.autoScroll;
const $6bf6c721298921df$export$c9168f41de61f525 = $6bf6c721298921df$var$api.autoScrollWindow;

});
parcelRegister("8m7FJ", function(module, exports) {

$parcel$export(module.exports, "makeApi", () => $df654215406fce06$export$b8fa21320a811083);

var $l5MhD = parcelRequire("l5MhD");

var $MUbtE = parcelRequire("MUbtE");

var $4gWxZ = parcelRequire("4gWxZ");

var $9Q0sJ = parcelRequire("9Q0sJ");
function $df654215406fce06$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        return (0, $l5MhD.combine)((0, $4gWxZ.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        return ()=>windowRegistry.delete(unique);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $9Q0sJ.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $MUbtE.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}

});
parcelRegister("MUbtE", function(module, exports) {

$parcel$export(module.exports, "getScheduler", () => $39c2ab61af696aa1$export$5cff7ac265db316a);
parcelRequire("9aDmr");
var $cbcqZ = parcelRequire("cbcqZ");

var $k0i4w = parcelRequire("k0i4w");
// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $39c2ab61af696aa1$var$schedulers = new Map();
function $39c2ab61af696aa1$export$5cff7ac265db316a(monitor) {
    const scheduler = $39c2ab61af696aa1$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $39c2ab61af696aa1$var$makeScheduler(monitor);
    $39c2ab61af696aa1$var$schedulers.set(monitor, created);
    return created;
}
function $39c2ab61af696aa1$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $cbcqZ.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $k0i4w.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $k0i4w.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}

});
parcelRegister("9aDmr", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("cbcqZ")).getElementFromPointWithoutHoneypot);

var $cbcqZ = parcelRequire("cbcqZ");

});

parcelRegister("k0i4w", function(module, exports) {

$parcel$export(module.exports, "markAndGetEngagement", () => $e2629d5e10987ff8$export$8c764c3f2fc3d2d2);
$parcel$export(module.exports, "clearUnusedEngagements", () => $e2629d5e10987ff8$export$991e77dd347f3df1);
$parcel$export(module.exports, "clearEngagementHistory", () => $e2629d5e10987ff8$export$13ae770ed39b71ea);
const $e2629d5e10987ff8$var$ledger = new Map();
const $e2629d5e10987ff8$var$requested = new Set();
function $e2629d5e10987ff8$export$8c764c3f2fc3d2d2(element) {
    $e2629d5e10987ff8$export$1cb7cbb266b6f6fa(element);
    const entry = $e2629d5e10987ff8$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $e2629d5e10987ff8$var$ledger.set(element, fresh);
    return fresh;
}
function $e2629d5e10987ff8$export$1cb7cbb266b6f6fa(element) {
    $e2629d5e10987ff8$var$requested.add(element);
}
function $e2629d5e10987ff8$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $e2629d5e10987ff8$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $e2629d5e10987ff8$var$ledger.forEach((_, element)=>{
        if (!$e2629d5e10987ff8$var$requested.has(element)) $e2629d5e10987ff8$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $e2629d5e10987ff8$var$requested.clear();
}
function $e2629d5e10987ff8$export$13ae770ed39b71ea() {
    $e2629d5e10987ff8$var$ledger.clear();
}

});


parcelRegister("4gWxZ", function(module, exports) {

$parcel$export(module.exports, "selector", () => $f1c4ee70a11135d7$export$aea217a45095ce11);
$parcel$export(module.exports, "addScrollableAttribute", () => $f1c4ee70a11135d7$export$4ec12fb57dfebd53);
const $f1c4ee70a11135d7$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $f1c4ee70a11135d7$export$aea217a45095ce11 = `[${$f1c4ee70a11135d7$export$4b152ab55cad4fd6}="true"]`;
function $f1c4ee70a11135d7$export$4ec12fb57dfebd53(element) {
    element.setAttribute($f1c4ee70a11135d7$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($f1c4ee70a11135d7$export$4b152ab55cad4fd6);
}

});

parcelRegister("9Q0sJ", function(module, exports) {

$parcel$export(module.exports, "tryScroll", () => $222b2c3ce6e23b15$export$233199807749476d);

var $fUWrt = parcelRequire("fUWrt");

var $k0i4w = parcelRequire("k0i4w");

var $4gWxZ = parcelRequire("4gWxZ");

var $ac6Lo = parcelRequire("ac6Lo");
function $222b2c3ce6e23b15$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $222b2c3ce6e23b15$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$222b2c3ce6e23b15$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $4gWxZ.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $222b2c3ce6e23b15$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $k0i4w.markAndGetEngagement)(element);
    const config = (0, $fUWrt.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $ac6Lo.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $222b2c3ce6e23b15$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $k0i4w.markAndGetEngagement)(element);
        const config = (0, $fUWrt.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $ac6Lo.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $222b2c3ce6e23b15$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $222b2c3ce6e23b15$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$222b2c3ce6e23b15$var$isScrollingAvailable(remainder)) return;
    $222b2c3ce6e23b15$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}

});
parcelRegister("fUWrt", function(module, exports) {

$parcel$export(module.exports, "getInternalConfig", () => $b88ad23aaba96e73$export$e96028ec7ff9d079);
const $b88ad23aaba96e73$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 400,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $b88ad23aaba96e73$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $b88ad23aaba96e73$export$e96028ec7ff9d079(provided) {
    return {
        ...$b88ad23aaba96e73$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $b88ad23aaba96e73$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}

});

parcelRegister("ac6Lo", function(module, exports) {

$parcel$export(module.exports, "getScrollBy", () => $80dd99b78a801dc7$export$6cfa6dfe6898b98f);

var $dOCCq = parcelRequire("dOCCq");

var $dVbO8 = parcelRequire("dVbO8");

var $5ZJA3 = parcelRequire("5ZJA3");

var $cobHf = parcelRequire("cobHf");

var $2itzM = parcelRequire("2itzM");

var $fcgVh = parcelRequire("fcgVh");
function $80dd99b78a801dc7$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $80dd99b78a801dc7$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $80dd99b78a801dc7$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $dVbO8.edges).reduce((map, edge)=>{
        const hitbox = (0, $5ZJA3.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $dVbO8.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $2itzM.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $fcgVh.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $dOCCq.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $cobHf.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $cobHf.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $cobHf.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $cobHf.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}

});
parcelRegister("dOCCq", function(module, exports) {

$parcel$export(module.exports, "canScrollOnEdge", () => $a1756d2ddd1d2634$export$ccd6d9407403fcad);
const $a1756d2ddd1d2634$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};

});

parcelRegister("dVbO8", function(module, exports) {

$parcel$export(module.exports, "edges", () => $6b1785d57f727834$export$4544a00f8eb65eb2);
$parcel$export(module.exports, "edgeAxisLookup", () => $6b1785d57f727834$export$7fc144124ccf8292);
const $6b1785d57f727834$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $6b1785d57f727834$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};

});

parcelRegister("5ZJA3", function(module, exports) {

$parcel$export(module.exports, "getOverElementHitbox", () => $508bfab179104f0a$export$b9a449c20abb0e9);

var $24px3 = parcelRequire("24px3");

var $gvIMT = parcelRequire("gvIMT");
function $508bfab179104f0a$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $24px3.axisLookup)[axis];
        const side = (0, $gvIMT.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $508bfab179104f0a$export$b9a449c20abb0e9 = {
    top: $508bfab179104f0a$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $508bfab179104f0a$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $508bfab179104f0a$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $508bfab179104f0a$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};

});
parcelRegister("24px3", function(module, exports) {

$parcel$export(module.exports, "axisLookup", () => $72807107540ca29a$export$42e42cdab35a2b96);
const $72807107540ca29a$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $72807107540ca29a$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $72807107540ca29a$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $72807107540ca29a$var$vertical,
        crossAxis: $72807107540ca29a$var$horizontal
    },
    horizontal: {
        mainAxis: $72807107540ca29a$var$horizontal,
        crossAxis: $72807107540ca29a$var$vertical
    }
};

});

parcelRegister("gvIMT", function(module, exports) {

$parcel$export(module.exports, "mainAxisSideLookup", () => $4a686423f5f596e8$export$a45c0cd714a4dbaa);
const $4a686423f5f596e8$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};

});


parcelRegister("cobHf", function(module, exports) {

$parcel$export(module.exports, "getScrollChange", () => $61b9c7ca468f8173$export$470a2ff46db8cee8);

var $24px3 = parcelRequire("24px3");

var $iMXw0 = parcelRequire("iMXw0");

var $gvIMT = parcelRequire("gvIMT");
// We want a consistent scroll speed across devices, regardless of framerate
function $61b9c7ca468f8173$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $61b9c7ca468f8173$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $24px3.axisLookup)[axis];
    const side = (0, $gvIMT.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $iMXw0.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $iMXw0.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $61b9c7ca468f8173$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $61b9c7ca468f8173$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $61b9c7ca468f8173$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $iMXw0.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $gvIMT.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}

});
parcelRegister("iMXw0", function(module, exports) {

$parcel$export(module.exports, "getPercentageInRange", () => $14875ee4d61bf17c$export$1a29de000a332d74);
function $14875ee4d61bf17c$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}

});


parcelRegister("2itzM", function(module, exports) {

$parcel$export(module.exports, "isAxisAllowed", () => $613244e96caeaa46$export$7120fdbd90bd1292);
function $613244e96caeaa46$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}

});

parcelRegister("fcgVh", function(module, exports) {

$parcel$export(module.exports, "isWithin", () => $8989672f56ebb0f6$export$cda7a9d4399bf2e3);
function $8989672f56ebb0f6$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}

});





parcelRegister("97ke5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e02750eae27905a9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $e02750eae27905a9$var$TabList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, label: label, addTab: addTab }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e02750eae27905a9$var$ResponsiveNav, {
        "aria-label": label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e02750eae27905a9$var$Wrapper, {
        ref: ref
    }, children), addTab));
var $e02750eae27905a9$export$2e2bcd8739ae039 = $e02750eae27905a9$var$TabList;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e02750eae27905a9$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulputpp _1reo1wug _18m91wug _1e0c1txw _2lx2vrvc _19pkze3t _otyrze3t _18u010v4 _2hwxxmi2 _ca0qze3t _n3tdze3t _19bv1ejb _u5f3pxbi _1nwp1wwx",
            __cmplp.className
        ])
    });
});
const $e02750eae27905a9$var$ResponsiveNav = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "nav", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulputpp _1e0c1txw _kqswh2mm _1ul9ze3t _19bv1ejb _u5f31ejb _1s6k4zrn _1kt9b3bt _1cs8stnw _19woze3t _kfgtv77o _qnecze3t _oounze3t",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bGvtA", function(module, exports) {

$parcel$export(module.exports, "useDroppableTabListOld", () => $be9546d5ab32f5da$export$27eb0a4ce7c928d1);

var $5uXOq = parcelRequire("5uXOq");

var $8iGQq = parcelRequire("8iGQq");

var $cAQ2Q = parcelRequire("cAQ2Q");

var $4nayr = parcelRequire("4nayr");

var $8dXDG = parcelRequire("8dXDG");

var $kaHBi = parcelRequire("kaHBi");

var $59kPM = parcelRequire("59kPM");
const $be9546d5ab32f5da$export$b8b9d90f9e5bd72b = 'jiraNavigationKitRankItem';
const $be9546d5ab32f5da$export$f1e608dba99fa330 = {
    experience: 'reorderView'
};
const $be9546d5ab32f5da$var$BEFORE = 'before';
const $be9546d5ab32f5da$var$AFTER = 'after';
const $be9546d5ab32f5da$export$27eb0a4ce7c928d1 = (tabs)=>{
    const onStartExperience = (0, $kaHBi.useExperienceStart)({
        ...$be9546d5ab32f5da$export$f1e608dba99fa330,
        analyticsSource: $be9546d5ab32f5da$export$b8b9d90f9e5bd72b
    });
    const onExperienceAbort = (0, $8dXDG.useExperienceAbort)($be9546d5ab32f5da$export$f1e608dba99fa330);
    const [rankNavigationItem] = (0, $59kPM.useRankNavigationItem)();
    (0, $5uXOq.useEffect)(()=>(0, $4nayr.monitorForElements)({
            canMonitor ({ source: source }) {
                return source.data.type === 'tab';
            },
            onDrop ({ source: source, location: location }) {
                onStartExperience();
                const destination = location.current.dropTargets[0];
                if (!destination) {
                    onExperienceAbort('Dropped outside of drop targets');
                    return;
                }
                if (source.data.type === 'tab' && source.data.id !== destination.data.id) {
                    const sourceTabIndex = tabs.findIndex((tab)=>tab.node.id === source.data.id);
                    const targetTabIndex = tabs.findIndex((tab)=>tab.node.id === destination.data.id);
                    const closestEdgeOfTarget = (0, $8iGQq.extractClosestEdge)(destination.data);
                    const reorderedTabs = (0, $cAQ2Q.reorderWithEdge)({
                        list: tabs,
                        startIndex: sourceTabIndex,
                        indexOfTarget: targetTabIndex,
                        closestEdgeOfTarget: closestEdgeOfTarget,
                        axis: 'horizontal'
                    });
                    if (reorderedTabs && tabs.every((value, index)=>value === reorderedTabs[index])) return;
                    const placement = closestEdgeOfTarget === 'left' ? $be9546d5ab32f5da$var$BEFORE : $be9546d5ab32f5da$var$AFTER;
                    const { id: id, __id: dataId } = tabs[sourceTabIndex].node;
                    const beforeItemId = placement === $be9546d5ab32f5da$var$BEFORE ? tabs[targetTabIndex].node.id : null;
                    const afterItemId = placement === $be9546d5ab32f5da$var$AFTER ? tabs[targetTabIndex].node.id : null;
                    if (id.includes('optimisticId') || beforeItemId && beforeItemId.includes('optimisticId') || afterItemId && afterItemId.includes('optimisticId')) return;
                    rankNavigationItem({
                        placement: placement,
                        sourceTabIndex: sourceTabIndex,
                        targetTabIndex: targetTabIndex,
                        id: id,
                        beforeItemId: beforeItemId,
                        afterItemId: afterItemId,
                        dataId: dataId,
                        actionType: 'dragged'
                    });
                }
            }
        }), // PLEASE CONFIRM THESE DEPENDENCIES ARE CORRECT
    [
        tabs,
        rankNavigationItem,
        onStartExperience,
        onExperienceAbort
    ]);
    return {
        tabs: tabs
    };
};

});
parcelRegister("8iGQq", function(module, exports) {

$parcel$export(module.exports, "attachClosestEdge", () => $567c9724221c2374$export$f0cafff222395e89);
$parcel$export(module.exports, "extractClosestEdge", () => $567c9724221c2374$export$945a571f3b658bf);
const $567c9724221c2374$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $567c9724221c2374$var$uniqueKey = Symbol('closestEdge');
function $567c9724221c2374$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $567c9724221c2374$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$567c9724221c2374$var$uniqueKey]: addClosestEdge
    };
}
function $567c9724221c2374$export$945a571f3b658bf(userData) {
    return userData[$567c9724221c2374$var$uniqueKey] ?? null;
}

});

parcelRegister("cAQ2Q", function(module, exports) {

$parcel$export(module.exports, "reorderWithEdge", () => $4c4baa50093f5356$export$d0bc664d2812b3ba);
parcelRequire("d1glB");
var $ku7Q5 = parcelRequire("ku7Q5");

var $d5s7y = parcelRequire("d5s7y");
function $4c4baa50093f5356$export$d0bc664d2812b3ba({ list: list, startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    return (0, $ku7Q5.reorder)({
        list: list,
        startIndex: startIndex,
        finishIndex: (0, $d5s7y.getReorderDestinationIndex)({
            closestEdgeOfTarget: closestEdgeOfTarget,
            startIndex: startIndex,
            indexOfTarget: indexOfTarget,
            axis: axis
        })
    });
}

});
parcelRegister("d1glB", function(module, exports) {

$parcel$export(module.exports, "reorder", () => (parcelRequire("ku7Q5")).reorder);

var $ku7Q5 = parcelRequire("ku7Q5");

});
parcelRegister("ku7Q5", function(module, exports) {

$parcel$export(module.exports, "reorder", () => $d88914ebc0116ecf$export$fc77a6137e3f91c);
/**
 * A function that will reorder an array (`list`).
 * `reorder` returns a new array with reordered items and does not
 *  modify the original array. The items in the array are also not modified.
 */ function $d88914ebc0116ecf$export$fc77a6137e3f91c({ list: list, startIndex: startIndex, finishIndex: finishIndex }) {
    if (startIndex === -1 || finishIndex === -1) // Making this function consistently return a new array reference.
    // This is consistent with .toSorted() which always returns a new array
    // even when it does not do anything
    return Array.from(list);
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(finishIndex, 0, removed);
    return result;
}

});


parcelRegister("d5s7y", function(module, exports) {

$parcel$export(module.exports, "getReorderDestinationIndex", () => $e5831fb06fa17ad8$export$846f792f51b92b6e);
function $e5831fb06fa17ad8$export$846f792f51b92b6e({ startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    // invalid index's
    if (startIndex === -1 || indexOfTarget === -1) return startIndex;
    // if we are targeting the same index we don't need to do anything
    if (startIndex === indexOfTarget) return startIndex;
    if (closestEdgeOfTarget == null) return indexOfTarget;
    const isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
    const isMovingForward = startIndex < indexOfTarget;
    // moving forward
    if (isMovingForward) return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
    // moving backwards
    return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}

});


parcelRegister("59kPM", function(module, exports) {

$parcel$export(module.exports, "useRankNavigationItem", () => $e0c9bf75fedd214b$export$d474c994a9313e38);

var $iEwLV = parcelRequire("iEwLV");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $cAQ2Q = parcelRequire("cAQ2Q");

var $c9Ur7 = parcelRequire("c9Ur7");

var $jcw0u = parcelRequire("jcw0u");

var $93jKl = parcelRequire("93jKl");

var $3bQtK = parcelRequire("3bQtK");

var $pa9q9 = parcelRequire("pa9q9");

var $eCBf9 = parcelRequire("eCBf9");

var $ktofH = parcelRequire("ktofH");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $1nb22 = parcelRequire("1nb22");

var $9OXo1 = parcelRequire("9OXo1");

var $doZTA = parcelRequire("doZTA");

var $3xu6l = parcelRequire("3xu6l");
const $e0c9bf75fedd214b$var$BEFORE = 'before';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $e0c9bf75fedd214b$var$AFTER = 'after';
const $e0c9bf75fedd214b$var$HANDLED_STATUS_CODES = [
    401,
    403,
    404
];
const $e0c9bf75fedd214b$var$ERROR_TYPE = 'error';
const $e0c9bf75fedd214b$var$RANK_NAVIGATION_ERROR_FLAG = {
    type: $e0c9bf75fedd214b$var$ERROR_TYPE,
    title: (0, $3xu6l.default).errorTitle,
    description: (0, $3xu6l.default).errorMessage,
    messageId: 'navigation-kit-rank-item-service-old.services.rank-navigation-error-flag.flag.default-error',
    messageType: 'transactional'
};
const $e0c9bf75fedd214b$export$b8b9d90f9e5bd72b = 'jiraNavigationKitRankItem';
const $e0c9bf75fedd214b$export$111d365fc37d2de3 = 'reorderView';
const $e0c9bf75fedd214b$export$f1e608dba99fa330 = {
    experience: $e0c9bf75fedd214b$export$111d365fc37d2de3
};
const $e0c9bf75fedd214b$var$getFlagDetails = (error)=>{
    const statusCode = error instanceof (0, $eCBf9.MutationError) ? error.extensions?.statusCode ?? null : error.extensions?.[0]?.statusCode ?? null;
    switch(statusCode){
        case 401:
            return {
                type: $e0c9bf75fedd214b$var$ERROR_TYPE,
                title: (0, $3xu6l.default).unauthenticatedUserErrorTitle,
                description: (0, $3xu6l.default).unauthenticatedUserErrorMessage,
                messageId: 'navigation-kit-rank-item-service-old.services.flag.unauthenticated-user-error',
                messageType: 'transactional'
            };
        case 403:
            return {
                type: $e0c9bf75fedd214b$var$ERROR_TYPE,
                title: (0, $3xu6l.default).authorisationErrorTitle,
                description: (0, $3xu6l.default).authorisationErrorMessage,
                messageId: 'navigation-kit-rank-item-service-old.services.flag.authorisation-error',
                messageType: 'transactional'
            };
        case 404:
            return {
                type: $e0c9bf75fedd214b$var$ERROR_TYPE,
                title: (0, $3xu6l.default).viewNotFoundErrorTitle,
                description: (0, $3xu6l.default).viewNotFoundErrorMessage,
                messageId: 'navigation-kit-rank-item-service-old.services.flag.view-not-found-error',
                messageType: 'transactional'
            };
        default:
            return null;
    }
};
const $e0c9bf75fedd214b$export$d474c994a9313e38 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const [routerState] = (0, $doZTA.useRouter)();
    const { projectKey: projectKey, projectId: projectId } = (0, $1nb22.getProjectKeyId)(routerState?.match, routerState?.query);
    const projectIdOrKey = projectKey || projectId;
    const [commitMutation, isLoading] = (0, $8Uumt.useMutation)((0, $iEwLV.default));
    const experienceAttributes = (0, $5uXOq.useMemo)(()=>({
            ...$e0c9bf75fedd214b$export$f1e608dba99fa330,
            attributes: {
                withContainerNav: false
            }
        }), []);
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)(experienceAttributes);
    const onExperienceFail = (0, $93jKl.useExperienceFail)(experienceAttributes);
    const sendErrorAnalytics = (0, $5uXOq.useCallback)((error)=>{
        onExperienceFail($e0c9bf75fedd214b$export$b8b9d90f9e5bd72b, error);
        (0, $jcw0u.default)({
            meta: {
                id: $e0c9bf75fedd214b$export$111d365fc37d2de3,
                packageName: $e0c9bf75fedd214b$export$b8b9d90f9e5bd72b,
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onExperienceFail
    ]);
    const rankNavigationItem = (0, $5uXOq.useCallback)(({ placement: placement, sourceTabIndex: sourceTabIndex, targetTabIndex: targetTabIndex, id: id, beforeItemId: beforeItemId, afterItemId: afterItemId, dataId: dataId, actionType: actionType })=>{
        commitMutation({
            variables: {
                input: {
                    id: id,
                    beforeItemId: beforeItemId,
                    afterItemId: afterItemId
                },
                first: (0, $ktofH.NAVIGATION_ITEMS_PAGE_SIZE)
            },
            optimisticUpdater: (store)=>{
                const parentRecord = store.getRoot().getLinkedRecord('jira');
                if (parentRecord == null) return;
                const connection = (0, $8Uumt.ConnectionHandler).getConnection(parentRecord, 'tabs_jiraNavigation__navigationItems', {
                    cloudId: cloudId,
                    projectIdOrKey: projectIdOrKey
                });
                if (!connection) return;
                const existingEdges = connection?.getLinkedRecords('edges') || [];
                const tabs = Array.from(existingEdges || []);
                const reorderedTabs = (0, $cAQ2Q.reorderWithEdge)({
                    list: tabs,
                    startIndex: sourceTabIndex,
                    indexOfTarget: targetTabIndex,
                    closestEdgeOfTarget: placement === $e0c9bf75fedd214b$var$BEFORE ? 'left' : 'right',
                    axis: 'horizontal'
                });
                const edges = reorderedTabs.map((tab)=>existingEdges.find((edge)=>tab?.getLinkedRecord('node')?.getDataID() === edge.getLinkedRecord('node')?.getDataID())).filter(Boolean);
                connection?.setLinkedRecords(edges, 'edges');
            },
            updater: (store, response)=>{
                if (!response?.jira?.rankNavigationItem?.success) return;
                const { navigationItems: navigationItems } = response.jira.rankNavigationItem;
                if (!navigationItems || navigationItems.errors) return;
                const parentRecord = store.getRoot().getLinkedRecord('jira');
                if (parentRecord == null) return;
                const connection = (0, $8Uumt.ConnectionHandler).getConnection(parentRecord, 'tabs_jiraNavigation__navigationItems', {
                    cloudId: cloudId,
                    projectIdOrKey: projectIdOrKey
                });
                if (!connection) return;
                const existingEdges = connection.getLinkedRecords('edges');
                if (!existingEdges || navigationItems.edges == null) return;
                const edges = navigationItems.edges.map((tab)=>existingEdges.find((edge)=>tab?.node?.__id === edge.getLinkedRecord('node')?.getDataID())).filter(Boolean);
                if (dataId) {
                    const itemType = store.get(dataId)?.getValue('typeKey');
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'navigationItem reordered', {
                        viewType: String(itemType).toLowerCase(),
                        actionType: actionType,
                        initialTabIndex: sourceTabIndex,
                        finalTabIndex: targetTabIndex
                    });
                }
                connection?.setLinkedRecords(edges, 'edges');
            },
            onCompleted: (data)=>{
                const { errors: errors, success: success, navigationItems: navigationItems } = data?.jira?.rankNavigationItem ?? {};
                if (success && navigationItems && !errors && !navigationItems.errors) {
                    onExperienceSuccess();
                    return;
                }
                if (errors && errors?.length > 0) {
                    const error = errors ? new (0, $eCBf9.MutationError)(errors[0]) : new (0, $c9Ur7.QueryError)({});
                    const flagDetails = $e0c9bf75fedd214b$var$getFlagDetails(error) ?? $e0c9bf75fedd214b$var$RANK_NAVIGATION_ERROR_FLAG;
                    showFlag(flagDetails);
                    if ($e0c9bf75fedd214b$var$HANDLED_STATUS_CODES.includes(error.statusCode ?? -1)) {
                        onExperienceSuccess();
                        return;
                    }
                    sendErrorAnalytics(error);
                    return;
                }
                if (navigationItems?.errors) {
                    const connectionErrors = navigationItems?.errors;
                    if (connectionErrors && connectionErrors.length > 0) {
                        const connectionError = new Error(connectionErrors[0].message ?? 'Error retrieving navigation items');
                        sendErrorAnalytics(connectionError);
                    }
                }
                showFlag($e0c9bf75fedd214b$var$RANK_NAVIGATION_ERROR_FLAG);
            },
            onError: (error)=>{
                const err = new (0, $eCBf9.MutationError)(error);
                showFlag($e0c9bf75fedd214b$var$RANK_NAVIGATION_ERROR_FLAG);
                sendErrorAnalytics(err);
            }
        });
    }, [
        commitMutation,
        cloudId,
        projectIdOrKey,
        createAnalyticsEvent,
        showFlag,
        onExperienceSuccess,
        sendErrorAnalytics
    ]);
    return [
        rankNavigationItem,
        isLoading
    ];
};

});
parcelRegister("iEwLV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d18de52adcbe8c26$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a93b54a347bb75f7cdabac6e46bc75c8>>
 * @relayHash 92af41fdf32c06bc2ee63aaffd33246d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1df32cba3c47d61b8839e08b2032e2c15fb891fd97c9f9e2314f2e2906b8a2b5
const $d18de52adcbe8c26$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v10 = {
        "concreteType": "QueryError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v4 /*: any*/ 
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "servicesRankNavigationItemOldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraRankNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "rankNavigationItem",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraNavigationItemConnection",
                                    "kind": "LinkedField",
                                    "name": "navigationItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNavigationItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "servicesRankNavigationItemOldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraRankNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "rankNavigationItem",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraNavigationItemConnection",
                                    "kind": "LinkedField",
                                    "name": "navigationItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNavigationItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1df32cba3c47d61b8839e08b2032e2c15fb891fd97c9f9e2314f2e2906b8a2b5",
            "metadata": {},
            "name": "servicesRankNavigationItemOldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d18de52adcbe8c26$var$node.hash = "8a0d3318b6a90a4e77034183ab047ea5";
var $d18de52adcbe8c26$export$2e2bcd8739ae039 = $d18de52adcbe8c26$var$node;

});

parcelRegister("eCBf9", function(module, exports) {

$parcel$export(module.exports, "MutationError", () => $5fe48c9a5d56428c$export$10c788363424e94e);
class $5fe48c9a5d56428c$export$10c788363424e94e extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.message = payload.message ?? '';
        this.extensions = payload.extensions;
        this.statusCode = payload.extensions?.statusCode ?? null;
        this.errorType = payload.extensions?.errorType ?? null;
    }
}

});

parcelRegister("3xu6l", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a1f9e8b53b8a9d7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4a1f9e8b53b8a9d7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "navigation-kit-rank-item-service-old.services.error-message",
        "defaultMessage": "Refresh the page and try again."
    },
    errorTitle: {
        "id": "navigation-kit-rank-item-service-old.services.error-title",
        "defaultMessage": "Something's gone wrong"
    },
    unauthenticatedUserErrorTitle: {
        "id": "navigation-kit-rank-item-service-old.services.unauthenticated-user-error-title",
        "defaultMessage": "You'll need to log in"
    },
    unauthenticatedUserErrorMessage: {
        "id": "navigation-kit-rank-item-service-old.services.unauthenticated-user-error-message",
        "defaultMessage": "You need to be logged in to manage the navigation. Please log in and try again."
    },
    authorisationErrorTitle: {
        "id": "navigation-kit-rank-item-service-old.services.authorisation-error-title",
        "defaultMessage": "You don't have permission"
    },
    authorisationErrorMessage: {
        "id": "navigation-kit-rank-item-service-old.services.authorisation-error-message",
        "defaultMessage": "Only project admins can manage the navigation."
    },
    viewNotFoundErrorTitle: {
        "id": "navigation-kit-rank-item-service-old.services.view-not-found-error-title",
        "defaultMessage": "This tab has been removed"
    },
    viewNotFoundErrorMessage: {
        "id": "navigation-kit-rank-item-service-old.services.view-not-found-error-message",
        "defaultMessage": "The tab you're trying to move can't be found"
    }
});

});



parcelRegister("dZ5ym", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc19506823173a8a$export$2e2bcd8739ae039);

var $i2X9v = parcelRequire("i2X9v");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eyM7m = parcelRequire("eyM7m");

var $6nk5B = parcelRequire("6nk5B");
const $bc19506823173a8a$var$JiraTab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ tabFragment: tabFragment, position: position, id: id, beforeItemId: beforeItemId, afterItemId: afterItemId, defaultViewTypeKey: defaultViewTypeKey }, ref)=>{
    const tabData = (0, $8Uumt.useFragment)((0, $i2X9v.default), tabFragment);
    const hideNavigationItem = (0, $6nk5B.useHideNavigationItem)();
    const hideTab = (0, $5uXOq.useCallback)((args)=>{
        hideNavigationItem({
            ...args
        });
    }, [
        hideNavigationItem
    ]);
    switch(tabData?.__typename){
        case 'JiraWorkManagementSavedView':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eyM7m.SimpleNavigationTab), {
                tabFragment: tabData,
                position: position,
                id: id,
                onHideTab: hideTab,
                beforeItemId: beforeItemId,
                afterItemId: afterItemId,
                defaultViewTypeKey: defaultViewTypeKey,
                ref: ref
            });
        default:
            return null;
    }
});
var $bc19506823173a8a$export$2e2bcd8739ae039 = $bc19506823173a8a$var$JiraTab;

});
parcelRegister("i2X9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9006df5e1a3fa09$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<447038276454656d5e745b09d48483ad>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d9006df5e1a3fa09$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jiraTab_navigationKitTabListOld",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "FragmentSpread",
            "name": "simpleNavigationTab_businessTabs"
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$d9006df5e1a3fa09$var$node.hash = "ba1f2747c0ac78b804fc3aabe3484099";
var $d9006df5e1a3fa09$export$2e2bcd8739ae039 = $d9006df5e1a3fa09$var$node;

});

parcelRegister("eyM7m", function(module, exports) {

$parcel$export(module.exports, "SimpleNavigationTab", () => $64afe64d0e3d0ff6$export$b455ef65e351f258);

var $bD5kJ = parcelRequire("bD5kJ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $21JTp = parcelRequire("21JTp");

var $bnWgN = parcelRequire("bnWgN");

var $4EVK0 = parcelRequire("4EVK0");

var $6jY6G = parcelRequire("6jY6G");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $l2N2a = parcelRequire("l2N2a");

var $2YP9W = parcelRequire("2YP9W");
var $doZTA = parcelRequire("doZTA");
var $lVJAU = parcelRequire("lVJAU");

var $0ud4r = parcelRequire("0ud4r");

var $8YSts = parcelRequire("8YSts");

var $42o5Y = parcelRequire("42o5Y");

var $lTLJa = parcelRequire("lTLJa");
const $64afe64d0e3d0ff6$export$b455ef65e351f258 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ tabFragment: tabFragment, position: position, id: id, onHideTab: onHideTab, beforeItemId: beforeItemId, afterItemId: afterItemId, defaultViewTypeKey: defaultViewTypeKey }, ref)=>{
    const { data: projectDetails } = (0, $2YP9W.useResource)((0, $l2N2a.DEPRECATED_DO_NOT_USE_projectDetailsResource));
    const projectKey = projectDetails?.currentProject?.key || '';
    const route = (0, $6jY6G.useCurrentRoute)();
    const { push: push, replace: replace } = (0, $lVJAU.useRouterActions)();
    const [routerState] = (0, $doZTA.useRouter)();
    const { name: routeName } = routerState.route;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const updateNavigationDefaultView = (0, $8YSts.useUpdateNavigationDefaultView)(projectKey);
    const tabData = (0, $8Uumt.useFragment)((0, $bD5kJ.default), tabFragment);
    const canEdit = projectDetails?.currentProject?.permissions.administerProject;
    const handleTabClick = (0, $5uXOq.useCallback)((itemTypeKey, extra)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'tab clicked', 'navigationItem', {
            viewType: itemTypeKey.toLowerCase(),
            ...extra
        });
    }, [
        createAnalyticsEvent
    ]);
    const handleDrag = (0, $5uXOq.useCallback)((itemTypeKey)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'tab dragged', 'navigationItem', {
            viewType: itemTypeKey.toLowerCase()
        });
    }, [
        createAnalyticsEvent
    ]);
    const onHideTabCompleted = (0, $5uXOq.useCallback)((isCurrentRoute)=>()=>{
            // Do not redirect to default view if the current route is not the hidden view
            if (!isCurrentRoute) return;
            if (projectDetails?.currentProject) {
                const redirectPath = (defaultViewTypeKey && (0, $bnWgN.getRouteForViewType)(projectKey, defaultViewTypeKey)) ?? `/projects/${projectKey}`;
                if (routeName.includes('legacy')) {
                    replace(redirectPath);
                    push(redirectPath);
                } else replace(redirectPath);
            }
        }, [
        defaultViewTypeKey,
        projectDetails,
        projectKey,
        push,
        replace,
        routeName
    ]);
    const onSetAsDefaultCompleted = (0, $5uXOq.useCallback)(()=>updateNavigationDefaultView(tabData.typeKey), [
        tabData.typeKey,
        updateNavigationDefaultView
    ]);
    switch(tabData.typeKey){
        case 'APPS':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42o5Y.AppNavigationTab), {
                tabFragment: tabData,
                position: position,
                id: id,
                onTabClick: handleTabClick,
                canEdit: canEdit,
                handleDrag: ()=>handleDrag(tabData.typeKey),
                afterItemId: afterItemId,
                beforeItemId: beforeItemId
            });
        case 'SHORTCUTS':
            {
                const isSelected = route.name === 'classic-business-shortcut';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lTLJa.ShortcutNavigationTab), {
                    isSelected: isSelected,
                    tabFragment: tabData,
                    position: position,
                    id: id,
                    onHideTab: (args)=>{
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'hideViewOption', {
                            viewType: tabData.typeKey.toLowerCase()
                        });
                        onHideTab({
                            ...args,
                            onCompleted: onHideTabCompleted(isSelected)
                        });
                    },
                    onTabClick: handleTabClick,
                    canEdit: canEdit,
                    handleDrag: ()=>handleDrag(tabData.typeKey),
                    afterItemId: afterItemId,
                    beforeItemId: beforeItemId
                });
            }
        default:
            if ((0, $21JTp.ITEM_TYPE_KEY_TO_ROUTES).has(tabData.typeKey)) {
                const routes = (0, $21JTp.ITEM_TYPE_KEY_TO_ROUTES).get(tabData.typeKey);
                const isSelected = routes?.has(route.name) || routes?.has(route.group ?? '') || false;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4EVK0.default), {
                    isSelected: isSelected,
                    onHideTab: (args)=>{
                        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'hideViewOption', {
                            viewType: tabData.typeKey.toLowerCase()
                        });
                        onHideTab({
                            ...args,
                            onCompleted: onHideTabCompleted(isSelected)
                        });
                    },
                    ref: ref,
                    tabFragment: tabData,
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0ud4r.TabIcon), {
                        typeKey: tabData.typeKey,
                        label: "",
                        size: "small"
                    }),
                    href: (0, $bnWgN.getRouteForViewType)(projectKey, tabData.typeKey),
                    position: position,
                    id: id,
                    onSetAsDefaultCompleted: onSetAsDefaultCompleted,
                    canEdit: canEdit,
                    handleDrag: ()=>handleDrag(tabData.typeKey),
                    onClick: ()=>handleTabClick(tabData.typeKey),
                    beforeItemId: beforeItemId,
                    afterItemId: afterItemId
                });
            }
            return null;
    }
});

});
parcelRegister("bD5kJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2ce9349f47e1093$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ea83b60ba902a317ff8133e455121627>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c2ce9349f47e1093$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "simpleNavigationTab_businessTabs",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "typeKey"
            },
            "action": "THROW",
            "path": "typeKey"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_navigationKitTabOld_Tab"
        },
        {
            "kind": "FragmentSpread",
            "name": "appNavigationTab_businessTabs"
        },
        {
            "kind": "FragmentSpread",
            "name": "shortcutNavigationTab_businessTabs_OldShortcutNavigationTab"
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$c2ce9349f47e1093$var$node.hash = "525f42f02684fc26673ffcdf08b15189";
var $c2ce9349f47e1093$export$2e2bcd8739ae039 = $c2ce9349f47e1093$var$node;

});

parcelRegister("bnWgN", function(module, exports) {

$parcel$export(module.exports, "getRouteForViewType", () => $2a5a115c895474c0$export$354a3334a0b30da2);

var $4R6GH = parcelRequire("4R6GH");
const $2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL = '/jira/core/projects';
const $2a5a115c895474c0$export$354a3334a0b30da2 = (projectKey, itemTypeKey)=>{
    switch(itemTypeKey){
        case 'SUMMARY':
            return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/summary`;
        case 'BOARD':
            return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/board`;
        case 'LIST':
            return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/list`;
        case 'TIMELINE':
            return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/timeline`;
        case 'CALENDAR':
            return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/calendar`;
        case 'FORMS':
            return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/form`;
        case 'APPROVALS':
            return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/approvals`;
        case 'ATTACHMENTS':
            return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/attachments`;
        case 'PAGES':
            return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/pages`;
        case 'ISSUES':
            return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/issues`;
        case 'ARCHIVED_ISSUES':
            return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/issues/archive`;
        case 'REPORTS':
            return (0, $4R6GH.fg)('reports-overview-page-migration') ? `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/reports` : `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`;
        case 'COMPONENTS':
            return `${$2a5a115c895474c0$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/components`;
        default:
            return undefined;
    }
};

});

parcelRegister("4EVK0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7febbf651e7bd31$export$2e2bcd8739ae039);

var $aoyyS = parcelRequire("aoyyS");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3Rem9 = parcelRequire("3Rem9");

var $bX17s = parcelRequire("bX17s");
const $e7febbf651e7bd31$var$Tab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ tabFragment: tabFragment, onHideTab: onHideTab, onSetAsDefaultCompleted: onSetAsDefaultCompleted, beforeItemId: beforeItemId, afterItemId: afterItemId, canEdit: canEdit, id: id, isOpen: // remove the destructuring of isOpen when cleaning up navigation-kit-ui-tab-old and spread with tabProps instead
isOpen, ...tabProps }, ref)=>{
    const tabData = (0, $8Uumt.useFragment)((0, $aoyyS.default), tabFragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bX17s.default), {
        name: tabData.label,
        isDraggable: canEdit,
        menu: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Rem9.default), {
            tabFragment: tabData,
            onHideClick: onHideTab,
            onSetAsDefaultCompleted: onSetAsDefaultCompleted,
            beforeItemId: beforeItemId,
            afterItemId: afterItemId,
            position: tabProps.position,
            canEdit: canEdit
        }),
        id: id,
        ...tabProps,
        ref: ref
    });
});
var $e7febbf651e7bd31$export$2e2bcd8739ae039 = $e7febbf651e7bd31$var$Tab;

});
parcelRegister("aoyyS", function(module, exports) {

$parcel$export(module.exports, "default", () => $87b35a2e029787ea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1dcc72650448c47aa503da0199134393>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $87b35a2e029787ea$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_navigationKitTabOld_Tab",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "label"
            },
            "action": "THROW",
            "path": "label"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_navigationKitTabMenuOld_TabMenu"
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$87b35a2e029787ea$var$node.hash = "c625355e8e1cd39e8d1a3c10b9dfa2a6";
var $87b35a2e029787ea$export$2e2bcd8739ae039 = $87b35a2e029787ea$var$node;

});

parcelRegister("3Rem9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f76093ddc3459a0$export$2e2bcd8739ae039);

var $g0i7z = parcelRequire("g0i7z");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $1Seuh = parcelRequire("1Seuh");

var $3jAdT = parcelRequire("3jAdT");

var $elaEw = parcelRequire("elaEw");

var $vCqQa = parcelRequire("vCqQa");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $5KCCi = parcelRequire("5KCCi");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $22OQR = parcelRequire("22OQR");

var $9kMYh = parcelRequire("9kMYh");

var $50RmU = parcelRequire("50RmU");

var $8raFJ = parcelRequire("8raFJ");

var $38KaR = parcelRequire("38KaR");
const $3f76093ddc3459a0$var$TabMenu = ({ tabFragment: tabFragment, onHideClick: onHideClick, onSetAsDefaultCompleted: onSetAsDefaultCompleted, beforeItemId: beforeItemId, afterItemId: afterItemId, position: position, canEdit: canEdit = false, isOverflowing: isOverflowing })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [isOpenOld, setIsOpenOld] = (0, $5uXOq.useState)(false);
    const tabData = (0, $8Uumt.useFragment)((0, $g0i7z.default), tabFragment);
    const canRemove = Boolean(tabData?.canRemove);
    const canSetAsDefault = Boolean(tabData?.canSetAsDefault);
    const handleTriggerClick = (0, $5uXOq.useCallback)(()=>{
        if (!isOpenOld) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'viewOptionsMenu');
        setIsOpenOld((previousIsOpen)=>!previousIsOpen);
    }, [
        createAnalyticsEvent,
        isOpenOld
    ]);
    const handleHideClick = (0, $5uXOq.useCallback)(()=>{
        onHideClick?.({
            id: tabData.id,
            relayId: tabData.__id
        });
    }, [
        onHideClick,
        tabData.id,
        tabData.__id
    ]);
    const handleSetAsDefault = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'setAsDefaultViewOption', {
            viewType: tabData.typeKey.toLowerCase()
        });
    }, [
        createAnalyticsEvent,
        tabData.typeKey
    ]);
    const handleMenuClose = (0, $5uXOq.useCallback)(()=>setIsOpenOld(false), []);
    if (!canRemove && !canSetAsDefault && !canEdit) return null;
    const trigger = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isOverflowing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
            ...triggerProps,
            label: formatMessage((0, $50RmU.default).viewOptions),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($elaEw))),
            isTooltipDisabled: false,
            tooltip: {
                hideTooltipOnClick: true
            },
            onClick: handleTriggerClick,
            appearance: "subtle",
            spacing: "compact",
            isSelected: undefined
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3f76093ddc3459a0$var$NavigationThemedButton, {
            ...triggerProps,
            isSelected: undefined,
            onClick: handleTriggerClick,
            appearance: "subtle",
            spacing: "compact",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
                content: formatMessage((0, $50RmU.default).viewOptions),
                hideTooltipOnClick: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($elaEw))), {
                label: formatMessage((0, $50RmU.default).viewOptions),
                LEGACY_size: "small"
            }))
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $vCqQa.default), {
        trigger: trigger,
        isOpen: isOpenOld,
        onClose: handleMenuClose,
        placement: isOverflowing ? 'right-start' : 'bottom-start',
        shouldUseCaptureOnOutsideClick: false,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                sourceType: (0, $4d5e0871c06cee03$export$d1123261ca8831d2),
                sourceName: "navigationKitTabMenuOld"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
                xcss: $3f76093ddc3459a0$var$containerStyles,
                testId: "navigation-kit-tab-menu.ui.tab-menu-options"
            }, canSetAsDefault && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jAdT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38KaR.default), {
                onClick: ()=>{
                    handleSetAsDefault();
                    handleMenuClose();
                },
                onCompleted: onSetAsDefaultCompleted,
                tabFragment: tabData
            })), position !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8raFJ.default), {
                hasSeparator: canSetAsDefault,
                id: tabData?.id,
                dataId: tabData?.__id,
                beforeItemId: beforeItemId,
                afterItemId: afterItemId,
                position: position,
                onClick: handleMenuClose,
                isOverflowing: isOverflowing
            }), canRemove && !tabData.isDefault && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jAdT.default), {
                hasSeparator: canSetAsDefault || typeof beforeItemId === 'string' || typeof afterItemId === 'string'
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9kMYh.default), {
                onClick: handleHideClick
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null))
    });
};
var $3f76093ddc3459a0$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($3f76093ddc3459a0$var$TabMenu);
const $3f76093ddc3459a0$var$NavigationThemedButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $22OQR.ThemedButton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_15ah14e8 _6h9q14e8",
            __cmplp.className
        ])
    });
});
const $3f76093ddc3459a0$var$containerStyles = (0, $2s57o.xcss)({
    minWidth: '124px'
});

});
parcelRegister("g0i7z", function(module, exports) {

$parcel$export(module.exports, "default", () => $a14172845f3c4054$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9a2f72ac4a64401c97c743326d45c0c0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a14172845f3c4054$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_navigationKitTabMenuOld_TabMenu",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "setAsDefaultItem_navigationKitTabMenuOld"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "typeKey"
            },
            "action": "THROW",
            "path": "typeKey"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isDefault"
            },
            "action": "THROW",
            "path": "isDefault"
        },
        {
            "kind": "ScalarField",
            "name": "canRemove"
        },
        {
            "kind": "ScalarField",
            "name": "canSetAsDefault"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$a14172845f3c4054$var$node.hash = "4037066866d5669ba70c12dab127b432";
var $a14172845f3c4054$export$2e2bcd8739ae039 = $a14172845f3c4054$var$node;

});

parcelRegister("9kMYh", function(module, exports) {

$parcel$export(module.exports, "default", () => $28b460b28e45304f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1eETS = parcelRequire("1eETS");

var $koVbs = parcelRequire("koVbs");

var $g0KNO = parcelRequire("g0KNO");
const $28b460b28e45304f$var$HideItem = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        onClick: onClick
    }, formatMessage((0, $g0KNO.default).hideItem));
};
var $28b460b28e45304f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($28b460b28e45304f$var$HideItem);

});
parcelRegister("g0KNO", function(module, exports) {

$parcel$export(module.exports, "default", () => $230247a99830651f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $230247a99830651f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    hideItem: {
        "id": "navigation-kit-tab-menu.hide-item.hide-item",
        "defaultMessage": "Remove"
    }
});

});


parcelRegister("50RmU", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb323f910d179be3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bb323f910d179be3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewOptions: {
        "id": "navigation-kit-tab-menu.view-options",
        "defaultMessage": "Tab options"
    }
});

});

parcelRegister("8raFJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b23333046481b5e8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1eETS = parcelRequire("1eETS");
var $3jAdT = parcelRequire("3jAdT");

var $kaHBi = parcelRequire("kaHBi");

var $koVbs = parcelRequire("koVbs");

var $59kPM = parcelRequire("59kPM");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $83Wrh = parcelRequire("83Wrh");
const $b23333046481b5e8$export$b8b9d90f9e5bd72b = 'jiraNavigationKitRankItem';
const $b23333046481b5e8$export$f1e608dba99fa330 = {
    experience: 'reorderView'
};
const $b23333046481b5e8$var$MoveItem = ({ id: id, dataId: dataId, beforeItemId: beforeItemId, afterItemId: afterItemId, position: position, hasSeparator: hasSeparator, onClick: onClick, isOverflowing: isOverflowing })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [rankNavigationItem] = (0, $59kPM.useRankNavigationItem)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const onStartExperience = (0, $kaHBi.useExperienceStart)({
        ...$b23333046481b5e8$export$f1e608dba99fa330,
        analyticsSource: $b23333046481b5e8$export$b8b9d90f9e5bd72b
    });
    const handleMoveAfter = (0, $5uXOq.useCallback)(()=>{
        if (id.includes('optimisticId') || afterItemId && afterItemId.includes('optimisticId')) return;
        onClick();
        onStartExperience();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'moveTab', {});
        rankNavigationItem({
            placement: 'after',
            sourceTabIndex: position,
            targetTabIndex: position + 1,
            id: id,
            afterItemId: afterItemId,
            dataId: dataId,
            actionType: 'clicked'
        });
    }, [
        id,
        afterItemId,
        onClick,
        onStartExperience,
        createAnalyticsEvent,
        rankNavigationItem,
        position,
        dataId
    ]);
    const handleMoveBefore = (0, $5uXOq.useCallback)(()=>{
        if (id.includes('optimisticId') || beforeItemId && beforeItemId.includes('optimisticId')) return;
        onClick();
        onStartExperience();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'moveTab', {});
        rankNavigationItem({
            placement: 'before',
            sourceTabIndex: position,
            targetTabIndex: position - 1,
            id: id,
            beforeItemId: beforeItemId,
            dataId: dataId,
            actionType: 'clicked'
        });
    }, [
        id,
        beforeItemId,
        onClick,
        onStartExperience,
        rankNavigationItem,
        position,
        dataId,
        createAnalyticsEvent
    ]);
    if (!beforeItemId && !afterItemId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jAdT.default), {
        hasSeparator: hasSeparator
    }, beforeItemId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        onClick: handleMoveBefore
    }, formatMessage(isOverflowing ? (0, $83Wrh.default).moveItemUp : (0, $83Wrh.default).moveItemLeft)), afterItemId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        onClick: handleMoveAfter
    }, formatMessage(isOverflowing ? (0, $83Wrh.default).moveItemDown : (0, $83Wrh.default).moveItemRight)));
};
var $b23333046481b5e8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($b23333046481b5e8$var$MoveItem);

});
parcelRegister("83Wrh", function(module, exports) {

$parcel$export(module.exports, "default", () => $47034ebafd57d316$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $47034ebafd57d316$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moveItemRight: {
        "id": "navigation-kit-tab-menu.move-item.move-item-right",
        "defaultMessage": "Move tab right"
    },
    moveItemDown: {
        "id": "navigation-kit-tab-menu.move-item.move-item-down",
        "defaultMessage": "Move tab down"
    },
    moveItemLeft: {
        "id": "navigation-kit-tab-menu.move-item.move-item-left",
        "defaultMessage": "Move tab left"
    },
    moveItemUp: {
        "id": "navigation-kit-tab-menu.move-item.move-item-up",
        "defaultMessage": "Move tab up"
    }
});

});


parcelRegister("38KaR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef182dbd970359f9$export$2e2bcd8739ae039);

var $6uadP = parcelRequire("6uadP");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1eETS = parcelRequire("1eETS");

var $hbAVG = parcelRequire("hbAVG");

var $koVbs = parcelRequire("koVbs");

var $99AQe = parcelRequire("99AQe");

var $h4SLG = parcelRequire("h4SLG");
const $ef182dbd970359f9$var$SetAsDefaultItem = ({ tabFragment: tabFragment, onClick: onClick, onCompleted: onCompleted })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { setAsDefault: setAsDefault } = (0, $99AQe.useSetAsDefault)();
    const { id: id, __id: __id, label: label, isDefault: isDefault } = (0, $8Uumt.useFragment)((0, $6uadP.default), tabFragment);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        if (!isDefault) {
            setAsDefault({
                id: id,
                __id: __id,
                label: label,
                onCompleted: onCompleted
            });
            onClick?.();
        }
    }, [
        isDefault,
        setAsDefault,
        id,
        __id,
        label,
        onCompleted,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        onClick: handleClick,
        elemAfter: isDefault && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hbAVG))), {
            spacing: "spacious",
            label: formatMessage((0, $h4SLG.default).selected),
            color: "var(--ds-icon-selected, #0C66E4)"
        })
    }, formatMessage((0, $h4SLG.default).setAsDefaultView));
};
var $ef182dbd970359f9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($ef182dbd970359f9$var$SetAsDefaultItem);

});
parcelRegister("6uadP", function(module, exports) {

$parcel$export(module.exports, "default", () => $dab3ec52a1910532$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<434258b5c930d585093e2363bb72efe3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dab3ec52a1910532$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "setAsDefaultItem_navigationKitTabMenuOld",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isDefault"
            },
            "action": "THROW",
            "path": "isDefault"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "label"
            },
            "action": "THROW",
            "path": "label"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "__id"
                    },
                    "action": "THROW",
                    "path": "__id"
                }
            ]
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$dab3ec52a1910532$var$node.hash = "c23cfeb3a5a0ee268d038559efd42314";
var $dab3ec52a1910532$export$2e2bcd8739ae039 = $dab3ec52a1910532$var$node;

});

parcelRegister("hbAVG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4eca488eebd24f6b0c74ed2566069d9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c8301c29749ee534$var$_react = $c8301c29749ee534$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c8301c29749ee534$var$_checkMark = $c8301c29749ee534$var$_interopRequireDefault((parcelRequire("dVU8x")));

var $c8301c29749ee534$var$_check = $c8301c29749ee534$var$_interopRequireDefault((parcelRequire("2n32C")));
function $c8301c29749ee534$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c8301c29749ee534$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $c8301c29749ee534$var$_react.default.createElement($c8301c29749ee534$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $c8301c29749ee534$var$_check.default
    }, props));
$c8301c29749ee534$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $c8301c29749ee534$var$_default = module.exports.default = $c8301c29749ee534$var$CheckMarkIcon;

});

parcelRegister("99AQe", function(module, exports) {

$parcel$export(module.exports, "useSetAsDefault", () => $9f5f7d191fd8f30a$export$5b2c06a7e56f39a8);

var $dL8zM = parcelRequire("dL8zM");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $eCBf9 = parcelRequire("eCBf9");

var $lpwtK = parcelRequire("lpwtK");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $9OXo1 = parcelRequire("9OXo1");

var $bPF58 = parcelRequire("bPF58");
const $9f5f7d191fd8f30a$var$VIEW_NOT_DEFAULTABLE_ERROR = 'View type is not defaultable';
const $9f5f7d191fd8f30a$var$DEFAULT_ERROR_FLAG = {
    type: 'error',
    title: (0, $bPF58.default).setAsDefaultErrorFlagTitle,
    description: (0, $bPF58.default).setAsDefaultErrorFlagDescription,
    messageId: 'navigation-kit-tab-menu-old.services.set-as-default.default-error-flag.error.flag.default-error',
    messageType: 'transactional'
};
const $9f5f7d191fd8f30a$var$getFlagDetails = (error)=>{
    const { message: message } = error;
    const { statusCode: statusCode } = error.extensions || {};
    switch(statusCode){
        case 400:
            if (message === $9f5f7d191fd8f30a$var$VIEW_NOT_DEFAULTABLE_ERROR) return {
                type: 'error',
                title: (0, $bPF58.default).viewNotDefaultableErrorFlagTitle,
                description: (0, $bPF58.default).viewNotDefaultableErrorFlagDescription,
                messageId: 'navigation-kit-tab-menu-old.services.set-as-default.flag.error.view-not-defaultable-error',
                messageType: 'transactional'
            };
            return null;
        case 401:
            return {
                type: 'error',
                title: (0, $bPF58.default).userNotLoggedInErrorFlagTitle,
                description: (0, $bPF58.default).userNotLoggedInErrorFlagDescription,
                messageId: 'navigation-kit-tab-menu-old.services.set-as-default.flag.error.user-not-logged-in-error',
                messageType: 'transactional'
            };
        case 403:
            return {
                type: 'error',
                title: (0, $bPF58.default).userNotAdminErrorFlagTitle,
                description: (0, $bPF58.default).userNotAdminErrorFlagDescription,
                messageId: 'navigation-kit-tab-menu-old.services.set-as-default.flag.error.user-not-admin-error',
                messageType: 'transactional'
            };
        case 404:
            return {
                type: 'error',
                title: (0, $bPF58.default).viewNotFoundErrorFlagTitle,
                description: (0, $bPF58.default).viewNotFoundErrorFlagDescription,
                messageId: 'navigation-kit-tab-menu-old.services.set-as-default.flag.error.view-not-found-error',
                messageType: 'transactional'
            };
        default:
            return null;
    }
};
const $9f5f7d191fd8f30a$export$b8b9d90f9e5bd72b = 'jiraNavigationKitTabMenu';
const $9f5f7d191fd8f30a$export$c028e73dc12a34c5 = 'setAsDefaultView';
const $9f5f7d191fd8f30a$export$f444706ea2b317f8 = {
    experience: $9f5f7d191fd8f30a$export$c028e73dc12a34c5
};
const $9f5f7d191fd8f30a$export$5b2c06a7e56f39a8 = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { data: project } = (0, $lpwtK.useProject)();
    const onStartExperience = (0, $kaHBi.useExperienceStart)({
        ...$9f5f7d191fd8f30a$export$f444706ea2b317f8,
        analyticsSource: $9f5f7d191fd8f30a$export$b8b9d90f9e5bd72b
    });
    const experienceAttributes = (0, $5uXOq.useMemo)(()=>({
            ...$9f5f7d191fd8f30a$export$f444706ea2b317f8,
            attributes: {
                withContainerNav: false
            }
        }), []);
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)(experienceAttributes);
    const onExperienceFail = (0, $93jKl.useExperienceFail)(experienceAttributes);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $dL8zM.default));
    const getStoreEdges = (0, $5uXOq.useCallback)((store)=>{
        const parentRecord = store.getRoot().getLinkedRecord('jira');
        if (parentRecord == null) return;
        const projectIdOrKey = String(project?.key || project?.id);
        const connection = (0, $8Uumt.ConnectionHandler).getConnection(parentRecord, 'tabs_jiraNavigation__navigationItems', {
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey
        });
        if (!connection) return;
        return connection.getLinkedRecords('edges');
    }, [
        cloudId,
        project?.id,
        project?.key
    ]);
    const updater = (0, $5uXOq.useCallback)((store, response)=>{
        if (response?.jira?.setDefaultNavigationItem == null) return;
        if (!response?.jira?.setDefaultNavigationItem?.success) return;
        const { newDefault: newDefault } = response.jira.setDefaultNavigationItem;
        if (newDefault == null) return;
        const edges = getStoreEdges(store);
        if (!edges) return;
        edges.forEach((edge)=>{
            const node = edge?.getLinkedRecord('node');
            if (node?.getValue('isDefault') === true && node?.getValue('id') !== newDefault.id) node.setValue(false, 'isDefault');
            if (node?.getValue('id') === newDefault.id) node?.setValue(true, 'isDefault');
        });
    }, [
        getStoreEdges
    ]);
    const handleError = (0, $5uXOq.useCallback)((error)=>{
        showFlag($9f5f7d191fd8f30a$var$DEFAULT_ERROR_FLAG);
        (0, $jcw0u.default)({
            meta: {
                id: $9f5f7d191fd8f30a$export$c028e73dc12a34c5,
                packageName: $9f5f7d191fd8f30a$export$b8b9d90f9e5bd72b,
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail($9f5f7d191fd8f30a$export$b8b9d90f9e5bd72b, error);
    }, [
        onExperienceFail,
        showFlag
    ]);
    const setAsDefault = (0, $5uXOq.useCallback)(({ id: id, __id: __id, label: label, onCompleted: onCompleted })=>{
        onStartExperience();
        commitMutation({
            variables: {
                input: {
                    id: id
                }
            },
            optimisticResponse: {
                jira: {
                    setDefaultNavigationItem: {
                        success: true,
                        newDefault: {
                            __typename: 'JiraNavigationItem',
                            __id: __id,
                            id: id,
                            label: label,
                            isDefault: true,
                            typeKey: label.toUpperCase(),
                            canRemove: false,
                            canSetAsDefault: true
                        },
                        errors: null
                    }
                }
            },
            updater: (store, response)=>{
                updater(store, response);
                if (response?.jira?.setDefaultNavigationItem?.success) {
                    const itemTypeKey = store.get(__id)?.getValue('typeKey');
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'defaultViewItem updated', {
                        viewType: String(itemTypeKey).toLowerCase()
                    });
                }
            },
            optimisticUpdater: (store, response)=>updater(store, response),
            onCompleted: (result)=>{
                const { success: success, newDefault: newDefault, errors: errors } = result?.jira?.setDefaultNavigationItem ?? {};
                if (success && newDefault && !errors) {
                    showFlag({
                        messageId: 'navigation-kit-tab-menu-old.services.set-as-default.show-flag.success.flag.success',
                        messageType: 'transactional',
                        type: 'success',
                        title: formatMessage((0, $bPF58.default).setAsDefaultSuccessFlagTitle, {
                            viewName: newDefault?.label
                        }),
                        description: formatMessage((0, $bPF58.default).setAsDefaultSuccessFlagDescription, {
                            viewName: newDefault?.label?.toLowerCase()
                        })
                    });
                    onExperienceSuccess();
                    onCompleted?.();
                    return;
                }
                if (errors) {
                    const error = new (0, $eCBf9.MutationError)(errors[0]);
                    const statusCode = error.statusCode;
                    if (statusCode != null) {
                        const flagDetails = $9f5f7d191fd8f30a$var$getFlagDetails(error);
                        if (flagDetails) {
                            showFlag(flagDetails);
                            onExperienceSuccess();
                            return;
                        }
                    }
                    handleError(error);
                }
            },
            onError: (error)=>handleError(error)
        });
    }, [
        commitMutation,
        createAnalyticsEvent,
        formatMessage,
        handleError,
        onExperienceSuccess,
        onStartExperience,
        showFlag,
        updater
    ]);
    return {
        setAsDefault: setAsDefault
    };
};

});
parcelRegister("dL8zM", function(module, exports) {

$parcel$export(module.exports, "default", () => $339e0892ceb20d25$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c70c50e79b306a884eff6e13ee2d227d>>
 * @relayHash a85d80e9644ac82bc3331ce6167bfa89
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ebe7121b983c4524677472fc735a1be6892e0df1ceed2eb00faa41200d3a9f00
const $339e0892ceb20d25$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "label"
    }, v5 = {
        "kind": "FragmentSpread",
        "name": "ui_navigationKitTabMenuOld_TabMenu"
    }, v6 = {
        "kind": "ScalarField",
        "name": "message"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraNavigationItem"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isDefault"
    }, v11 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "typeKey"
    }, v13 = {
        "kind": "ScalarField",
        "name": "canRemove"
    }, v14 = {
        "kind": "ScalarField",
        "name": "canSetAsDefault"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "setAsDefaultItemOldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSetDefaultNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "setDefaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "newDefault",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "previousDefault",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "setAsDefaultItemOldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSetDefaultNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "setDefaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "newDefault",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "previousDefault",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ebe7121b983c4524677472fc735a1be6892e0df1ceed2eb00faa41200d3a9f00",
            "metadata": {},
            "name": "setAsDefaultItemOldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$339e0892ceb20d25$var$node.hash = "c8367bd6e7751463d79f52ede1a5fe37";
var $339e0892ceb20d25$export$2e2bcd8739ae039 = $339e0892ceb20d25$var$node;

});

parcelRegister("bPF58", function(module, exports) {

$parcel$export(module.exports, "default", () => $55202fd60f3f3c55$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $55202fd60f3f3c55$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    setAsDefaultSuccessFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.set-as-default-success-flag-title",
        "defaultMessage": "{viewName} set as default view"
    },
    setAsDefaultSuccessFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.set-as-default-success-flag-description",
        "defaultMessage": "The {viewName} will be the default view for everyone in this project."
    },
    setAsDefaultErrorFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.set-as-default-error-flag-title",
        "defaultMessage": "Something's gone wrong"
    },
    setAsDefaultErrorFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.set-as-default-error-flag-description",
        "defaultMessage": "Refresh the page and try again."
    },
    userNotLoggedInErrorFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.user-not-logged-in-error-flag-title",
        "defaultMessage": "You'll need to log in"
    },
    userNotLoggedInErrorFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.user-not-logged-in-error-flag-description",
        "defaultMessage": "You need to be logged in to set this view as default. Please log in and try again."
    },
    userNotAdminErrorFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.user-not-admin-error-flag-title",
        "defaultMessage": "You don't have permission"
    },
    userNotAdminErrorFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.user-not-admin-error-flag-description",
        "defaultMessage": "Only project admins can manage the navigation."
    },
    viewNotDefaultableErrorFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.view-not-defaultable-error-flag-title",
        "defaultMessage": "Choose a different default view"
    },
    viewNotDefaultableErrorFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.view-not-defaultable-error-flag-description",
        "defaultMessage": "You can only set the summary, board, list, calendar, or timeline as the default view."
    },
    viewNotFoundErrorFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.view-not-found-error-flag-title",
        "defaultMessage": "This view tab been removed"
    },
    viewNotFoundErrorFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.view-not-found-error-flag-description",
        "defaultMessage": "The tab you're trying to set as default can't be found."
    }
});

});


parcelRegister("h4SLG", function(module, exports) {

$parcel$export(module.exports, "default", () => $31a0828f68f748ee$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $31a0828f68f748ee$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    setAsDefaultView: {
        "id": "navigation-kit-tab-menu.set-as-default-item.set-as-default-view",
        "defaultMessage": "Set as default"
    },
    selected: {
        "id": "navigation-kit-tab-menu.set-as-default-item.selected",
        "defaultMessage": "Selected"
    }
});

});



parcelRegister("bX17s", function(module, exports) {

$parcel$export(module.exports, "default", () => $373b9b8ffeb4bd43$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $dGKFs = parcelRequire("dGKFs");

var $hhogF = parcelRequire("hhogF");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $6cG4N = parcelRequire("6cG4N");

var $ktofH = parcelRequire("ktofH");

var $8LJKo = parcelRequire("8LJKo");

var $kwxLQ = parcelRequire("kwxLQ");

var $fCLTb = parcelRequire("fCLTb");

var $ecT1y = parcelRequire("ecT1y");

var $azzkO = parcelRequire("azzkO");

var $eUTnt = parcelRequire("eUTnt");

var $edwOn = parcelRequire("edwOn");
const $373b9b8ffeb4bd43$var$Tab = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, outerRef)=>{
    /*
   * Warning - if you add a new prop to this component make sure you add it
   * to the list of ignored destructured props in props.type === 'dropdown-trigger'
   * block down below or you will get the error
   * "React does not recognize the `yourNewProp` prop on a DOM element."
   */ const { name: name, onClick: onClick, href: href, isSelected: isSelected = false, isLoading: isLoading = false, type: type = 'router-link', elemBefore: elemBefore, elemAfter: elemAfter, isDraggable: isDraggable = false, position: position, id: id, menu: menu, handleDrag: handleDrag, className: className } = props;
    const elementRef = (0, $5uXOq.useRef)(null);
    const draggableRef = (0, $5uXOq.useRef)(null);
    const { closestEdge: closestEdge, dragState: dragState } = (0, $kwxLQ.useDraggableTabs)({
        isDragEnabled: isDraggable,
        position: position,
        id: id,
        handleDrag: handleDrag,
        isSelected: isSelected,
        elementRef: elementRef,
        draggableRef: draggableRef
    });
    const isDragging = Boolean(dragState && dragState.type === 'dragging');
    const commonAfterElements = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, elemAfter, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azzkO.default), {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "navigation-kit-ui-tab.ui.drag-indicator",
        closestEdge: closestEdge
    }), dragState && dragState.type === 'preview' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($373b9b8ffeb4bd43$var$DraggablePreview, {
        "data-testid": "navigation-kit-ui-tab.ui.drag-preview"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hhogF))), {
        label: "",
        LEGACY_size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, name), elemAfter), dragState.container) : null);
    if (isLoading || isSelected && type !== 'dropdown-trigger') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($373b9b8ffeb4bd43$var$NonInteractiveTab, {
        as: isSelected ? 'h2' : undefined,
        "aria-current": isSelected ? 'page' : undefined,
        tabIndex: 0,
        isDraggable: isDraggable,
        isDragging: isDragging,
        ref: (r)=>{
            if (outerRef && typeof outerRef === 'object') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
            outerRef.current = r;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            elementRef.current = r;
        },
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "navigation-kit-ui-tab.ui.non-interactive-tab"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8LJKo.default), {
        elementBefore: elemBefore,
        isDraggable: isDraggable,
        draggableRef: draggableRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, name), !isLoading && menu, commonAfterElements);
    if (type === 'anchor') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($373b9b8ffeb4bd43$var$TabAnchor, {
        href: href,
        onClick: onClick,
        isDraggable: isDraggable,
        isDragging: isDragging,
        ref: elementRef,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "navigation-kit-ui-tab.ui.tab-anchor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8LJKo.default), {
        elementBefore: elemBefore,
        isDraggable: isDraggable,
        draggableRef: draggableRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, name), commonAfterElements);
    if (props.type === 'dropdown-trigger') {
        const { name: _name, onClick: _onClick, href: _href, isSelected: _isSelected, isLoading: _isLoading, type: _type, elemAfter: _elemAfter, elemBefore: _elemBefore, handleDrag: _handleDrag, menu: _menu, testId: testId, ...buttonHTMLProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: $373b9b8ffeb4bd43$var$boxStyles,
            ref: elementRef,
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            testId: "navigation-kit-ui-tab.ui.tab-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($373b9b8ffeb4bd43$var$TabButton, {
            "data-testid": testId,
            // @ts-expect-error - TS2322
            ref: outerRef,
            ...buttonHTMLProps,
            "aria-current": isSelected ? 'page' : undefined,
            type: "button",
            onClick: onClick,
            isDraggable: isDraggable,
            isDragging: isDragging
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8LJKo.default), {
            elementBefore: elemBefore,
            isDraggable: isDraggable,
            draggableRef: draggableRef
        }), name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($373b9b8ffeb4bd43$var$ChevronContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dGKFs))), {
            spacing: "spacious",
            label: ""
        })), commonAfterElements));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($373b9b8ffeb4bd43$var$TabLink, {
        to: href,
        onClick: onClick,
        isDraggable: isDraggable,
        isDragging: isDragging,
        prefetch: "hover",
        ref: elementRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "navigation-kit-ui-tab.ui.tab-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8LJKo.default), {
        elementBefore: elemBefore,
        isDraggable: isDraggable,
        draggableRef: draggableRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, name), commonAfterElements);
}));
const $373b9b8ffeb4bd43$var$themedUnderline = {
    '&::after': {
        position: 'absolute',
        bottom: "var(--ds-space-0, 0px)",
        left: "var(--ds-space-0, 0px)",
        right: "var(--ds-space-0, 0px)",
        content: "''",
        height: "var(--ds-space-025, 2px)",
        maxWidth: '100%',
        borderRadius: `${(0, $ktofH.TAB_UNDERLINE_HEIGHT) / 2}px`,
        backgroundColor: (0, $6cG4N.Tokens).COLOR_LINK
    }
};
const $373b9b8ffeb4bd43$var$themedUnderlinePressed = {
    '&::after': {
        ...$373b9b8ffeb4bd43$var$themedUnderline['&::after'],
        backgroundColor: `${(0, $6cG4N.Tokens).COLOR_LINK_PRESSED}`
    }
};
const $373b9b8ffeb4bd43$var$tabStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- To migrate as part of go/ui-styling-standard
const $373b9b8ffeb4bd43$var$NonInteractiveTab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $edwOn.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_b3nd5v": (0, $lD23V.default)(__cmplp.isDraggable ? 'none' : 'flex'),
            "--_11m4mys": (0, $lD23V.default)(__cmplp.isDraggable ? 'flex' : 'none')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4bfu18uv _1hmsglyw _ajmmnqa1 _11c82smr _zulp1b66 _1e0c1txw _kqswh2mm _ca0qu2gc _u5f31b66 _n3tdu2gc _19bv1b66 _k48p1wq8 _o5721q9c _4t3i14no _vchhusvi _1ul91ris _syazvy9e _4cvr1h6o _1al8t94y _1en3t94y _15opstnw _swr6stnw _1dc4ze3t _yxy2ze3t _1kzdze3t _94ktze3t _1r6xze3t _yz12ze3t _1ccmb3bt _ia7kb3bt _e88sv77o _1n1yv77o _1dhw1osq _l86r1osq _1wbh14e8 _2ykp14e8 _ty5w1txw _1q6e1txw _yqic1h6o _vir01h6o _434t14e8 _137c14e8 _1ygbugt7 _1q5t1r31 _ymio1r31 _1dit1r31 _1ohyglyw _ypr0glyw _ksodglyw _1r9x1o36 _zcxs1o36 _4hz81o36 _1a3b18uv _vjfr18uv _9oik18uv _4fprglyw _10xfglyw _1bnxglyw _5goinqa1 _1w0vnqa1 _jf4cnqa1 _19v6t94y _5or0t94y _qrdit94y _ee5ostnw _1tfxstnw _ixiwstnw _2zt0ze3t _gabdze3t _9di1ze3t _3my4ze3t _1a07ze3t _1wtqze3t _1vttze3t _ti30ze3t _1j2wze3t _bje7b3bt _h10pb3bt _1boqb3bt _xsxlv77o _1ne8v77o _1kmzv77o _kcf41osq _k96a1osq _an691osq _1vcl14e8 _klyr14e8 _4tpu14e8 _1bg41i6y _1ah31i6y _1qb11i6y _7ehiglyw _1ejjglyw _1dbzglyw _f8pj14e8 _v0vw14e8 _30l314e8 _15y3r8wq _oyoh2fjc _1nrm18uv _c2waglyw _1iohnqa1 _13ro1i6y _180dglyw _9h8h18zq _174kt94y _1uf0stnw _1tg4ze3t _12k4ze3t _1tqdze3t _t1p4b3bt _17rjv77o _1wbu1osq _1yox14e8 _gcm118zq",
            __cmplp.isDragging && "_tzy41kuy",
            __cmplp.className
        ])
    });
});
const $373b9b8ffeb4bd43$var$TabLink = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $eUTnt.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_b3nd5v": (0, $lD23V.default)(__cmplp.isDraggable ? 'none' : 'flex'),
            "--_11m4mys": (0, $lD23V.default)(__cmplp.isDraggable ? 'flex' : 'none')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4bfu18uv _1hmsglyw _ajmmnqa1 _11c82smr _zulp1b66 _1e0c1txw _kqswh2mm _ca0qu2gc _u5f31b66 _n3tdu2gc _19bv1b66 _k48p1wq8 _o5721q9c _4t3i14no _vchhusvi _1ul91ris _syazvy9e _4cvr1h6o _1al8t94y _1en3t94y _15opstnw _swr6stnw _1dc4ze3t _yxy2ze3t _1kzdze3t _94ktze3t _1r6xze3t _yz12ze3t _1ccmb3bt _ia7kb3bt _e88sv77o _1n1yv77o _1dhw1osq _l86r1osq _1wbh14e8 _2ykp14e8 _ty5w1txw _1q6e1txw _yqic1h6o _vir01h6o _434t14e8 _137c14e8 _1ygbugt7 _1q5t1r31 _ymio1r31 _1dit1r31 _1ohyglyw _ypr0glyw _ksodglyw _1r9x1o36 _zcxs1o36 _4hz81o36 _1a3b18uv _vjfr18uv _9oik18uv _4fprglyw _10xfglyw _1bnxglyw _5goinqa1 _1w0vnqa1 _jf4cnqa1 _19v6t94y _5or0t94y _qrdit94y _ee5ostnw _1tfxstnw _ixiwstnw _2zt0ze3t _gabdze3t _9di1ze3t _3my4ze3t _1a07ze3t _1wtqze3t _1vttze3t _ti30ze3t _1j2wze3t _bje7b3bt _h10pb3bt _1boqb3bt _xsxlv77o _1ne8v77o _1kmzv77o _kcf41osq _k96a1osq _an691osq _1vcl14e8 _klyr14e8 _4tpu14e8 _1bg41i6y _1ah31i6y _1qb11i6y _7ehiglyw _1ejjglyw _1dbzglyw _f8pj14e8 _v0vw14e8 _30l314e8 _15y3r8wq _oyoh2fjc _1nrm18uv _c2waglyw _1iohnqa1 _13ro1i6y _180dglyw _9h8h18zq _174kt94y _1uf0stnw _1tg4ze3t _12k4ze3t _1tqdze3t _t1p4b3bt _17rjv77o _1wbu1osq _1yox14e8 _gcm118zq",
            __cmplp.isDragging && "_tzy41kuy",
            __cmplp.className
        ])
    });
});
const $373b9b8ffeb4bd43$var$TabAnchor = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fCLTb.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_b3nd5v": (0, $lD23V.default)(__cmplp.isDraggable ? 'none' : 'flex'),
            "--_11m4mys": (0, $lD23V.default)(__cmplp.isDraggable ? 'flex' : 'none')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4bfu18uv _1hmsglyw _ajmmnqa1 _11c82smr _zulp1b66 _1e0c1txw _kqswh2mm _ca0qu2gc _u5f31b66 _n3tdu2gc _19bv1b66 _k48p1wq8 _o5721q9c _4t3i14no _vchhusvi _1ul91ris _syazvy9e _4cvr1h6o _1al8t94y _1en3t94y _15opstnw _swr6stnw _1dc4ze3t _yxy2ze3t _1kzdze3t _94ktze3t _1r6xze3t _yz12ze3t _1ccmb3bt _ia7kb3bt _e88sv77o _1n1yv77o _1dhw1osq _l86r1osq _1wbh14e8 _2ykp14e8 _ty5w1txw _1q6e1txw _yqic1h6o _vir01h6o _434t14e8 _137c14e8 _1ygbugt7 _1q5t1r31 _ymio1r31 _1dit1r31 _1ohyglyw _ypr0glyw _ksodglyw _1r9x1o36 _zcxs1o36 _4hz81o36 _1a3b18uv _vjfr18uv _9oik18uv _4fprglyw _10xfglyw _1bnxglyw _5goinqa1 _1w0vnqa1 _jf4cnqa1 _19v6t94y _5or0t94y _qrdit94y _ee5ostnw _1tfxstnw _ixiwstnw _2zt0ze3t _gabdze3t _9di1ze3t _3my4ze3t _1a07ze3t _1wtqze3t _1vttze3t _ti30ze3t _1j2wze3t _bje7b3bt _h10pb3bt _1boqb3bt _xsxlv77o _1ne8v77o _1kmzv77o _kcf41osq _k96a1osq _an691osq _1vcl14e8 _klyr14e8 _4tpu14e8 _1bg41i6y _1ah31i6y _1qb11i6y _7ehiglyw _1ejjglyw _1dbzglyw _f8pj14e8 _v0vw14e8 _30l314e8 _15y3r8wq _oyoh2fjc _1nrm18uv _c2waglyw _1iohnqa1 _13ro1i6y _180dglyw _9h8h18zq _174kt94y _1uf0stnw _1tg4ze3t _12k4ze3t _1tqdze3t _t1p4b3bt _17rjv77o _1wbu1osq _1yox14e8 _gcm118zq",
            __cmplp.isDragging && "_tzy41kuy",
            __cmplp.className
        ])
    });
});
const $373b9b8ffeb4bd43$var$TabButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $ecT1y.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_b3nd5v": (0, $lD23V.default)(__cmplp.isDraggable ? 'none' : 'flex'),
            "--_11m4mys": (0, $lD23V.default)(__cmplp.isDraggable ? 'flex' : 'none')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4bfu18uv _1hmsglyw _ajmmnqa1 _11c82smr _zulp1b66 _19itglyw _kqswh2mm _ca0qu2gc _n3tdu2gc _19bv1b66 _k48p1wq8 _o5721q9c _4t3i14no _vchhusvi _1ul91ris _syazvy9e _bfhk18uv _1e0c1txw _4cvr1h6o _80omtlke _u5f3idpf _1al8t94y _1en3t94y _15opstnw _swr6stnw _1dc4ze3t _yxy2ze3t _1kzdze3t _94ktze3t _1r6xze3t _yz12ze3t _1ccmb3bt _ia7kb3bt _e88sv77o _1n1yv77o _1dhw1osq _l86r1osq _1wbh14e8 _2ykp14e8 _ty5w1txw _1q6e1txw _yqic1h6o _vir01h6o _434t14e8 _137c14e8 _1ygbugt7 _1q5t1r31 _ymio1r31 _1dit1r31 _1ohyglyw _ypr0glyw _ksodglyw _1r9x1o36 _zcxs1o36 _4hz81o36 _1a3b18uv _vjfr18uv _9oik18uv _4fprglyw _10xfglyw _1bnxglyw _5goinqa1 _1w0vnqa1 _jf4cnqa1 _19v6t94y _5or0t94y _qrdit94y _ee5ostnw _1tfxstnw _ixiwstnw _2zt0ze3t _gabdze3t _9di1ze3t _3my4ze3t _1a07ze3t _1wtqze3t _1vttze3t _ti30ze3t _1j2wze3t _bje7b3bt _h10pb3bt _1boqb3bt _xsxlv77o _1ne8v77o _1kmzv77o _kcf41osq _k96a1osq _an691osq _1vcl14e8 _klyr14e8 _4tpu14e8 _1bg41i6y _1ah31i6y _1qb11i6y _7ehiglyw _1ejjglyw _1dbzglyw _f8pj14e8 _v0vw14e8 _30l314e8 _15y3r8wq _oyoh2fjc _1nrm18uv _c2waglyw _1iohnqa1 _13ro1i6y _180dglyw _9h8h18zq _174kt94y _1uf0stnw _1tg4ze3t _12k4ze3t _1tqdze3t _t1p4b3bt _17rjv77o _1wbu1osq _1yox14e8 _gcm118zq",
            __cmplp.isDragging && "_tzy41kuy",
            __cmplp.className
        ])
    });
});
const $373b9b8ffeb4bd43$var$ChevronContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxr5cr",
            __cmplp.className
        ])
    });
});
const $373b9b8ffeb4bd43$var$previewStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- To migrate as part of go/ui-styling-standard
const $373b9b8ffeb4bd43$var$DraggablePreview = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_b3nd5v": (0, $lD23V.default)(__cmplp.isDraggable ? 'none' : 'flex'),
            "--_11m4mys": (0, $lD23V.default)(__cmplp.isDraggable ? 'flex' : 'none')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4bfu18uv _1hmsglyw _ajmmnqa1 _11c82smr _zulp1b66 _1kl77r9e _1s7z7r9e _1e0c1txw _kqswh2mm _k48p1wq8 _o5721q9c _vchhusvi _1ul91ris _syazvy9e _4cvr1h6o _13lipd34 _qrwqpd34 _bfhkdhxl _ca0qidpf _u5f3u2gc _n3tdidpf _19bv1b66 _4t3i1ul9 _19pku2gc _otyru2gc _139e1smy _qdn51txw _14mjt94y _18postnw _1x88ze3t _19doze3t _32rxze3t _aetrb3bt _1qdgv77o _wbcj1osq _1hfk14e8 _1al8t94y _1en3t94y _15opstnw _swr6stnw _1dc4ze3t _yxy2ze3t _1kzdze3t _94ktze3t _1r6xze3t _yz12ze3t _1ccmb3bt _ia7kb3bt _e88sv77o _1n1yv77o _1dhw1osq _l86r1osq _1wbh14e8 _2ykp14e8 _ty5w1txw _1q6e1txw _yqic1h6o _vir01h6o _434t14e8 _137c14e8 _1ygbugt7 _1q5t1r31 _ymio1r31 _1dit1r31 _1ohyglyw _ypr0glyw _ksodglyw _1r9x1o36 _zcxs1o36 _4hz81o36 _1a3b18uv _vjfr18uv _9oik18uv _4fprglyw _10xfglyw _1bnxglyw _5goinqa1 _1w0vnqa1 _jf4cnqa1 _19v6t94y _5or0t94y _qrdit94y _ee5ostnw _1tfxstnw _ixiwstnw _2zt0ze3t _gabdze3t _9di1ze3t _3my4ze3t _1a07ze3t _1wtqze3t _1vttze3t _ti30ze3t _1j2wze3t _bje7b3bt _h10pb3bt _1boqb3bt _xsxlv77o _1ne8v77o _1kmzv77o _kcf41osq _k96a1osq _an691osq _1vcl14e8 _klyr14e8 _4tpu14e8 _1bg41i6y _1ah31i6y _1qb11i6y _7ehiglyw _1ejjglyw _1dbzglyw _f8pj14e8 _v0vw14e8 _30l314e8 _15y3r8wq _oyoh2fjc _1nrm18uv _c2waglyw _1iohnqa1 _13ro1i6y _180dglyw _9h8h18zq _174kt94y _1uf0stnw _1tg4ze3t _12k4ze3t _1tqdze3t _t1p4b3bt _17rjv77o _1wbu1osq _1yox14e8 _gcm118zq",
            __cmplp.isDragging && "_tzy41kuy",
            __cmplp.className
        ])
    });
});
const $373b9b8ffeb4bd43$var$boxStyles = (0, $2s57o.xcss)({
    minWidth: 'max-content'
});
var $373b9b8ffeb4bd43$export$2e2bcd8739ae039 = $373b9b8ffeb4bd43$var$Tab;

});
parcelRegister("hhogF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8e199447618ebf9961e7eca7a27c952>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c946d94ee24f80d1$var$_react = $c946d94ee24f80d1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c946d94ee24f80d1$var$_dragHandleVertical = $c946d94ee24f80d1$var$_interopRequireDefault((parcelRequire("9sKQw")));

var $c946d94ee24f80d1$var$_dragHandler = $c946d94ee24f80d1$var$_interopRequireDefault((parcelRequire("cAaml")));
function $c946d94ee24f80d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DragHandleVerticalIcon.
 * This component is DragHandleVerticalIcon, with `UNSAFE_fallbackIcon` set to "DragHandlerIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c946d94ee24f80d1$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $c946d94ee24f80d1$var$_react.default.createElement($c946d94ee24f80d1$var$_dragHandleVertical.default, Object.assign({
        LEGACY_fallbackIcon: $c946d94ee24f80d1$var$_dragHandler.default
    }, props));
$c946d94ee24f80d1$var$DragHandleVerticalIcon.Name = 'DragHandleVerticalIconMigration';
var $c946d94ee24f80d1$var$_default = module.exports.default = $c946d94ee24f80d1$var$DragHandleVerticalIcon;

});
parcelRegister("9sKQw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37637907bc962c27c98c216148025653>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e3b1145cb65094d$var$_react = $6e3b1145cb65094d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6e3b1145cb65094d$var$_baseNew = $6e3b1145cb65094d$var$_interopRequireDefault((parcelRequire("enEmH")));
function $6e3b1145cb65094d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DragHandleVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6e3b1145cb65094d$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $6e3b1145cb65094d$var$_react.default.createElement($6e3b1145cb65094d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
    }, props));
$6e3b1145cb65094d$var$DragHandleVerticalIcon.displayName = 'DragHandleVerticalIcon';
var $6e3b1145cb65094d$var$_default = module.exports.default = $6e3b1145cb65094d$var$DragHandleVerticalIcon;

});

parcelRegister("cAaml", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9290e2012148d12f$var$_react = $9290e2012148d12f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $9290e2012148d12f$var$_dragHandleVertical = $9290e2012148d12f$var$_interopRequireDefault((parcelRequire("9sKQw")));
function $9290e2012148d12f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9290e2012148d12f$var$DragHandlerIcon = (props)=>/*#__PURE__*/ $9290e2012148d12f$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="10" cy="8" r="1"/><circle cx="14" cy="8" r="1"/><circle cx="10" cy="16" r="1"/><circle cx="14" cy="16" r="1"/><circle cx="10" cy="12" r="1"/><circle cx="14" cy="12" r="1"/></g></svg>`
    }, props, {
        newIcon: $9290e2012148d12f$var$_dragHandleVertical.default
    }));
$9290e2012148d12f$var$DragHandlerIcon.displayName = 'DragHandlerIcon';
var $9290e2012148d12f$var$_default = module.exports.default = $9290e2012148d12f$var$DragHandlerIcon;

});


parcelRegister("8LJKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $76ab70d91edfc3f9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hhogF = parcelRequire("hhogF");
const $76ab70d91edfc3f9$var$BeforeTab = ({ elementBefore: elementBefore, isDraggable: isDraggable, draggableRef: draggableRef })=>elementBefore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($76ab70d91edfc3f9$var$ElementBeforeContainer, null, elementBefore), isDraggable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($76ab70d91edfc3f9$var$DragHandleContainer, {
        ref: draggableRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hhogF))), {
        label: "",
        LEGACY_size: "small"
    }))) : undefined;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $76ab70d91edfc3f9$var$ElementBeforeContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbpxbi _4t3ipxbi _1e0cb6a7",
            __cmplp.className
        ])
    });
});
const $76ab70d91edfc3f9$var$DragHandleContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_80om1qgj _1bsbpxbi _4t3ipxbi _1e0c1wjw",
            __cmplp.className
        ])
    });
});
var $76ab70d91edfc3f9$export$2e2bcd8739ae039 = $76ab70d91edfc3f9$var$BeforeTab;

});

parcelRegister("kwxLQ", function(module, exports) {

$parcel$export(module.exports, "useDraggableTabs", () => $2379e985f3e09ca9$export$9fa04411e270c5cb);

var $5uXOq = parcelRequire("5uXOq");

var $8iGQq = parcelRequire("8iGQq");

var $l5MhD = parcelRequire("l5MhD");

var $4nayr = parcelRequire("4nayr");
parcelRequire("7mduf");
var $kdSEN = parcelRequire("kdSEN");
function $2379e985f3e09ca9$export$9fa04411e270c5cb({ isDragEnabled: isDragEnabled, position: position, id: id, handleDrag: handleDrag, isSelected: isSelected, elementRef: elementRef, draggableRef: draggableRef }) {
    const [closestEdge, setClosestEdge] = (0, $5uXOq.useState)(null);
    const [dragState, setDragState] = (0, $5uXOq.useState)({
        type: 'idle'
    });
    (0, $5uXOq.useEffect)(()=>{
        const element = elementRef.current;
        const draggableElement = draggableRef.current;
        if (!element || !draggableElement) return;
        return (0, $l5MhD.combine)((0, $4nayr.draggable)({
            element: element,
            dragHandle: draggableElement,
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage }) {
                (0, $kdSEN.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: ({ container: container })=>{
                        const rect = container.getBoundingClientRect();
                        // 12 is the offset from the left edge of the tab to the cursor
                        // it is defined by the sum of the padding left + the half the icon width
                        return {
                            x: 12,
                            y: rect.height / 2
                        };
                    },
                    render ({ container: container }) {
                        setDragState({
                            type: 'preview',
                            container: container
                        });
                        return ()=>setDragState({
                                type: 'dragging'
                            });
                    }
                });
            },
            canDrag: ()=>isDragEnabled,
            onDragStart: handleDrag,
            onDrag: ()=>{
                setDragState({
                    type: 'dragging'
                });
            },
            onDrop: ()=>{
                setDragState({
                    type: 'idle'
                });
            },
            getInitialData () {
                return {
                    position: position,
                    id: id,
                    type: 'tab'
                };
            }
        }), (0, $4nayr.dropTargetForElements)({
            element: element,
            canDrop: (args)=>args.source.data.type === 'tab',
            getIsSticky: ()=>true,
            getData: ({ input: input, element: dataElement })=>{
                const data = {
                    id: id,
                    position: position
                };
                return (0, $8iGQq.attachClosestEdge)(data, {
                    input: input,
                    element: dataElement,
                    allowedEdges: [
                        'left',
                        'right'
                    ]
                });
            },
            onDrag ({ source: source, self: self }) {
                if (source.data.id !== id) setClosestEdge((0, $8iGQq.extractClosestEdge)(self.data));
            },
            onDragLeave: ()=>{
                setClosestEdge(null);
            },
            onDrop: ()=>{
                setClosestEdge(null);
            }
        }));
    }, [
        isDragEnabled,
        position,
        id,
        isSelected,
        elementRef,
        draggableRef,
        handleDrag
    ]);
    return {
        closestEdge: closestEdge,
        dragState: dragState
    };
}

});
parcelRegister("7mduf", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("kdSEN")).setCustomNativeDragPreview);

var $kdSEN = parcelRequire("kdSEN");

});
parcelRegister("kdSEN", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => $320831611590d912$export$52d889c66db0f96e);

var $bAMyk = parcelRequire("bAMyk");

var $374Vm = parcelRequire("374Vm");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $320831611590d912$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $320831611590d912$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $320831611590d912$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $56611718a37028ae$export$7d0a15ee70427305),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ if ((0, $374Vm.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $bAMyk.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $56611718a37028ae$export$7d0a15ee70427305 = 2147483647;




parcelRegister("fCLTb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f16a17df948a6f9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $9f16a17df948a6f9$var$AnchorTab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isDraggable: isDraggable, isDragging: isDragging, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        ref: ref,
        ...props
    }, children));
var $9f16a17df948a6f9$export$2e2bcd8739ae039 = $9f16a17df948a6f9$var$AnchorTab;

});

parcelRegister("ecT1y", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee2de551a5c6e79e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $ee2de551a5c6e79e$var$ButtonTab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isDraggable: isDraggable, isDragging: isDragging, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("button", {
        ref: ref,
        ...props
    }, children));
var $ee2de551a5c6e79e$export$2e2bcd8739ae039 = $ee2de551a5c6e79e$var$ButtonTab;

});

parcelRegister("azzkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $97ff1ca82f9a18ab$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lrco3 = parcelRequire("lrco3");

var $ktofH = parcelRequire("ktofH");
const $97ff1ca82f9a18ab$var$DropIndicator = ({ closestEdge: closestEdge, testId: testId })=>closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97ff1ca82f9a18ab$var$DropIndicatorWrapper, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lrco3.DropIndicator), {
        edge: closestEdge,
        gap: `${(0, $ktofH.TAB_GAP)}px`
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97ff1ca82f9a18ab$var$DropIndicatorWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154i1b66 _1ltvidpf _1bsb1osq _4t3imslj _z1i3eyly",
            __cmplp.className
        ])
    });
});
var $97ff1ca82f9a18ab$export$2e2bcd8739ae039 = $97ff1ca82f9a18ab$var$DropIndicator;

});
parcelRegister("lrco3", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $cc76973c2ae8fbb2$export$62ed72bc21f6b8a6);
$parcel$export(module.exports, "default", () => $cc76973c2ae8fbb2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c6UJt = parcelRequire("c6UJt");

var $6Lt23 = parcelRequire("6Lt23");
function $cc76973c2ae8fbb2$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c6UJt.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $6Lt23.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
$cc76973c2ae8fbb2$export$2e2bcd8739ae039 = $cc76973c2ae8fbb2$export$62ed72bc21f6b8a6;

});
parcelRegister("c6UJt", function(module, exports) {

$parcel$export(module.exports, "Line", () => $4187af2f62a33e74$export$17d680238e50603e);
/* line.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6Lt23 = parcelRequire("6Lt23");
const $4187af2f62a33e74$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $4187af2f62a33e74$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $4187af2f62a33e74$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $4187af2f62a33e74$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $4187af2f62a33e74$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $4187af2f62a33e74$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $6Lt23.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $6Lt23.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $4187af2f62a33e74$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $4187af2f62a33e74$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $bwpsq.default)([
            $4187af2f62a33e74$var$baseStyles.root,
            $4187af2f62a33e74$var$orientationStyles[orientation],
            $4187af2f62a33e74$var$edgeStyles[edge]
        ])
    });
}
var // For React.lazy
$4187af2f62a33e74$export$2e2bcd8739ae039 = $4187af2f62a33e74$export$17d680238e50603e;

});
parcelRegister("6Lt23", function(module, exports) {

$parcel$export(module.exports, "presetStrokeColors", () => $c5dbe78bd4d684b9$export$477fafec326bfca0);
$parcel$export(module.exports, "presetStrokeWidth", () => $c5dbe78bd4d684b9$export$45db03aa04b685e3);
const $c5dbe78bd4d684b9$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #0C66E4)",
    warning: "var(--ds-border-warning, #E56910)"
};
const $c5dbe78bd4d684b9$export$45db03aa04b685e3 = "var(--ds-border-width-outline, 2px)";

});




parcelRegister("eUTnt", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb9e9f1dd5eda46d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hjSul = parcelRequire("hjSul");
const $fb9e9f1dd5eda46d$var$LinkTab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isDraggable: isDraggable, isDragging: isDragging, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
        ref: ref,
        ...props
    }, children));
var $fb9e9f1dd5eda46d$export$2e2bcd8739ae039 = $fb9e9f1dd5eda46d$var$LinkTab;

});

parcelRegister("edwOn", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa511afea3b5ced5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $aa511afea3b5ced5$var$StaticTab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isDraggable: isDraggable, isDragging: isDragging, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ref,
        ...props
    }, children));
var $aa511afea3b5ced5$export$2e2bcd8739ae039 = $aa511afea3b5ced5$var$StaticTab;

});



parcelRegister("0ud4r", function(module, exports) {

$parcel$export(module.exports, "TabIcon", () => $e297b32a90b3997e$export$101d1271c02245ef);

var $5uXOq = parcelRequire("5uXOq");

var $lgPyf = parcelRequire("lgPyf");

var $ddl7e = parcelRequire("ddl7e");

var $41Nl9 = parcelRequire("41Nl9");

var $d0RKL = parcelRequire("d0RKL");

var $aqJO7 = parcelRequire("aqJO7");

var $2VmPP = parcelRequire("2VmPP");

var $4KUYb = parcelRequire("4KUYb");

var $fxg6i = parcelRequire("fxg6i");

var $ef9tG = parcelRequire("ef9tG");

var $9bNK0 = parcelRequire("9bNK0");

var $cQJCJ = parcelRequire("cQJCJ");

var $5P2bV = parcelRequire("5P2bV");

var $044lR = parcelRequire("044lR");

var $fVgSt = parcelRequire("fVgSt");

var $4HiZI = parcelRequire("4HiZI");

var $jri1L = parcelRequire("jri1L");

var $k11Fy = parcelRequire("k11Fy");
const $e297b32a90b3997e$export$101d1271c02245ef = ({ typeKey: typeKey, ...iconProps })=>{
    const migrationIconSize = iconProps.size === 'small' ? 'none' : 'spacious';
    switch(typeKey){
        case 'SUMMARY':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ef9tG))), {
                ...iconProps,
                color: "currentColor",
                spacing: migrationIconSize,
                LEGACY_size: iconProps.size
            });
        case 'BOARD':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aqJO7))), {
                ...iconProps,
                color: "currentColor",
                spacing: migrationIconSize,
                LEGACY_size: iconProps.size
            });
        case 'LIST':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($044lR))), {
                ...iconProps,
                color: "currentColor",
                spacing: migrationIconSize,
                LEGACY_size: iconProps.size
            });
        case 'CALENDAR':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2VmPP))), {
                ...iconProps,
                color: "currentColor",
                spacing: migrationIconSize,
                LEGACY_size: iconProps.size
            });
        case 'TIMELINE':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fVgSt))), {
                ...iconProps,
                color: "currentColor",
                spacing: migrationIconSize,
                LEGACY_size: iconProps.size
            });
        case 'APPROVALS':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9bNK0))), {
                ...iconProps,
                color: "currentColor",
                spacing: migrationIconSize,
                LEGACY_size: iconProps.size
            });
        case 'FORMS':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ddl7e))), {
                ...iconProps,
                color: "currentColor",
                spacing: migrationIconSize,
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jri1L))),
                LEGACY_size: iconProps.size
            });
        case 'PAGES':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4HiZI))), {
                ...iconProps,
                color: "currentColor",
                spacing: migrationIconSize,
                LEGACY_size: iconProps.size,
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($k11Fy)))
            });
        case 'ATTACHMENTS':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d0RKL))), {
                ...iconProps,
                color: "currentColor",
                spacing: migrationIconSize,
                LEGACY_size: iconProps.size
            });
        case 'ISSUES':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQJCJ))), {
                ...iconProps,
                color: "currentColor",
                spacing: migrationIconSize,
                LEGACY_size: iconProps.size
            });
        case 'REPORTS':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4KUYb))), {
                ...iconProps,
                color: "currentColor",
                spacing: migrationIconSize,
                LEGACY_size: iconProps.size
            });
        case 'COMPONENTS':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxg6i))), {
                ...iconProps,
                color: "currentColor",
                spacing: migrationIconSize,
                LEGACY_size: iconProps.size
            });
        case 'APPS':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($41Nl9))), {
                ...iconProps,
                color: "currentColor",
                spacing: migrationIconSize,
                LEGACY_size: iconProps.size
            });
        case 'SHORTCUTS':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5P2bV))), {
                ...iconProps,
                color: "currentColor",
                spacing: migrationIconSize,
                LEGACY_size: iconProps.size
            });
        case 'ARCHIVED_ISSUES':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgPyf))), {
                ...iconProps,
                color: "currentColor",
                spacing: migrationIconSize,
                LEGACY_size: iconProps.size
            });
        default:
            return null;
    }
};

});
parcelRegister("lgPyf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53af402aec64299fbaefa11fd3d04c88>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7c314a31c145780$var$_react = $f7c314a31c145780$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f7c314a31c145780$var$_baseNew = $f7c314a31c145780$var$_interopRequireDefault((parcelRequire("enEmH")));
function $f7c314a31c145780$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArchiveBox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: archiving pages, storage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7c314a31c145780$var$ArchiveBoxIcon = (props)=>/*#__PURE__*/ $f7c314a31c145780$var$_react.default.createElement($f7c314a31c145780$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v5h-1v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6H1zm2.5 5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V6zm10-1.5h-11v-2h11zm-3 4.5h-5V7.5h5z" clip-rule="evenodd"/>`
    }, props));
$f7c314a31c145780$var$ArchiveBoxIcon.displayName = 'ArchiveBoxIcon';
var $f7c314a31c145780$var$_default = module.exports.default = $f7c314a31c145780$var$ArchiveBoxIcon;

});

parcelRegister("ddl7e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6cd595d4ec67af9dd83acc02e35c9f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99ecde63fa3b9455$var$_react = $99ecde63fa3b9455$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $99ecde63fa3b9455$var$_baseNew = $99ecde63fa3b9455$var$_interopRequireDefault((parcelRequire("enEmH")));
function $99ecde63fa3b9455$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Form".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Represents forms across Atlassian products, including Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $99ecde63fa3b9455$var$FormIcon = (props)=>/*#__PURE__*/ $99ecde63fa3b9455$var$_react.default.createElement($99ecde63fa3b9455$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 1.5H1V0h6zM1 3.875c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75C15 6.385 14.384 7 13.625 7H2.375C1.615 7 1 6.384 1 5.625zM2.5 4v1.5h11V4zM7 10.5H1V9h6zm-6 2.375c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75c0 .76-.616 1.375-1.375 1.375H2.375C1.615 16 1 15.384 1 14.625zM2.5 13v1.5h11V13z" clip-rule="evenodd"/>`
    }, props));
$99ecde63fa3b9455$var$FormIcon.displayName = 'FormIcon';
var $99ecde63fa3b9455$var$_default = module.exports.default = $99ecde63fa3b9455$var$FormIcon;

});

parcelRegister("d0RKL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0f7d584f0c375bf34e40fdaa7660bdc1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9794f8b8484cce30$var$_react = $9794f8b8484cce30$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9794f8b8484cce30$var$_attachment = $9794f8b8484cce30$var$_interopRequireDefault((parcelRequire("hZ9xc")));

var $9794f8b8484cce30$var$_attachment2 = $9794f8b8484cce30$var$_interopRequireDefault((parcelRequire("8FO5r")));
function $9794f8b8484cce30$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AttachmentIcon.
 * This component is AttachmentIcon, with `UNSAFE_fallbackIcon` set to "AttachmentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for attaching files to issues or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9794f8b8484cce30$var$AttachmentIcon = (props)=>/*#__PURE__*/ $9794f8b8484cce30$var$_react.default.createElement($9794f8b8484cce30$var$_attachment.default, Object.assign({
        LEGACY_fallbackIcon: $9794f8b8484cce30$var$_attachment2.default
    }, props));
$9794f8b8484cce30$var$AttachmentIcon.Name = 'AttachmentIconMigration';
var $9794f8b8484cce30$var$_default = module.exports.default = $9794f8b8484cce30$var$AttachmentIcon;

});
parcelRegister("hZ9xc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fb48769bc9741be5df69b5fd6e0f8435>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d17f8781c4018223$var$_react = $d17f8781c4018223$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d17f8781c4018223$var$_baseNew = $d17f8781c4018223$var$_interopRequireDefault((parcelRequire("enEmH")));
function $d17f8781c4018223$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Attachment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for attaching files to issues or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d17f8781c4018223$var$AttachmentIcon = (props)=>/*#__PURE__*/ $d17f8781c4018223$var$_react.default.createElement($d17f8781c4018223$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.72 1.97a3.578 3.578 0 1 1 5.06 5.06l-4.5 4.5a2.164 2.164 0 1 1-3.06-3.06l4.5-4.5 1.06 1.06-4.5 4.5a.664.664 0 0 0 .94.94l4.5-4.5a2.079 2.079 0 0 0-2.94-2.94l-4.5 4.5a3.493 3.493 0 0 0 4.94 4.94l2.5-2.5 1.06 1.06-2.5 2.5a4.993 4.993 0 1 1-7.06-7.06z" clip-rule="evenodd"/>`
    }, props));
$d17f8781c4018223$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $d17f8781c4018223$var$_default = module.exports.default = $d17f8781c4018223$var$AttachmentIcon;

});

parcelRegister("8FO5r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6509013b18e62844$var$_react = $6509013b18e62844$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $6509013b18e62844$var$_attachment = $6509013b18e62844$var$_interopRequireDefault((parcelRequire("hZ9xc")));
function $6509013b18e62844$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6509013b18e62844$var$AttachmentIcon = (props)=>/*#__PURE__*/ $6509013b18e62844$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.643 17.965c-1.53 1.495-4.016 1.496-5.542.004a3.773 3.773 0 0 1 .002-5.412l7.147-6.985a2.316 2.316 0 0 1 3.233-.003c.893.873.895 2.282.004 3.153l-6.703 6.55a.653.653 0 0 1-.914-.008.62.62 0 0 1 0-.902l6.229-6.087a.94.94 0 0 0 0-1.353.995.995 0 0 0-1.384 0l-6.23 6.087a2.5 2.5 0 0 0 0 3.607 2.643 2.643 0 0 0 3.683.009l6.703-6.55a4.074 4.074 0 0 0-.003-5.859 4.306 4.306 0 0 0-6.002.003l-7.148 6.985a5.655 5.655 0 0 0-.001 8.118c2.29 2.239 6.015 2.238 8.31-.005l6.686-6.533a.94.94 0 0 0 0-1.353.995.995 0 0 0-1.384 0z"/></svg>`
    }, props, {
        newIcon: $6509013b18e62844$var$_attachment.default
    }));
$6509013b18e62844$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $6509013b18e62844$var$_default = module.exports.default = $6509013b18e62844$var$AttachmentIcon;

});


parcelRegister("2VmPP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9571ec76557171a7f54748c218c48225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $22129e2c287d5de4$var$_react = $22129e2c287d5de4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $22129e2c287d5de4$var$_calendar = $22129e2c287d5de4$var$_interopRequireDefault((parcelRequire("iTgNO")));

var $22129e2c287d5de4$var$_calendar2 = $22129e2c287d5de4$var$_interopRequireDefault((parcelRequire("kqwhU")));
function $22129e2c287d5de4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $22129e2c287d5de4$var$CalendarIcon = (props)=>/*#__PURE__*/ $22129e2c287d5de4$var$_react.default.createElement($22129e2c287d5de4$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $22129e2c287d5de4$var$_calendar2.default
    }, props));
$22129e2c287d5de4$var$CalendarIcon.Name = 'CalendarIconMigration';
var $22129e2c287d5de4$var$_default = module.exports.default = $22129e2c287d5de4$var$CalendarIcon;

});
parcelRegister("iTgNO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dc0a65a8f23cfe26$var$_react = $dc0a65a8f23cfe26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $dc0a65a8f23cfe26$var$_baseNew = $dc0a65a8f23cfe26$var$_interopRequireDefault((parcelRequire("enEmH")));
function $dc0a65a8f23cfe26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dc0a65a8f23cfe26$var$CalendarIcon = (props)=>/*#__PURE__*/ $dc0a65a8f23cfe26$var$_react.default.createElement($dc0a65a8f23cfe26$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$dc0a65a8f23cfe26$var$CalendarIcon.displayName = 'CalendarIcon';
var $dc0a65a8f23cfe26$var$_default = module.exports.default = $dc0a65a8f23cfe26$var$CalendarIcon;

});

parcelRegister("kqwhU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $edef480bec250815$var$_react = $edef480bec250815$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $edef480bec250815$var$_calendar = $edef480bec250815$var$_interopRequireDefault((parcelRequire("iTgNO")));
function $edef480bec250815$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $edef480bec250815$var$CalendarIcon = (props)=>/*#__PURE__*/ $edef480bec250815$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $edef480bec250815$var$_calendar.default
    }));
$edef480bec250815$var$CalendarIcon.displayName = 'CalendarIcon';
var $edef480bec250815$var$_default = module.exports.default = $edef480bec250815$var$CalendarIcon;

});


parcelRegister("4KUYb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::82e1d157ecf30f62ef37497818841c29>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3767a65103c7d22a$var$_react = $3767a65103c7d22a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3767a65103c7d22a$var$_chartTrend = $3767a65103c7d22a$var$_interopRequireDefault((parcelRequire("g95pD")));

var $3767a65103c7d22a$var$_graphLine = $3767a65103c7d22a$var$_interopRequireDefault((parcelRequire("6tgIY")));
function $3767a65103c7d22a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChartTrendIcon.
 * This component is ChartTrendIcon, with `UNSAFE_fallbackIcon` set to "GraphLineIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3767a65103c7d22a$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $3767a65103c7d22a$var$_react.default.createElement($3767a65103c7d22a$var$_chartTrend.default, Object.assign({
        LEGACY_fallbackIcon: $3767a65103c7d22a$var$_graphLine.default
    }, props));
$3767a65103c7d22a$var$ChartTrendIcon.Name = 'ChartTrendIconMigration';
var $3767a65103c7d22a$var$_default = module.exports.default = $3767a65103c7d22a$var$ChartTrendIcon;

});
parcelRegister("6tgIY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $013743d1004a6124$var$_react = $013743d1004a6124$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $013743d1004a6124$var$_chartTrend = $013743d1004a6124$var$_interopRequireDefault((parcelRequire("g95pD")));
function $013743d1004a6124$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $013743d1004a6124$var$GraphLineIcon = (props)=>/*#__PURE__*/ $013743d1004a6124$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M21 17H5c-.55 0-1-.45-1-1.01V6a1 1 0 1 0-2 0v9.99A3 3 0 0 0 5 19h16a1 1 0 0 0 0-2m-3-8v3a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="M13.293 13.707a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L14 11.586l-2.293-2.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L11 11.414z"/></g></svg>`
    }, props, {
        newIcon: $013743d1004a6124$var$_chartTrend.default
    }));
$013743d1004a6124$var$GraphLineIcon.displayName = 'GraphLineIcon';
var $013743d1004a6124$var$_default = module.exports.default = $013743d1004a6124$var$GraphLineIcon;

});


parcelRegister("fxg6i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afb010b77a3674d977e5adddea745303>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4f66d54b6c02996$var$_react = $b4f66d54b6c02996$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b4f66d54b6c02996$var$_component = $b4f66d54b6c02996$var$_interopRequireDefault((parcelRequire("gLsrb")));

var $b4f66d54b6c02996$var$_component2 = $b4f66d54b6c02996$var$_interopRequireDefault((parcelRequire("btAaL")));
function $b4f66d54b6c02996$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ComponentIcon.
 * This component is ComponentIcon, with `UNSAFE_fallbackIcon` set to "ComponentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for components in Jira and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4f66d54b6c02996$var$ComponentIcon = (props)=>/*#__PURE__*/ $b4f66d54b6c02996$var$_react.default.createElement($b4f66d54b6c02996$var$_component.default, Object.assign({
        LEGACY_fallbackIcon: $b4f66d54b6c02996$var$_component2.default
    }, props));
$b4f66d54b6c02996$var$ComponentIcon.Name = 'ComponentIconMigration';
var $b4f66d54b6c02996$var$_default = module.exports.default = $b4f66d54b6c02996$var$ComponentIcon;

});
parcelRegister("gLsrb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b85e957a451f01111d5005fe7bfa754b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3471833a6d190d1$var$_react = $c3471833a6d190d1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c3471833a6d190d1$var$_baseNew = $c3471833a6d190d1$var$_interopRequireDefault((parcelRequire("enEmH")));
function $c3471833a6d190d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Component".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for components in Jira and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3471833a6d190d1$var$ComponentIcon = (props)=>/*#__PURE__*/ $c3471833a6d190d1$var$_react.default.createElement($c3471833a6d190d1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.75A.75.75 0 0 1 2.75 2h3.5a.75.75 0 0 1 .75.75V4.5h2V2.75A.75.75 0 0 1 9.75 2h3.5a.75.75 0 0 1 .75.75V4.5a2 2 0 0 1 2 2V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6.5a2 2 0 0 1 2-2zM3.5 4.5h2v-1h-2zm9 0v-1h-2v1zM2 6a.5.5 0 0 0-.5.5V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V6.5A.5.5 0 0 0 14 6z" clip-rule="evenodd"/>`
    }, props));
$c3471833a6d190d1$var$ComponentIcon.displayName = 'ComponentIcon';
var $c3471833a6d190d1$var$_default = module.exports.default = $c3471833a6d190d1$var$ComponentIcon;

});

parcelRegister("btAaL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85ae7647340a2223$var$_react = $85ae7647340a2223$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $85ae7647340a2223$var$_component = $85ae7647340a2223$var$_interopRequireDefault((parcelRequire("gLsrb")));
function $85ae7647340a2223$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $85ae7647340a2223$var$ComponentIcon = (props)=>/*#__PURE__*/ $85ae7647340a2223$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5 17.991c0 .007 14.005.009 14.005.009-.006 0-.005-7.991-.005-7.991C19 10.002 4.995 10 4.995 10 5.001 10 5 17.991 5 17.991M3 10.01C3 8.899 3.893 8 4.995 8h14.01C20.107 8 21 8.902 21 10.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 17.991z"/><path d="M7 8.34h2V6.67H7zM5 6.67C5 5.75 5.9 5 7 5h2c1.11 0 2 .75 2 1.67v1.67c0 .92-.9 1.66-2 1.66H7c-1.11 0-2-.75-2-1.66zm10 1.67h2V6.67h-2zm-2-1.67c0-.92.9-1.67 2-1.67h2c1.11 0 2 .75 2 1.67v1.67c0 .92-.9 1.67-2 1.67h-2c-1.11-.01-2-.76-2-1.67z"/></g></svg>`
    }, props, {
        newIcon: $85ae7647340a2223$var$_component.default
    }));
$85ae7647340a2223$var$ComponentIcon.displayName = 'ComponentIcon';
var $85ae7647340a2223$var$_default = module.exports.default = $85ae7647340a2223$var$ComponentIcon;

});


parcelRegister("9bNK0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d9c2fe4153711de61c73f11b1bae070a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b0bb9a80ddcdb58$var$_react = $6b0bb9a80ddcdb58$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6b0bb9a80ddcdb58$var$_decision = $6b0bb9a80ddcdb58$var$_interopRequireDefault((parcelRequire("iZSbd")));

var $6b0bb9a80ddcdb58$var$_decision2 = $6b0bb9a80ddcdb58$var$_interopRequireDefault((parcelRequire("h3Khn")));
function $6b0bb9a80ddcdb58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DecisionIcon.
 * This component is DecisionIcon, with `UNSAFE_fallbackIcon` set to "EditorDecisionIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b0bb9a80ddcdb58$var$DecisionIcon = (props)=>/*#__PURE__*/ $6b0bb9a80ddcdb58$var$_react.default.createElement($6b0bb9a80ddcdb58$var$_decision.default, Object.assign({
        LEGACY_fallbackIcon: $6b0bb9a80ddcdb58$var$_decision2.default
    }, props));
$6b0bb9a80ddcdb58$var$DecisionIcon.Name = 'DecisionIconMigration';
var $6b0bb9a80ddcdb58$var$_default = module.exports.default = $6b0bb9a80ddcdb58$var$DecisionIcon;

});
parcelRegister("iZSbd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be0b9c9537e0b69b1d3c8d2587861fe5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd47f381f05c3215$var$_react = $dd47f381f05c3215$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $dd47f381f05c3215$var$_baseNew = $dd47f381f05c3215$var$_interopRequireDefault((parcelRequire("enEmH")));
function $dd47f381f05c3215$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dd47f381f05c3215$var$DecisionIcon = (props)=>/*#__PURE__*/ $dd47f381f05c3215$var$_react.default.createElement($dd47f381f05c3215$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$dd47f381f05c3215$var$DecisionIcon.displayName = 'DecisionIcon';
var $dd47f381f05c3215$var$_default = module.exports.default = $dd47f381f05c3215$var$DecisionIcon;

});

parcelRegister("h3Khn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6b69d938eef8b40$var$_react = $c6b69d938eef8b40$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $c6b69d938eef8b40$var$_decision = $c6b69d938eef8b40$var$_interopRequireDefault((parcelRequire("iZSbd")));
function $c6b69d938eef8b40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6b69d938eef8b40$var$EditorDecisionIcon = (props)=>/*#__PURE__*/ $c6b69d938eef8b40$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.414 8 3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2zm8.293-1.707a1 1 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0"/></svg>`
    }, props, {
        newIcon: $c6b69d938eef8b40$var$_decision.default
    }));
$c6b69d938eef8b40$var$EditorDecisionIcon.displayName = 'EditorDecisionIcon';
var $c6b69d938eef8b40$var$_default = module.exports.default = $c6b69d938eef8b40$var$EditorDecisionIcon;

});


parcelRegister("5P2bV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bb119a22bda01c1dc796d8c652f466ee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $43d36a5310be3cb4$var$_react = $43d36a5310be3cb4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $43d36a5310be3cb4$var$_link = $43d36a5310be3cb4$var$_interopRequireDefault((parcelRequire("bDHz4")));

var $43d36a5310be3cb4$var$_link2 = $43d36a5310be3cb4$var$_interopRequireDefault((parcelRequire("9KNZD")));
function $43d36a5310be3cb4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "EditorLinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $43d36a5310be3cb4$var$LinkIcon = (props)=>/*#__PURE__*/ $43d36a5310be3cb4$var$_react.default.createElement($43d36a5310be3cb4$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $43d36a5310be3cb4$var$_link2.default
    }, props));
$43d36a5310be3cb4$var$LinkIcon.Name = 'LinkIconMigration';
var $43d36a5310be3cb4$var$_default = module.exports.default = $43d36a5310be3cb4$var$LinkIcon;

});
parcelRegister("bDHz4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8795214424a53a62$var$_react = $8795214424a53a62$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8795214424a53a62$var$_baseNew = $8795214424a53a62$var$_interopRequireDefault((parcelRequire("enEmH")));
function $8795214424a53a62$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8795214424a53a62$var$LinkIcon = (props)=>/*#__PURE__*/ $8795214424a53a62$var$_react.default.createElement($8795214424a53a62$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$8795214424a53a62$var$LinkIcon.displayName = 'LinkIcon';
var $8795214424a53a62$var$_default = module.exports.default = $8795214424a53a62$var$LinkIcon;

});

parcelRegister("9KNZD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $719f30899c971b03$var$_react = $719f30899c971b03$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $719f30899c971b03$var$_link = $719f30899c971b03$var$_interopRequireDefault((parcelRequire("bDHz4")));
function $719f30899c971b03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $719f30899c971b03$var$EditorLinkIcon = (props)=>/*#__PURE__*/ $719f30899c971b03$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12.654 8.764a.858.858 0 0 1-1.213-1.213l1.214-1.214a3.717 3.717 0 0 1 5.257 0 3.714 3.714 0 0 1 .001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 0 1-5.263.005.858.858 0 0 1 1.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a2 2 0 0 0-.001-2.831 2 2 0 0 0-2.83 0zm-.808 6.472a.858.858 0 0 1 1.213 1.213l-1.214 1.214a3.717 3.717 0 0 1-5.257 0 3.714 3.714 0 0 1-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 0 1 5.263-.005.858.858 0 0 1-1.214 1.214 2.005 2.005 0 0 0-2.836.005l-.804.803L7.8 13.618a2 2 0 0 0 .001 2.831 2 2 0 0 0 2.83 0z"/></svg>`
    }, props, {
        newIcon: $719f30899c971b03$var$_link.default
    }));
$719f30899c971b03$var$EditorLinkIcon.displayName = 'EditorLinkIcon';
var $719f30899c971b03$var$_default = module.exports.default = $719f30899c971b03$var$EditorLinkIcon;

});


parcelRegister("jri1L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e26e85ccf7880e8a$var$_react = $e26e85ccf7880e8a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $e26e85ccf7880e8a$var$_contentWrapLeft = $e26e85ccf7880e8a$var$_interopRequireDefault((parcelRequire("fSWOc")));
function $e26e85ccf7880e8a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e26e85ccf7880e8a$var$EditorMediaWrapLeftIcon = (props)=>/*#__PURE__*/ $e26e85ccf7880e8a$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m8-8h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2m0 4h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2M6 9h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1m0-4h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $e26e85ccf7880e8a$var$_contentWrapLeft.default
    }));
$e26e85ccf7880e8a$var$EditorMediaWrapLeftIcon.displayName = 'EditorMediaWrapLeftIcon';
var $e26e85ccf7880e8a$var$_default = module.exports.default = $e26e85ccf7880e8a$var$EditorMediaWrapLeftIcon;

});
parcelRegister("fSWOc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6da00ec8512e57c3de0efa89726a9f3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b909845b694bbd7a$var$_react = $b909845b694bbd7a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b909845b694bbd7a$var$_baseNew = $b909845b694bbd7a$var$_interopRequireDefault((parcelRequire("enEmH")));
function $b909845b694bbd7a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWrapLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for left aligning media and content with wrapping enabled.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b909845b694bbd7a$var$ContentWrapLeftIcon = (props)=>/*#__PURE__*/ $b909845b694bbd7a$var$_react.default.createElement($b909845b694bbd7a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-12.5 4v3h3v-3zM2.375 5h3.25C6.385 5 7 5.616 7 6.375v3.25C7 10.385 6.384 11 5.625 11h-3.25C1.615 11 1 10.384 1 9.625v-3.25C1 5.615 1.616 5 2.375 5M15 6.667H9v-1.5h6zm0 4.166H9v-1.5h6zM15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$b909845b694bbd7a$var$ContentWrapLeftIcon.displayName = 'ContentWrapLeftIcon';
var $b909845b694bbd7a$var$_default = module.exports.default = $b909845b694bbd7a$var$ContentWrapLeftIcon;

});


parcelRegister("k11Fy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e92532192e00a5e6$var$_react = $e92532192e00a5e6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $e92532192e00a5e6$var$_file = $e92532192e00a5e6$var$_interopRequireDefault((parcelRequire("4a1LF")));
function $e92532192e00a5e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e92532192e00a5e6$var$FileIcon = (props)=>/*#__PURE__*/ $e92532192e00a5e6$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M17 10.005V19H7V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.522c0-.297-.132-.578-.359-.768l-5.074-4.236c-.36-.3-.813-.464-1.282-.464H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.995z"/><rect width="8" height="2" x="8" y="12" rx="1"/><rect width="4" height="2" x="8" y="15" rx="1"/></g></svg>`
    }, props, {
        newIcon: $e92532192e00a5e6$var$_file.default
    }));
$e92532192e00a5e6$var$FileIcon.displayName = 'FileIcon';
var $e92532192e00a5e6$var$_default = module.exports.default = $e92532192e00a5e6$var$FileIcon;

});
parcelRegister("4a1LF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $307977acb25eeff1$var$_react = $307977acb25eeff1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $307977acb25eeff1$var$_baseNew = $307977acb25eeff1$var$_interopRequireDefault((parcelRequire("enEmH")));
function $307977acb25eeff1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $307977acb25eeff1$var$FileIcon = (props)=>/*#__PURE__*/ $307977acb25eeff1$var$_react.default.createElement($307977acb25eeff1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$307977acb25eeff1$var$FileIcon.displayName = 'FileIcon';
var $307977acb25eeff1$var$_default = module.exports.default = $307977acb25eeff1$var$FileIcon;

});



parcelRegister("8YSts", function(module, exports) {

$parcel$export(module.exports, "useUpdateNavigationDefaultView", () => $2a0981ef4e32b758$export$270f365f5c56bdc1);

var $5uXOq = parcelRequire("5uXOq");


var $iNzEe = parcelRequire("iNzEe");
const $2a0981ef4e32b758$export$270f365f5c56bdc1 = (projectKey)=>{
    const { data: navigationData, update: update } = (0, $iNzEe.useNavigationResource)();
    return (0, $5uXOq.useCallback)((defaultView)=>{
        if (navigationData == null || navigationData === (0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71)) return;
        const favorites = navigationData?.favorites?.map((favourite)=>{
            if (favourite.key === projectKey) return {
                ...favourite,
                defaultView: defaultView.toLowerCase()
            };
            return favourite;
        });
        const recents = navigationData?.recents?.map((recent)=>{
            if (recent.key === projectKey) return {
                ...recent,
                defaultView: defaultView.toLowerCase()
            };
            return recent;
        });
        update(()=>({
                ...navigationData,
                recents: recents,
                favorites: favorites
            }));
    }, [
        navigationData,
        update,
        projectKey
    ]);
};

});

parcelRegister("42o5Y", function(module, exports) {

$parcel$export(module.exports, "AppNavigationTab", () => $7169d4264ad047bf$export$b47970bc3ef5558e);

var $dZISa = parcelRequire("dZISa");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $j7m8K = parcelRequire("j7m8K");
var $3jAdT = parcelRequire("3jAdT");

var $hecDf = parcelRequire("hecDf");

var $gZbSF = parcelRequire("gZbSF");

var $231OU = parcelRequire("231OU");

var $4EVK0 = parcelRequire("4EVK0");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $0ud4r = parcelRequire("0ud4r");

var $5jZ3g = parcelRequire("5jZ3g");

var $7GxxM = parcelRequire("7GxxM");
const $7169d4264ad047bf$export$b47970bc3ef5558e = ({ tabFragment: tabFragment, position: position, id: id, canEdit: canEdit, onTabClick: onTabClick, handleDrag: handleDrag, beforeItemId: beforeItemId, afterItemId: afterItemId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $5uXOq.useState)(false);
    const { project: project } = (0, $hecDf.useNavigationProject)();
    const { data: forgeAppsData, loading: forgeAppsLoading } = (0, $231OU.useProjectForgeApps)('forge-spa-project');
    const { data: connectAppsData, loading: connectAppsLoading } = (0, $gZbSF.useProjectConnectItems)();
    const forgeItems = forgeAppsData ?? [];
    const connectItems = connectAppsData ?? [];
    const totalNumberOfApps = forgeItems.length + connectItems.length;
    const hasApps = totalNumberOfApps > 0;
    const hasForgeApps = !forgeAppsLoading && forgeItems.length > 0;
    const hasConnectApps = !connectAppsLoading && connectItems.length > 0;
    const shouldRenderApps = project != null && (hasForgeApps || hasConnectApps);
    const handleItemClick = (appName, appType)=>{
        setIsDropdownOpen(false);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'app', {
            appName: appName,
            appType: appType
        });
    };
    const tabData = (0, $8Uumt.useFragment)((0, $dZISa.default), tabFragment);
    const trigger = ({ isSelected: isSelected, onClick: onClick, triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4EVK0.default), {
            tabFragment: tabData,
            type: "dropdown-trigger",
            isSelected: isSelected,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0ud4r.TabIcon), {
                typeKey: "APPS",
                label: "",
                size: "small"
            }),
            onClick: (event)=>{
                onClick && onClick(event);
                onTabClick('APPS', {
                    childCount: totalNumberOfApps
                });
            },
            position: position,
            id: id,
            ref: triggerRef,
            handleDrag: handleDrag,
            beforeItemId: beforeItemId,
            afterItemId: afterItemId,
            canEdit: canEdit,
            ...triggerProps
        });
    if (!shouldRenderApps) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j7m8K.default), {
        trigger: trigger,
        placement: "bottom-end",
        isOpen: isDropdownOpen,
        onOpenChange: ({ isOpen: isOpen })=>{
            setIsDropdownOpen(()=>isOpen);
        }
    }, hasApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jAdT.default), {
        testId: "business-tabs.ui.simple-navigation-tab.app-navigation-tab.dropdown-item-group"
    }, forgeItems.map((forgeItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7GxxM.default), {
            key: forgeItem.id,
            data: forgeItem,
            project: project,
            onItemClick: ()=>handleItemClick(forgeItem.properties.title, 'forge')
        })), connectItems.map((connectItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5jZ3g.default), {
            key: connectItem.id,
            data: connectItem,
            onItemClick: ()=>handleItemClick(connectItem.name, 'connect')
        }))));
};

});
parcelRegister("dZISa", function(module, exports) {

$parcel$export(module.exports, "default", () => $05b00b17f58a48af$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4529cc0089dc80119109e0900171e0ba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $05b00b17f58a48af$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "appNavigationTab_businessTabs",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_navigationKitTabOld_Tab"
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$05b00b17f58a48af$var$node.hash = "f67e752c2cd890a3fdfe9249c174c9d7";
var $05b00b17f58a48af$export$2e2bcd8739ae039 = $05b00b17f58a48af$var$node;

});

parcelRegister("231OU", function(module, exports) {

$parcel$export(module.exports, "useProjectForgeApps", () => $1a247d2d1d6e7cdf$export$338edd25edcf3648);
$parcel$export(module.exports, "useProjectForgeAppsNav4", () => $1a247d2d1d6e7cdf$export$80e84933a3e2f677);

var $5uXOq = parcelRequire("5uXOq");

var $5cmSg = parcelRequire("5cmSg");

var $5bkvv = parcelRequire("5bkvv");

var $324W5 = parcelRequire("324W5");

var $kKdpt = parcelRequire("kKdpt");
const $1a247d2d1d6e7cdf$export$338edd25edcf3648 = (routeName, projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $324W5.useResourceWithCustomRouterContext)((0, $5bkvv.forgeProjectModuleResource), projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined);
    const projectData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionVisible)) || null, [
        data
    ]);
    const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionHiddenByAppAccessRules)) || null, [
        data
    ]);
    const stack = (0, $kKdpt.useForgeItemStack)(projectData, routeName);
    return (0, $5uXOq.useMemo)(()=>({
            data: projectData,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error,
            stack: stack
        }), [
        projectData,
        accessNarrowedData,
        loading,
        error,
        stack
    ]);
};
const $1a247d2d1d6e7cdf$export$80e84933a3e2f677 = (projectKey)=>$1a247d2d1d6e7cdf$export$338edd25edcf3648(undefined, projectKey);

});

parcelRegister("5jZ3g", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec4c9a134135b933$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $1eETS = parcelRequire("1eETS");

var $hrlU6 = parcelRequire("hrlU6");

var $aUk4j = parcelRequire("aUk4j");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $hjSul = parcelRequire("hjSul");
// Perform a BFS to find the first connect page that does not have children.
// This will be used as the default selected item when the app is clicked from the apps dropdown menu.
const $ec4c9a134135b933$var$getItemLink = (connectItem)=>{
    const queue = [
        connectItem
    ];
    while(queue.length > 0){
        const current = queue.shift();
        if (current != null && (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(current.items)) return current.url;
        current?.items?.forEach((childItem)=>{
            queue.push(childItem);
        });
    }
    return '';
};
const $ec4c9a134135b933$var$ConnectItem = ({ data: data, onItemClick: onItemClick })=>{
    const webItemRef = (0, $5uXOq.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        (0, $hrlU6.withConnectHost)((connectHost)=>{
            if (webItemRef.current && data.url) connectHost.triggerWebItem(webItemRef.current, data.styleClass ?? '', data.url);
        });
        if (data.styleClass && (0, $hrlU6.isConnectDialogWebItem)(data.styleClass)) {
            e.preventDefault();
            e.stopPropagation();
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'app', {
                appName: data.name,
                appType: 'connect'
            });
        } else onItemClick(e);
    }, [
        data,
        onItemClick,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        // @ts-expect-error - dropdown item is poorly typed and won't allow Link to be used even though it is compatible
        component: (0, $hjSul.Link),
        href: $ec4c9a134135b933$var$getItemLink(data),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aUk4j.default), {
            url: data.iconUrl
        }),
        onClick: handleClick,
        UNSAFE_shouldDisableRouterLink: true,
        ref: (ref)=>{
            if (ref) webItemRef.current = ref;
        }
    }, data.name);
};
var $ec4c9a134135b933$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($ec4c9a134135b933$var$ConnectItem);

});
parcelRegister("hrlU6", function(module, exports) {

$parcel$export(module.exports, "withConnectHost", () => $9316db67541b8a94$export$970e2411dd8601c8);
$parcel$export(module.exports, "getConnectHost", () => $9316db67541b8a94$export$186d423c00af146c);
$parcel$export(module.exports, "isConnectDialogWebItem", () => $9316db67541b8a94$export$920fb4b46d4f2eec);

var $dJZWD = parcelRequire("dJZWD");
const $9316db67541b8a94$export$970e2411dd8601c8 = async (action)=>{
    const connectHost = await (0, $dJZWD.setupConnectJs)();
    action(connectHost);
};
const $9316db67541b8a94$export$186d423c00af146c = ()=>window.connectHost;
const $9316db67541b8a94$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');

});
parcelRegister("dJZWD", function(module, exports) {

$parcel$export(module.exports, "setupConnectJs", () => $762ba9fa524ea8e6$export$891414b605e5f038);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
var $cQZXC = parcelRequire("cQZXC");

var $dH9DT = parcelRequire("dH9DT");

const $762ba9fa524ea8e6$var$installConnectJs = async ()=>{
    // we need the heritage to load in order for WRM core and jQuery to exist.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $cQZXC.waitForHeritage)();
    await (0, $dH9DT.waitForJQuery)();
    const loader = await (parcelRequire("3hUjN"));
    await loader.performSideEffects();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};
let $762ba9fa524ea8e6$var$installConnectJsPromise = null;
const $762ba9fa524ea8e6$export$891414b605e5f038 = async ()=>{
    // Only pages in the SPA will benefit from modernising connect
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__SPA__) {
        if ($762ba9fa524ea8e6$var$installConnectJsPromise === null) $762ba9fa524ea8e6$var$installConnectJsPromise = $762ba9fa524ea8e6$var$installConnectJs();
        return $762ba9fa524ea8e6$var$installConnectJsPromise;
    }
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $6BZYo.loadBridge)({
        name: 'ac/create',
        wrmKeys: [
            'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
            // Undeclared Dependency: jira/navigation
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
        ]
    });
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};

});
parcelRegister("6BZYo", function(module, exports) {

$parcel$export(module.exports, "loadBridge", () => $ce95ee3fd66207c7$export$df8409da353bde5a);

var $fqWWz = parcelRequire("fqWWz");
var $3GASE = parcelRequire("3GASE");
var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");

var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");
var $8JNtu = parcelRequire("8JNtu");
var $5Ik5Y = parcelRequire("5Ik5Y");
const $ce95ee3fd66207c7$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, $fqWWz.MAX_RETRIES), timeout: timeout = (0, $fqWWz.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    if (wrmKeys != null) return (0, $7T84i.loadBridgeStrict)({
        name: name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        wrmKeys: [].concat(wrmKeys),
        shouldLogError: shouldLogError
    });
    if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
    if (tentatives <= 1) return (0, $3GASE.loadBridgeBail)({
        name: name,
        shouldLogError: shouldLogError
    });
    return (0, $ig88W.loadBridgeRace)({
        name: name,
        shouldLogError: shouldLogError,
        timeout: (tentatives - 1) * timeout
    });
};

});
parcelRegister("fqWWz", function(module, exports) {

$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $71bf66166926d1dc$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $71bf66166926d1dc$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $71bf66166926d1dc$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $71bf66166926d1dc$export$37f20f0ff732fcd7);

var $dJl1T = parcelRequire("dJl1T");
const { safeErrorWithoutCustomerData: $71bf66166926d1dc$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $71bf66166926d1dc$export$ea810ce67e3c8eac } = (0, $dJl1T.default);
const $71bf66166926d1dc$export$1f86472c1374185a = 40;
const $71bf66166926d1dc$export$7bd623b29ec8e1eb = 500;
const $71bf66166926d1dc$export$37f20f0ff732fcd7 = true;

});

parcelRegister("3GASE", function(module, exports) {

$parcel$export(module.exports, "loadBridgeBail", () => $e512b6cc4a8702e5$export$a036f92c2465504e);

var $wRU6t = parcelRequire("wRU6t");

var $fqWWz = parcelRequire("fqWWz");
const $e512b6cc4a8702e5$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $wRU6t.safeStringify)(error) ?? ''}`, {
            isSpa: __SPA__,
            name: name,
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error(`Unable to load bridge "${name}"`, {
            cause: error
        });
    }
};

});
parcelRegister("wRU6t", function(module, exports) {

$parcel$export(module.exports, "safeStringify", () => $7e2bd894031d4476$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7e2bd894031d4476$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});


parcelRegister("ig88W", function(module, exports) {

$parcel$export(module.exports, "loadBridgeRace", () => $64f1dbae1ea314ee$export$20c32b4579d78b92);

var $3GASE = parcelRequire("3GASE");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $64f1dbae1ea314ee$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $fqWWz.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>Promise.race([
        (0, $9B86Q.loadBridgeWeak)({
            name: name
        }),
        new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $3GASE.loadBridgeBail)({
                name: name,
                shouldLogError: shouldLogError
            }))
    ]);

});
parcelRegister("9B86Q", function(module, exports) {

$parcel$export(module.exports, "loadBridgeWeak", () => $61b2a5aa3a2a1160$export$3cefda82396756a1);

var $ifVVd = parcelRequire("ifVVd");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $61b2a5aa3a2a1160$var$pollingSingleton = null;
const $61b2a5aa3a2a1160$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $61b2a5aa3a2a1160$var$pollingSingleton ?? (0, $ifVVd.createPollingCollection)((v)=>window.require(v), 100);
    $61b2a5aa3a2a1160$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("ifVVd", function(module, exports) {

$parcel$export(module.exports, "createPollingCollection", () => $60e6b0d4bc46beac$export$f163446a982a8077);

var $gKZoD = parcelRequire("gKZoD");

var $aePFs = parcelRequire("aePFs");
const $60e6b0d4bc46beac$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $gKZoD.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $aePFs.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $aePFs.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("aePFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $02f3c6551bf5b1ff$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $02f3c6551bf5b1ff$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});




parcelRegister("7T84i", function(module, exports) {

$parcel$export(module.exports, "loadBridgeStrict", () => $89a95eb8b151782d$export$eba600d28decc4ac);

var $c56lL = parcelRequire("c56lL");

var $ig88W = parcelRequire("ig88W");

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $89a95eb8b151782d$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    (0, $c56lL.saveStats)(name, wrmKeys);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $fVOHM.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
        return (0, $ig88W.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError
        });
    }
};

});
parcelRegister("c56lL", function(module, exports) {

$parcel$export(module.exports, "saveStats", () => $6c875a5034ae8433$export$9ea3ff7978093559);
const $6c875a5034ae8433$var$incrementResourceStats = (resource, stats)=>{
    if (stats[resource] == null) // eslint-disable-next-line no-param-reassign
    stats[resource] = 1;
    else // eslint-disable-next-line no-param-reassign
    stats[resource] += 1;
};
const $6c875a5034ae8433$var$getEmptyLoadBridgeStats = ()=>({
        requests: 0,
        amdModules: {},
        wrmKeys: {}
    });
const $6c875a5034ae8433$var$initStats = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__WRM_INTERNAL_STATS__ == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__ = {
        loadBridge: $6c875a5034ae8433$var$getEmptyLoadBridgeStats()
    };
    else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__.loadBridge = $6c875a5034ae8433$var$getEmptyLoadBridgeStats();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WRM_INTERNAL_STATS__.loadBridge;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $6c875a5034ae8433$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
const $6c875a5034ae8433$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
    try {
        const stats = $6c875a5034ae8433$var$initStats();
        // stop accumulating stats at TTI mark
        if ($6c875a5034ae8433$var$isPageInteractive()) return;
        stats.requests += 1;
        $6c875a5034ae8433$var$incrementResourceStats(amdModuleName, stats.amdModules);
        if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$6c875a5034ae8433$var$incrementResourceStats(wrmKey, stats.wrmKeys));
        else if (wrmKeys != null) $6c875a5034ae8433$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // not critical functionality
    }
};

});

parcelRegister("fVOHM", function(module, exports) {

$parcel$export(module.exports, "loadWrmResources", () => $0c0552c7bb135144$export$6cda16b6eff75f59);

var $wRU6t = parcelRequire("wRU6t");

var $294PS = parcelRequire("294PS");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $0c0552c7bb135144$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $9B86Q.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $294PS.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("294PS", function(module, exports) {

$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $a437264dd6b89021$export$93d9db5fbabad1b0);

var $1r4rO = parcelRequire("1r4rO");
let $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = false;
const $a437264dd6b89021$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href.includes('secure/RapidBoard.jspa');
};
const $a437264dd6b89021$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($a437264dd6b89021$var$isSuperBatchDependenciesLoaded || $a437264dd6b89021$var$isOnRapidBoardsPage()) return wrmKeys;
    $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = true;
    return (0, $1r4rO.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("1r4rO", function(module, exports) {

$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $e87d6a02e2466ae8$export$f14a6b583ce9e077);
const $e87d6a02e2466ae8$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});




parcelRegister("cQZXC", function(module, exports) {

$parcel$export(module.exports, "waitForHeritage", () => $90def0f7a7aa11d6$export$c61060338d026f78);

var $7aBP4 = parcelRequire("7aBP4");

var $aePFs = parcelRequire("aePFs");
const $90def0f7a7aa11d6$export$c61060338d026f78 = ()=>{
    if (false) // WRM is not used on server
    // return null because we don't want to ?.then() chain into loadBridge functions
    return null;
    if (!__SPA__) // Heritage remainder is an SPA concept
    // return promise because we want to ?.then() chain into loadBridge functions
    return Promise.resolve();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.__WAIT_FOR_HERITAGE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WAIT_FOR_HERITAGE__ = new (0, $aePFs.default)();
        (0, $7aBP4.bootstrapWrmClient)().then(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__WAIT_FOR_HERITAGE__.resolve();
        });
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WAIT_FOR_HERITAGE__;
};

});
parcelRegister("7aBP4", function(module, exports) {

$parcel$export(module.exports, "bootstrapWrmClient", () => $f93199c7ae9c59d8$export$d001f71dd306cb0c);

var $7f4tk = parcelRequire("7f4tk");
const $f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT = '/rest/frontend/1/spawrmcontext';
const $f93199c7ae9c59d8$var$fetchSpaWrmContext = async ()=>{
    return (0, $7f4tk.default)($f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT);
};
const $f93199c7ae9c59d8$var$createResourceElement = ({ url: url, resourceType: resourceType, key: key, batchType: batchType })=>{
    let element;
    if (resourceType === 'JAVASCRIPT') {
        element = globalThis.document?.createElement('script');
        element.setAttribute('crossorigin', '');
        element.setAttribute('src', url);
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    } else {
        element = globalThis.document?.createElement('link');
        element.setAttribute('crossorigin', '');
        element.setAttribute('href', url);
        element.setAttribute('rel', 'stylesheet');
        element.setAttribute('media', 'all');
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    }
    return element;
};
let $f93199c7ae9c59d8$var$hasWrmInitialised;
const $f93199c7ae9c59d8$var$runBootstrap = ()=>{
    const spaWrmContext = $f93199c7ae9c59d8$var$fetchSpaWrmContext();
    return new Promise((resolve)=>{
        spaWrmContext.then(({ data: data, errors: errors, resources: resources })=>{
            // eslint-disable-next-line no-multi-assign
            const WRM = globalThis.WRM = globalThis.WRM || {};
            WRM._unparsedData = data;
            WRM._unparsedErrors = errors;
            if (WRM._dataArrived) WRM._dataArrived();
            resources.map($f93199c7ae9c59d8$var$createResourceElement).forEach((element)=>globalThis.document?.head.appendChild(element));
            resolve();
        });
    });
};
const $f93199c7ae9c59d8$export$d001f71dd306cb0c = ()=>{
    if (false) return Promise.resolve();
    if ($f93199c7ae9c59d8$var$hasWrmInitialised) return $f93199c7ae9c59d8$var$hasWrmInitialised;
    // todo maybe a more robust check to validate whether WRM initialisation already underway?
    if (typeof globalThis.WRM !== 'undefined') $f93199c7ae9c59d8$var$hasWrmInitialised = Promise.resolve();
    else $f93199c7ae9c59d8$var$hasWrmInitialised = $f93199c7ae9c59d8$var$runBootstrap();
    return $f93199c7ae9c59d8$var$hasWrmInitialised;
};

});


parcelRegister("8JNtu", function(module, exports) {

$parcel$export(module.exports, "wrmRequire", () => $17e2d7d864398bad$export$cc9d8f51375ef66a);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $17e2d7d864398bad$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError
    });

});

parcelRegister("5Ik5Y", function(module, exports) {

$parcel$export(module.exports, "wrmRequireWithPrefetch", () => $a1df1daee76d40f7$export$e53a5db19a39ed2f);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $a1df1daee76d40f7$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError,
        batchUrl: batchUrl
    });

});


parcelRegister("dH9DT", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $a78c52ec7ed5d025$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getJQuery", () => $a78c52ec7ed5d025$export$7232a6dc780f9887);
$parcel$export(module.exports, "getGlobalAP", () => $a78c52ec7ed5d025$export$fbc82125a6bd8012);
$parcel$export(module.exports, "isObject", () => $a78c52ec7ed5d025$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "escapeSelector", () => $a78c52ec7ed5d025$export$c8c0ea01c118c2eb);
$parcel$export(module.exports, "waitForJQuery", () => $a78c52ec7ed5d025$export$97214de9c546981c);
$parcel$export(module.exports, "ErrorDebugAddonKeys", () => $a78c52ec7ed5d025$export$d690da9bc8146677);

var $jcw0u = parcelRequire("jcw0u");

const $a78c52ec7ed5d025$export$c47913ca32a5c6f7 = (key)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
    return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
};
const $a78c52ec7ed5d025$export$7232a6dc780f9887 = ()=>AJS.$;
const $a78c52ec7ed5d025$export$fbc82125a6bd8012 = ()=>// In the future, we can add analytics events to know how this can fail to access the global variable.
    // We can improve it to load WRM in async
    // Just to add some context for future reviewers: `window._AP` is the actual Connect module that will no longer be loaded via WRM.
    // Its properties are both appended from modules like the dialog options and the public atlassian-connect-js library.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window._AP;
const $a78c52ec7ed5d025$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
const $a78c52ec7ed5d025$export$c8c0ea01c118c2eb = (s)=>{
    if (!s) throw new Error('No selector to escape');
    return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
};
const $a78c52ec7ed5d025$var$FIVE_MINUTES = 300000;
const $a78c52ec7ed5d025$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
        const interval = setInterval(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.AJS?.$) {
                clearInterval(interval);
                resolve();
            }
        }, 10);
        setTimeout(()=>{
            clearInterval(interval);
            (0, $jcw0u.default)({
                meta: {
                    id: 'connect-jquery-timeout',
                    packageName: 'jiraConnect'
                },
                error: new Error('Timeout when waiting for jQuery to be available on the page'),
                // this is an extremely common error, so we don't want to spam Sentry with it
                skipSentry: true
            });
            reject();
        }, $a78c52ec7ed5d025$var$FIVE_MINUTES);
    });
const $a78c52ec7ed5d025$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
const $a78c52ec7ed5d025$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
const $a78c52ec7ed5d025$export$d690da9bc8146677 = [
    $a78c52ec7ed5d025$export$cb954c21735b28e4,
    $a78c52ec7ed5d025$export$7315c38dc71bd41f
];

});

parcelRegister("3hUjN", function(module, exports) {

let $264ea540dc548cff$var$load = (parcelRequire("28QjX"))(4);
module.exports = $264ea540dc548cff$var$load("aVR4N").then(()=>parcelRequire('8vJyT'));

});



parcelRegister("aUk4j", function(module, exports) {

$parcel$export(module.exports, "default", () => $edf3f4c4729be8b6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $41Nl9 = parcelRequire("41Nl9");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $edf3f4c4729be8b6$var$AppIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.size === 'small' ? "_1bsbpxbi" : "_1bsbv47k",
            __cmplp.size === 'small' ? "_4t3ipxbi" : "_4t3iv47k",
            __cmplp.className
        ])
    });
});
const $edf3f4c4729be8b6$var$AppItemIcon = ({ url: url, size: size })=>url != null && String(url).trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($edf3f4c4729be8b6$var$AppIcon, {
        src: url,
        alt: "",
        size: size
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($41Nl9))), {
        label: "",
        spacing: size === 'small' ? 'none' : 'spacious',
        color: "currentColor",
        LEGACY_size: size
    });
var $edf3f4c4729be8b6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($edf3f4c4729be8b6$var$AppItemIcon);

});


parcelRegister("7GxxM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0abc8bedfd779118$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1eETS = parcelRequire("1eETS");

var $e0AC8 = parcelRequire("e0AC8");

var $aUk4j = parcelRequire("aUk4j");

var $hjSul = parcelRequire("hjSul");
const $0abc8bedfd779118$var$getForgeItemLink = (forgeItem, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(forgeItem.id);
    return `/jira/core/projects/${projectKey}/apps/${appId}/${envId}`;
};
const $0abc8bedfd779118$var$ForgeItem = ({ data: data, project: project, onItemClick: onItemClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eETS.default), {
        // @ts-expect-error - dropdown item is poorly typed and won't allow Link to be used even though it is compatible
        component: (0, $hjSul.Link),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aUk4j.default), {
            url: data.properties.icon
        }),
        onClick: onItemClick,
        href: $0abc8bedfd779118$var$getForgeItemLink(data, project.key),
        UNSAFE_shouldDisableRouterLink: true
    }, data.properties.title);
var $0abc8bedfd779118$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($0abc8bedfd779118$var$ForgeItem);

});


parcelRegister("lTLJa", function(module, exports) {

$parcel$export(module.exports, "ShortcutNavigationTab", () => $04817b66e85332a4$export$a6241dac1bfc71ae);

var $7pkaF = parcelRequire("7pkaF");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $j7m8K = parcelRequire("j7m8K");

var $hecDf = parcelRequire("hecDf");

var $hlGFI = parcelRequire("hlGFI");

var $k1ALc = parcelRequire("k1ALc");

var $lPApw = parcelRequire("lPApw");

var $4EVK0 = parcelRequire("4EVK0");

var $1vBwL = parcelRequire("1vBwL");

var $itmJb = parcelRequire("itmJb");

var $0ud4r = parcelRequire("0ud4r");
/**
 * @deprecated delete when cleaning up getWillShowNav4
 */ const $04817b66e85332a4$var$OldShortcutNavigationTab = ({ tabFragment: tabFragment, position: position, id: id, canEdit: canEdit, onHideTab: onHideTab, onTabClick: onTabClick, handleDrag: handleDrag, beforeItemId: beforeItemId, afterItemId: afterItemId, isSelected: isSelected = false })=>{
    const [{ data: shortcutItems }, actions] = (0, $k1ALc.useShortcutItems)();
    const { project: project } = (0, $hecDf.useNavigationProject)();
    const { data: featuresData } = (0, $lPApw.useFeatures)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const [isDropdownMenuOpen, setIsDropdownMenuOpen] = (0, $5uXOq.useState)(false);
    const tabData = (0, $8Uumt.useFragment)((0, $7pkaF.default), tabFragment);
    const canHideShortcuts = Boolean(tabData.canRemove);
    const canAddShortcuts = Boolean(featuresData?.hasAddItem);
    if (!project) return null;
    const handleDeleteView = ()=>{
        onHideTab({
            id: tabData?.id ?? null,
            relayId: tabData?.__id ?? null
        });
    };
    const trigger = ({ isSelected: isMenuOpen, onClick: onClick, triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4EVK0.default), {
            tabFragment: tabData,
            type: "dropdown-trigger",
            isSelected: isMenuOpen || isSelected,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0ud4r.TabIcon), {
                typeKey: "SHORTCUTS",
                label: "",
                size: "small"
            }),
            onClick: (event)=>{
                onClick && onClick(event);
                onTabClick('SHORTCUTS', {
                    childCount: shortcutItems.length
                });
            },
            position: position,
            id: id,
            ref: triggerRef,
            handleDrag: handleDrag,
            beforeItemId: beforeItemId,
            afterItemId: afterItemId,
            canEdit: canEdit,
            ...triggerProps
        });
    return(// ShortcutsApp expects items type to be NavigationItem, when useShortcutItems returns items with type ShortcutItem
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1vBwL.default), {
        // @ts-expect-error - TS2322
        methods: actions,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        items: shortcutItems,
        projectKey: project.key,
        projectId: project.id,
        isAdmin: isAdmin,
        canAddLinks: canAddShortcuts,
        canAddRepositories: false,
        baseUrl: ""
    }, ({ openAddModal: openAddModal, openEditModal: openEditModal })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j7m8K.default), {
            trigger: trigger,
            placement: "bottom-end",
            shouldFlip: false,
            isOpen: isDropdownMenuOpen,
            testId: "business-tabs.ui.simple-navigation-tab.shortcut-navigation-tab.dropdown-menu",
            onOpenChange: ()=>setIsDropdownMenuOpen((isDropdownMenuCurrent)=>!isDropdownMenuCurrent)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hlGFI.default), {
            canAddShortcuts: canAddShortcuts,
            onOpenAddModal: openAddModal,
            onOpenEditModal: openEditModal,
            onClose: ()=>setIsDropdownMenuOpen(false),
            onHideShortcuts: handleDeleteView,
            canHideShortcuts: canHideShortcuts
        }))));
};
const $04817b66e85332a4$export$a6241dac1bfc71ae = $04817b66e85332a4$var$OldShortcutNavigationTab;

});
parcelRegister("7pkaF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5677117660244f8a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b42acb21d89838bb1bc55fff2f0d4fdc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5677117660244f8a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "shortcutNavigationTab_businessTabs_OldShortcutNavigationTab",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_navigationKitTabOld_Tab"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "canRemove"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$5677117660244f8a$var$node.hash = "976a6a04f46be97f5b60fab212990714";
var $5677117660244f8a$export$2e2bcd8739ae039 = $5677117660244f8a$var$node;

});

parcelRegister("hlGFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $45348ddfa6681dc3$export$2e2bcd8739ae039);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $2w90g = parcelRequire("2w90g");

var $eo0PI = parcelRequire("eo0PI");
const $45348ddfa6681dc3$var$entryPointParams = {};
const $45348ddfa6681dc3$var$AsyncShortcutMenuContent = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $2w90g.ShortcutMenuContentEntryPoint), $45348ddfa6681dc3$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($45348ddfa6681dc3$var$ShortcutMenuContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.shortcut.shortcuts-menu-content",
        packageName: "jiraBusinessShortcut",
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eo0PI.Fallback), null)
    }));
};
var $45348ddfa6681dc3$export$2e2bcd8739ae039 = $45348ddfa6681dc3$var$AsyncShortcutMenuContent;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $45348ddfa6681dc3$var$ShortcutMenuContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul91gwv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2w90g", function(module, exports) {

$parcel$export(module.exports, "ShortcutMenuContentEntryPoint", () => $bde9d05e849edf11$export$de0921feb8dcb7b7);

var $aNsVT = parcelRequire("aNsVT");

var $3rdd7 = parcelRequire("3rdd7");

const $bde9d05e849edf11$export$de0921feb8dcb7b7 = (0, $3rdd7.createEntryPoint)({
    root: (0, $aNsVT.JSResourceForInteraction)(()=>(parcelRequire("e4myZ")).then((module)=>module.ShortcutContentForEntrypoint), {
        moduleId: "7af2069d"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("e4myZ", function(module, exports) {

let $a3e2f1073a4ae578$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a3e2f1073a4ae578$var$load("dsiAd"),
    $a3e2f1073a4ae578$var$load("cM9em"),
    $a3e2f1073a4ae578$var$load("fr9NE"),
    $a3e2f1073a4ae578$var$load("h2MrD"),
    $a3e2f1073a4ae578$var$load("bYT2S"),
    $a3e2f1073a4ae578$var$load("hPzOn"),
    $a3e2f1073a4ae578$var$load("jsvfr")
]).then(()=>parcelRequire('d8H0p'));

});


parcelRegister("eo0PI", function(module, exports) {

$parcel$export(module.exports, "Fallback", () => $e1c5cdec25d6fa94$export$fb8d7f40caaeea67);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $clxo5 = parcelRequire("clxo5");

var $fQdZB = parcelRequire("fQdZB");
const $e1c5cdec25d6fa94$export$fb8d7f40caaeea67 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $e1c5cdec25d6fa94$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
        size: "medium"
    }));
const $e1c5cdec25d6fa94$var$wrapperStyles = (0, $2s57o.xcss)({
    height: '240px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $fQdZB.SHORTCUT_MENU_ITEM_BASE_WIDTH)}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});

});
parcelRegister("fQdZB", function(module, exports) {

$parcel$export(module.exports, "SHORTCUT_MENU_ITEM_BASE_WIDTH", () => $f5a59074e7863dc5$export$69c209761db64142);
$parcel$export(module.exports, "MAIN_EXPERIENCE", () => $f5a59074e7863dc5$export$b3d8a68bfc68a411);
$parcel$export(module.exports, "SHORTCUT_EMBED_EXPERIENCE", () => $f5a59074e7863dc5$export$f6967bfd4a1993af);
const $f5a59074e7863dc5$export$69c209761db64142 = 360;
const $f5a59074e7863dc5$export$8876f5d532b0d2ab = 196;
const $f5a59074e7863dc5$export$965026a4c38e5545 = 86;
const $f5a59074e7863dc5$var$PACKAGE_NAME = 'jiraBusinessShortcut';
const $f5a59074e7863dc5$export$b3d8a68bfc68a411 = {
    experience: 'shortcut',
    experienceId: 'main',
    packageName: $f5a59074e7863dc5$var$PACKAGE_NAME,
    teamName: 'jira-warepil'
};
const $f5a59074e7863dc5$export$f6967bfd4a1993af = {
    experience: 'shortcutEmbed',
    packageName: $f5a59074e7863dc5$var$PACKAGE_NAME,
    teamName: 'jira-warepil'
};

});



parcelRegister("1vBwL", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e55df98ec766a24$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $6P0Kj = parcelRequire("6P0Kj");

var $7T84i = parcelRequire("7T84i");
var $cQZXC = parcelRequire("cQZXC");

var $dJl1T = parcelRequire("dJl1T");

var $b71gk = parcelRequire("b71gk");

var $4R6GH = parcelRequire("4R6GH");

var $lfTZh = parcelRequire("lfTZh");

var $g5X3G = parcelRequire("g5X3G");

var $b7Svb = parcelRequire("b7Svb");
var $Ix35T = parcelRequire("Ix35T");


var $lkWkR = parcelRequire("lkWkR");

const $0e55df98ec766a24$export$220dc4f1b8ffa17c = (0, $b7Svb.lazy)(()=>(parcelRequire("jA4Dc")), {
    moduleId: "./src/packages/navigation-apps/shortcuts/src/add-link-modal/index.tsx"
});

const $0e55df98ec766a24$export$f4f22b2fa38658d6 = (0, $b7Svb.lazy)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("aiSFl")), {
    moduleId: "./src/packages/navigation-apps/shortcuts/src/main/view/add-item/index.tsx"
});

const $0e55df98ec766a24$export$f525b7ef0c89cbed = (0, $b7Svb.lazy)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("2EZdp")), {
    moduleId: "./src/packages/navigation-apps/shortcuts/src/main/view/add-item-v2/index.tsx"
});

const $0e55df98ec766a24$export$234ec8e31562766c = (0, $b7Svb.lazy)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("aFtLa")), {
    moduleId: "./src/packages/navigation-apps/shortcuts/src/main/view/edit-shortcut-modal/index.tsx"
});

const $0e55df98ec766a24$export$14ff0695ca26505c = (0, $b7Svb.lazy)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("67YVY")), {
    moduleId: "./src/packages/navigation-apps/shortcuts/src/manage-pages-link-modal/index.tsx"
});
const $0e55df98ec766a24$var$MODAL_ANIMATION_DELAY = 500;
const $0e55df98ec766a24$var$renderShortcutIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6P0Kj))), {
        spacing: "spacious",
        label: ""
    });
const $0e55df98ec766a24$var$findRepoShortcuts = (items)=>items.filter((i)=>i.shortcutType === (0, $27f32c1fbb856eaf$export$399c7e6858236b4));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0e55df98ec766a24$var$toItem = (link)=>{
    // We cannot create shortcuts with legacyId as it would exclude them from the list of navigation items -
    // they don't exist in the sidebar config we've fetched before
    const { legacyId: legacyId, ...withoutLegacyId } = (0, $lkWkR.getItemFromLink)(link);
    return {
        ...withoutLegacyId,
        onEditClick: ()=>setTimeout(()=>link.onEditClick()),
        onSyncClick: link.onSyncClick
    };
};
class $0e55df98ec766a24$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isSpa: false,
            isAdmin: false,
            canAddLinks: true,
            canAddRepositories: false,
            showPagesSelector: true,
            items: []
        };
    }
    constructor(props){
        super(props), this.addItemButtonRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.onAddItem = ()=>{
            if (this.props.canAddLinks && !this.state.canAddRepositories) this.onAddLink();
            else if (this.state.canAddRepositories && !this.props.canAddLinks) this.onAddRepository();
            else this.setState({
                addItem: {
                    type: undefined
                }
            });
        }, this.onAddLink = ()=>{
            // if a modal is already open, close it and open the add link modal
            // with a delay to ensure the modal is closed before opening the new one
            if (this.state.addItem) {
                this.setState({
                    addItem: undefined
                });
                // wait for the modal to close before opening the next modal
                setTimeout(()=>{
                    this.setState({
                        addItem: {
                            type: 'link'
                        }
                    });
                }, $0e55df98ec766a24$var$MODAL_ANIMATION_DELAY);
            } else this.setState({
                addItem: {
                    type: 'link'
                }
            });
        }, this.onAddRepository = ()=>{
            this.setState(()=>({
                    addItem: undefined
                }));
            setTimeout(()=>{
                if (typeof this.repositoryApi.add === 'function') this.repositoryApi.add();
                else (0, $dJl1T.default).safeErrorWithoutCustomerData('navigation-next.shortcuts.repository', "Cannot open add repository shortcut modal - the API wan't set up");
            }, $0e55df98ec766a24$var$MODAL_ANIMATION_DELAY);
        }, this.onAddItemCompleted = ({ item: item })=>{
            if (item) this.props.methods.addItem({
                ...item,
                target: '_blank',
                canEdit: true,
                before: $0e55df98ec766a24$var$renderShortcutIcon
            });
            this.setState(()=>{
                return {
                    addItem: undefined
                };
            }, ()=>{
                if (this.addItemButtonRef?.current) this.addItemButtonRef.current.focus();
            });
        }, this.onEditOrDeleteItem = (id, ref)=>{
            if (ref) this.setState({
                editOrDeleteItem: id,
                editShortcutButtonRef: ref
            });
            else this.setState({
                editOrDeleteItem: id
            });
        }, this.openManagePagesLinkModal = ()=>{
            this.setState({
                isPagesModalOpen: true
            });
        }, this.closeManagePagesLinkModal = ()=>{
            this.setState({
                isPagesModalOpen: false
            });
        }, this.onEditOrDeleteItemCompleted = (args)=>{
            const { item: item, deleted: deleted } = args;
            if (item) deleted ? this.props.methods.deleteItem(item.id) : this.props.methods.editItem(item);
            this.setState(()=>{
                return {
                    editOrDeleteItem: undefined,
                    editShortcutButtonRef: undefined
                };
            });
        }, this.setPagesLink = ({ setPagesLink: setPagesLink })=>(isEnabled)=>{
                const { baseUrl: baseUrl, projectKey: projectKey } = this.props;
                return setPagesLink({
                    baseUrl: (0, $g5X3G.toBaseUrl)(baseUrl),
                    projectKey: (0, $g5X3G.toProjectKey)(projectKey),
                    enable: isEnabled
                });
            }, this.repositoryApi = {};
        this.state = {
            canAddRepositories: props.canAddRepositories,
            addItem: undefined,
            editOrDeleteItem: undefined,
            isPagesModalOpen: false,
            editShortcutButtonRef: undefined
        };
        if (props.canAddRepositories) this.initLegacyBridgeAPI();
    }
    componentDidMount() {
        if ((0, $4R6GH.fg)('jsw_simplify_navigation_m2_gate')) this.showModalIfAddShortcutClickedFromAddView();
    }
    componentDidUpdate(prevProps) {
        if ((0, $4R6GH.fg)('jsw_simplify_navigation_m2_gate')) {
            if (this.props.isModalOpenViaAddView !== prevProps.isModalOpenViaAddView) this.showModalIfAddShortcutClickedFromAddView();
        }
    }
    showModalIfAddShortcutClickedFromAddView() {
        if (this.props.isModalOpenViaAddView === true) {
            this.onAddItem();
            this.props.setIsModalOpenViaAddView?.(false);
        }
    }
    initLegacyBridgeAPI() {
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $cQZXC.waitForHeritage)()?.then(()=>// eslint-disable-next-line jira/wrm/no-load-bridge
            (0, $7T84i.loadBridgeStrict)({
                name: 'repository-shortcuts/navigation-next',
                wrmKeys: [
                    'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:repository-shortcuts-navigation-next'
                ]
            })) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ?.then((init)=>{
            const { methods: methods, items: items, projectKey: projectKey, projectId: projectId, isAdmin: isAdmin } = this.props;
            this.repositoryApi = init({
                shortcuts: $0e55df98ec766a24$var$findRepoShortcuts(items),
                // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
                onAdd: (item)=>methods.addItem($0e55df98ec766a24$var$toItem(item)),
                // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
                onEdit: (item)=>methods.editItem($0e55df98ec766a24$var$toItem(item)),
                // @ts-expect-error - TS7006 - Parameter 'id' implicitly has an 'any' type.
                onDelete: (id)=>methods.deleteItem((0, $lkWkR.getIdFromLinkId)(id)),
                // @ts-expect-error - TS7006 - Parameter 'itemBulk' implicitly has an 'any' type.
                onBulkEdit: (itemBulk)=>// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
                    methods.editItems(itemBulk.map((item)=>$0e55df98ec766a24$var$toItem(item))),
                projectKey: projectKey,
                projectId: projectId,
                isAdmin: isAdmin
            });
        }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ?.catch((e)=>{
            this.setState({
                canAddRepositories: false
            });
            (0, $dJl1T.default).safeErrorWithoutCustomerData('navigation-next.shortcuts.repository', 'There was a problem loading or integrating with repository shortcuts', e);
        });
    }
    render() {
        const { children: children, baseUrl: baseUrl, pagesLink: pagesLink, projectKey: projectKey, items: items, showPagesSelector: showPagesSelector } = this.props;
        const { editOrDeleteItem: editOrDeleteItem, addItem: addItem, isPagesModalOpen: isPagesModalOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children({
            data: {
                shortcuts: items
            },
            openAddModal: this.onAddItem,
            openEditModal: this.onEditOrDeleteItem,
            openManagePagesLinkModal: pagesLink ? this.openManagePagesLinkModal : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            addItemButtonRef: this.addItemButtonRef
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
            id: "shortcuts-modal",
            packageName: "jiraNavigationShortcuts"
        }, pagesLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Ix35T.LazyWait), {
            until: (0, $4R6GH.fg)('nav_prevent_eager_manage_pages_modal') ? isPagesModalOpen === true : isPagesModalOpen != null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "manage-pages-link-modal",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0e55df98ec766a24$export$14ff0695ca26505c, {
            config: {
                isPagesLinkEnabled: pagesLink.isEnabled,
                setPagesLink: this.setPagesLink(pagesLink)
            },
            isOpen: isPagesModalOpen,
            onClose: this.closeManagePagesLinkModal
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Ix35T.LazyWait), {
            until: addItem != null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "add-item-modal",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
        }, pagesLink ? // add shortcut modal
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0e55df98ec766a24$export$f525b7ef0c89cbed, {
            addItem: addItem,
            baseUrl: baseUrl,
            pages: {
                isEnabled: pagesLink.isEnabled,
                setPagesLink: this.setPagesLink(pagesLink)
            },
            projectKey: projectKey,
            onAddItemCompleted: this.onAddItemCompleted,
            onAddLink: this.onAddLink,
            onAddRepo: this.onAddRepository,
            showPagesSelector: showPagesSelector,
            addItemButtonRef: this.addItemButtonRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0e55df98ec766a24$export$f4f22b2fa38658d6, {
            addItem: addItem,
            baseUrl: baseUrl,
            projectKey: projectKey,
            onAddItemCompleted: this.onAddItemCompleted,
            onAddLink: this.onAddLink,
            onAddRepo: this.onAddRepository
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Ix35T.LazyWait), {
            until: editOrDeleteItem != null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "edit-shortcut-modal",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0e55df98ec766a24$export$234ec8e31562766c, {
            baseUrl: baseUrl,
            projectKey: projectKey,
            editOrDeleteItem: editOrDeleteItem,
            items: items,
            editOrDeleteItemCompleted: this.onEditOrDeleteItemCompleted,
            editButtonRef: this.state.editShortcutButtonRef
        })))));
    }
}

});
const $27f32c1fbb856eaf$export$399c7e6858236b4 = 'source.code.link';
const $27f32c1fbb856eaf$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
const $27f32c1fbb856eaf$export$3746846b4d8615c3 = 'INVALID_URL';

parcelRegister("lkWkR", function(module, exports) {

$parcel$export(module.exports, "getIdFromLinkId", () => $74dd3faace70a053$export$3cec694c50bc695d);
$parcel$export(module.exports, "getItemFromLink", () => $74dd3faace70a053$export$60d4c4ef6da272ad);

var $5uXOq = parcelRequire("5uXOq");

var $ixUGT = parcelRequire("ixUGT");

var $hYfgW = parcelRequire("hYfgW");

var $32ra4 = parcelRequire("32ra4");

var $a8Wzb = parcelRequire("a8Wzb");

var $h6M2t = parcelRequire("h6M2t");
const $74dd3faace70a053$var$getLinkParts = (linkId)=>linkId.split(':')[1].split('.');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $74dd3faace70a053$var$SizedBitBucketIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h6M2t.BitbucketIcon), {
        ...props,
        size: "small"
    });
const $74dd3faace70a053$export$16b26cd5e98d9100 = (iconName)=>{
    switch(iconName){
        case 'bitbucket':
            return $74dd3faace70a053$var$SizedBitBucketIcon;
        case 'github':
        case 'repos':
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
            return 0, (/*@__PURE__*/$parcel$interopDefault($32ra4));
        default:
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
            return 0, (/*@__PURE__*/$parcel$interopDefault($a8Wzb));
    }
};
const $74dd3faace70a053$export$3cec694c50bc695d = (linkId)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($74dd3faace70a053$var$getLinkParts(linkId));
const $74dd3faace70a053$export$92a97f8239a551c5 = (linkId)=>(0, (/*@__PURE__*/$parcel$interopDefault($ixUGT)))($74dd3faace70a053$var$getLinkParts(linkId)).join('.');
const $74dd3faace70a053$export$60d4c4ef6da272ad = (link)=>{
    const { id: linkId, icon: icon } = link;
    const id = $74dd3faace70a053$export$3cec694c50bc695d(linkId);
    const shortcutType = $74dd3faace70a053$export$92a97f8239a551c5(linkId);
    const target = link.target || '_blank';
    const Icon = $74dd3faace70a053$export$16b26cd5e98d9100(icon);
    return {
        type: 'Item',
        id: id,
        icon: icon,
        legacyId: linkId,
        target: target,
        shortcutType: shortcutType,
        text: link.name,
        before: Icon,
        href: link.url,
        canEdit: link.canEdit,
        showSync: link.showSync,
        itemType: 'shortcut'
    };
};

});

parcelRegister("jA4Dc", function(module, exports) {

let $e414f8ca3f5a3ebd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e414f8ca3f5a3ebd$var$load("9aYrW").then(()=>parcelRequire('1KSRk'));

});

parcelRegister("aiSFl", function(module, exports) {

let $7805fd52d29baf3f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7805fd52d29baf3f$var$load("lw2WF").then(()=>parcelRequire('283Hr'));

});

parcelRegister("2EZdp", function(module, exports) {

let $1efecd478bb26902$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1efecd478bb26902$var$load("hVh0q").then(()=>parcelRequire('kSuJt'));

});

parcelRegister("aFtLa", function(module, exports) {

let $7c44d1638e625f20$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7c44d1638e625f20$var$load("bpNdl").then(()=>parcelRequire('5h9Nf'));

});

parcelRegister("67YVY", function(module, exports) {

let $4762a9c73f87d768$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4762a9c73f87d768$var$load("lVTe9").then(()=>parcelRequire('bw5U3'));

});




parcelRegister("6nk5B", function(module, exports) {

$parcel$export(module.exports, "useHideNavigationItem", () => $bc3578f8016f2d5b$export$f81bcd521f99d535);

var $bZXvp = parcelRequire("bZXvp");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $eCBf9 = parcelRequire("eCBf9");

var $lpwtK = parcelRequire("lpwtK");

var $jafiA = parcelRequire("jafiA");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $9OXo1 = parcelRequire("9OXo1");

var $jASP5 = parcelRequire("jASP5");
const $bc3578f8016f2d5b$export$b8b9d90f9e5bd72b = 'jiraNavigationKitHideItemService';
const $bc3578f8016f2d5b$export$6d6eb6668e23e980 = 'hideView';
const $bc3578f8016f2d5b$export$ab511d8a11c8295c = {
    experience: $bc3578f8016f2d5b$export$6d6eb6668e23e980
};
const $bc3578f8016f2d5b$var$NON_ADMIN_ERROR = 'User is not an admin';
const $bc3578f8016f2d5b$var$getFlagDetails = (error)=>{
    const { message: message } = error;
    const { statusCode: statusCode } = error.extensions || {};
    switch(statusCode){
        case 401:
            return {
                type: 'error',
                title: (0, $jASP5.default).userNotLoggedInErrorFlagTitle,
                description: (0, $jASP5.default).userNotLoggedInErrorFlagDescription,
                messageId: 'navigation-kit-hide-item-service-old.services.flag.error.user-not-logged-in-error',
                messageType: 'transactional'
            };
        case 403:
            if (message === $bc3578f8016f2d5b$var$NON_ADMIN_ERROR) return {
                type: 'error',
                title: (0, $jASP5.default).userNotAdminErrorFlagTitle,
                description: (0, $jASP5.default).userNotAdminErrorFlagDescription,
                messageId: 'navigation-kit-hide-item-service-old.services.flag.error.user-not-admin-error',
                messageType: 'transactional'
            };
            return null;
        case 404:
            return {
                type: 'error',
                title: (0, $jASP5.default).viewNotFoundErrorFlagTitle,
                description: (0, $jASP5.default).viewNotFoundErrorFlagDescription,
                messageId: 'navigation-kit-hide-item-service-old.services.flag.error.view-not-found-error',
                messageType: 'transactional'
            };
        default:
            return null;
    }
};
const $bc3578f8016f2d5b$export$f81bcd521f99d535 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { data: project } = (0, $lpwtK.useProject)();
    const projectIdOrKey = String(project?.key || project?.id);
    const onStartExperience = (0, $kaHBi.useExperienceStart)({
        ...$bc3578f8016f2d5b$export$ab511d8a11c8295c,
        analyticsSource: $bc3578f8016f2d5b$export$b8b9d90f9e5bd72b
    });
    const experienceAttributes = (0, $5uXOq.useMemo)(()=>({
            ...$bc3578f8016f2d5b$export$ab511d8a11c8295c,
            attributes: {
                withContainerNav: false
            }
        }), []);
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)(experienceAttributes);
    const onExperienceFail = (0, $93jKl.useExperienceFail)(experienceAttributes);
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $bZXvp.default));
    const updater = (0, $5uXOq.useCallback)((store, response, navigationItemRelayId)=>{
        if (response?.jira?.deleteNavigationItem == null) return;
        const { success: success, navigationItem: navigationItem } = response.jira.deleteNavigationItem;
        if (!success || navigationItem == null) return;
        const connectionRecord = (0, $jafiA.getConnection)(store, cloudId, projectIdOrKey);
        if (!connectionRecord || navigationItemRelayId == null) return;
        (0, $8Uumt.ConnectionHandler).deleteNode(connectionRecord, navigationItemRelayId);
    }, [
        cloudId,
        projectIdOrKey
    ]);
    const onError = (0, $5uXOq.useCallback)((error)=>{
        showFlag({
            messageId: 'navigation-kit-hide-item-service-old.services.show-flag.error.hide-navigation-item-default-error',
            messageType: 'transactional',
            type: 'error',
            title: formatMessage((0, $jASP5.default).hideNavigationItemDefaultErrorFlagTitle),
            description: formatMessage((0, $jASP5.default).hideNavigationItemDefaultErrorFlagDescription)
        });
        (0, $jcw0u.default)({
            meta: {
                id: $bc3578f8016f2d5b$export$6d6eb6668e23e980,
                packageName: $bc3578f8016f2d5b$export$b8b9d90f9e5bd72b,
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail($bc3578f8016f2d5b$export$b8b9d90f9e5bd72b, error);
    }, [
        formatMessage,
        onExperienceFail,
        showFlag
    ]);
    return (0, $5uXOq.useCallback)(({ id: id, relayId: relayId, onCompleted: onCompleted })=>{
        if (id == null) return;
        onStartExperience();
        commitMutation({
            variables: {
                input: {
                    id: id
                }
            },
            optimisticResponse: {
                jira: {
                    deleteNavigationItem: {
                        success: true,
                        navigationItem: id,
                        errors: null
                    }
                }
            },
            optimisticUpdater: (store, response)=>{
                updater(store, response, relayId);
            },
            updater: (store, response)=>{
                updater(store, response, relayId);
                if (response?.jira?.deleteNavigationItem?.success) {
                    const itemTypeKey = store.get(String(relayId))?.getValue('typeKey');
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewItem removed', {
                        viewType: String(itemTypeKey).toLowerCase()
                    });
                }
            },
            onError: onError,
            onCompleted: (response)=>{
                const { errors: errors } = response?.jira?.deleteNavigationItem ?? {};
                if (errors) {
                    const error = new (0, $eCBf9.MutationError)(errors[0]);
                    const statusCode = error.statusCode;
                    if (statusCode != null) {
                        const flagDetails = $bc3578f8016f2d5b$var$getFlagDetails(error);
                        if (flagDetails) {
                            showFlag(flagDetails);
                            onExperienceSuccess();
                            return;
                        }
                    }
                    onError(error);
                    return;
                }
                onExperienceSuccess();
                onCompleted();
            }
        });
    }, [
        commitMutation,
        createAnalyticsEvent,
        onError,
        onExperienceSuccess,
        onStartExperience,
        showFlag,
        updater
    ]);
};

});
parcelRegister("bZXvp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c01cf54797d5738$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<70c67b6570c098fc1613cf4ce604c4aa>>
 * @relayHash 4401cb7dab7b41592659dd4079c4d015
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 05f4591e39f7bca12c87ea039270e468be56dc943fd588c38b71adfb1abbfa4c
const $8c01cf54797d5738$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "navigationItem"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "servicesHideNavigationItemOldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDeleteNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "deleteNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "servicesHideNavigationItemOldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDeleteNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "deleteNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "05f4591e39f7bca12c87ea039270e468be56dc943fd588c38b71adfb1abbfa4c",
            "metadata": {},
            "name": "servicesHideNavigationItemOldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$8c01cf54797d5738$var$node.hash = "c64217753967f6ae1b972a37898f837f";
var $8c01cf54797d5738$export$2e2bcd8739ae039 = $8c01cf54797d5738$var$node;

});

parcelRegister("jafiA", function(module, exports) {

$parcel$export(module.exports, "getRouteForViewType", () => $a03cc82cfce26759$export$354a3334a0b30da2);
$parcel$export(module.exports, "getConnection", () => $a03cc82cfce26759$export$26b2f38d0fc342a3);

var $eiowN = parcelRequire("eiowN");

var $4R6GH = parcelRequire("4R6GH");
const $a03cc82cfce26759$var$JIRA_BUSINESS_BASE_PROJECT_URL = '/jira/core/projects';
const $a03cc82cfce26759$export$354a3334a0b30da2 = (projectKey, itemTypeKey)=>{
    switch(itemTypeKey){
        case 'SUMMARY':
            return `${$a03cc82cfce26759$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/summary`;
        case 'BOARD':
            return `${$a03cc82cfce26759$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/board`;
        case 'LIST':
            return `${$a03cc82cfce26759$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/list`;
        case 'TIMELINE':
            return `${$a03cc82cfce26759$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/timeline`;
        case 'CALENDAR':
            return `${$a03cc82cfce26759$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/calendar`;
        case 'FORMS':
            return `${$a03cc82cfce26759$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/form`;
        case 'APPROVALS':
            return `${$a03cc82cfce26759$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/approvals`;
        case 'ATTACHMENTS':
            return `${$a03cc82cfce26759$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/attachments`;
        case 'PAGES':
            return `${$a03cc82cfce26759$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/pages`;
        case 'ISSUES':
            return `${$a03cc82cfce26759$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/issues`;
        case 'REPORTS':
            return (0, $4R6GH.fg)('reports-overview-page-migration') ? `${$a03cc82cfce26759$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/reports` : `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`;
        case 'COMPONENTS':
            return `${$a03cc82cfce26759$var$JIRA_BUSINESS_BASE_PROJECT_URL}/${projectKey}/components`;
        default:
            return undefined;
    }
};
const $a03cc82cfce26759$export$26b2f38d0fc342a3 = (store, cloudId, projectIdOrKey)=>{
    const parentRecord = store.getRoot().getLinkedRecord('jira');
    if (parentRecord == null) return undefined;
    return (0, $eiowN.ConnectionHandler).getConnection(parentRecord, 'tabs_jiraNavigation__navigationItems', {
        cloudId: cloudId,
        projectIdOrKey: projectIdOrKey
    });
};
const $a03cc82cfce26759$export$137f3eb02a91737e = (store, cloudId, projectIdOrKey)=>{
    const connection = $a03cc82cfce26759$export$26b2f38d0fc342a3(store, cloudId, projectIdOrKey);
    if (!connection) return undefined;
    return connection.getLinkedRecords('edges');
};
const $a03cc82cfce26759$export$58da6593ae071994 = (store, cloudId, projectIdOrKey)=>{
    const edges = $a03cc82cfce26759$export$137f3eb02a91737e(store, cloudId, projectIdOrKey);
    if (!edges) return [];
    return edges.map((edge)=>{
        const node = edge?.getLinkedRecord('node');
        const tabId = node?.getValue('appId');
        return {
            itemType: String(node?.getValue('typeKey')).toLowerCase(),
            itemId: tabId ? String(tabId) : undefined,
            // relay will have already updated the changed item, exclude the new default to restore the original values
            defaultTab: Boolean(node?.getValue('isDefault'))
        };
    });
};

});

parcelRegister("jASP5", function(module, exports) {

$parcel$export(module.exports, "default", () => $595941131c6b2fae$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $595941131c6b2fae$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    hideNavigationItemDefaultErrorFlagTitle: {
        "id": "navigation-kit-hide-item-service-old.services.hide-navigation-item-default-error-flag-title",
        "defaultMessage": "Something's gone wrong"
    },
    hideNavigationItemDefaultErrorFlagDescription: {
        "id": "navigation-kit-hide-item-service-old.services.hide-navigation-item-default-error-flag-description",
        "defaultMessage": "Refresh the page and try again."
    },
    userNotLoggedInErrorFlagTitle: {
        "id": "navigation-kit-hide-item-service-old.services.user-not-logged-in-error-flag-title",
        "defaultMessage": "You'll need to log in"
    },
    userNotLoggedInErrorFlagDescription: {
        "id": "navigation-kit-hide-item-service-old.services.user-not-logged-in-error-flag-description",
        "defaultMessage": "You need to be logged in to manage the navigation. Please log in and try again."
    },
    userNotAdminErrorFlagTitle: {
        "id": "navigation-kit-hide-item-service-old.services.user-not-admin-error-flag-title",
        "defaultMessage": "You don't have permission"
    },
    userNotAdminErrorFlagDescription: {
        "id": "navigation-kit-hide-item-service-old.services.user-not-admin-error-flag-description",
        "defaultMessage": "Only project admins can manage the navigation."
    },
    viewNotFoundErrorFlagTitle: {
        "id": "navigation-kit-hide-item-service-old.services.view-not-found-error-flag-title",
        "defaultMessage": "This tab has been removed"
    },
    viewNotFoundErrorFlagDescription: {
        "id": "navigation-kit-hide-item-service-old.services.view-not-found-error-flag-description",
        "defaultMessage": "The tab you're trying to remove can't be found."
    }
});

});



parcelRegister("iJvdU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d46f2e76bf1769ab$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d46f2e76bf1769ab$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tabGroup: {
        "id": "navigation-kit-tab-list-old.tab-group",
        "defaultMessage": "Project view"
    },
    projectNavigation: {
        "id": "navigation-kit-tab-list-old.project-navigation",
        "defaultMessage": "Project Navigation"
    }
});

});


parcelRegister("l3f0R", function(module, exports) {

$parcel$export(module.exports, "tabsConfiguration", () => $1cf894fead65ac85$export$9b209feccba8ab55);

var $5uXOq = parcelRequire("5uXOq");

var $lgPyf = parcelRequire("lgPyf");

var $ddl7e = parcelRequire("ddl7e");

var $3pK7p = parcelRequire("3pK7p");

var $d0RKL = parcelRequire("d0RKL");

var $aqJO7 = parcelRequire("aqJO7");

var $2VmPP = parcelRequire("2VmPP");

var $4KUYb = parcelRequire("4KUYb");

var $fxg6i = parcelRequire("fxg6i");

var $ef9tG = parcelRequire("ef9tG");

var $9bNK0 = parcelRequire("9bNK0");

var $cQJCJ = parcelRequire("cQJCJ");

var $5P2bV = parcelRequire("5P2bV");

var $044lR = parcelRequire("044lR");

var $fVgSt = parcelRequire("fVgSt");

var $4HiZI = parcelRequire("4HiZI");

var $c9NFd = parcelRequire("c9NFd");

var $jri1L = parcelRequire("jri1L");

var $k11Fy = parcelRequire("k11Fy");

var $21JTp = parcelRequire("21JTp");

var $bwCQX = parcelRequire("bwCQX");

var $aZEzT = parcelRequire("aZEzT");

var $bU94A = parcelRequire("bU94A");

var $9a8PH = parcelRequire("9a8PH");

var $fGlXq = parcelRequire("fGlXq");

var $ivrMo = parcelRequire("ivrMo");

var $3pzqk = parcelRequire("3pzqk");

var $gafcx = parcelRequire("gafcx");

var $ad6tu = parcelRequire("ad6tu");

var $1X4ga = parcelRequire("1X4ga");

var $sQUnj = parcelRequire("sQUnj");

var $5EY5v = parcelRequire("5EY5v");

var $gS64m = parcelRequire("gS64m");

var $hR0XV = parcelRequire("hR0XV");

var $833ck = parcelRequire("833ck");
const $1cf894fead65ac85$export$5d9709eb58866a62 = {
    SUMMARY: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3pK7p))), {
            ...props,
            color: "currentColor",
            spacing: props.size === 'small' ? 'none' : 'spacious',
            LEGACY_size: props.size,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ef9tG)))
        }),
    BOARD: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aqJO7))), {
            ...props,
            color: "currentColor",
            spacing: props.size === 'small' ? 'none' : 'spacious',
            LEGACY_size: props.size
        }),
    LIST: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c9NFd))), {
            ...props,
            color: "currentColor",
            spacing: props.size === 'small' ? 'none' : 'spacious',
            LEGACY_size: props.size,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($044lR)))
        }),
    TIMELINE: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fVgSt))), {
            ...props,
            color: "currentColor",
            spacing: props.size === 'small' ? 'none' : 'spacious',
            LEGACY_size: props.size
        }),
    CALENDAR: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2VmPP))), {
            ...props,
            color: "currentColor",
            spacing: props.size === 'small' ? 'none' : 'spacious',
            LEGACY_size: props.size
        }),
    FORMS: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ddl7e))), {
            ...props,
            color: "currentColor",
            spacing: props.size === 'small' ? 'none' : 'spacious',
            LEGACY_size: props.size,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jri1L)))
        }),
    APPROVALS: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9bNK0))), {
            ...props,
            color: "currentColor",
            spacing: props.size === 'small' ? 'none' : 'spacious',
            LEGACY_size: props.size
        }),
    ATTACHMENTS: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d0RKL))), {
            ...props,
            color: "currentColor",
            spacing: props.size === 'small' ? 'none' : 'spacious',
            LEGACY_size: props.size
        }),
    PAGES: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4HiZI))), {
            ...props,
            color: "currentColor",
            spacing: props.size === 'small' ? 'none' : 'spacious',
            LEGACY_size: props.size,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($k11Fy)))
        }),
    ISSUES: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQJCJ))), {
            ...props,
            color: "currentColor",
            spacing: props.size === 'small' ? 'none' : 'spacious',
            LEGACY_size: props.size
        }),
    REPORTS: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4KUYb))), {
            ...props,
            color: "currentColor",
            spacing: props.size === 'small' ? 'none' : 'spacious',
            LEGACY_size: props.size
        }),
    COMPONENTS: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxg6i))), {
            ...props,
            color: "currentColor",
            spacing: props.size === 'small' ? 'none' : 'spacious',
            LEGACY_size: props.size
        }),
    SHORTCUTS: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5P2bV))), {
            ...props,
            color: "currentColor",
            spacing: props.size === 'small' ? 'none' : 'spacious',
            LEGACY_size: props.size
        }),
    ARCHIVED_ISSUES: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lgPyf))), {
            ...props,
            color: "currentColor",
            spacing: props.size === 'small' ? 'none' : 'spacious',
            LEGACY_size: props.size
        })
};
const $1cf894fead65ac85$export$9b209feccba8ab55 = {
    SUMMARY: {
        type: 'project',
        id: 'summaryTab',
        team: 'Wanjel',
        getConfiguration: ()=>({
                path: '/summary',
                icon: $1cf894fead65ac85$export$5d9709eb58866a62.SUMMARY,
                isSelectedOnRoutes: (0, $21JTp.SUMMARY_ROUTES)
            }),
        tabDetails: {
            illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hR0XV.default), {
                alt: ""
            }),
            component: (0, $bwCQX.SummaryDetails)
        }
    },
    BOARD: {
        type: 'project',
        id: 'boardTab',
        team: 'Wanjel',
        getConfiguration: ()=>({
                path: '/board',
                icon: $1cf894fead65ac85$export$5d9709eb58866a62.BOARD,
                isSelectedOnRoutes: (0, $21JTp.BOARD_ROUTES)
            }),
        tabDetails: {
            illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fGlXq.default), {
                alt: ""
            }),
            component: (0, $bwCQX.BoardDetails)
        }
    },
    LIST: {
        type: 'project',
        id: 'listTab',
        team: 'Wanjel',
        getConfiguration: ()=>({
                path: '/list',
                icon: $1cf894fead65ac85$export$5d9709eb58866a62.LIST,
                isSelectedOnRoutes: (0, $21JTp.LIST_ROUTES)
            }),
        tabDetails: {
            illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1X4ga.default), {
                alt: ""
            }),
            component: (0, $bwCQX.ListDetails)
        }
    },
    TIMELINE: {
        type: 'project',
        id: 'timelineTab',
        team: 'Wanjel',
        getConfiguration: ()=>({
                path: '/timeline',
                icon: $1cf894fead65ac85$export$5d9709eb58866a62.TIMELINE,
                isSelectedOnRoutes: (0, $21JTp.TIMELINE_ROUTES)
            }),
        tabDetails: {
            illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $833ck.default), {
                alt: ""
            }),
            component: (0, $bwCQX.TimelineDetails)
        }
    },
    CALENDAR: {
        type: 'project',
        id: 'calendarTab',
        team: 'Wanjel',
        getConfiguration: ()=>({
                path: '/calendar',
                icon: $1cf894fead65ac85$export$5d9709eb58866a62.CALENDAR,
                isSelectedOnRoutes: (0, $21JTp.CALENDAR_ROUTES)
            }),
        tabDetails: {
            illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivrMo.default), {
                alt: ""
            }),
            component: (0, $bwCQX.CalendarDetails)
        }
    },
    FORMS: {
        type: 'project',
        id: 'formsTab',
        team: 'Wanjel',
        getConfiguration: ()=>({
                path: '/form',
                icon: $1cf894fead65ac85$export$5d9709eb58866a62.FORMS,
                isSelectedOnRoutes: (0, $21JTp.FORMS_ROUTES)
            }),
        tabDetails: {
            illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gafcx.default), {
                alt: ""
            }),
            component: (0, $bwCQX.FormsDetails)
        }
    },
    APPROVALS: {
        type: 'project',
        id: 'approvalsTab',
        team: 'Wanjel',
        getConfiguration: ()=>({
                path: '/approvals',
                icon: $1cf894fead65ac85$export$5d9709eb58866a62.APPROVALS,
                isSelectedOnRoutes: (0, $21JTp.APPROVALS_ROUTES)
            }),
        tabDetails: {
            illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bU94A.default), {
                alt: ""
            }),
            component: (0, $bwCQX.ApprovalsDetails)
        }
    },
    ATTACHMENTS: {
        type: 'project',
        id: 'attachmentsTab',
        team: 'Wanjel',
        getConfiguration: ()=>({
                path: '/attachments',
                icon: $1cf894fead65ac85$export$5d9709eb58866a62.ATTACHMENTS,
                isSelectedOnRoutes: (0, $21JTp.ATTACHMENTS_ROUTES)
            }),
        tabDetails: {
            illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9a8PH.default), {
                alt: ""
            }),
            component: (0, $bwCQX.AttachmentsDetails)
        }
    },
    PAGES: {
        type: 'project',
        id: 'pagesTab',
        team: 'Wanjel',
        getConfiguration: ()=>({
                path: '/pages',
                icon: $1cf894fead65ac85$export$5d9709eb58866a62.PAGES,
                isSelectedOnRoutes: (0, $21JTp.PAGES_ROUTES)
            }),
        tabDetails: {
            illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $sQUnj.default), {
                alt: ""
            }),
            component: (0, $bwCQX.PagesDetails)
        }
    },
    ISSUES: {
        type: 'project',
        id: 'issuesTab',
        team: 'Wanjel',
        getConfiguration: ()=>({
                path: '/issues',
                icon: $1cf894fead65ac85$export$5d9709eb58866a62.ISSUES,
                isSelectedOnRoutes: (0, $21JTp.ISSUES_ROUTES)
            }),
        tabDetails: {
            illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ad6tu.default), {
                alt: ""
            }),
            component: (0, $bwCQX.IssuesDetails)
        }
    },
    REPORTS: {
        type: 'reports',
        id: 'reportsTab',
        team: 'Wanjel',
        getConfiguration: ()=>({
                icon: $1cf894fead65ac85$export$5d9709eb58866a62.REPORTS,
                isSelectedOnRoutes: (0, $21JTp.REPORTS_ROUTES)
            }),
        tabDetails: {
            illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5EY5v.default), {
                alt: ""
            }),
            component: (0, $bwCQX.ReportsDetails)
        }
    },
    COMPONENTS: {
        type: 'project',
        id: 'componentsTab',
        team: 'Wanjel',
        getConfiguration: ()=>({
                path: '/components',
                icon: $1cf894fead65ac85$export$5d9709eb58866a62.COMPONENTS,
                isSelectedOnRoutes: (0, $21JTp.COMPONENTS_ROUTES)
            }),
        tabDetails: {
            illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3pzqk.default), {
                alt: ""
            }),
            component: (0, $bwCQX.ComponentsDetails)
        }
    },
    SHORTCUTS: {
        type: 'shortcuts',
        id: 'shortcutsTab',
        team: 'Wanjel',
        getConfiguration: ()=>({
                icon: $1cf894fead65ac85$export$5d9709eb58866a62.SHORTCUTS,
                isSelectedOnRoutes: (0, $21JTp.SHORTCUTS_ROUTES)
            }),
        tabDetails: {
            illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gS64m.default), {
                alt: ""
            }),
            component: (0, $bwCQX.ShortcutsDetails)
        }
    },
    APP: {
        type: 'app',
        id: 'appTab',
        team: 'Wanjel',
        getConfiguration: ()=>({}),
        tabDetails: {
            illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aZEzT.default), {
                alt: ""
            }),
            component: (0, $bwCQX.AppDetails)
        }
    },
    ARCHIVED_ISSUES: {
        type: 'project',
        id: 'archivedIssuesTab',
        team: 'Kenji',
        getConfiguration: ()=>({
                path: '/issues/archive',
                icon: $1cf894fead65ac85$export$5d9709eb58866a62.ARCHIVED_ISSUES,
                isSelectedOnRoutes: (0, $21JTp.ARCHIVE_ROUTES)
            }),
        tabDetails: {
            illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ad6tu.default), {
                alt: ""
            }),
            component: (0, $bwCQX.ArchivedIssuesDetails)
        }
    }
};

});
parcelRegister("c9NFd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1fd96c5b3b13ee02dc5743b09d638d98>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0248b92f6c6ad227$var$_react = $0248b92f6c6ad227$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0248b92f6c6ad227$var$_baseNew = $0248b92f6c6ad227$var$_interopRequireDefault((parcelRequire("enEmH")));
function $0248b92f6c6ad227$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spreadsheet".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for spreadsheets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0248b92f6c6ad227$var$SpreadsheetIcon = (props)=>/*#__PURE__*/ $0248b92f6c6ad227$var$_react.default.createElement($0248b92f6c6ad227$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v3.25H5V3.5zm4.5 0v3.75h8V4a.5.5 0 0 0-.5-.5zm8 5.25h-8v3.75H14a.5.5 0 0 0 .5-.5zM5 12.5V8.75H1.5V12a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$0248b92f6c6ad227$var$SpreadsheetIcon.displayName = 'SpreadsheetIcon';
var $0248b92f6c6ad227$var$_default = module.exports.default = $0248b92f6c6ad227$var$SpreadsheetIcon;

});

parcelRegister("bwCQX", function(module, exports) {

$parcel$export(module.exports, "SummaryDetails", () => $d73c7eed6f8b79f8$export$9811fe609657ae14);
$parcel$export(module.exports, "BoardDetails", () => $d73c7eed6f8b79f8$export$232d017baf232785);
$parcel$export(module.exports, "ListDetails", () => $d73c7eed6f8b79f8$export$c1227a1ac2a65982);
$parcel$export(module.exports, "CalendarDetails", () => $d73c7eed6f8b79f8$export$adc8d7e419c90776);
$parcel$export(module.exports, "TimelineDetails", () => $d73c7eed6f8b79f8$export$2a5453c6d798e51b);
$parcel$export(module.exports, "FormsDetails", () => $d73c7eed6f8b79f8$export$ac27bed18ae3cb11);
$parcel$export(module.exports, "ApprovalsDetails", () => $d73c7eed6f8b79f8$export$c08f29505c928d55);
$parcel$export(module.exports, "AttachmentsDetails", () => $d73c7eed6f8b79f8$export$de1ffa6169ed3398);
$parcel$export(module.exports, "PagesDetails", () => $d73c7eed6f8b79f8$export$91a89a6317f70b4a);
$parcel$export(module.exports, "IssuesDetails", () => $d73c7eed6f8b79f8$export$b5cc2500a910df46);
$parcel$export(module.exports, "ReportsDetails", () => $d73c7eed6f8b79f8$export$9e5e7ceeeab9c464);
$parcel$export(module.exports, "ComponentsDetails", () => $d73c7eed6f8b79f8$export$b9900b9cebab7d57);
$parcel$export(module.exports, "ShortcutsDetails", () => $d73c7eed6f8b79f8$export$6f75d8615aefdaa3);
$parcel$export(module.exports, "AppDetails", () => $d73c7eed6f8b79f8$export$ad632fed13b68969);
$parcel$export(module.exports, "ArchivedIssuesDetails", () => $d73c7eed6f8b79f8$export$64b125cf41827f4a);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $lpwtK = parcelRequire("lpwtK");

var $jafiA = parcelRequire("jafiA");

var $8CFRw = parcelRequire("8CFRw");

var $14oTU = parcelRequire("14oTU");
const $d73c7eed6f8b79f8$export$9811fe609657ae14 = ({ label: label, onConfirm: onConfirm, preview: preview })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = (0, $lpwtK.useProject)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const path = project?.key ? (0, $jafiA.getRouteForViewType)(project.key, 'SUMMARY') : undefined;
        onConfirm(path);
    }, [
        onConfirm,
        project?.key
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8CFRw.default), {
        label: label,
        preview: preview,
        description: formatMessage((0, $14oTU.default).summaryDescription),
        onClick: onClick
    });
};
const $d73c7eed6f8b79f8$export$232d017baf232785 = ({ label: label, onConfirm: onConfirm, preview: preview })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = (0, $lpwtK.useProject)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const path = project?.key ? (0, $jafiA.getRouteForViewType)(project.key, 'BOARD') : undefined;
        onConfirm(path);
    }, [
        onConfirm,
        project?.key
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8CFRw.default), {
        label: label,
        preview: preview,
        description: formatMessage((0, $14oTU.default).boardDescription),
        onClick: onClick
    });
};
const $d73c7eed6f8b79f8$export$c1227a1ac2a65982 = ({ label: label, onConfirm: onConfirm, preview: preview })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = (0, $lpwtK.useProject)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const path = project?.key ? (0, $jafiA.getRouteForViewType)(project.key, 'LIST') : undefined;
        onConfirm(path);
    }, [
        onConfirm,
        project?.key
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8CFRw.default), {
        label: label,
        preview: preview,
        description: formatMessage((0, $14oTU.default).listDescription),
        onClick: onClick
    });
};
const $d73c7eed6f8b79f8$export$adc8d7e419c90776 = ({ label: label, onConfirm: onConfirm, preview: preview })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = (0, $lpwtK.useProject)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const path = project?.key ? (0, $jafiA.getRouteForViewType)(project.key, 'CALENDAR') : undefined;
        onConfirm(path);
    }, [
        onConfirm,
        project?.key
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8CFRw.default), {
        label: label,
        preview: preview,
        description: formatMessage((0, $14oTU.default).calendarDescription),
        onClick: onClick
    });
};
const $d73c7eed6f8b79f8$export$2a5453c6d798e51b = ({ label: label, onConfirm: onConfirm, preview: preview })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = (0, $lpwtK.useProject)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const path = project?.key ? (0, $jafiA.getRouteForViewType)(project.key, 'TIMELINE') : undefined;
        onConfirm(path);
    }, [
        onConfirm,
        project?.key
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8CFRw.default), {
        label: label,
        preview: preview,
        description: formatMessage((0, $14oTU.default).timelineDescription),
        onClick: onClick
    });
};
const $d73c7eed6f8b79f8$export$ac27bed18ae3cb11 = ({ label: label, onConfirm: onConfirm, preview: preview })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = (0, $lpwtK.useProject)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const path = project?.key ? (0, $jafiA.getRouteForViewType)(project.key, 'FORMS') : undefined;
        onConfirm(path);
    }, [
        onConfirm,
        project?.key
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8CFRw.default), {
        label: label,
        preview: preview,
        description: formatMessage((0, $14oTU.default).formsDescription),
        onClick: onClick
    });
};
const $d73c7eed6f8b79f8$export$c08f29505c928d55 = ({ label: label, onConfirm: onConfirm, preview: preview })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = (0, $lpwtK.useProject)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const path = project?.key ? (0, $jafiA.getRouteForViewType)(project.key, 'APPROVALS') : undefined;
        onConfirm(path);
    }, [
        onConfirm,
        project?.key
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8CFRw.default), {
        label: label,
        preview: preview,
        description: formatMessage((0, $14oTU.default).approvalsDescription),
        onClick: onClick
    });
};
const $d73c7eed6f8b79f8$export$de1ffa6169ed3398 = ({ label: label, onConfirm: onConfirm, preview: preview })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = (0, $lpwtK.useProject)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const path = project?.key ? (0, $jafiA.getRouteForViewType)(project.key, 'ATTACHMENTS') : undefined;
        onConfirm(path);
    }, [
        onConfirm,
        project?.key
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8CFRw.default), {
        label: label,
        preview: preview,
        description: formatMessage((0, $14oTU.default).attachmentsDescription),
        onClick: onClick
    });
};
const $d73c7eed6f8b79f8$export$91a89a6317f70b4a = ({ label: label, onConfirm: onConfirm, preview: preview })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = (0, $lpwtK.useProject)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const path = project?.key ? (0, $jafiA.getRouteForViewType)(project.key, 'PAGES') : undefined;
        onConfirm(path);
    }, [
        onConfirm,
        project?.key
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8CFRw.default), {
        label: label,
        preview: preview,
        description: formatMessage((0, $14oTU.default).pagesDescription),
        onClick: onClick
    });
};
const $d73c7eed6f8b79f8$export$b5cc2500a910df46 = ({ label: label, onConfirm: onConfirm, preview: preview })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = (0, $lpwtK.useProject)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const path = project?.key ? (0, $jafiA.getRouteForViewType)(project.key, 'ISSUES') : undefined;
        onConfirm(path);
    }, [
        onConfirm,
        project?.key
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8CFRw.default), {
        label: label,
        preview: preview,
        description: formatMessage((0, $14oTU.default).issuesDescription),
        onClick: onClick
    });
};
const $d73c7eed6f8b79f8$export$9e5e7ceeeab9c464 = ({ label: label, onConfirm: onConfirm, preview: preview })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = (0, $lpwtK.useProject)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const path = project?.key ? (0, $jafiA.getRouteForViewType)(project.key, 'REPORTS') : undefined;
        onConfirm(path);
    }, [
        onConfirm,
        project?.key
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8CFRw.default), {
        label: label,
        preview: preview,
        description: formatMessage((0, $14oTU.default).reportsDescription),
        onClick: onClick
    });
};
const $d73c7eed6f8b79f8$export$b9900b9cebab7d57 = ({ label: label, onConfirm: onConfirm, preview: preview })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = (0, $lpwtK.useProject)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const path = project?.key ? (0, $jafiA.getRouteForViewType)(project.key, 'COMPONENTS') : undefined;
        onConfirm(path);
    }, [
        onConfirm,
        project?.key
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8CFRw.default), {
        label: label,
        preview: preview,
        description: formatMessage((0, $14oTU.default).componentsDescription),
        onClick: onClick
    });
};
const $d73c7eed6f8b79f8$export$6f75d8615aefdaa3 = ({ label: label, onConfirm: onConfirm, preview: preview })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClick = (0, $5uXOq.useCallback)(()=>onConfirm(), [
        onConfirm
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8CFRw.default), {
        label: label,
        preview: preview,
        description: formatMessage((0, $14oTU.default).shortcutsDescription),
        onClick: onClick
    });
};
const $d73c7eed6f8b79f8$export$ad632fed13b68969 = ({ label: label, onConfirm: onConfirm, preview: preview })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClick = (0, $5uXOq.useCallback)(()=>onConfirm(), [
        onConfirm
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8CFRw.default), {
        preview: preview,
        label: label,
        description: formatMessage((0, $14oTU.default).appDescription),
        onClick: onClick
    });
};
const $d73c7eed6f8b79f8$export$64b125cf41827f4a = ({ label: label, onConfirm: onConfirm, preview: preview })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = (0, $lpwtK.useProject)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const path = project?.key ? (0, $jafiA.getRouteForViewType)(project.key, 'ARCHIVED_ISSUES') : undefined;
        onConfirm(path);
    }, [
        onConfirm,
        project?.key
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8CFRw.default), {
        preview: preview,
        label: label,
        description: formatMessage((0, $14oTU.default).archivedIssuesDescription),
        onClick: onClick
    });
};

});
parcelRegister("8CFRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8c0df113039d254$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cNW3X = parcelRequire("cNW3X");

var $bWfiu = parcelRequire("bWfiu");

var $0yZbT = parcelRequire("0yZbT");
var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");

var $koVbs = parcelRequire("koVbs");

var $3I0fc = parcelRequire("3I0fc");
const $c8c0df113039d254$var$TabDetails = ({ onClick: onClick, preview: preview, label: label, description: description })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $0yZbT.default), {
        xcss: $c8c0df113039d254$var$detailsWrapperStyles,
        role: "region",
        "aria-live": "polite"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $bEIgH.default), {
        alignInline: "start",
        space: "space.200",
        xcss: $c8c0df113039d254$var$columnStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $0yZbT.default), {
        xcss: $c8c0df113039d254$var$imageWrapperStyles
    }, preview), /*#__PURE__*/ $5uXOq.createElement((0, $bEIgH.default), {
        space: "space.050"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $bWfiu.default), {
        size: "xsmall",
        testId: "navigation-kit-add-tab.ui.content.details.tab-details.heading"
    }, /*#__PURE__*/ $5uXOq.createElement("span", {
        className: (0, $bwpsq.default)([
            "_1nmz9jpi"
        ])
    }, label)), /*#__PURE__*/ $5uXOq.createElement((0, $0yZbT.default), {
        xcss: $c8c0df113039d254$var$descriptionStyles
    }, description)), /*#__PURE__*/ $5uXOq.createElement((0, $cNW3X.default), {
        appearance: "primary",
        onClick: onClick
    }, formatMessage((0, $3I0fc.default).addViewButton))));
};
var $c8c0df113039d254$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($c8c0df113039d254$var$TabDetails);
const $c8c0df113039d254$var$columnStyles = (0, $2s57o.xcss)({
    paddingInline: 'space.500',
    width: '100%'
});
const $c8c0df113039d254$var$descriptionStyles = (0, $2s57o.xcss)({
    color: 'color.text.subtle',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $c8c0df113039d254$var$imageWrapperStyles = (0, $2s57o.xcss)({
    width: '100%'
});
const $c8c0df113039d254$var$detailsWrapperStyles = (0, $2s57o.xcss)({
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderWidth: 'border.width.0',
    borderInlineStartWidth: 'border.width',
    flexBasis: '320px',
    backgroundColor: 'elevation.surface.sunken',
    display: 'flex',
    paddingBlockStart: 'space.500'
});
const $c8c0df113039d254$var$headingExtraStyles = null;

});
parcelRegister("3I0fc", function(module, exports) {

$parcel$export(module.exports, "default", () => $16ceb8bde790416f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $16ceb8bde790416f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addViewButton: {
        "id": "navigation-kit-add-tab.content.details.tab-details.add-view-button",
        "defaultMessage": "Add to navigation"
    }
});

});


parcelRegister("14oTU", function(module, exports) {

$parcel$export(module.exports, "default", () => $29cb3c9f9389dfd5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $29cb3c9f9389dfd5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    summaryDescription: {
        "id": "business-tabs.add-tab-details.summary-description",
        "defaultMessage": "Get an overview of work progress, priorities, workload distribution, and other projects."
    },
    boardDescription: {
        "id": "business-tabs.add-tab-details.board-description",
        "defaultMessage": "Get a snapshot of the status of your team\u2019s work and easily drag your cards through a workflow."
    },
    listDescription: {
        "id": "business-tabs.add-tab-details.list-description",
        "defaultMessage": "Get a list of your project\u2019s work in spreadsheet-like table."
    },
    timelineDescription: {
        "id": "business-tabs.add-tab-details.timeline-description",
        "defaultMessage": "Plan and manage your project dependencies on a timeline and see when things are landing."
    },
    calendarDescription: {
        "id": "business-tabs.add-tab-details.calendar-description",
        "defaultMessage": "See when work is due and get a quick glance at what the next month looks like."
    },
    formsDescription: {
        "id": "business-tabs.add-tab-details.forms-description",
        "defaultMessage": "Collect information for your team with forms."
    },
    approvalsDescription: {
        "id": "business-tabs.add-tab-details.approvals-description",
        "defaultMessage": "Add approvals into your workflow to save you time following up."
    },
    attachmentsDescription: {
        "id": "business-tabs.add-tab-details.attachments-description",
        "defaultMessage": "View attachments that have been added to issues within your project."
    },
    pagesDescription: {
        "id": "business-tabs.add-tab-details.pages-description",
        "defaultMessage": "Create and manage Confluence pages in your project."
    },
    shortcutsDescription: {
        "id": "business-tabs.add-tab-details.shortcuts-description",
        "defaultMessage": "Add easily accessible links for your team to access from your project."
    },
    issuesDescription: {
        "id": "business-tabs.add-tab-details.issues-description",
        "defaultMessage": "View all the issues in a project."
    },
    reportsDescription: {
        "id": "business-tabs.add-tab-details.reports-description",
        "defaultMessage": "View statistics for people, projects, versions, or information about issues."
    },
    componentsDescription: {
        "id": "business-tabs.add-tab-details.components-description",
        "defaultMessage": "Use components to create subsections of a project."
    },
    appDescription: {
        "id": "business-tabs.add-tab-details.app-description",
        "defaultMessage": "Supercharge your project by integrating third-party apps."
    },
    archivedIssuesDescription: {
        "id": "business-tabs.add-tab-details.archived-issues-description",
        "defaultMessage": "View all the issues archived in your project here."
    }
});

});


parcelRegister("aZEzT", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8e9302a8b16bd67$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $25Q2Y = parcelRequire("25Q2Y");

var $eosrI = parcelRequire("eosrI");
const $f8e9302a8b16bd67$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($eosrI)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($25Q2Y))
});
var $f8e9302a8b16bd67$export$2e2bcd8739ae039 = $f8e9302a8b16bd67$var$Illustration;
// for advanced use only
const $f8e9302a8b16bd67$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("dCLgq", function(module, exports) {

$parcel$export(module.exports, "Illustration", () => $191b30bb5e9fa934$export$d43c2e2ca9b2c105);
$parcel$export(module.exports, "createIllustration", () => $191b30bb5e9fa934$export$4d00e7be716a0093);

var $5uXOq = parcelRequire("5uXOq");

var $10ozQ = parcelRequire("10ozQ");
function $191b30bb5e9fa934$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $10ozQ.AsImg), props);
}
function $191b30bb5e9fa934$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($191b30bb5e9fa934$export$d43c2e2ca9b2c105, {
            srcLight: srcLight,
            srcDark: srcDark,
            autoDark: autoDark,
            ...props
        });
}

});
parcelRegister("10ozQ", function(module, exports) {

$parcel$export(module.exports, "AsImg", () => $b5af8835f639f069$export$75e378065cb7d6c0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // This is an INTENTIONAL FORK of @atlaskit/image
// copied 2023-11-09 v1.1.6
// with permission from @DDC from Design System,
// in order to refine the API and use cases.
// Will be back-ported to @atlaskit/image https://hello.atlassian.net/browse/ERAI-1660

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");
// suggested defaults, the consumer is free to override
const $b5af8835f639f069$var$defaultStyles = null;
const $b5af8835f639f069$var$fillStyles = null;
const $b5af8835f639f069$var$autoDarkModeStyles = null;
function $b5af8835f639f069$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: colorMode === 'dark' ? srcDark : srcLight,
        alt: alt,
        "data-testid": testId,
        ...imgProps,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
            fill && "_1r04idpf _kqswstnw _1bsb1osq _4t3i1osq",
            colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
        ])
    });
}

});


parcelRegister("25Q2Y", function(module, exports) {
module.exports = new URL("app-preview-dark.692f3794.svg", import.meta.url).toString();

});

parcelRegister("eosrI", function(module, exports) {
module.exports = new URL("app-preview.701bd916.svg", import.meta.url).toString();

});


parcelRegister("bU94A", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ab5734c5483a312$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $6UE2v = parcelRequire("6UE2v");

var $7yuDf = parcelRequire("7yuDf");
const $2ab5734c5483a312$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($7yuDf)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6UE2v))
});
var $2ab5734c5483a312$export$2e2bcd8739ae039 = $2ab5734c5483a312$var$Illustration;
// for advanced use only
const $2ab5734c5483a312$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("6UE2v", function(module, exports) {
module.exports = new URL("approvals-preview-dark.6d3cc8df.svg", import.meta.url).toString();

});

parcelRegister("7yuDf", function(module, exports) {
module.exports = new URL("approvals-preview.ce5f015e.svg", import.meta.url).toString();

});


parcelRegister("9a8PH", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d6f697cd504e99$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $2AEJs = parcelRequire("2AEJs");

var $g8jD8 = parcelRequire("g8jD8");
const $45d6f697cd504e99$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($g8jD8)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2AEJs))
});
var $45d6f697cd504e99$export$2e2bcd8739ae039 = $45d6f697cd504e99$var$Illustration;
// for advanced use only
const $45d6f697cd504e99$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("2AEJs", function(module, exports) {
module.exports = new URL("attachments-preview-dark.33a03e0d.svg", import.meta.url).toString();

});

parcelRegister("g8jD8", function(module, exports) {
module.exports = new URL("attachments-preview.7bdfffc6.svg", import.meta.url).toString();

});


parcelRegister("fGlXq", function(module, exports) {

$parcel$export(module.exports, "default", () => $56958bdcbb5fed5b$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $dfBGt = parcelRequire("dfBGt");

var $jNEsV = parcelRequire("jNEsV");
const $56958bdcbb5fed5b$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($jNEsV)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($dfBGt))
});
var $56958bdcbb5fed5b$export$2e2bcd8739ae039 = $56958bdcbb5fed5b$var$Illustration;
// for advanced use only
const $56958bdcbb5fed5b$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("dfBGt", function(module, exports) {
module.exports = new URL("board-preview-dark.ba6ae5d7.svg", import.meta.url).toString();

});

parcelRegister("jNEsV", function(module, exports) {
module.exports = new URL("board-preview.caf8f30f.svg", import.meta.url).toString();

});


parcelRegister("ivrMo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e950b3b295ffcd66$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $fRklT = parcelRequire("fRklT");

var $C1qTt = parcelRequire("C1qTt");
const $e950b3b295ffcd66$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($C1qTt)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($fRklT))
});
var $e950b3b295ffcd66$export$2e2bcd8739ae039 = $e950b3b295ffcd66$var$Illustration;
// for advanced use only
const $e950b3b295ffcd66$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("fRklT", function(module, exports) {
module.exports = new URL("calendar-preview-dark.1428b9c3.svg", import.meta.url).toString();

});

parcelRegister("C1qTt", function(module, exports) {
module.exports = new URL("calendar-preview.cff0b145.svg", import.meta.url).toString();

});


parcelRegister("3pzqk", function(module, exports) {

$parcel$export(module.exports, "default", () => $936ff2bab8c98662$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $glR0t = parcelRequire("glR0t");

var $1M128 = parcelRequire("1M128");
const $936ff2bab8c98662$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1M128)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($glR0t))
});
var $936ff2bab8c98662$export$2e2bcd8739ae039 = $936ff2bab8c98662$var$Illustration;
// for advanced use only
const $936ff2bab8c98662$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("glR0t", function(module, exports) {
module.exports = new URL("component-preview-dark.ac5aacd0.svg", import.meta.url).toString();

});

parcelRegister("1M128", function(module, exports) {
module.exports = new URL("component-preview.e6bd185f.svg", import.meta.url).toString();

});


parcelRegister("gafcx", function(module, exports) {

$parcel$export(module.exports, "default", () => $84cfa41e2e38c966$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $kHWJn = parcelRequire("kHWJn");

var $6PP4l = parcelRequire("6PP4l");
const $84cfa41e2e38c966$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6PP4l)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($kHWJn))
});
var $84cfa41e2e38c966$export$2e2bcd8739ae039 = $84cfa41e2e38c966$var$Illustration;
// for advanced use only
const $84cfa41e2e38c966$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("kHWJn", function(module, exports) {
module.exports = new URL("forms-preview-dark.430156b1.svg", import.meta.url).toString();

});

parcelRegister("6PP4l", function(module, exports) {
module.exports = new URL("forms-preview.5e482c7a.svg", import.meta.url).toString();

});


parcelRegister("ad6tu", function(module, exports) {

$parcel$export(module.exports, "default", () => $686a30c829043502$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $2Spml = parcelRequire("2Spml");

var $8PHg6 = parcelRequire("8PHg6");
const $686a30c829043502$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8PHg6)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2Spml))
});
var $686a30c829043502$export$2e2bcd8739ae039 = $686a30c829043502$var$Illustration;
// for advanced use only
const $686a30c829043502$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("2Spml", function(module, exports) {
module.exports = new URL("issues-preview-dark.5cdc89fc.svg", import.meta.url).toString();

});

parcelRegister("8PHg6", function(module, exports) {
module.exports = new URL("issues-preview.c08edc67.svg", import.meta.url).toString();

});


parcelRegister("1X4ga", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b7a866c21212700$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $ar1zY = parcelRequire("ar1zY");

var $73Rxa = parcelRequire("73Rxa");
const $3b7a866c21212700$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($73Rxa)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($ar1zY))
});
var $3b7a866c21212700$export$2e2bcd8739ae039 = $3b7a866c21212700$var$Illustration;
// for advanced use only
const $3b7a866c21212700$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("ar1zY", function(module, exports) {
module.exports = new URL("list-preview-dark.e53f1bb5.svg", import.meta.url).toString();

});

parcelRegister("73Rxa", function(module, exports) {
module.exports = new URL("list-preview.9c8441b2.svg", import.meta.url).toString();

});


parcelRegister("sQUnj", function(module, exports) {

$parcel$export(module.exports, "default", () => $128e5932ddfe0686$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $2BF50 = parcelRequire("2BF50");

var $jGooG = parcelRequire("jGooG");
const $128e5932ddfe0686$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($jGooG)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2BF50))
});
var $128e5932ddfe0686$export$2e2bcd8739ae039 = $128e5932ddfe0686$var$Illustration;
// for advanced use only
const $128e5932ddfe0686$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("2BF50", function(module, exports) {
module.exports = new URL("pages-preview-dark.db4817b0.svg", import.meta.url).toString();

});

parcelRegister("jGooG", function(module, exports) {
module.exports = new URL("pages-preview.fb1778e6.svg", import.meta.url).toString();

});


parcelRegister("5EY5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $05de15dfc4738b45$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $dJYWt = parcelRequire("dJYWt");

var $bykH3 = parcelRequire("bykH3");
const $05de15dfc4738b45$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($bykH3)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($dJYWt))
});
var $05de15dfc4738b45$export$2e2bcd8739ae039 = $05de15dfc4738b45$var$Illustration;
// for advanced use only
const $05de15dfc4738b45$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("dJYWt", function(module, exports) {
module.exports = new URL("reports-preview-dark.c0a44511.svg", import.meta.url).toString();

});

parcelRegister("bykH3", function(module, exports) {
module.exports = new URL("reports-preview.8bb5ca71.svg", import.meta.url).toString();

});


parcelRegister("gS64m", function(module, exports) {

$parcel$export(module.exports, "default", () => $098262013fc43113$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $2KuAY = parcelRequire("2KuAY");

var $7EBtb = parcelRequire("7EBtb");
const $098262013fc43113$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($7EBtb)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2KuAY))
});
var $098262013fc43113$export$2e2bcd8739ae039 = $098262013fc43113$var$Illustration;
// for advanced use only
const $098262013fc43113$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("2KuAY", function(module, exports) {
module.exports = new URL("shortcuts-preview-dark.ee547f9e.svg", import.meta.url).toString();

});

parcelRegister("7EBtb", function(module, exports) {
module.exports = new URL("shortcuts-preview.8780e9d0.svg", import.meta.url).toString();

});


parcelRegister("hR0XV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0734d37e50948b26$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $5EwWC = parcelRequire("5EwWC");

var $laN0O = parcelRequire("laN0O");
const $0734d37e50948b26$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($laN0O)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($5EwWC))
});
var $0734d37e50948b26$export$2e2bcd8739ae039 = $0734d37e50948b26$var$Illustration;
// for advanced use only
const $0734d37e50948b26$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("5EwWC", function(module, exports) {
module.exports = new URL("summary-preview-dark.32dd4d90.svg", import.meta.url).toString();

});

parcelRegister("laN0O", function(module, exports) {
module.exports = new URL("summary-preview.10045d4f.svg", import.meta.url).toString();

});


parcelRegister("833ck", function(module, exports) {

$parcel$export(module.exports, "default", () => $7790084e44c29578$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $jc7Jr = parcelRequire("jc7Jr");

var $5wMM8 = parcelRequire("5wMM8");
const $7790084e44c29578$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5wMM8)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($jc7Jr))
});
var $7790084e44c29578$export$2e2bcd8739ae039 = $7790084e44c29578$var$Illustration;
// for advanced use only
const $7790084e44c29578$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("jc7Jr", function(module, exports) {
module.exports = new URL("timeline-preview-dark.a8fbe72d.svg", import.meta.url).toString();

});

parcelRegister("5wMM8", function(module, exports) {
module.exports = new URL("timeline-preview.cf56bfbb.svg", import.meta.url).toString();

});



parcelRegister("71WSM", function(module, exports) {

$parcel$export(module.exports, "useHideAppsTab", () => $477e8d5af8d42c78$export$32cad00d369d116d);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $hecDf = parcelRequire("hecDf");

var $gZbSF = parcelRequire("gZbSF");

var $231OU = parcelRequire("231OU");

var $9OXo1 = parcelRequire("9OXo1");
const $477e8d5af8d42c78$export$32cad00d369d116d = ()=>{
    const { project: project } = (0, $hecDf.useNavigationProject)();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { data: forgeAppsData, loading: forgeAppsLoading } = (0, $231OU.useProjectForgeApps)('forge-spa-project');
    const { data: connectAppsData, loading: connectAppsLoading } = (0, $gZbSF.useProjectConnectItems)();
    const forgeItems = forgeAppsData ?? [];
    const connectItems = connectAppsData ?? [];
    const totalNumberOfApps = forgeItems.length + connectItems.length;
    const hasApps = totalNumberOfApps > 0;
    const isLoading = forgeAppsLoading || connectAppsLoading;
    const shouldRenderApps = project != null && hasApps;
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useCallback)(()=>{
        if (!isLoading && !shouldRenderApps) (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
            const projectIdOrKey = String(project?.key || project?.id);
            const parentRecord = store.getRoot().getLinkedRecord('jira');
            if (parentRecord == null) return;
            const connection = (0, $8Uumt.ConnectionHandler).getConnection(parentRecord, 'tabs_jiraNavigation__navigationItems', {
                cloudId: cloudId,
                projectIdOrKey: projectIdOrKey
            });
            if (!connection) return;
            const existingEdges = connection?.getLinkedRecords('edges') || [];
            const edges = existingEdges.filter((edge)=>{
                const typeKey = edge?.getLinkedRecord('node')?.getValue('typeKey');
                return typeKey !== 'APPS';
            });
            connection?.setLinkedRecords(edges, 'edges');
        });
    }, [
        cloudId,
        environment,
        isLoading,
        project?.id,
        project?.key,
        shouldRenderApps
    ]);
};

});


parcelRegister("cNBOV", function(module, exports) {

$parcel$export(module.exports, "HANDLED_STATUS_CODES", () => $1d5387bc164ab59a$export$ad73a344b1bd5415);
$parcel$export(module.exports, "getFlagDetails", () => $1d5387bc164ab59a$export$e0141c03826f0c2c);

var $2FBSL = parcelRequire("2FBSL");
const $1d5387bc164ab59a$var$DEFAULT_ERROR_FLAG = {
    type: 'error',
    title: (0, $2FBSL.default).defaultErrorTitle,
    description: (0, $2FBSL.default).defaultErrorMessage,
    messageId: 'business-horizontal-nav.ui.project-navigation.default-error-flag.error.error.default-error-flag',
    messageType: 'transactional'
};
const $1d5387bc164ab59a$export$ad73a344b1bd5415 = [
    401,
    403,
    404
];
const $1d5387bc164ab59a$export$e0141c03826f0c2c = (statusCode)=>{
    switch(statusCode){
        case 401:
            return {
                type: 'error',
                title: (0, $2FBSL.default).unauthenticatedUserErrorTitle,
                description: (0, $2FBSL.default).unauthenticatedUserErrorMessage,
                messageId: 'business-horizontal-nav.ui.project-navigation.flag.error.error.401',
                messageType: 'transactional'
            };
        case 403:
            return {
                type: 'error',
                title: (0, $2FBSL.default).unauthorizedUserErrorTitle,
                description: (0, $2FBSL.default).unauthorizedUserErrorMessage,
                messageId: 'business-horizontal-nav.ui.project-navigation.flag.error.error.403',
                messageType: 'transactional'
            };
        case 404:
            return {
                type: 'error',
                title: (0, $2FBSL.default).projectNotFoundErrorTitle,
                description: (0, $2FBSL.default).projectNotFoundErrorMessage,
                messageId: 'business-horizontal-nav.ui.project-navigation.flag.error.error.404',
                messageType: 'transactional'
            };
        default:
            return $1d5387bc164ab59a$var$DEFAULT_ERROR_FLAG;
    }
};

});



//# sourceMappingURL=project-navigation.f35ddaab.js.map
